module.exports = {
  Cargo_CreatBy: 'Người báo giá',
  Cargo_TrunkLine: 'Chặng chính',
  Cargo_Inquiry_MissingBusinessCannotSubmit: 'Loại {0} chưa chọn nhân viên kinh doanh, không thể gửi',
  Cargo_100Million: 'tỷ',
  Cargo_10Cents: 'Góc',
  Cargo_1St: 'Trang đầu',
  Cargo_1StInvoiceNo: 'Số hóa đơn đầu tiên',
  Cargo_1Year: '1 năm',
  Cargo_2NdDispatch: 'Gửi lần thứ hai',
  Cargo_2NdDispatchTime: 'Thời gian gửi lần thứ hai',
  Cargo_2NdReleaseTime: 'Thời gian đặt hàng thứ cấp',
  Cargo_2NdTransitAirportAir: 'Trung chuyển 2 đoạn (cảng hàng không)',
  Cargo_2StUnit: 'Đơn vị 2',
  Cargo_2Years: '2 năm',
  Cargo_30DaysShpt: '30 ngày (vé)',
  Cargo_3RdParty: 'Bên thứ ba',
  Cargo_3RdTransitAirportAir: 'Trung chuyển 3 đoạn (cảng hàng không)',
  Cargo_3Years: '3 năm',
  Cargo_60DaysShpt: '60 ngày (vé)',
  Cargo_90DaysShpt: '90 ngày (vé)',
  Cargo_AAPACRIG: 'Như một khoản thanh toán trước, tạo ra một hồ sơ tương ứng!',
  Cargo_AbandonThisVoucher: 'Xác nhận từ bỏ chứng từ này?',
  Cargo_Abbreviation: 'Viết tắt',
  Cargo_AbbreviationOfConsignor: 'Đơn vị ủy thác (gọi tắt)',
  Cargo_ABCDC: 'Xác nhận, trong đó {0} được xác nhận.',
  Cargo_MessageTip1: 'Bạn có [...]',
  Cargo_MessageTip2: 'Điều chưa đọc nhắc nhở.',
  Cargo_Abstract: 'Tóm tắt',
  Cargo_AbstractRuleOfJournalEntry: 'Quy tắc tóm tắt mục lục',
  Cargo_ABYBPSTCI23M: 'AA - đấu thầu hàng năm, tùy thuộc vào tình hình có thể xem xét, trong vòng 2-3 tháng.',
  Cargo_Accepted: 'Chấp nhận',
  Cargo_AccordingBillExchangeRate: 'Tỷ giá thanh toán',
  Cargo_AccordingForStatementFxRate: 'Tỷ giá hối đoái theo sao kê',
  Cargo_AccountClosedSuccessfully: 'Thanh toán xong rồi.',
  Cargo_AccountInForeignCurrency: 'Có phải hạch toán nguyên tệ không?',
  Cargo_AccountingMethod: 'Phương thức kế toán',
  Cargo_AccountingOrganizationCode: 'Mã tổ chức kế toán',
  Cargo_AccountingQuantity: 'Số lượng kế toán',
  Cargo_AccountingVoucher: 'Chứng từ kế toán',
  Cargo_AccountPeriod: 'Tài khoản',
  Cargo_AccountPeriodDay: 'Sổ sách (ngày)',
  Cargo_AccountQuantityOrNot: 'Có nên hạch toán theo số lượng không?',
  Cargo_AccountsReconciliation: 'Kiểm tra tài khoản qua lại',
  Cargo_AccountsReconciliation2: 'Kiểm tra sổ sách qua lại 2',
  Cargo_AccountStatement: 'Báo cáo',
  Cargo_AccountStatementNo: 'Số đối chiếu',
  Cargo_AccountStatementNoP: 'Số đối chiếu:',
  Cargo_AccountTitle: 'Đối tượng',
  Cargo_AccountTitle2: 'Đối tượng 2',
  Cargo_AccountTitleCanTBeEmpty: 'Chủ đề không được để trống',
  Cargo_AccountTitleCategory: 'Danh mục đối tượng',
  Cargo_AccountTitleClassification: 'Phân loại đối tượng',
  Cargo_AccountTitleClassificationRule: 'Quy tắc phân loại đối tượng',
  Cargo_AccountTitleCode: 'Mã hóa đối tượng',
  Cargo_AccountTitleCodeCanTBeEmpty: 'Mã hóa đối tượng không thể để trống.',
  Cargo_AccountTitleCodeP: 'Mã hóa đối tượng:',
  Cargo_AccountTitleGroupingCondition1: 'Subject Group Điều kiện 1',
  Cargo_AccountTitleGroupingCondition2: 'Điều kiện nhóm đối tượng II',
  Cargo_AccountTitleGroupingCondition3: 'Subject Group Điều kiện 3',
  Cargo_AccountTitleGroupingCondition4: 'Điều kiện nhóm đối tượng IV',
  Cargo_AccountTitleGroupingCondition5: 'Điều kiện nhóm đối tượng 5',
  Cargo_AccountTitleGroupingCondition6: 'Điều kiện nhóm đối tượng 6',
  Cargo_AccountTitleLevel: 'Cấp độ đối tượng',
  Cargo_AccountTitleMapping: 'Bản đồ đối tượng',
  Cargo_AccountTitleName: 'Tên đối tượng',
  Cargo_AccountTitleNameCanTBeEmpty: 'Tên đối tượng không được để trống',
  Cargo_AccountTitleNameP: 'Tên môn học:',
  Cargo_AccountTitleOfProfitNotAllocated: 'Đối tượng lợi nhuận chưa phân phối',
  Cargo_AccountTitleOfProfitNotAllocatedP: 'Đối tượng lợi nhuận chưa phân phối:',
  Cargo_AccrualDate: 'Ngày tính tiền',
  Cargo_JobAccrualDate: 'Ngày lập kế hoạch kinh doanh',
  Cargo_AccrualReview: 'Kiểm tra kế hoạch',
  Cargo_AccrualStatus: 'Trạng thái kế hoạch',
  Cargo_Accrue: 'Đề xuất',
  Cargo_Accrued: 'Đã tính toán.',
  Cargo_UsersAlreadyProvisionedToday: 'Có người dùng đã được trích lập hôm nay, vui lòng kiểm tra',
  Cargo_AccumulatedCommissionProfit: 'Lợi nhuận chiết khấu lũy kế',
  Cargo_AConsiderChangeIfOffersCheap: 'A - Hãy nghĩ về nó miễn là nó rẻ.',
  Cargo_ACPCOIM: 'Hệ thống đang thanh toán, vui lòng kiên nhẫn chờ, thử lại sau~',
  Cargo_Acquired: 'Đã đăng ký',
  Cargo_AcquireFilteredExpenseList: 'Nhận danh sách chi phí lọc',
  Cargo_Acquirer: 'Tuyển dụng',
  Cargo_AcquirerCanTBeEmpty: 'Người lãnh đạo không thể để trống.',
  Cargo_AcquireSelectedItems: 'Lấy đối tượng đã chọn',
  Cargo_AcquireTotalAROrAPAmount: 'Nhận tổng số tiền phải trả',
  Cargo_Acquisition: 'Cổ áo',
  Cargo_AcquisitionRecord: 'Đăng nhập',
  Cargo_AcquisitionTime: 'Lĩnh thời gian',
  Cargo_AcquisitionTimeCanTBeEmpty: 'Thời gian lĩnh dụng không thể để trống.',
  Cargo_ACSWASRATBTSWEAC: 'Sau khi xác nhận, hệ thống sẽ tự động đặt số tiền hòa giải giống như số tiền phí, bạn có tiếp tục không?',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: 'Tất cả số tiền đối chiếu sẽ được thiết lập dựa trên số tiền chi phí và các khoản phí được xác nhận hoặc bán sẽ bị bỏ qua, có tiếp tục không?',
  Cargo_ThereAreAlreadyExportedVouchers: 'Có chứng từ đã xuất',
  Cargo_ActualChargedWeight: 'Trọng lượng thanh toán thực tế',
  Cargo_ActualGrossWeight: 'Tổng trọng lượng thực tế',
  Cargo_ActualQuantity: 'Số mảnh thực tế',
  Cargo_ActualReceiptAmount: 'Số tiền trả góp',
  Cargo_ActualReceiptAndPayment: 'Nhận và trả',
  Cargo_ActualVolume: 'Khối lượng thực tế',
  Cargo_ActualWeight: 'Trọng lượng thực tế',
  Cargo_ActualWriteOffAmountRequired: 'Số tiền thực tế cần bán',
  Cargo_OnlyImportedCurrentBranch: 'Chi phí chỉ nhập chi nhánh hoạt động là chi nhánh hiện tại',
  Cargo_Add: 'Mới',
  Cargo_AddAdjustBill: 'Điều chỉnh tăng (Bill)',
  Cargo_AddAirBooking: 'Đặt phòng máy bay mới.',
  Cargo_AddRailwayBooking: 'Thêm đường sắt mới',
  Cargo_RailwayBooking: 'Đặt phòng đường sắt',
  Cargo_AddAirFreightServiceItems: 'Dự án dịch vụ vận chuyển hàng không mới',
  Cargo_AddAssetAccountTitle: 'Các môn tài sản mới',
  Cargo_AddAssociatedPort: 'Thêm cảng liên kết',
  Cargo_AddAwbSurcharge: 'Phí vận chuyển hàng không mới',
  Cargo_AddBasePort: 'Thêm cảng cơ bản',
  Cargo_AddBill: 'Hóa đơn mới',
  Cargo_AddBillCharge: 'Phí tham gia',
  Cargo_AddBLType: 'Các loại B/L mới',
  Cargo_AddCashFlowItem: 'Dự án Cash Flow',
  Cargo_AddCharges: 'Phí mới',
  Cargo_AddCostType: 'Thêm loại chi phí',
  Cargo_EditFeeType: 'Chỉnh sửa loại phí',
  Cargo_DeleteFeeType: 'Xóa loại phí',
  Cargo_ImportFeeType: 'Nhập loại phí',
  Cargo_SelectBusinessOperation: 'Vui lòng chọn nghiệp vụ đúng',
  Cargo_SelectSameDelegateUnit: 'Vui lòng chọn nghiệp vụ cùng đơn vị ủy thác',
  Cargo_SelectSameBusinessType: 'Vui lòng chọn nghiệp vụ cùng loại hình kinh doanh',
  Cargo_SelectSameFbaStatus: 'Vui lòng chọn nghiệp vụ có cùng trạng thái FBA',
  Cargo_SelectSameBusinessTypeWithJobNo: 'Loại hình kinh doanh không khớp: {baseJobNo} và {currentJobNo}. Vui lòng chọn nghiệp vụ cùng loại hình kinh doanh',
  Cargo_SelectSameFbaStatusWithJobNo: 'Trạng thái FBA không khớp: {baseJobNo} và {currentJobNo}. Vui lòng chọn nghiệp vụ có cùng trạng thái FBA',
  Cargo_SelectFeeType: 'Vui lòng chọn loại phí!',
  Cargo_ReceivablePayableLocked: 'Doanh nghiệp đã chọn có khoản phải thu và phải trả đã bị khóa, không thể thực hiện thao tác này!',
  Cargo_ReceivableLocked: 'Doanh nghiệp đã chọn có khoản phải thu đã bị khóa, không thể thực hiện thao tác này!',
  Cargo_PayableLocked: 'Doanh nghiệp đã chọn có khoản phải trả đã bị khóa, không thể thực hiện thao tác này!',
  Cargo_PleaseSelectTheManifestYouWishToDelete: 'Vui lòng chọn bản kê khai bạn cần xóa',
  Cargo_TheManifestYouWishToDeleteTips: '* Gợi ý ấm áp: Xóa danh sách ghép lại, phải xóa cùng một lúc trong hộp, cho nên danh sách khoang, không được xóa riêng!',
  Cargo_ConfirmDelete: 'Xác nhận xóa',
  Cargo_AddCirculationDocumentType: 'Thêm kiểu tập tin lưu',
  Cargo_AddClientType: 'Loại khách hàng mới',
  Cargo_AddCollectionRecord: 'Đăng ký nhờ thu mới',
  Cargo_AddCommissionRules: 'Quy tắc chiết khấu mới',
  Cargo_AddContinent: 'lục địa mới',
  Cargo_AddContract: 'Hợp đồng mới',
  Cargo_AddCustomizedServiceType: 'Loại Custom Business Type',
  Cargo_AddedAlreadyDoNotRepeat: 'Đã thêm và không thể thêm lại.',
  Cargo_AddedSuccessfully: 'Thành công mới.',
  Cargo_AddFees: 'Phí bổ sung',
  Cargo_AddHeadquartersToTheList: 'Thêm trụ sở chính vào.',
  Cargo_AddJournalEntry: 'Tăng mục',
  Cargo_AddKeyword: 'Thêm các từ nhạy cảm',
  Cargo_AddMscService: 'Thêm dịch vụ msc',
  Cargo_AddNewSoaOrNot: 'Báo cáo mới',
  Cargo_AddRailwayStation: 'Thêm trạm đường sắt',
  Cargo_AddressTelNo: 'Địa chỉ/Điện thoại',
  Cargo_AddressTelNoP: 'Địa chỉ, số điện thoại:',
  Cargo_AddRoute: 'Đường bay mới',
  Cargo_AddSave: 'Thêm lưu',
  Cargo_AddSeaBooking: 'Đăng ký tàu biển mới',
  Cargo_IntelligentDocumentRecognition: 'Nhận dạng sách thông minh',
  Cargo_AddSoa: 'Báo cáo mới',
  Cargo_AddToBlackList: 'Tham gia danh sách đen',
  Cargo_AdjustBillDate: 'Điều chỉnh ngày thanh toán',
  Cargo_AdjustDate: 'Điều chỉnh ngày',
  Cargo_AdjustedItem: 'Điều chỉnh mục',
  Cargo_QuickSearchCustomPage: 'Tìm kiếm nhanh: Tên biểu mẫu',
  Cargo_ApplicationScene: 'Tình huống ứng dụng',
  Cargo_CreateForm: 'Tạo biểu mẫu mới',
  Cargo_ConfigForm: 'Cấu hình biểu mẫu',
  Cargo_Branch: 'Công ty ứng dụng',
  Cargo_CopyOne: 'Vui lòng chọn một dữ liệu để sao chép!',
  Cargo_SelectDeleteTip4: 'Vui lòng chọn dữ liệu bạn cần xóa',
  Cargo_CopyFormConfirm: 'Xác nhận sao chép biểu mẫu này và tất cả thông tin cấu hình khác bao gồm bố cục khối và phần tử?',
  Cargo_CannotDeleteEnabledForm: 'Không thể xóa biểu mẫu đã được kích hoạt, vui lòng vô hiệu hóa biểu mẫu này trước',
  Cargo_FormInfo: 'Thông tin biểu mẫu',
  Cargo_CopySucceed: 'Sao chép thành công',
  Cargo_FormId: 'Số biểu mẫu',
  Cargo_FormType: 'Loại biểu mẫu',
  Cargo_AddSelectedElements: 'Thêm trường đã chọn',
  Cargo_ElementsAddedSuccessfully: 'Thêm phần tử thành công',
  Cargo_SelectPagePart: 'Chọn khu vực thông tin',
  Cargo_AddPagePart: 'Thêm khu vực thông tin',
  Cargo_ChatUser: 'Người dùng',
  Cargo_ChatAI: 'Trợ lý AI',
  Cargo_ChatInputPlaceholder: 'Gửi tin nhắn... (Enter xuống dòng, Ctrl+Enter gửi)',
  Cargo_ChatThinking: 'Đang suy nghĩ...',
  Cargo_ChatCopySuccess: 'Đã sao chép vào clipboard',
  Cargo_ChatConfirmTitle: 'Cảnh báo',
  Cargo_ChatDeleteConfirm: 'Xác nhận xóa tin nhắn này?',
  Cargo_ChatCopyFailed: 'Sao chép thất bại',
  Cargo_ChatDeleteSuccess: 'Đã xóa',
  Cargo_ChatNoResponse: 'Không nhận được phản hồi',
  Cargo_ChatConnectionError: 'Xin lỗi, kết nối có vấn đề, vui lòng thử lại',
  Cargo_Debug: 'Gỡ lỗi',
  Cargo_DebugAndConfig: 'Gỡ lỗi và cài đặt',
  Cargo_EnterValue: 'Vui lòng nhập giá trị',
  Cargo_FormNamePlaceholder: 'Vui lòng nhập tên biểu mẫu',
  Cargo_BranchPlaceholder: 'Vui lòng chọn công ty ứng dụng',
  Cargo_ApplicationScenePlaceholder: 'Vui lòng chọn tình huống ứng dụng',
  Cargo_BusinessTypePlaceholder: 'Vui lòng chọn loại nghiệp vụ',
  Cargo_RemarksPlaceholder: 'Vui lòng nhập thông tin ghi chú',
  Cargo_APIApplication: 'Ứng dụng API',
  Cargo_ConfirmMessageNotEditableAfterCreate: 'Không thể sửa đổi sau khi tạo, xác nhận vào bước tiếp theo?',
  Cargo_Tip2: 'Cảnh báo',
  Cargo_SelectDeleteTip5: 'Xác nhận xóa dữ liệu đã chọn? Thao tác này không thể hoàn tác',
  Cargo_FormDisableWarning: 'Biểu mẫu bị vô hiệu hóa sẽ không thể sử dụng, vui lòng điều chỉnh kịp thời các mô-đun sử dụng biểu mẫu này!',
  Cargo_ElementSettings: 'Cài đặt trường',
  Cargo_ElementRules: 'Quy tắc trường',
  Cargo_IsReadOnly: 'Chỉ đọc hay không',
  Cargo_IsRequired: 'Bắt buộc hay không',
  Cargo_MaxPagePartsReached: 'Đã đạt số lượng khu vực thông tin tối đa {0}',
  Cargo_InputOutputConfig: 'Cài đặt đầu vào-đầu ra',
  Cargo_FormInputConfigDescription: 'Tải biểu mẫu (Request Params): Khi tải biểu mẫu, yêu cầu giao diện theo thứ tự, xử lý các trường biểu mẫu',
  Cargo_FormInputAPI: 'Giao diện đầu vào',
  Cargo_FormInputAPIPlaceholder: 'Vui lòng nhập danh sách giao diện đầu vào',
  Cargo_FormOutputConfigDescription: 'Gửi biểu mẫu (Function Call): Khi gửi biểu mẫu, yêu cầu giao diện ứng dụng theo thứ tự',
  Cargo_FormOutputAPI: 'Giao diện đầu ra',
  Cargo_FormOutputAPIPlaceholder: 'Vui lòng nhập danh sách giao diện đầu ra',
  Cargo_PublishForm: 'Xuất bản biểu mẫu',
  Cargo_LastOperateTime: 'Thời gian thao tác cuối',
  Cargo_Draft: 'Bản nháp',
  Cargo_Published: 'Đã xuất bản',
  Cargo_ConfigPagePart: 'Cấu hình khu vực',
  Cargo_ConfigName: 'Tên cấu hình',
  Cargo_PagePartFunction: 'Chức năng khu vực',
  Cargo_PleaseSelectFunction: 'Vui lòng chọn chức năng',
  Cargo_BusinessElements: 'Trường nghiệp vụ',
  Cargo_ConsigneeShipperAndNotifyInfo: 'Thông tin người nhận-người gửi-người thông báo',
  Cargo_AccountsReceivable: 'Chi phí phải thu',
  Cargo_AccountsPayable: 'Chi phí phải trả',
  Cargo_UploadFile: 'Tải tệp lên',
  Cargo_UploadInstruction: 'Hướng dẫn tải lên',
  Cargo_InstructionParameter: 'Tham số hướng dẫn',
  Cargo_FormPreviewInListViewIsReadOnly: 'Nếu cần chỉnh sửa dữ liệu gỡ lỗi, vui lòng nhấp "Chỉnh sửa" để vào trang chi tiết',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: 'Xuất bản thành công',
  Cargo_PublishFailed: 'Xuất bản thất bại',
  Cargo_ValueRequired: 'Giá trị này không thể để trống',
  Cargo_FixFormErrors: 'Vui lòng kiểm tra xem việc Điền vào biểu mẫu có chính xác không',
  Cargo_ValidationFailed: 'Kết quả kiểm tra sai, vui lòng kiểm tra xem giá trị điền có chính xác không',
  Cargo_ToggleStatusFailed: 'Chuyển trạng thái kích hoạt biểu mẫu thất bại',
  Cargo_CopyFailed: 'Sao chép thất bại',
  Cargo_GetFormConfigFailed: 'Lấy cấu hình biểu mẫu thất bại',
  Cargo_ConfirmChangeBlockType: 'Thay đổi chức năng khu vực, xác nhận xóa nội dung cấu hình của khu vực ban đầu?',
  Cargo_ConfirmDeleteBlock: 'Xác nhận xóa khu vực này và hủy các trường đã chọn?',
  Carog_ConfirmSaveBeforeGoBack: 'Có cần lưu nội dung cấu hình hiện tại không?',
  Cargo_FormValidation: 'Kiểm tra biểu mẫu',
  Cargo_Problem: 'Vấn đề',
  Cargo_Description: 'Mô tả',
  Cargo_ValidationSucceed: 'Kiểm tra thành công',
  Cargo_NoChanges: 'Không sửa đổi dữ liệu',
  Cargo_JobUuidRequired: 'Biểu mẫu nghiệp vụ uuid không thể để trống',
  Cargo_LoadFormDataFailed: 'Tải dữ liệu biểu mẫu thất bại',
  Cargo_SyncRuleExecutionFailed: 'Lỗi thực thi quy tắc chỉnh sửa liên kết dữ liệu',
  Cargo_PreviewRevision: 'Xem trước hiệu ứng phiên bản này',
  Cargo_Current: 'Hiện tại',
  Cargo_FormPreviewInRevisionViewIsReadOnly: 'Bản xem trước hiện tại là phiên bản lịch sử và chỉ hỗ trợ chế độ chỉ đọc.',
  Cargo_VisualizationView: 'Bố trí trực quan',
  Cargo_CodeView: 'Chế độ xem mã',
  Cargo_ChatView: 'Trợ lý AI',
  Cargo_RestoreRevision: 'Khôi phục về phiên bản này',
  Cargo_RestoreSucceed: 'Khôi phục thành công',
  Cargo_RestoreFailed: 'Khôi phục thất bại',
  Cargo_ConfirmRestoreRevision: 'Xác nhận khôi phục phiên bản này?',
  Cargo_NeedAtLeastOnePagePart: 'Không thể xóa tất cả khu vực thông tin',
  Cargo_DataFill: 'Điền dữ liệu',
  Cargo_CSNInfo_BASIC: 'Thông tin người nhận-người gửi-người thông báo (tab cơ bản)',
  Cargo_CSNInfo_MBL: 'Thông tin người nhận-người gửi-người thông báo (MBL)',
  Cargo_CSNInfo_HBL: 'Thông tin người nhận-người gửi-người thông báo (HBL)',
  Cargo_CSNInfo_HBL2: 'Thông tin người nhận-người gửi-người thông báo (Hình thức đặt hàng)',
  Cargo_ReadOnly: 'Chỉ đọc',
  Cargo_Notify: 'Người thông báo',
  Cargo_AlsoNotify: 'Người thông báo thứ hai',
  Cargo_DataLoadingPleaseWait: 'กำลังโหลดข้อมูล กรุณารอสักครู่',
  Cargo_RuleID: 'รหัสกฎ',
  Cargo_ValidationRule: 'กฎการตรวจสอบ',
  Cargo_TriggerElement: 'ฟิลด์ทริกเกอร์',
  Cargo_RelatedElements: 'ฟิลด์ที่เกี่ยวข้อง',
  Cargo_TriggerCondition: 'เงื่อนไขทริกเกอร์',
  Cargo_FunctionCode: 'รหัสฟังก์ชัน',
  Cargo_AddedValidationRules: 'เพิ่มกฎการตรวจสอบต่อไปนี้แล้ว',
  Cargo_AddedSyncRules: 'เพิ่มกฎการซิงค์ต่อไปนี้แล้ว',
  Cargo_AddedVisibilityRules: 'เพิ่มกฎการแสดงผลต่อไปนี้แล้ว',
  Cargo_NoRuleDetected: 'ขออภัย ไม่พบฟังก์ชันการตรวจสอบข้อมูลหรือฟังก์ชันแก้ไขความสมาคมที่มีประสิทธิภาพ คุณสามารถลองปรับเปลี่ยนคำค้นหาและลองอีกครั้ง',
  Cargo_ConnectionError: 'ขออภัย การเชื่อมต่อมีปัญหา โปรดลองอีกครั้ง',
  Cargo_OperationArea: 'พื้นที่ดำเนินการ',
  Cargo_BlDataNotFound: 'ไม่พบข้อมูลใบตราส่งที่สอดคล้องกัน',
  Cargo_SelectBlDocument: 'กรุณาเลือกเอกสารใบตราส่ง',
  Cargo_SelectHblDocument: 'กรุณาเลือกเอกสารใบตราส่ง HBL',
  Cargo_SelectHawb2Document: 'กรุณาเลือกเอกสารแบบฟอร์ม',
  Cargo_AgentParty: 'Thông tin đại lý',
  Cargo_AdjustedOrNot: 'Điều chỉnh hay không',
  Cargo_AdjustedSuccessfully: 'Điều chỉnh thành công',
  Cargo_AdjustedValue: 'Điều chỉnh giá trị',
  Cargo_AdjustExpenseOrNot: 'Điều chỉnh chi phí',
  Cargo_AdjustFxRateEndOfPeriod: 'Điều chỉnh tỷ giá (cuối kỳ)',
  Cargo_AdjustmentDateCanTBeEmpty: 'Ngày điều chỉnh không được để trống.',
  Cargo_AdjustmentExpense: 'Chi phí điều chỉnh',
  Cargo_AdjustmentExpenseState: 'Điều chỉnh trạng thái',
  Cargo_Advance: 'Thanh toán trước',
  Cargo_AdvanceAP: 'Trả trước phải trả',
  Cargo_AdvanceAPDifferential: 'Chênh lệch phải trả trước',
  Cargo_AdvanceChargeInfo: 'Ứng trước thu hộ',
  Cargo_AdvancedSearch: 'Truy vấn nâng cao',
  Cargo_AdvanceMoneyForAnotherOrNot: 'Có nên thay đệm hay không?',
  Cargo_AdvanceOrNot: 'Có nên ứng trước hay không',
  Cargo_AdvancePayment: 'Trả trước',
  Cargo_AdvancePaymentAmount: 'Số tiền trả trước',
  Cargo_AdvancePaymentItem: 'Mục ứng trước',
  Cargo_AdvanceReceiptOrNot: 'Có thu trước hay không',
  Cargo_AdvanceReceivedAmount: 'Số tiền thu trước',
  Cargo_AdvanceReceivedAmountIs: 'Số tiền thu trước là:',
  Cargo_AEBPWTCW1Y: 'AAA: Có quan hệ đối tác cố định không thay đổi trong vòng một năm',
  Cargo_AEFTSIST: 'Xuất khẩu hàng không Thượng Hải tương tự như',
  Cargo_AEIMBOUF: 'Cập nhật thất bại và chi phí đã được sửa đổi bởi người khác.',
  Cargo_AEIMBOUFM: 'Việc cập nhật không thành công và chi phí đã được người khác sửa đổi.',
  Cargo_AGEBDAWI: 'Điều chỉnh chi phí phát sinh tự động khi lập hóa đơn chênh lệch.',
  Cargo_AgentBillNo: 'Số hóa đơn của nhau',
  Cargo_Aging: 'Sổ sách (ngày)',
  Cargo_AgingOfCurrentBill: 'Khi tuổi vé',
  Cargo_Agree: 'Đồng ý',
  Cargo_AILCNETOCERCTS: 'Số tiền bản vị không tương đương với tỷ giá hối đoái * tiền gốc, bạn có tiếp tục giữ không?',
  Cargo_Air: 'Hàng không',
  Cargo_AirExport: 'Xuất khẩu hàng không',
  Cargo_AirImport: 'Nhập khẩu hàng không',
  Cargo_AirImportExport: 'Vận chuyển hàng không',
  Cargo_Airline: 'Đường bay',
  Cargo_AirlineCode: 'Mã đường bay',
  Cargo_AirlineCompany: 'Hãng hàng không',
  Cargo_ShippingCompanyName: 'Tên công ty tàu/tiếng Anh',
  Cargo_ShippingCompanyCode: 'Mã công ty tàu',
  Cargo_ShippingCompanyScacCode: 'Hãng tàu SCAC Code',
  Cargo_ShippingCompanyChineseName: 'Name',
  Cargo_ShippingCompanyEnglishName: 'Tên công ty tàu trong tiếng Anh',
  Cargo_DataDuplication: 'Dữ liệu đã tồn tại, đừng thêm lại',
  Cargo_AdditionFailed: 'Lỗi mới',
  Cargo_DeleteShipCompany: 'Xác nhận rằng bạn muốn xóa thông tin đã chọn? <br>Gợi ý ấm áp: sau khi xóa người thuê liên quan đến việc xóa thuyền trưởng mặc định trống',
  Cargo_AssociatedPlatformShippingCompany: 'Công ty Platform Ships',
  Cargo_ShipCompanyThirdPartyCode: 'Mã bên thứ ba của hãng tàu',
  Cargo_MblCode: 'Mã vận đơn',
  Cargo_AirlinePerson: 'Trang chủ',
  Cargo_Airport: 'Cảng hàng không',
  Cargo_AirportOfDischarge: 'Cảng hàng không (Airport)',
  Cargo_AirService: 'Dự án dịch vụ vận chuyển hàng không',
  Cargo_AlertConfiguration: 'Cấu hình nhắc nhở',
  Cargo_AlertDaysPriorToExpiryDate: 'Ngày hết hạn còn lại * Ngày nhắc nhở',
  Cargo_All: 'Tất cả',
  Cargo_AllB: '(Tất cả)',
  Cargo_AllP: '【Tất cả】',
  Cargo_AllAmount: 'Tổng số',
  Cargo_AllAmountP: 'Tổng số:',
  Cargo_AllCurrencies: 'Tất cả tiền tệ',
  Cargo_AllForeignCurrencies: 'Tất cả ngoại tệ',
  Cargo_AllSelectedBillsWrittenOff: 'Các hóa đơn được chọn đã được bán hết.',
  Cargo_AllSelectedRecordsConfirmed: 'Tất cả hồ sơ đã chọn đã được xác nhận.',
  Cargo_AllSelectedSoaWrittenOff: 'Báo cáo đã chọn đã được bán hết.',
  Cargo_WithoutDiscrepancies: 'Không có sự khác biệt',
  Cargo_AllWithWithoutDiscrepancies: 'Tất cả có sự khác biệt/không có sự khác biệt',
  Cargo_AllWrittenOff: 'Hết hàng rồi.',
  Cargo_AlreadyAddedOrNot: 'Đã thêm chưa',
  Cargo_AmendmentFee: 'Chi phí thay đổi',
  Cargo_Amount: 'Số lượng',
  Cargo_AmountF: 'Số tiền.',
  Cargo_AmountCanTBeEmpty: 'Số tiền không được để trống',
  Cargo_AmountCanTBeZero: 'Số tiền không thể bằng 0.',
  Cargo_AmountCNY: 'Số tiền (CNY)',
  Cargo_AmountCNYP: 'Số lượng CNY:',
  Cargo_AmountEnteredForReconciliation: 'Số lượng đối chiếu đã nhập',
  Cargo_AmountIncurredOfCurrentPeriod: 'Số tiền phát sinh trong kỳ này',
  Cargo_AmountInOriginalCurrency: 'Số tiền ban đầu',
  Cargo_AmountNotWrittenOff: 'Số tiền chưa bán',
  Cargo_AmountNumber: 'Số lượng',
  Cargo_AmountNumberP: 'Số lượng:',
  Cargo_AmountOfActualCollectionPayment: 'Số tiền trả thật',
  Cargo_AmountOfCurrentMonth: 'Số tiền trong tháng',
  Cargo_AmountOfPaidInOutOfPocket: 'Số tiền thu và nhận thực tế',
  Cargo_AmountOfPaymentApplication: 'Số lượng ứng dụng',
  Cargo_AmountRange: 'Khoảng tiền',
  Cargo_AmountRemark: 'Ghi chú chi phí',
  Cargo_AmountSum: 'Tổng số tiền',
  Cargo_AmountTo: 'Tổng cộng',
  Cargo_AmountToDetail: 'Tổng chi tiết',
  Cargo_CurrentMonthAmountTo: 'Tháng này cộng',
  Cargo_CurrentYearAmountTo: 'Tổng cộng năm nay',
  Cargo_TotalReportingCurrencyOfThisMonth: 'Tổng số tiền trong tháng',
  Cargo_TotalReportingCurrencyOfThisYear: 'Năm nay tổng số tiền',
  Cargo_AmountToCNY: 'Tổng cộng (CNY)',
  Cargo_AmountToP: 'Tổng cộng:',
  Cargo_AmountToUSD: 'Tổng cộng (USD)',
  Cargo_AmountUSD: 'Số tiền USD',
  Cargo_AmountUSDP: 'Số tiền USD:',
  Cargo_AmsEnsCyCutOffDate: 'Ngày đóng cửa AMS/ENS',
  Cargo_Annual: 'Hàng năm',
  Cargo_AolAir: 'Sân bay khởi hành',
  Cargo_AOPLVCTBE: 'Chứng từ lỗ không được để trống',
  Cargo_APAR: 'Đối phó phải thu',
  Cargo_APBill: 'Thanh toán hóa đơn',
  Cargo_APEOFINNPPARFV: 'Vui lòng kiểm tra, các khoản phí phải trả cho các số hóa đơn sau đây chưa hoàn thành phê duyệt thanh toán: \n',
  Cargo_APInclusive: 'Bao gồm chi phí phải trả',
  Cargo_APInvoice: 'Hóa đơn phải trả',
  Cargo_Appendix: 'Trang đính kèm',
  Cargo_Applicant: 'Ứng viên',
  Cargo_ApplicationDateApplicationDate: 'Ngày nộp đơn Ngày nộp đơn',
  Cargo_ApplicationDateBusinessDate: 'Ngày đăng ký Ngày kinh doanh',
  Cargo_ApplicationFormSavedSuccessfully: 'Ứng dụng đã được lưu thành công!',
  Cargo_ApplicationNo: 'Đơn xin số',
  Cargo_ApplicationNoBill: 'Không có hóa đơn cho đơn yêu cầu số {0} và số doanh nghiệp {1}',
  Cargo_ApplicationPermission: 'Quyền áp dụng',
  Cargo_ApplicationStatus: 'Tình trạng ứng tuyển',
  Cargo_AppliedForPaymentOrNot: 'Đã yêu cầu thanh toán chưa',
  Cargo_ApplyForPayment: 'Yêu cầu thanh toán',
  Cargo_Approval: 'Phê duyệt thông qua',
  Cargo_ApprovalStatus: 'Trạng thái phê duyệt',
  Cargo_Approved: 'Kiểm toán',
  Cargo_ApprovedBy: 'Người kiểm tra',
  Cargo_ApprovedStatue: 'Trạng thái xem lại',
  Cargo_April: 'Tháng Tư',
  Cargo_APWriteOff: 'Tài khoản phải trả',
  Cargo_APWriteOffAmount: 'Số tiền phải trả',
  Cargo_APWrittenOff: 'Đối phó với pin',
  Cargo_APWrittenOffP: 'Đối phó với bán:',
  Cargo_ARAges: 'Tuổi tài khoản',
  Cargo_ARAmountCanTExceedAPAmount: 'Chi phí phải thu không được lớn hơn chi phí phải trả.',
  Cargo_ARAP: 'Phải thu phải trả',
  Cargo_ARAPItemsMustBeComplete: 'Chi phí phải thu phải nhập đầy đủ.',
  Cargo_ARBill: 'Thanh toán',
  Cargo_ARegularExportVolume20TeuMonthly: 'A. Xuất khẩu hàng hóa ổn định 20TEU mỗi tháng.',
  Cargo_ARInvoice: 'Phải thu hóa đơn',
  Cargo_ARIPFCSC: 'Tư Duệ ứng thu hóa đơn đẩy đi thất bại:',
  Cargo_ARNotWrittenOff: 'Phải thu không bán',
  Cargo_ARNotWrittenOffP: 'Phải thu chưa bán:',
  Cargo_AROrNot: 'Có nên nhận hay không',
  Cargo_InvoiceAROrNot: 'Hóa đơn có nên thu hay không',
  Cargo_ArrivalDate: 'Ngày đến cảng',
  Cargo_ArrivalTime: 'Thời gian đến cảng',
  Cargo_ARWriteOffAmount: 'Số tiền bán phải thu',
  Cargo_ARWrittenOff: 'Cần bán',
  Cargo_ARWrittenOffP: 'Phải thu đã bán:',
  Cargo_ASRCCTD: 'Tất cả hồ sơ đã được xác nhận và không thể từ chối',
  Cargo_AssessedClientLevel: 'Đánh giá khách hàng',
  Cargo_AssignedClientsSuccessfully: 'Phân phối thành công {0} khách hàng',
  Cargo_AssignmentDate: 'Ngày phân phối',
  Cargo_AssignToMe: 'Phân bổ cho tôi',
  Cargo_AssociatedPort: 'Cảng liên kết',
  Cargo_ATCIJECTBE: 'Mã hóa các mục phân loại không được để trống.',
  Cargo_AttachedDocuments: 'Tài liệu đính kèm',
  Cargo_Attachment: 'Phụ kiện',
  Cargo_AttachmentP: 'Phụ kiện:',
  Cargo_AttachmentInvoice: 'Phụ kiện hóa đơn',
  Cargo_AttachmentStorage: 'Lưu trữ phụ kiện',
  Cargo_Audit: 'Đánh giá',
  Cargo_AuditDate: 'Ngày đánh giá',
  Cargo_Auditor: 'Đánh giá',
  Cargo_AuditorP: 'Đánh giá bởi:',
  Cargo_AuditStatus: 'Trạng thái kiểm toán',
  Cargo_AuditSuccessfully: 'Kiểm toán thành công',
  Cargo_AuditSuccessfullyF: 'Xét duyệt thành công.',
  Cargo_Guarantee: 'Bảo lãnh',
  Cargo_GuaranteeName: 'Tên bảo lãnh',
  Cargo_GuaranteeType: 'Loại bảo lãnh',
  Cargo_August: 'Tháng Tám',
  Cargo_AuthorizedClient: 'Đơn vị ủy thác',
  Cargo_AvailableBranch: 'Chi nhánh có sẵn',
  Cargo_AuthorizedCubage: 'Khối lượng ủy quyền',
  Cargo_AuthorizedQuantity: 'Số lượng delegate',
  Cargo_AutomaticallyEnterInvoiceNumber: 'Tự động nhập số hóa đơn',
  Cargo_AutomaticGenerated: 'Tự động tạo',
  Cargo_AvailableOrNot: 'Có sẵn hay không',
  Cargo_AverageMonthlyCargoVolume: 'Vận chuyển hàng tháng',
  Cargo_AwaitBusinessApproval: 'Chờ phê duyệt nghiệp vụ',
  Cargo_AwaitFinancialApproval: 'Chờ phê duyệt tài chính',
  Cargo_Back: 'Quay lại',
  Cargo_BackgroundParameter: 'Tham số nền',
  Cargo_BackgroundProcessing: 'Đang xử lý nền',
  Cargo_BackgroundReturnedErrorStatus: 'Background trả về trạng thái lỗi',
  Cargo_BackToCancel: 'Quay lại Hủy',
  Cargo_BackToInvoicingStatus: 'Trở lại trạng thái thanh toán',
  Cargo_BackToProcessingMethod: 'Quay lại phương pháp xử lý',
  Cargo_BackToSearchResults: 'Quay lại kết quả truy vấn',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: 'Số dư',
  Cargo_BalanceCalculation: 'Tính toán số dư',
  Cargo_BalanceCNY: 'Số dư (CNY)',
  Cargo_BalanceDirection: 'Hướng cân bằng',
  Cargo_BalanceOfActualCollectionPayment: 'Số dư thanh toán thực',
  Cargo_BalanceSheet: 'Bảng cân đối kế toán',
  Cargo_BalanceSheet2: 'Bảng cân đối kế toán 2',
  Cargo_BalancesOfAccountTitle: 'Bảng cân đối đối tượng',
  Cargo_BalancesOfAccountTitle2: 'Bảng cân đối đối tượng 2',
  Cargo_BalanceUSD: 'Số dư (USD)',
  Cargo_BangPic: 'Ảnh vào kho',
  Cargo_Bank: 'Ngân hàng',
  Cargo_BankAccount: 'Số tài khoản ngân hàng',
  Cargo_BankAccountBalance: 'Số dư ngân hàng',
  Cargo_BankAccountNo: 'Số tài khoản ngân hàng',
  Cargo_BankOfPayment: 'Ngân hàng thanh toán',
  Cargo_BankReceiptDetails: 'Chi tiết hóa đơn nước',
  Cargo_BankReceiptNo: 'Ngân hàng nước',
  Cargo_ReceiptNo: 'Số nước',
  Cargo_BankReceiptRecord: 'Đăng ký hóa đơn nước',
  Cargo_BankReceiptStatus: 'Trạng thái nước',
  Cargo_BaseCurrency: 'Tiền tệ Benchmark',
  Cargo_BasePort: 'Cảng cơ sở',
  Cargo_Basic: 'Cơ bản',
  Cargo_ExternalInterface: 'Giao diện ngoài',
  Cargo_Blacklisted: 'Đã bị thêm vào danh sách đen!',
  Cargo_BasicInfo: 'Thông tin cơ bản',
  Cargo_BasicInformation: 'Thông tin cơ bản',
  Cargo_BasisForGrouping: 'Điều kiện nhóm',
  Cargo_BatchAudit: 'Kiểm toán hàng loạt',
  Cargo_BatchCancelAudit: 'Hủy kiểm toán hàng loạt',
  Cargo_BatchCancelConfirmation: 'Hủy xác nhận hàng loạt',
  Cargo_BatchConfirm: 'Xác nhận hàng loạt',
  Cargo_BatchDelete: 'Xóa hàng loạt',
  Cargo_BatchDownload: 'Tải xuống hàng loạt',
  Cargo_BatchEnterModifyBusinessOrderNo: 'Nhập hàng loạt Sửa đổi số đơn kinh doanh',
  Cargo_BatchNo: 'Số lô',
  Cargo_BatchNoOfCollection: 'Số lô ủy thác',
  Cargo_BatchNoP: 'Số lô:',
  Cargo_BatchPrint: 'In hàng loạt',
  Cargo_BatchProcessing: 'Hoạt động hàng loạt',
  Cargo_BatchRetrieval: 'Lấy hàng loạt',
  Cargo_BatchRetrievalButtonTrigger: 'Kích hoạt nút lấy hàng loạt',
  Cargo_BatchRevokeRetrieval: 'Thu hồi hàng loạt',
  Cargo_BatchTransfer: 'Gửi hàng loạt',
  Cargo_BelowBillingAmountsIncorrect: 'Số tiền hóa đơn sau đây có sai sót:',
  Cargo_Bill: 'Thanh toán',
  Cargo_BillCanTBeEmpty: 'Hóa đơn không được để trống.',
  Cargo_BillConfirmed: 'Hóa đơn đã được xác nhận.',
  Cargo_BillConfirmedM: '[0] Hóa đơn đã được xác nhận.',
  Cargo_BillDate: 'Ngày thanh toán',
  Cargo_DueDate: 'Ngày hết hạn thanh toán',
  Cargo_BillDeleteAdjustment: 'Hóa đơn - Xóa điều chỉnh',
  Cargo_BillDeletedSuccessfully: 'Xóa thành công {0} hóa đơn',
  Cargo_BilledOrNot: 'Đã lập hóa đơn chưa',
  Cargo_BillingAmount: 'Số tiền thanh toán',
  Cargo_BillingCurrency: 'Thanh toán tiền tệ',
  Cargo_BillingData: 'Dữ liệu thanh toán',
  Cargo_BillingDetails: 'Chi tiết hóa đơn',
  Cargo_BillingExpenditure: 'Chi phí thanh toán',
  Cargo_BillingExpenditureDetails: 'Chi tiết hóa đơn',
  Cargo_BillingExpense: 'Chi phí thanh toán',
  Cargo_BillingMethod: 'Phương thức thanh toán',
  Cargo_BillingRevenue: 'Thu nhập hóa đơn',
  Cargo_BillingRevenueExpenseDetails: 'Chi tiết thu nhập hóa đơn',
  Cargo_BillInvoiced: '[{0}] Hóa đơn đã được thanh toán',
  Cargo_BillIssued: 'Hóa đơn',
  Cargo_BillList: 'Danh sách thanh toán',
  Cargo_BillNo: 'Số hóa đơn',
  Cargo_BillNoP: 'Số hóa đơn:',
  Cargo_BillNotSelected: 'Không có hóa đơn nào được chọn.',
  Cargo_BillPaidInFullCanTRepeatWriteOff: 'Các hóa đơn đã được thanh toán đầy đủ và không thể được bán lại.',
  Cargo_BillStatus: 'Tình trạng thanh toán',
  Cargo_BillTo: 'Đối tượng thanh toán',
  Cargo_BillType: 'Loại hóa đơn',
  Cargo_BillWrittenOff: '[{0}] Hóa đơn đã được bán',
  Cargo_Blacklist: 'Danh sách đen',
  Cargo_BLControl: 'Quản lý vận đơn',
  Cargo_BLMAEONRS: 'Phương thức vận đơn đã tồn tại hoặc không có hồ sơ nào được chọn',
  Cargo_BLMethodMaintenance: 'Bảo trì phương pháp B/L',
  Cargo_BLMode: 'Phương pháp B/L',
  Cargo_BLNo: 'Số vận đơn',
  Cargo_BLReleaseManagement: 'Quản lý đặt hàng',
  Cargo_MBLReleaseManagement: 'Quản lý vận đơn chính',
  Cargo_HBLReleaseManagement: 'Quản lý vận đơn thả',
  Cargo_BLReleaseReview: 'Kiểm tra đặt hàng',
  Cargo_MBLReleaseReview: 'Kiểm tra đơn đặt hàng chính',
  Cargo_HBLReleaseReview: 'Kiểm toán theo đơn đặt hàng',
  Cargo_BLReleaseReviewStatus: 'Trạng thái kiểm tra đặt hàng',
  Cargo_BlReleasingNo: 'Đặt số đơn',
  Cargo_BlReleasingNoP: 'Đặt số đơn:',
  Cargo_BLRemoteReleaseFee: 'Phí đặt cọc đất khách',
  Cargo_BLRetrieved: 'B/L có được lấy lại hay không',
  Cargo_BLType: 'Loại B/L',
  Cargo_HBLType: 'Loại HBL B/L',
  Cargo_BNASPCTBBE: 'Số doanh nghiệp và đối tượng thanh toán không được để trống',
  Cargo_BNTTPRS: 'Số lô {0} Chuyển sang đăng ký trả trước thành công',
  Cargo_BOECTBCIWBII: 'Vui lòng chọn thống nhất phí trong nước/nước ngoài để tạo hóa đơn',
  Cargo_Booking: 'Đặt phòng',
  Cargo_BookingAgent: 'Đại lý đặt phòng',
  Cargo_BookingAgentAbbreviation: 'Đại lý đặt khoang',
  Cargo_BookingAgentCode: 'Đại lý đặt phòng (Mã)',
  Cargo_BookingNo: 'Số đặt phòng',
  Cargo_BookingOrderNotExistCanTBeAdded: 'Việc bổ sung thất bại, đơn đặt hàng không tồn tại.',
  Cargo_BookingWindow: 'Đặt/Thay đổi cửa sổ đơn',
  Cargo_BookKeeper: 'Trang chủ',
  Cargo_BookKeepingDate: 'Ngày kế toán',
  Cargo_BookKeepingMethod: 'Phương thức kế toán',
  Cargo_BookKeepingVoucher: 'Chứng từ kế toán',
  Cargo_BOPIOOPCTBLT: 'Số dư thanh toán thực tế không được nhỏ hơn {0}',
  Cargo_BOPIOOPCTBLTCWOA: 'Số dư thu chi thực tế không thể nhỏ hơn số tiền tiêu thụ hạt nhân lần này.',
  Cargo_BPHCCTBWO: 'Hóa đơn {0} đang chờ bán hạt nhân tại trụ sở chính và hiện không thể bán được.',
  Cargo_BranchBill: 'Thanh toán chi nhánh',
  Cargo_BranchCMP: 'Chi nhánh',
  Cargo_BranchCMPP: 'Chi nhánh:',
  Cargo_BranchCompany: 'Chi nhánh trực thuộc',
  Cargo_BranchConfirmation: 'Chi nhánh xác nhận',
  Cargo_BranchConfirmed: 'Chi nhánh đã xác nhận',
  Cargo_BranchFilter: 'Chi nhánh lọc',
  Cargo_BREVB20TM: 'B. Xuất khẩu ổn định hơn dưới 20TEU',
  Cargo_BRNPNACW: 'Số tham chiếu kinh doanh/Số mục/Trọng lượng thanh toán thực tế',
  Cargo_BrokenDesc: 'Mô tả thiệt hại hàng hóa',
  Cargo_BrokenNumberDetection: 'Phát hiện số ngắt',
  Cargo_Browse: 'Duyệt......',
  Cargo_BRTSIOC: 'Giá rẻ nên cân nhắc giới thiệu cho sếp',
  Cargo_BSNMIR: 'Tình trạng kinh doanh không đáp ứng yêu cầu lập hóa đơn',
  Cargo_BSNMPCR: 'Tình trạng kinh doanh không đáp ứng yêu cầu thanh toán.',
  Cargo_BSNMWOR: 'Tình trạng kinh doanh không phù hợp với yêu cầu bán hàng',
  Cargo_BulkCargo: 'Hàng tạp hóa',
  Cargo_BURCNBE: 'Các doanh nghiệp được xem xét không thể được chỉnh sửa',
  Cargo_Business: 'Kinh doanh',
  Cargo_BusinessAdjustment: 'Điều chỉnh kinh doanh',
  Cargo_BusinessAdjustmentLog: 'Nhật ký điều chỉnh kinh doanh',
  Cargo_BusinessApproval: 'Phê duyệt kinh doanh',
  Cargo_BusinessApprovalDate: 'Ngày phê duyệt kinh doanh',
  Cargo_BusinessApproved: 'Đã được phê duyệt kinh doanh',
  Cargo_OfficeApproved: 'Đã được phê duyệt thương mại',
  Cargo_BusinessCategory: 'Loại hình kinh doanh',
  Cargo_BusinessCharacteristic: 'Đặc điểm kinh doanh',
  Cargo_BusinessCommission: 'Chiết khấu kinh doanh',
  Cargo_BusinessCreateDate: 'Ngày thành lập doanh nghiệp',
  Cargo_BusinessCreator: 'Người sáng lập doanh nghiệp',
  Cargo_BusinessDate: 'Ngày kinh doanh',
  Cargo_BusinessDateBusinessDate: 'Ngày kinh doanh Ngày kinh doanh',
  Cargo_BusinessDateP: 'Ngày kinh doanh:',
  Cargo_BusinessDocNo: 'Số doanh nghiệp',
  Cargo_BusinessDocNo2: 'Đơn hàng kinh doanh 2',
  Cargo_BusinessDocNoP: 'Số đơn nghiệp vụ:',
  Cargo_BusinessHappenDate: 'Ngày kinh doanh',
  Cargo_BusinessHappenDateP: 'Ngày kinh doanh:',
  Cargo_BusinessInformation: 'Thông tin doanh nghiệp',
  Cargo_BusinessModel: 'Mô hình kinh doanh',
  Cargo_BusinessNo: 'Số doanh nghiệp',
  Cargo_BusinessNoInBill: '(Bill) Số doanh nghiệp',
  Cargo_BusinessNotSelected: 'Không có doanh nghiệp nào được chọn.',
  Cargo_BusinessReferenceNo: 'Số tham chiếu doanh nghiệp',
  Cargo_GenerateNumberOfBusiness: 'Tạo số bản sao kinh doanh',
  Cargo_UpdateBusinessAgain: 'Sửa đổi Generation Business',
  Cargo_Business_CustomerRefNo: 'Số tham chiếu doanh nghiệp/khách hàng',
  Cargo_BusinessStatus: 'Tình trạng kinh doanh',
  Cargo_BusinessStatusChangeLog: 'Thay đổi trạng thái kinh doanh',
  Cargo_DataPushResultRecords: 'Dữ liệu Push Results Record',
  Cargo_SendType: 'Loại gửi',
  Cargo_ReissueFees: 'Chi phí tái phát',
  Cargo_ReissueFeesTips: 'Nhấp vào nút này sẽ gửi lại tất cả các khoản phí gửi không thành công.',
  Cargo_BusinessType: 'Loại hình kinh doanh',
  Cargo_BusinessTypeP: 'Loại hình kinh doanh:',
  Cargo_BusinessTypeCanTBeEmpty: 'Loại hình kinh doanh không được để trống',
  Cargo_BusinessTypeInconsistent: 'Loại hình kinh doanh không phù hợp',
  Cargo_ButtonPermissionControl: 'Nút điều khiển quyền',
  Cargo_BuyingPrice: 'Giá bán',
  Cargo_BWNBCAED: 'Bạn sẽ không còn có thể tạo doanh nghiệp sau khi hết hạn hợp đồng.',
  Cargo_ByBill: 'bởi Bill',
  Cargo_ByDetail: 'Theo phân tích',
  Cargo_ByInvoice: 'Theo hóa đơn',
  Cargo_ByInvoiceFxRate: 'Theo tỷ giá hóa đơn',
  Cargo_ByJob: 'Theo doanh nghiệp',
  Cargo_ByJobNo: 'Theo số doanh nghiệp',
  Cargo_ByPaymentRequestFxRate: 'Yêu cầu tỷ giá hối đoái theo thanh toán',
  Cargo_BySettlementAgent: 'Thông qua đại lý thanh toán',
  Cargo_CAEONRS: 'Tiền tệ đã tồn tại hoặc không được chọn',
  Cargo_CAIFCINFCAUU: 'Chọn hạch toán ngoại tệ. Nếu không có ngoại tệ thì phán đoán theo đô - la Mỹ.',
  Cargo_CAIOCPCRY: 'Bên cho vay phát sinh kỳ này (NDT)',
  Cargo_CAIOCPUSD: 'Số tiền phát sinh trong kỳ này (USD)',
  Cargo_CalculateBalance: 'Tính số dư',
  Cargo_CalculateBalanceTotalToWriteOff: 'Tính tổng số dư bán được',
  Cargo_CalculateBillingAmount: 'Tính toán số tiền thanh toán',
  Cargo_CalculatedInOriginalCurrency: 'Tính bằng đồng tiền gốc',
  Cargo_CalculateTaxRate: 'Tính thuế suất',
  Cargo_CallbackFunction: 'Chức năng callback',
  Cargo_CanBeConfirmedOrNot: 'Có thể xác nhận',
  Cargo_CanBeDeletedOrNot: 'Có thể gỡ bỏ',
  Cargo_CanBePrintedOrNot: 'Có thể in',
  Cargo_CanBeVoidedOrNot: 'Có thể hủy bỏ hay không',
  Cargo_CANCA: 'Thanh toán bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ bù trừ',
  Cargo_Cancel: 'Hủy bỏ',
  Cargo_CancelAccrue: 'Hủy bỏ kế hoạch',
  Cargo_CancelAudit: 'Hủy kiểm toán',
  Cargo_NewCustomerApplication: 'Đơn đăng ký khách hàng mới',
  Cargo_NewSupplierApplication: 'Đơn đăng ký nhà cung cấp mới',
  Cargo_RequiredFields: 'Vui lòng điền vào các trường bắt buộc tương ứng của biểu mẫu',
  Cargo_SelectTradeType: 'Vui lòng chọn loại hình giao dịch',
  Cargo_CancelCheckOfSelectedRecord: 'Xác nhận hồ sơ hủy bỏ lựa chọn xem lại không?',
  Cargo_CancelClosure: 'Hủy đóng cửa',
  Cargo_CancelConfirm: 'Hủy xác nhận',
  Cargo_CancelCurrentModification: 'Hủy sửa đổi thông tin hiện tại',
  Cargo_CancelDefaultsInBatch: 'Bỏ mặc định hàng loạt',
  Cargo_CancelEditing: 'Hủy chỉnh sửa',
  Cargo_CancelGetBack: 'Thu hồi',
  Cargo_CancelIgnore: 'Bỏ qua',
  Cargo_CancelMark: 'Bỏ thẻ',
  Cargo_CancelMerging: 'Hủy hợp nhất',
  Cargo_CancelModification: 'Hủy sửa đổi hiện tại?',
  Cargo_CancelPublishment: 'Hủy đăng',
  Cargo_DownloadImportTemplate: 'Tải về mẫu nhập khẩu',
  Cargo_CancelReconciliation: 'Hủy đối chiếu',
  Cargo_CancelReturn: 'Hủy trả lại',
  Cargo_CancelSuccessfully: 'Hủy bỏ thành công.',
  Cargo_CancelTheChargesAudit: 'Hủy kiểm tra chi phí',
  Cargo_CancelWriteOff: 'Thu hồi bán hàng',
  Cargo_CanNotProcessUnsavedNewExpense: 'Không thể xử lý các khoản phí mới chưa được lưu.',
  Cargo_CanNotRedoCancellation: 'Không thể lặp lại đăng xuất.',
  Cargo_CanNotRemoveAllBills: 'Không thể xóa toàn bộ hóa đơn.',
  Cargo_CanOnlyRetrieveAfterDelivered: 'Đã đưa ra mới có thể lấy lại!',
  Cargo_CanTDeleteItemsWithInvoiceNo: 'Đã nhập số hóa đơn, không thể xóa.',
  Cargo_CanTDeleteWrittenOffItem: 'Đã bán, không thể xóa',
  Cargo_CanTEditClosedItem: 'Đã thanh toán không thể chỉnh sửa.',
  Cargo_CanTRepeatVoiding: '【{0}】 Đã hết hiệu lực, không còn hiệu lực nữa',
  Cargo_CanTSelectInvoiceNoForEInvoice: 'Hóa đơn điện tử không thể chọn số hóa đơn.',
  Cargo_CanTSplitInvoicedItem: 'Đã lập hóa đơn, không thể chia ra!',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: 'Không có số hóa đơn, không thể hủy bỏ hóa đơn!',
  Cargo_CanTVoidWrittenOffItem: '【{0}】 đã được bán, không thể hủy bỏ.',
  Cargo_CAOPWWT: 'Tính giá thuế chưa bao gồm giá thuế',
  Cargo_Cargo: 'Hàng hóa',
  Cargo_Remark: 'Ghi chú hàng hóa',
  Cargo_Remark_Check: 'Ghi chú hàng hóa chỉ được nhập tối đa 3999 ký tự bao gồm chữ hoa/chữ thường, số và ký tự đặc biệt: !"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s',
  Cargo_CargoDetention: 'Khấu trừ hàng hóa',
  Cargo_CargoInfo: 'Thông tin hàng hóa',
  Cargo_CargoName: 'Tên sản phẩm',
  Cargo_CargoNature: 'Tài sản hàng hóa',
  Cargo_CargoType: 'Loại hàng hóa',
  Cargo_CAROJE: 'Cấu hình quy tắc tóm tắt mục',
  Cargo_CarriedOver: 'Đã kết nối',
  Cargo_Carrier: 'Hãng vận chuyển',
  Cargo_Carrier_Ship: 'Hãng tàu (Ship Company)',
  Cargo_Carrier_Air: 'Hãng hàng không (airlines)',
  Cargo_Carrier_Railway: 'Người vận chuyển (đại lý cửa khẩu)',
  Cargo_CarrierAgent: 'Đại diện tàu',
  Cargo_CarrierShip: 'Công ty tàu',
  Cargo_CarryOverForeignExchange: 'Trao đổi',
  Cargo_CarryOverInitialized: 'Name',
  Cargo_CarryOverProfitLoss: 'Lợi nhuận chuyển',
  Cargo_CarryOverProfitLoss2: 'Lợi nhuận chuyển sang 2.',
  Cargo_CarryOverToNextPeriod: 'Chuyển sang phần tiếp theo.',
  Cargo_CartonQuantity: 'Loại hộp Số lượng hộp',
  Cargo_TicketCount: 'Số phiếu',
  Cargo_Cash: 'Tiền mặt',
  Cargo_CasualClientNonCasualClient: 'Khách lẻ/Không khách lẻ',
  Cargo_NonCasualClient: 'Không khách lẻ',
  Cargo_CasualClientOrNot: 'Khách lẻ',
  Cargo_Category: 'Danh mục',
  Cargo_CategoryOfPartner: 'Loại đối tác',
  Cargo_CATISExport: 'Xuất khẩu thuế vàng',
  Cargo_CATISInvalid: 'Thuế vàng hủy bỏ',
  Cargo_CATISPrint: 'In thuế vàng',
  Cargo_CBEIPCPTSINACSRANMPC: 'Hóa đơn điện tử chi nhánh hiện tại: Mã nền tảng/Mật khẩu/Số nhận dạng người nộp thuế/Mã ủy quyền/Địa chỉ yêu cầu dịch vụ chưa được bảo trì, vui lòng kiểm tra.',
  Cargo_CBEIPCTSINACSRANMPC: 'Hóa đơn điện tử chi nhánh hiện tại: Mã nền tảng/Số nhận dạng người nộp thuế/Mã ủy quyền/Địa chỉ yêu cầu dịch vụ chưa được bảo trì, vui lòng kiểm tra.',
  Cargo_CBFCEBD: 'Tạo hóa đơn phí đã xác nhận theo mặc định',
  Cargo_CBISAWTSNM: 'Địa chỉ dịch vụ giao diện hệ thống thuế chi nhánh hiện tại không được duy trì.',
  Cargo_CBTSINNM: 'Số nhận dạng người nộp thuế chi nhánh hiện tại không được duy trì.',
  Cargo_CCOCM: 'Xác định hủy bỏ sửa đổi hiện tại?',
  Cargo_CCOPLV: 'Tạo ra chứng từ tổn thất kết chuyển thành công:',
  Cargo_CCRAIOC: 'Giá rẻ nên cân nhắc đổi đại lý',
  Cargo_CCS: 'Hủy xác nhận thành công.',
  Cargo_CDOPRI: 'Xác định thông tin yêu cầu từ chối thanh toán',
  Cargo_Cent: 'Phân chia',
  Cargo_AndTo: '{0} đến {1}',
  Cargo_AlreadyHere: 'Đến rồi',
  Cargo_IsOver: '♪ Đã qua rồi ♪',
  Cargo_CERNM: 'Tiền tệ ({0}) Tỷ giá hối đoái không được duy trì',
  Cargo_CFCNAPM: 'Đối tượng không tính toán ngoại tệ hiện tại: {0}, vui lòng sửa đổi.',
  Cargo_CGS1RV: 'Bán hàng cướp khách hàng thành công! Kiểm tra thành công {0} hồ sơ.',
  Cargo_ChangeContent: 'Thay đổi nội dung',
  Cargo_ChangeInvoiceTitle: 'Thay đổi Invoice Head',
  Cargo_ChangeInvoiceTitleP: 'Thay đổi Invoice Head:',
  Cargo_ChangeSob: 'Thay đổi tài khoản',
  Cargo_ChangeTo: 'Thay đổi',
  Cargo_ChangeToP: 'Thay đổi:',
  Cargo_Charge: 'Nhận',
  Cargo_Chargeback: 'Thanh toán',
  Cargo_ChargebackFile: 'Tài liệu hoàn trả',
  Cargo_ChargeDetails: 'Chi tiết chi phí',
  Cargo_ChargedWeight: 'Trọng lượng thanh toán',
  Cargo_ChargeName: 'Tên chi phí',
  Cargo_ChargeOriginalAmount: 'Giá gốc',
  Cargo_ChargeOriginalCurrency: 'Phí tiền tệ gốc',
  Cargo_ChargeOriginalExchangeRate: 'Tỷ giá hối đoái gốc',
  Cargo_ChargesAudit: 'Kiểm toán chi phí',
  Cargo_ChargesContactPerson: 'Chi phí liên hệ',
  Cargo_ChargesReject: 'Phí từ chối',
  Cargo_ChargeStatus: 'Tình trạng chi phí',
  Cargo_ChargesTotalAmount: 'Tổng số chi phí',
  Cargo_ChargeType: 'Loại phí',
  Cargo_ChargeTypeP: 'Loại phí:',
  Cargo_CHBRNFOA: 'Hợp đồng đã được gia hạn và cấm hoạt động',
  Cargo_CheckAccountInForeignCurrency: 'Chọn tài khoản ngoại tệ',
  Cargo_CheckChargeDetailBranch: 'Chi nhánh nơi dữ liệu đang hoạt động không thuộc chi nhánh hiện tại hoặc chi nhánh cấp cao hơn.',
  Cargo_CheckCreateBillWay: 'Đối tượng thanh toán hoặc đại lý thanh toán phải đáp ứng một điều tương tự',
  Cargo_CheckInvoiceQueryBranch: 'Chi nhánh hiện đang hoạt động không phù hợp với chi nhánh phân bổ dữ liệu, vui lòng truy vấn lại để xử lý lại dữ liệu.',
  Cargo_CheckClientToExtendValidPeriod: 'Vui lòng chọn khách hàng cần gia hạn trước.',
  Cargo_CheckIfSoaFullyWrittenOff: 'Kiểm tra xem báo cáo có bán hết không.',
  Cargo_CheckingStatus: 'B/L xác nhận trạng thái',
  Cargo_HblCheckingStatus: 'HBL B/L xác nhận trạng thái',
  Cargo_CheckingURLStatus: 'Trạng thái đơn',
  Cargo_CheckInvoice: 'Thanh toán hóa đơn',
  Cargo_CheckWriteOffDetails: 'Kiểm tra chi tiết bán hàng',
  Cargo_ChineseCargoName: 'Tên Trung Quốc',
  Cargo_StatusUpdateTime: 'Thời gian thay đổi trạng thái vận đơn',
  Cargo_StatusUpdateUser: 'Thay đổi trạng thái vận đơn',
  Cargo_ChineseFirstVesselName: 'Tên tàu',
  Cargo_ChineseName: 'Tên Trung Quốc',
  Cargo_ChineseNameCanTBeEmpty: 'Tên Trung Quốc không được để trống',
  Cargo_ChineseNameOfSettlingParty: 'Name',
  Cargo_Choose0P: 'Chọn 0:',
  Cargo_ChooseByText: 'Chọn theo văn bản',
  Cargo_ChooseFee: 'Phí lựa chọn',
  Cargo_ChooseFeeCNY: 'Chọn phí RMB',
  Cargo_ChooseFeeUSD: 'Chọn phí USD',
  Cargo_ChooseInvoicedFee: 'Chọn có phí hóa đơn',
  Cargo_ChooseP: 'Chọn {0}:',
  Cargo_TicketCount: 'Số phiếu: ',
  Cargo_CIIRSBATTB: 'Xác nhận có nên thêm yêu cầu lập hóa đơn trong hóa đơn hay không',
  Cargo_CIMJ: 'Thông tin chuyển phát nhanh',
  Cargo_CIMS: 'Nhờ thu thông tin sửa đổi thành công.',
  Cargo_City: 'Thành phố sở hữu',
  Cargo_CityCode: 'Mã thành phố',
  Cargo_CityMaintenance: 'Bảo trì thành phố',
  Cargo_CityName: 'Tên thành phố',
  Cargo_CityNotSelected: 'Thành phố chưa chọn',
  Cargo_CityP: 'Thành phố',
  Cargo_Claim: 'Yêu cầu',
  Cargo_ClaimAdvanceReceipt: 'Nhận tiền trước',
  Cargo_ClaimAR: 'Yêu cầu bồi thường phải thu',
  Cargo_ClaimBankReceipt: 'Nhận hóa đơn nước',
  Cargo_ClaimDate: 'Ngày nhận',
  Cargo_ClaimedBy: 'Người nhận',
  Cargo_ClaimInformation: 'Yêu cầu thông tin',
  Cargo_ClaimOrNot: 'Có nhận hay không',
  Cargo_ClaimState: 'Tình trạng yêu cầu',
  Cargo_ClaimStatusOfAdvanceReceipt: 'Tình trạng yêu cầu (Pre-Receive)',
  Cargo_ClaimStatusOfAR: 'Tình trạng nhận (cần nhận)',
  Cargo_Clear: 'Xoá',
  Cargo_ClearData: 'Xóa dữ liệu',
  Cargo_ClearFilter: 'Xóa bộ lọc',
  Cargo_ClickToFilter: 'Click để lọc',
  Cargo_ClickToLoadParameter: 'Nhấp vào nút để tải tham số truy vấn',
  Cargo_ClickToQuery: 'Nhấn nút để truy vấn',
  Cargo_ClientAllocationStatus: 'Tình trạng phân bổ khách hàng',
  Cargo_CLientCantBeEmpty: 'Khách hàng không được để trống',
  Cargo_ClientContract: 'Hợp đồng khách hàng',
  Cargo_ClientEventNotSelected: 'Sự kiện khách hàng Chưa chọn',
  Cargo_ClientList: 'Danh sách khách hàng',
  Cargo_ClientMovedToRecycleBin: 'Khách hàng được chuyển đến Recycle Bin',
  Cargo_ClientNo: 'Số khách hàng',
  Cargo_ClientOverseasAgent: 'Khách hàng/Đại lý ở nước ngoài',
  Cargo_ClientStatus: 'Tình trạng khách hàng',
  Cargo_ClientSVisit: 'Khách hàng ghé thăm',
  Cargo_ClientVendor: 'Khách hàng/Nhà cung cấp',
  Cargo_Close: 'Đóng cửa',
  Cargo_Close2: 'Thu gọn',
  Cargo_CloseAccount: 'Thanh toán',
  Cargo_CloseAccount2: 'Thanh toán 2',
  Cargo_CloseAccountOrNot: 'Thanh toán hay không',
  Cargo_CloseDateOfContainerReturn: 'Trả lại ngày kết thúc',
  Cargo_CloseDetailWindow: 'Đóng cửa sổ Chi tiết',
  Cargo_CloseWindow: 'Đóng cửa sổ',
  Cargo_ClosureNo: 'Số kết thúc',
  Cargo_ClosureTimeSelection: 'Lựa chọn thời gian kết thúc',
  Cargo_ClosureTitleOfAccount: 'Kết thúc chủ đề',
  Cargo_CNY: 'Nhân dân tệ',
  Cargo_CNYHKD: 'CNY/HKD',
  Cargo_CNYInvoiceNo: 'Số hóa đơn CNY',
  Cargo_CNYP: 'Nhân dân tệ:',
  Cargo_COACP: 'Tiền thật và thanh toán',
  Cargo_Code: 'Mã số',
  Cargo_CodeCanTBeEmpty: 'Mã không thể rỗng',
  Cargo_DuplicateCode: 'Mã lặp lại, vui lòng nhập lại.',
  Cargo_CodeNotMaintained: 'Mã hóa không được bảo trì.',
  Cargo_CodeOfExpenseDescription: 'Phí Tên Mã',
  Cargo_CodeSearching: 'Mã truy xuất',
  Cargo_CodeType: 'Loại mã hóa',
  Cargo_CodeTypeP: 'Loại mã hóa:',
  Cargo_Coding: 'Mã hóa',
  Cargo_ApCoding: 'Đối phó với mã hóa',
  Cargo_ArCoding: 'Mã hóa cần thu',
  Cargo_CodingMapping: 'Bản đồ mã hóa',
  Cargo_CodingP: 'Mã hóa:',
  Cargo_Collect: 'Nhận',
  Cargo_CollectAndPrepaidOrNot: 'Có nên ứng trước hay không?',
  Cargo_CollectedExpenseDetails: 'Chi tiết chi phí ủy thác',
  Cargo_CollectedExpenseDetailsP: 'Chi phí đã gửi gắm:',
  Cargo_CollectedInFull: 'Đã thu thập đủ.',
  Cargo_CollectedNotCollectedInFull: 'Đã thu thập/Chưa thu thập',
  Cargo_CollectFormation: 'Thông tin thu tiền',
  Cargo_CollectInvoice: 'Nhận vé',
  Cargo_Collection: 'Thu nhập',
  Cargo_CollectionCNY: 'Nhận CNY',
  Cargo_CollectionDetails: 'Chi tiết chi phí ủy thác',
  Cargo_CollectionDifference: 'Sự khác biệt về thu nhập',
  Cargo_CollectionInformation: 'Thông tin thu',
  Cargo_CollectionPayment: 'Nhận thanh toán',
  Cargo_CollectionPaymentCleared: 'Thanh toán đã được thanh toán',
  Cargo_CollectionPaymentDate: 'Ngày nhận thanh toán',
  Cargo_CollectionPaymentInformation: 'Thông tin nhận thanh toán',
  Cargo_CollectionPaymentMethod: 'Phương thức nhận thanh toán',
  Cargo_CollectionPaymentTypeFilter: 'Loại thanh toán Lọc',
  Cargo_CollectionRecordByCarrier: 'Hồ sơ nhờ thu của công ty tàu',
  Cargo_CollectionSituation: 'Tình hình thu tiền',
  Cargo_CollectionStatus: 'Tình trạng thu',
  Cargo_CollectionUSD: 'Nhận USD',
  Cargo_CoLoadConsol: 'Ủy quyền LCL',
  Cargo_ColorOfControllingRow: 'Kiểm soát màu dòng',
  Cargo_CombinedInvoicing: 'Hợp nhất hóa đơn',
  Cargo_CombinedListNo: 'Số danh sách vé',
  Cargo_Commission: 'Hoa hồng',
  Cargo_CommissionAmount: 'Số tiền rút',
  Cargo_CommissionedGrossWeight: 'Tổng trọng lượng ủy thác',
  Cargo_CommissionItems: 'Mục hoa hồng',
  Cargo_CommissionOrNot: 'Hoa hồng hay không',
  Cargo_CommissionPercentage: 'Tỷ lệ chiết khấu',
  Cargo_CommissionRules: 'Quy tắc rút tiền',
  Cargo_CommodityCode: 'Mã sản phẩm',
  Cargo_CommodityInspection: 'Kiểm tra thương mại',
  Cargo_CommonlyUsedTradeTerms: 'Điều khoản thương mại phổ biến',
  Cargo_Company: 'Công ty',
  Cargo_CompanySelfRelease: 'Công ty tự đặt hàng',
  Cargo_CompanySReceivingAccountNumber: 'Số tài khoản công ty',
  Cargo_CompanySReceivingBank: 'Ngân hàng thu tiền doanh nghiệp',
  Cargo_Competitor: 'Công ty cạnh tranh',
  Cargo_Completed: 'Hoàn thành',
  Cargo_CompleteDate: 'Ngày kết thúc',
  Cargo_CompletedOrNot: 'Đã hoàn thành',
  Cargo_CompleteWriteOff: 'Hoàn toàn nucleopin',
  Cargo_CompletionTime: 'Thời gian hoàn thành',
  Cargo_ConditionOfSearch: 'Điều kiện tìm kiếm',
  Cargo_ConditionType: 'Loại điều kiện',
  Cargo_ConfiCNYill: 'Xác nhận hóa đơn',
  Cargo_ConfigureAccountTitle: 'Thiết lập đối tượng',
  Cargo_Confirm: 'Xác định',
  Cargo_AMSEnsChannel: 'Nhà cung cấp bản kê khai chống khủng bố ENS',
  Cargo_SkipAll: 'Bỏ qua tất cả',
  Cargo_SecondFlightSchedule: 'Thời gian chuyến bay 2',
  Cargo_TwoWayFreighter: 'Máy bay chở hàng 2 chiều',
  Cargo_EmailFormatError: 'Lỗi định dạng hộp thư',
  Cargo_CountryOfShipment: 'Quốc gia khởi hành',
  Cargo_AirFreightRateDetails: 'Chi tiết vận chuyển hàng không',
  Cargo_ConfirmAndCheckSelectedRecord: 'Ghi chép về lựa chọn xem lại có được xác nhận không?',
  Cargo_ConfirmAP: 'Xác nhận chi phí phải trả',
  Cargo_ConfirmCancellationOfRecord: 'Bạn có chắc chắn về Remove record?',
  Cargo_ConfirmCombinedInvoice: 'Xác định thanh toán hợp nhất',
  Cargo_ConfirmDate: 'Ngày xác nhận',
  Cargo_Confirmed: 'Xác nhận',
  Cargo_ConfirmedSuccessfully: 'Xác nhận thành công.',
  Cargo_ConfirmExpenses: 'Xác nhận chi phí',
  Cargo_ConfirmNotification: 'Nhắc nhở xác nhận',
  Cargo_ConfirmOffset: 'Xác nhận pin cặp',
  Cargo_ConfirmOrNot: 'Xác nhận',
  Cargo_ConfirmPartial: 'Xác nhận một phần',
  Cargo_ConfirmR: 'Xác nhận',
  Cargo_ConfirmRQ: 'Xác nhận?',
  Cargo_ConfirmRemarks: 'Ghi chú xác nhận',
  Cargo_ConfirmSelectedItem: 'Xác nhận lựa chọn',
  Cargo_ConfirmStatus: 'Xác nhận trạng thái',
  Cargo_ConfirmSubmissionOfPaymentOrder: 'Xác định gửi thông báo thanh toán?',
  Cargo_ConfirmWriteOff: 'Xác định doanh thu',
  Cargo_ConfirmWriteOffQ: 'Xác nhận tiêu thụ không?',
  Cargo_ConfirmWrittenOffExpense: 'Xác nhận chi phí bán hàng',
  Cargo_ConflictExpenseDetails: 'Chi tiết chi phí xung đột',
  Cargo_Consignation: 'Trang chủ',
  Cargo_ConsignationCompanyCannotBeNull: 'Đơn vị ủy quyền không được để trống',
  Cargo_Consignee: 'Người nhận hàng',
  Cargo_ConsigneeId: 'Mã nhận hàng',
  Cargo_ConsigneeInfo: 'Thông tin người nhận hàng',
  Cargo_ConsigneeSName: 'Tên người nhận hàng',
  Cargo_ConsignorSCode: 'Đơn vị ủy quyền (Mã)',
  Cargo_ConsolidatedCNY: 'Tổng hợp (NDT)',
  Cargo_ConsolidatedCurrency: 'Đồng tiền hợp nhất',
  Cargo_ConsolidatedLocalCurrency: 'Tiền bản vị tổng hợp',
  Cargo_ConsolidatedLocalCurrencyCNY: 'Tổng hợp bản vị tệ (NDT)',
  Cargo_ConsolidatedProfitLossIs: 'Hối đoái tổn hại là:',
  Cargo_ConsolidateOrNot: 'Trở về hay không',
  Cargo_Contact: 'Liên hệ',
  Cargo_ContactNumber: 'Số điện thoại',
  Cargo_ContainerAmount: 'Số lượng hộp',
  Cargo_ContainerDescription: 'Mô tả khối lượng hộp',
  Cargo_ContainerInfo: 'Thông tin đóng gói',
  Cargo_ContainerNo: 'Số hộp',
  Cargo_ContainerSize: 'Loại hộp',
  Cargo_ContainerType: 'Loại hộp',
  Cargo_ContainerRule: 'Hộp thước',
  Cargo_ContainerTypeCanTBeEmpty: 'Loại hộp không thể rỗng',
  Cargo_ContainerTypeMaintenance: 'Bảo trì giống hộp',
  Cargo_ContainerTypeSea: 'Loại đánh vần đầy đủ (bằng đường biển)',
  Cargo_ContentDescription: 'Mô tả nội dung',
  Cargo_ContentFailedToLoad: 'Tải nội dung thất bại',
  Cargo_ContentFailedToLoadP: 'Tải nội dung thất bại:',
  Cargo_ContentOfAmount: 'Số lượng nội dung',
  Cargo_ContentOfExpenseDescription: 'Chi phí Tên Nội dung',
  Cargo_ContentPreviewOfPaymentNotice: 'Xem thử nội dung thông báo rút tiền',
  Cargo_Continent: 'lục địa',
  Cargo_ContinueToAddData: 'Tiếp tục thêm dữ liệu',
  Cargo_ContinueToSave: 'Tiếp tục tiết kiệm',
  Cargo_ContinuousFilter: 'Lọc liên tục',
  Cargo_Contra: 'Đối với Pin',
  Cargo_ContraAmount: 'Số lượng pin',
  Cargo_ContraAmountP: 'Số tiền bán hàng:',
  Cargo_ContraBalance: 'Cân bằng pin',
  Cargo_ContractAdministrator: 'Quản trị hợp đồng',
  Cargo_ContractConfiguration: 'Cấu hình hợp đồng',
  Cargo_Contracted: 'Đã ký',
  Cargo_ContractedClientInformation: 'Đăng ký thông tin khách hàng',
  Cargo_ContractExpired: 'Hợp đồng hết hạn',
  Cargo_ContractNumber: 'Số hợp đồng',
  Cargo_ContractNumberCanTBeEmpty: 'Số hợp đồng không được để trống',
  Cargo_ContractRateProperty: 'Tính chất xấp xỉ',
  Cargo_ContractSignedSuccessfully: 'Đăng ký thành công',
  Cargo_ContractStatus: 'Tình trạng hợp đồng',
  Cargo_RiskReason: 'Lý do kiểm soát rủi ro',
  Cargo_ContractValidStatus: 'Hợp đồng có hiệu lực hay không',
  Cargo_ContractTerms: 'Điều khoản hợp đồng',
  Cargo_CurrentCredit: 'Tín hiệu hiện tại',
  Cargo_ContractCredit: 'Tín dụng hợp đồng',
  Cargo_ContractType: 'Loại hợp đồng',
  Cargo_ConversionAmountContent: 'Số tiền chiết khấu',
  Cargo_ConversionAmountInCNY: 'Tỷ giá CNY',
  Cargo_ConversionRMB: 'Tương đương RMB',
  Cargo_ConversionAP: 'Tương ứng đối phó',
  Cargo_ConversionAPCNY: 'Đối phó với CNY',
  Cargo_ConversionPaidCNY: 'CNY trả tiền',
  Cargo_ConversionAPCurrency: '{0} đối phó',
  Cargo_ConversionAR: 'Tương ứng phải thu',
  Cargo_ConversionARCNY: 'CNY nhận',
  Cargo_ConversionReceivedCNY: 'CNY đã nhận',
  Cargo_ConversionARCurrency: 'Tương ứng {0} sẽ được nhận',
  Cargo_ConversionCurrencyAmount: 'Số tiền chiết khấu',
  Cargo_ConversionOutstandingAR: 'Tương đương không thu',
  Cargo_ConversionOutstandingARCNY: 'CNY không nhận',
  Cargo_ConversionOutstandingARCurrency: 'Không nhận {0}',
  Cargo_ConversionOutstandingReceivedCurrency: '{0} Đã nhận',
  Cargo_ConversionProfit: 'Lợi nhuận tương đương',
  Cargo_ConversionProfitCNY: 'Lợi nhuận CNY',
  Cargo_ConversionProfitCNYP: 'Lợi nhuận CNY:',
  Cargo_ConversionWriteOffAmountInCNY: 'B5-05=giá trị thông số Kd, (cài 2)',
  Cargo_COPLOCP: 'Kết chuyển kỳ này tổn hại',
  Cargo_Copy: 'Sao chép',
  Cargo_CopyAndAddPoItems: 'Sao chép Thêm',
  Cargo_CopyExchangeRate: 'Sao chép tỷ giá hối đoái',
  Cargo_CopyFromExisting: 'Mới dựa trên sổ sách hiện có',
  Cargo_InitializeLevelOneSubject: 'Khởi tạo chủ đề cấp 1',
  Cargo_InitializeReport: 'Khởi tạo báo cáo',
  Cargo_Cost: 'Chi phí',
  Cargo_CostInvoiceNo: 'Số hóa đơn chi phí',
  Cargo_CounterpartySBankAccount: 'Tài khoản đối phương',
  Cargo_CounterpartySBillingNo: 'Số hóa đơn của nhau',
  Cargo_Country: 'Quốc gia',
  Cargo_CountryMaintenance: 'Bảo trì quốc gia',
  Cargo_CountryRegion: 'Quốc gia (khu vực)',
  Cargo_CountryRegionCode: 'Mã quốc gia (Regional Code)',
  Cargo_CourierOrderNo: 'Số đơn chuyển phát nhanh',
  Cargo_CPIOOPRCCTBV: 'Hồ sơ thanh toán thực tế hiện tại đã được kiểm tra lại, không thể hủy bỏ.',
  Cargo_CPIOOPRVCTBM: 'Hiện nay ghi chép thực thu đã bị hủy bỏ, không thể bị sửa đổi!',
  Cargo_CPIOOPRWOCTBV: 'Hiện tại hồ sơ thực thu thực trả đã có hồ sơ tiêu thụ hạt nhân, không thể hủy bỏ.',
  Cargo_Create: 'Tạo',
  Cargo_uploadErr: 'Tải lên không thành công',
  Cargo_CreateAndExportDirectly: 'Xuất trực tiếp sau khi tạo',
  Cargo_CreateBill: 'Tạo hóa đơn',
  Cargo_BatchCreateBill: 'Tạo hóa đơn hàng loạt',
  Cargo_BatchCreateBillTitle: 'Vui lòng chọn phạm vi dữ liệu',
  Cargo_BatchCreateBillBySame: 'Chi phí của cùng một đối tượng giải quyết sẽ tạo ra một hóa đơn',
  Cargo_BatchCreateBillByAll: 'Tất cả hồ sơ đã được tìm thấy.',
  Cargo_BatchCreateBillBySelected: 'Bản ghi đã chọn',
  Cargo_BatchCreateBillSuccess: 'Hoạt động thành công: Đồng tạo {0} hóa đơn',
  Cargo_CreateBillQ: 'Tạo hóa đơn hay không',
  Cargo_CreateCombination: 'Kết hợp Generation',
  Cargo_CreateCostInvoice: 'Tạo hóa đơn chi phí hay không',
  Cargo_CreatedBy: 'Đăng nhập',
  Cargo_CreatedDate: 'Ngày tạo',
  Cargo_CreatedSuccessfully: 'Thành công mới!',
  Cargo_CreateInvoice: 'Tạo hóa đơn',
  Cargo_CreateListOfCombinedInvoices: 'Tạo và danh sách vé',
  Cargo_CreateOffsetExpense: 'Tạo phí bảo hiểm rủi ro',
  Cargo_CreatePaymentRequest: 'Tạo đơn yêu cầu thanh toán',
  Cargo_CreatePaymentRequestChooseFees: 'Tạo yêu cầu thanh toán - Chọn phí',
  Cargo_CreatePaymentRequestDetails: 'Tạo yêu cầu thanh toán - Chi tiết',
  Cargo_BasicPaymentRequest: 'Yêu cầu thanh toán (phiên bản cơ bản)',
  Cargo_PendingSupervisorApproval: 'Chờ phê duyệt của giám sát',
  Cargo_PaymentRequestSettings: 'Cài đặt yêu cầu thanh toán',
  Cargo_EnableUICustomization: 'Bật hiển thị tùy chỉnh UI',
  Cargo_AdditionalApprovalNode: 'Nút phê duyệt bổ sung',
  Cargo_DepartmentApprovalTab: 'Phê duyệt bộ phận (hiển thị tab chờ phê duyệt bộ phận)',
  Cargo_SupervisorApprovalTab: 'Phê duyệt giám sát (hiển thị tab chờ phê duyệt giám sát)',
  Cargo_PreApproval: 'Kiểm tra trước',
  Cargo_FinanceApproval: 'Kiểm tra tài chính',
  Cargo_OperationReview: 'Rà soát hoạt động',
  Cargo_DepartmentReview: 'Rà soát bộ phận',
  Cargo_SupervisorReview: 'Rà soát giám sát',
  Cargo_RuleBasedApproval: 'Chỉ tài liệu đáp ứng quy tắc mới vào tab này để phê duyệt bổ sung',
  Cargo_NonRuleBypass: 'Cho phép tài liệu không đáp ứng quy tắc cụ thể không cần phê duyệt giám sát',
  Cargo_Settings: 'Cài đặt',
  Cargo_PendingDepartmentApproval: 'Chờ phê duyệt của bộ phận',
  Cargo_AllPaymentRequests: 'Yêu cầu thanh toán (tất cả)',
  Cargo_SupervisorReviewer: 'Người rà soát giám sát',
  Cargo_SupervisorReviewDate: 'Ngày rà soát giám sát',
  Cargo_SettlementUnitContractStatus: 'Tình trạng hợp đồng đơn vị thanh toán',
  Cargo_ReturnToPreviousApprovalNode: 'Có trở lại nút phê duyệt trước đó hay không',
  Cargo_CreateSoa: 'Tạo báo cáo',
  Cargo_CreateVoucher: 'Tạo chứng từ',
  Cargo_Creator: 'Tạo bởi',
  Cargo_Credit: 'Cho vay',
  Cargo_CreditAmount: 'Số lượng credit',
  Cargo_CreditAmount2: 'Số tiền tín dụng',
  Cargo_CreditAmountCNY: 'Bên cho vay (NDT)',
  Cargo_CreditAmountOccurred: 'Số tiền phát sinh tín dụng',
  Cargo_CreditAmountOccurredCNY: 'Mức phát sinh của bên cho vay (NDT)',
  Cargo_CreditAmountOccurredP: 'Số tiền phát sinh của bên cho vay:',
  Cargo_CreditAmountOccurredUSD: 'Số tiền phát sinh tín dụng (USD)',
  Cargo_CreditAmountTo: 'Credit tổng cộng',
  Cargo_CreditAmountToP: 'Credit tổng cộng:',
  Cargo_CreditAmountUSD: 'Tín dụng (USD)',
  Cargo_CreditControlDetails: 'Chi tiết kiểm soát tín dụng',
  Cargo_CreditControlSettings: 'Thiết lập Tín dụng',
  Cargo_CreditLimitExceeded: 'Hạn mức vượt quá',
  Cargo_CreditLimitRange: 'Phạm vi dòng',
  Cargo_CreditLocalCurrency: 'Tiền bản vị tín dụng',
  Cargo_CreditNotWrittenOff: 'Credit chưa bán',
  Cargo_CreditOriginalAmount: 'Credit số tiền ban đầu',
  Cargo_CreditSide: 'Tín dụng',
  Cargo_CreditUsed: 'Hạn mức sử dụng',
  Cargo_CreditWriteOffAmount: 'Credit Số tiền bán hàng',
  Cargo_CREVB5TM: 'C. Xuất khẩu ổn định trong vòng 5TEU mỗi tháng',
  Cargo_CRPI: 'Xác định phải đăng ký ứng trước?',
  Cargo_CSNPM: 'Bảo trì thông tin Telecom',
  Cargo_CSR: 'Nhà điều hành',
  Cargo_CSRGTIDDDI: 'Kết quả của truy vấn hiện tại lớn hơn số thanh hiển thị và dữ liệu không được hiển thị đầy đủ.',
  Cargo_CSWTCSTR: 'Khách hàng này đã ký hợp đồng và có thể chọn khách hàng này để gia hạn',
  Cargo_CTMCWOPCCF: 'Tài khoản đã được kiểm tra lại không thể sửa đổi, xin hủy bỏ kiểm tra lại trước.',
  Cargo_CTOPR: 'Xác định chuyển sang đăng ký ứng trước?',
  Cargo_CTORI: 'Xác định quay lại đối chiếu?',
  Cargo_CTRCWOPCCF: 'Tài khoản đã được kiểm tra lại không thể hủy bỏ, xin hãy hủy bỏ kiểm tra lại trước.',
  Cargo_CTRLSPFCC: 'Xác nhận việc bán hàng giải phóng ràng buộc khách hàng',
  Cargo_Cubage: 'Khối lượng',
  Cargo_Currency: 'Tiền tệ',
  Cargo_CurrencyCanTBeEmpty: 'Tiền không thể để trống',
  Cargo_CurrencyFXRateNoMaintained: 'Tỷ giá hối đoái cho đồng tiền 【{0}】 không được duy trì!',
  Cargo_CurrencyInconsistent: 'Tiền tệ không nhất trí.',
  Cargo_CurrencyMaintenance: 'Bảo trì tiền tệ',
  Cargo_CurrencyOfPayment: 'Tiền tệ thanh toán',
  Cargo_CurrencyOfTotal: 'Tổng tiền tệ',
  Cargo_CurrencyP: 'Tiền tệ:',
  Cargo_CurrentClientIsContracted: 'Khách hàng hiện tại đã đăng ký',
  Cargo_CurrentExchangeRate: 'Tỷ giá hối đoái hiện tại',
  Cargo_CurrentLoginUser: 'Đăng nhập hiện tại',
  Cargo_CurrentMonth: 'Tháng hiện tại',
  Cargo_CurrentSelected: 'Chọn hiện thời',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: 'Hiển thị đặc tính hàng hóa',
  Cargo_ShowCharacteristicsTip: 'Khi chọn loại hàng hóa hiện tại, hộp đánh dấu "Live" "Magnetic" Liquid""Powder"được hiển thị thêm trên trang cơ bản',
  Electric: 'Trực tiếp',
  Magnetic: 'Với Magnetic',
  Powder: 'Bột',
  Liquid: 'Chất lỏng',
  Cargo_CurrentSelectedExpense: 'Chi phí được chọn hiện tại {0}',
  Cargo_CurrentSelectedSobIs: 'Tài khoản được chọn hiện tại là: {0}',
  Cargo_CurrentSettlingParty: 'Đối tượng thanh toán hiện tại',
  Cargo_CurrentWriteOffSerialNoCompleted: 'Số lượng tiêu thụ lần này là {0}, tiêu thụ thành công.',
  Cargo_CurrentYearAccumulatedAmount: 'Số tiền tích lũy trong năm',
  Cargo_CurrentYearProfitAccount: 'Chủ đề lợi nhuận năm nay',
  Cargo_CurrentYearProfitAccountP: 'Đối tượng lợi nhuận năm nay:',
  Cargo_CurrentYearTotal: 'Tích lũy năm nay',
  Cargo_CurrentYearTotalAmout: 'Tổng số phát sinh trong năm nay',
  Cargo_CurrentYearTotalAmoutCreditCNY: 'Năm nay, tổng số tiền phát sinh (NDT)',
  Cargo_CurrentYearTotalAmoutCreditUSD: 'Tín dụng phát sinh tích lũy trong năm (USD)',
  Cargo_CurrentYearTotalAmoutDebitCNY: 'Tổng số tiền phát sinh trong năm nay (NDT)',
  Cargo_CurrentYearTotalAmoutDebitUSD: 'Nợ phát sinh tích lũy trong năm (USD)',
  Cargo_CursorPointedInvoiceNo: 'Con trỏ định vị số hóa đơn',
  Cargo_Customer: 'Khách hàng',
  Cargo_CustomerAddress: 'Địa chỉ khách hàng',
  Cargo_CustomerHasConfirm: 'Khách hàng đã xác nhận.',
  Cargo_CustomerLevel: 'Cấp độ khách hàng',
  Cargo_CustomerName: 'Tên khách hàng',
  Cargo_CustomerP: 'Khách hàng:',
  Cargo_CustomerProperty: 'Tài sản khách hàng',
  Cargo_CustomerReferenceNumber: 'Số tham chiếu khách hàng',
  Cargo_CustomerSelfRelease: 'Khách hàng tự đặt hàng',
  Cargo_CustomerService: 'Dịch vụ',
  Cargo_CustomerSpace2: 'Hàng hóa được chỉ định',
  Cargo_CustomerSpace3: 'Trang chủ',
  Cargo_CustomerType: 'Loại khách hàng',
  Cargo_Customized: 'Tùy chỉnh',
  Cargo_CustomizedField1: 'Trường tùy chỉnh 1',
  Cargo_CustomizedField2: 'Trường tùy chỉnh 2',
  Cargo_CustomizedField3: 'Trường tùy chỉnh 3',
  Cargo_CustomizedField4: 'Trường tùy chỉnh 4',
  Cargo_CustomJobType: 'Loại hình kinh doanh tùy chỉnh',
  Cargo_CustomJobTypeP: 'Loại hình kinh doanh tùy chỉnh',
  Cargo_CustomsApproval: 'Phê duyệt hải quan',
  Cargo_CustomsBroker: 'Nhà môi giới hải quan',
  Cargo_CustomsBrokerFilter: 'Bộ lọc môi giới hải quan',
  Cargo_CustomsDeclaration: 'Khai báo hải quan',
  Cargo_CustomsDeclarationSearchFailed: 'Truy vấn thông tin khai hải quan thất bại:',
  Cargo_CustomsNo: 'Số hải quan',
  Cargo_CWOIFCTTTEPRCOEA: 'Nhờ thu đã tiêu thụ toàn bộ hạt nhân, không thể chuyển tiếp chi phí, xin làm nhờ thu hoặc xin chi phí khác.',
  Cargo_CYCutOffDate: 'Ngày đóng cửa',
  Cargo_CYSPATIPLVCTBE: 'Chứng từ lợi nhuận năm nay không được để trống',
  Cargo_CYWRYTTPPATDWBMTRS: 'Nhấp vào Yes để chuyển đến trang in và sửa đổi chứng từ thành trạng thái hoàn trả',
  Cargo_CYWRYTTPPATRDWBCTRS: 'Nhấp vào Yes để chuyển đến trang in và các chứng từ đã được thu hồi được thay đổi thành trạng thái hoàn trả.',
  Cargo_DAIIUCTBD: '【Điều chỉnh chênh lệch】 đã được sử dụng cho doanh nghiệp và không thể xóa',
  Cargo_DAIOCPCNY: 'Bên vay nợ kỳ này (NDT)',
  Cargo_DAIOCPUSD: 'Số dư nợ phát sinh trong kỳ này (USD)',
  Cargo_DataExport: 'Xuất',
  Cargo_DataExportPDF: 'Xuất PDF',
  Cargo_DataSent: 'Thông tin đã gửi',
  Cargo_DataTransmissionStatus: 'Trạng thái gửi dữ liệu',
  Cargo_DataType: 'Kiểu dữ liệu',
  Cargo_DataTypeP: 'Kiểu dữ liệu:',
  Cargo_Date: 'Ngày',
  Cargo_DateCanTBeEmpty: 'Ngày không được để trống',
  Cargo_DateFrom: 'Ngày bắt đầu',
  Cargo_DateFunction: 'Chức năng ngày',
  Cargo_DateNotInPeriod: 'Ngày không có trong khoảng thời gian',
  Cargo_DateOfApplication: 'Ngày đăng ký',
  Cargo_DateOfCollectionCanTBeEmpty: 'Ngày thu tiền không được để trống.',
  Cargo_DateOfDeclaration: 'Ngày khai báo',
  Cargo_DateOfDepartureCannotBeNull: 'Ngày khởi hành không được để trống',
  Cargo_DateOfDocument: 'Ngày sản xuất',
  Cargo_DateOfInvoicingList: 'Danh sách thanh toán Ngày',
  Cargo_DateP: 'Ngày:',
  Cargo_DateType: 'Kiểu ngày',
  Cargo_DateType2: 'Loại ngày 2',
  Cargo_Days: 'Ngày',
  Cargo_DaysFromContractSigned: 'Số ngày đăng ký',
  Cargo_DaysOfSleep: 'Số ngày ngủ',
  Cargo_DaysOverdue: 'Ngày quá hạn',
  Cargo_DaysToContractExpiry: 'Số ngày sắp hết hạn',
  Cargo_DBASBEICS: 'Tài khoản ngân hàng cần được mặc định trống khi chọn tiền mặt',
  Cargo_Deadline: 'Ngày kết thúc',
  Cargo_TempCredit: 'Tín hiệu tạm thời',
  Cargo_EtdDays: 'Số ngày dự kiến khởi hành',
  Cargo_EtdExceedsDays: 'ETD vượt quá {0} ngày, không thể cấp số hiệu.',
  Cargo_EtdExceedsDaysOrder: 'ETD vượt quá {0} ngày, không thể phát hành chứng từ (vận đơn).',
  Cargo_ShippingDocumentsNotBeReleased: 'Chứng từ vận chuyển sẽ không được phát hành cho đến khi tất cả cước phí tồn đọng được thanh toán.',
  Cargo_SpecialFeePaymentLimit: 'Hạn chế đối với việc đề nghị thanh toán chi phí chuyên dụng',
  Cargo_PaymentOnlySpecificCosts: 'Đề nghị thanh toán chi phí chuyên dụng chỉ được phép bao gồm các khoản chi phí chuyên dụng đó, không được chứa bất kỳ chi phí nào khác.',
  Cargo_ThePaymentNotSettled: 'Khoản thanh toán cho tháng {0} chưa được thanh toán xong.',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} chưa xác nhận, vui lòng xác nhận trước!',
  Cargo_SpecialApproval2: 'Phê duyệt đặc biệt',
  Application_Item: 'Hạng mục đề nghị',
  Application_Content: 'Nội dung đề nghị',
  Application_Reason: 'Lý do đề nghị',
  Cargo_DomesticOverseas: 'Trong nước/Nước ngoài',
  Cargo_IncludeOverseasWarehouse: 'Bao gồm kho nước ngoài',
  Cargo_SignContract2: 'Ký kết hợp đồng',
  Cargo_LatestContractDate: 'Ngày ký hợp đồng muộn nhất',
  Cargo_CreditControlSelfAssessment: 'Biểu tự đánh giá hạn mức tín dụng',
  Cargo_CustomerFile: 'Hồ sơ khách hàng',
  Cargo_CustomerConsignmentNote: 'Phiếu ủy thác khách hàng',
  Cargo_HasContract: 'Có hợp đồng',
  Cargo_NoContract: 'Không có hợp đồng',
  Cargo_ContractStatus2: 'Có hợp đồng hay không',
  Cargo_SupplierFile: 'Hồ sơ nhà cung cấp',
  Cargo_ApprovalSummary: 'Tóm tắt nội dung phê duyệt',
  Cargo_AlreadyExistsCannotSubmit: '{0} đã tồn tại, không thể gửi đơn đăng ký!',
  Action_AddAttachment: 'Thêm tệp đính kèm',
  Validation_ApplicationContentRequired: 'Nội dung đề nghị không được để trống.',
  Validation_ApplicationReasonRequired: 'Lý do đề nghị không được để trống.',
  Cargo_AutoReceivablesWriteOff: 'Tự động thanh lý các khoản phải thu',
  Cargo_WhetherIgnore: 'Bỏ qua',
  Cargo_TempCreditNotBeCross: 'Thời hạn kiểm soát tín dụng tạm thời không thể giao nhau.',
  Cargo_TempCreditNotice: 'B5-05=giá trị thông số Kd, (cài 2)',
  Cargo_CurrentCreditNotice: 'Lưu ý: Thời hạn/hạn mức tài khoản đáp ứng các điều kiện theo thời gian hiện tại, kiểm soát tín dụng tạm thời được duy trì trong ngày sẽ được đồng bộ hóa với các đối tác vào ngày hôm sau',
  Cargo_CurrentAvailableNotEntered: 'Số lượng hiện có chưa được nhập',
  Cargo_Debit: 'Mượn',
  Cargo_DebitAmount: 'Số lượng debit',
  Cargo_DebitAmount2: 'Số tiền ghi nợ',
  Cargo_DebitAmountCNY: 'Kim ngạch vay (NDT)',
  Cargo_DebitAmountOccurred: 'Số tiền phát sinh nợ',
  Cargo_DebitAmountOccurredCNY: 'Kim ngạch phát sinh của bên mượn (Nhân dân tệ)',
  Cargo_DebitAmountOccurredP: 'Mức phát sinh nợ:',
  Cargo_DebitAmountOccurredUSD: 'Số tiền phát sinh nợ (USD)',
  Cargo_DebitAmountTo: 'Debit tổng cộng',
  Cargo_DebitAmountToP: 'Debit tổng cộng:',
  Cargo_DebitAmountUSD: 'Số tiền ghi nợ (USD)',
  Cargo_DebitLocalCurrency: 'Ghi nợ tiền bản vị',
  Cargo_DebitNotWrittenOff: 'Debit không bán',
  Cargo_DebitOriginalAmount: 'Số tiền gốc Debit',
  Cargo_DebitSide: 'Ghi nợ',
  Cargo_DebitSideCNY: 'Bên ghi nợ (NDT)',
  Cargo_DebitSideCreditSide: 'Ghi nợ/Cho vay',
  Cargo_DebitSideCreditSideP: 'Ghi nợ/Tín dụng:',
  Cargo_DebitSideUSD: 'Nợ (USD)',
  Cargo_DebitWriteOffAmount: 'Số lượng bán hàng Debit',
  Cargo_December: 'Tháng Mười Hai',
  Cargo_DeclareWarehouseLoadingContainer: 'Có khai báo hải quan trong kho đóng gói',
  Cargo_DeemedPrinted: 'In tương tự',
  Cargo_VGMLog: 'Nhật ký VGM',
  Cargo_SendVGM: 'Gửi VGM',
  Cargo_VGMChannel: 'Kênh VGM',
  Cargo_VGMBasicInfo: 'Thông tin cơ bản về VGM',
  Cargo_FriendlyReminder: 'Gợi ý ấm áp: Thêm đánh vần xin điền số chính',
  Cargo_VGMCutOffDate: 'Cắt ngày VGM',
  Cargo_ContainerHolder: 'Người giữ hộp',
  Cargo_NotFilledIn: 'Không điền, vui lòng gửi khi điền xong.',
  Cargo_NotSelected: 'Chưa chọn, vui lòng gửi khi điền xong.',
  Cargo_PleaseMaintainCargoInfo: 'Vui lòng duy trì thông tin hàng hóa hộp',
  Cargo_IfYouHaveSentPreStowageManifest: 'Nếu bạn đã gửi danh sách bán hàng dự phòng qua kênh quản gia biển, bạn sẽ ký thông tin đồng bộ từ trang thông tin dự phòng;',
  Cargo_IfYouHaveNotSentPreStowageManifest: 'Nếu không gửi danh sách khoang dự phòng qua kênh quản gia biển, thì sẽ ký thông tin đồng bộ từ trang cơ bản, trang đặt khoang.',
  Cargo_FriendlyReminderWithPort: 'Gợi ý ấm áp: Cửa khẩu Thượng Hải, đề nghị bạn gửi thông tin VGM sau khi hoàn thành việc nhập trước, sà lan đón tàu lớn, tùy thuộc vào thời gian sà lan',
  Cargo_TerminalInfoForReferenceOnly: 'Thông tin bến tàu chỉ cung cấp cho tham khảo, cụ thể xin lấy cửa đặt khoang làm chuẩn!',
  Cargo_TerminalInfoForReferenceWse: 'Nếu thông tin bến tàu đặt khoang không phù hợp với thông tin bến tàu tham khảo của chúng tôi, xin liên hệ với dịch vụ khách hàng, cảm ơn!',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: 'Nếu thông tin bến tàu đặt khoang không phù hợp với thông tin bến tàu tham khảo của chúng tôi, xin liên hệ với dịch vụ khách hàng.',
  Cargo_FriendlyReminderWithCutOffTime: 'Gợi ý ấm áp: Vui lòng điền vào thời gian chặn chính xác, chúng tôi sẽ gửi đi nhiều lần theo ngày này, nếu phí vận chuyển muộn do lỗi thông tin, nền tảng không chịu.',
  Cargo_TheShipperDeclares: 'Tuyên bố của người gửi hàng này: Thông tin về trọng lượng của container chở hàng chứa trong tài liệu này được thu thập theo các phương pháp được mô tả trong Công ước quốc tế về an toàn sinh mạng trên biển 1974, nói rằng người đo trọng tâm đã nhận được giấy chứng nhận kiểm tra đo lường do cơ quan kỹ thuật đo lường cấp và ngày nhận được trọng lượng nằm trong phạm vi hợp lệ của giấy chứng nhận.',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: 'VGM sẽ bị tính phí nhiều lần nếu bạn muốn gửi lại. {0}S Gửi sau.',
  Cargo_Send_VGM_Reminder: 'Mỗi số hộp gửi VGM sẽ bị trừ một lần, cùng một số hộp gửi nhiều lần sẽ bị trừ nhiều lần. Chẳng hạn như sửa đổi thông tin VGM, chỉ cần gửi thông tin VGM của hộp đã sửa đổi. <br>Vui lòng xác nhận nếu bạn tiếp tục gửi?',
  Cargo_ContinueSending: 'Tiếp tục gửi',
  Cargo_ResendAfterS: 'Gửi lại sau khi s',
  Cargo_ExternalAssociationCode: 'Mã liên kết ngoài',
  Cargo_ExternalAssociationCodeValidMessage: 'Mã liên kết bên ngoài chỉ có thể là chữ cái hoặc số',
  Cargo_ShippingCompanyReceiptStatus: 'Tình trạng trả tàu',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'Không tìm thấy thông tin phù hợp với Sea Butler trong lĩnh vực cảng khởi hành, vui lòng đánh dấu.',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'Không tìm thấy thông tin nào phù hợp với Sea Butler, vui lòng đánh dấu.',
  Cargo_CharLengthWithRange: 'Độ dài từ {0} đến {1} ký tự',
  Cargo_TheBoxNumberMustBe: 'Số hộp phải có 4 chữ cái+7 chữ số',
  Cargo_LoadWharfTips: 'Thông tin bến tàu chỉ cung cấp cho tham khảo, cụ thể xin lấy cửa đặt khoang làm chuẩn! Nếu thông tin bến tàu đặt khoang không phù hợp với thông tin bến tàu tham khảo của chúng tôi, xin liên hệ với dịch vụ khách hàng, cảm ơn!',
  Cargo_WhetherToContinueSendingVGM: 'Tiếp tục gửi VGM?',
  Cargo_Default: 'Mặc định',
  Cargo_DefaultAPUnitPrice: 'Đơn giá phải trả mặc định',
  Cargo_DefaultARCurrency: 'Loại tiền phải thu mặc định',
  Cargo_DefaultAPCurrency: 'Đồng tiền phải trả mặc định',
  Cargo_DefaultARUnitPrice: 'Đơn giá phải thu mặc định',
  Cargo_DefaultDecimalPlaces: 'Số thập phân mặc định',
  Cargo_DefaultLine: 'Hàng mặc định',
  Cargo_DefaultMenuItems: 'Mục trình đơn mặc định',
  Cargo_DefaultOrNot: 'Mặc định',
  Cargo_DefaultPayee: 'Đối tượng phải trả mặc định',
  Cargo_DefaultPayer: 'Đối tượng nhận mặc định',
  Cargo_DefaultSearchCondition: 'Điều kiện truy vấn mặc định',
  Cargo_DefaultValue: 'Mặc định',
  Cargo_SeDefaultValue: 'Out Mặc định',
  Cargo_SiDefaultValue: 'Mặc định Hải Tiến',
  Cargo_AeDfaultValue: 'Bỏ mặc định',
  Cargo_AiDfaultValue: 'Mặc định rỗng',
  Cargo_ReDfaultValue: 'Sắt ra mặc định',
  Cargo_RiDfaultValue: 'Sắt Mặc định',
  Cargo_EditDefaultValue: 'Sửa mặc định',
  Cargo_EditJobDefaultValueTip: `Nếu giá trị mặc định của mỗi loại hình kinh doanh khác nhau, hãy bảo trì trong hộp văn bản loại hình kinh doanh tương ứng;；
Nếu các hộp văn bản loại doanh nghiệp và các giá trị mặc định đều được duy trì, ưu tiên nhận các giá trị hộp văn bản loại doanh nghiệp tương ứng dựa trên loại doanh nghiệp；`,
  Cargo_DefaultWriteOffCurrency: 'Loại tiền tệ bán hàng mặc định',
  Cargo_DelayedTaxRefund: 'Là trì hoãn hoàn thuế.',
  Cargo_DelegationTypeRailway: 'Đường sắt (Railway)',
  Cargo_Delete: 'Xoá',
  Cargo_DeleteConfirmation: 'Bạn có chắc chắn muốn xóa bản ghi đã chọn không?',
  Cargo_DeleteBill: 'Xóa hóa đơn',
  Cargo_DisplayRules: 'Quy tắc hiển thị',
  Cargo_ViewAttachments: 'Xem phụ kiện',
  Cargo_DeleteCollectionRecord: 'Xóa đăng ký nhờ thu',
  Cargo_DeletedBillList: 'Danh sách thanh toán bị xóa',
  Cargo_DeletedSuccessfully: 'Xóa thành công.',
  Cargo_WithdrawSuccessfully: 'Rút tiền thành công',
  Cargo_DeletedNotHavePermission: 'Bạn không có quyền xóa bảng báo giá này.',
  Cargo_DeletedNotIntoBusiness: 'Danh sách báo giá đã được đưa vào chi phí của doanh nghiệp và không thể bị xóa!',
  Cargo_DeleteEntry: 'Xoá mục',
  Cargo_DeleteFailed: 'Xóa thất bại.',
  Cargo_DeleteFee: 'Phí xóa',
  Cargo_DeleteFeeConfirmedListSync: 'Xóa xác nhận chi phí cùng một lúc',
  Cargo_DeleteInvoice: 'Xóa hóa đơn',
  Cargo_DeleteNotification: 'Xóa lời nhắc',
  Cargo_DeleteOrNot: 'Xóa?',
  Cargo_DeleteVoucher: 'Xóa chứng từ',
  Cargo_Delivered: 'Đã gửi',
  Cargo_DeliveredButNotRetrieved: 'Đã gửi (không lấy lại)',
  Cargo_DeliveredSuccessfully: 'Gửi đi thành công.',
  Cargo_DeliveredToBranch: 'Gửi công ty quá mức',
  Cargo_DeliverPartial: 'Gửi một phần',
  Cargo_DeliverySigned: 'Đã ký',
  Cargo_DenialReason: 'Lý do từ chối',
  Cargo_DenialReasonP: 'Lý do từ chối:',
  Cargo_Denied: 'Bị từ chối',
  Cargo_DeniedSuccessfully: 'Từ chối thành công',
  Cargo_DenyApplication: 'Từ chối ứng dụng',
  Cargo_DenyPaymentApplication: 'Từ chối yêu cầu thanh toán',
  Cargo_Department: 'Trang chủ',
  Cargo_DepartmentApproval: 'Bộ phận phê duyệt',
  Cargo_DepartmentP: 'Bộ phận:',
  Cargo_DepartureTime: 'Thời gian khởi hành',
  Cargo_DepositBank: 'Mở tài khoản ngân hàng',
  Cargo_DepositBankAccountNo: 'Mở tài khoản ngân hàng',
  Cargo_DepositBankAndAccountNo: 'Mở tài khoản và tài khoản',
  Cargo_DepositBankAndAccountNoP: 'Mở tài khoản và tài khoản:',
  Cargo_DesCharge: 'Chi phí điểm đến',
  Cargo_DescriptionCanTBeEmpty: 'Mô tả nội dung không được để trống',
  Cargo_DescriptionOfCharge: 'Nội dung tính phí',
  Cargo_DescriptionOfExpenseItem: 'Name',
  Cargo_DescriptionOfExpenseItemCNY: 'Name',
  Cargo_DescriptionOfExpenseItemUSD: 'Name',
  Cargo_DescriptionOfExpenseItemJPY: 'Name',
  Cargo_DescriptionOfExpenseItemEUR: 'Name',
  Cargo_DescriptionOfPlan: 'Mô tả chương trình',
  Cargo_DescriptionOfQuantity: 'Số lượng nội dung',
  Cargo_DescriptionOfVoucherType: 'Mô tả các loại chứng từ',
  Cargo_DesignatedDepartment: 'Bộ phận chỉ định',
  Cargo_DesignSubTitlesOfAccount: 'Thiết kế Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub-Sub',
  Cargo_Destination: 'Điểm đến',
  Cargo_ChargeItemMaintenance: 'Bảo trì dự án thu phí',
  Cargo_ZeroTaxRate: 'Không có thuế suất',
  Cargo_DestinationAgent: 'Đại lý cảng đích',
  Cargo_DestinationAgent1: 'Đại lý ở nước ngoài',
  Cargo_DestinationChargeOrNot: 'Chi phí điểm đến',
  Cargo_DestinationPort: 'Cảng đích',
  Cargo_DestinationPortSea: 'Cảng đích (bằng đường biển)',
  Cargo_DestinationPortAir: 'Cảng đích (bằng đường hàng không)',
  Cargo_OverseaWarehouse: 'Kho ở nước ngoài',
  Cargo_NoRestriction: 'Không giới hạn',
  Cargo_Details: 'Chi tiết',
  Cargo_DetailsOfOutOfPocketRecord: 'Chi tiết đăng ký thanh toán',
  Cargo_DetailsOfSingleWriteOff: 'Chi tiết bán hàng đơn',
  Cargo_DetailsOfSingleWriteOffPDF: 'Chi tiết bán hàng.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: 'Chi tiết tiêu thụ.',
  Cargo_DevelopedAtExhibitions: 'Phát triển triển lãm',
  Cargo_Difference: 'Khác biệt',
  Cargo_DifferenceAdjustment: 'Điều chỉnh chênh lệch',
  Cargo_DifferenceCNYCNY: 'Chênh lệch CNY',
  Cargo_DifferenceUSD: 'Chênh lệch USD',
  Cargo_DifferentialAdjustedSuccessfully: 'Điều chỉnh chênh lệch thành công',
  Cargo_DifferentialIs: 'Sự khác biệt là: {0}',
  Cargo_DifferentialProcessing: 'Xử lý chênh lệch',
  Cargo_DifficultyIndex: 'Đánh bại chỉ số khó khăn',
  Cargo_DIITRLNLTSIT: 'Hiển thị danh sách bên phải không liên quan đến loại hóa đơn đã chọn',
  Cargo_DirectAssign: 'Phân phối trực tiếp',
  Cargo_DirectBusiness: 'Đơn thẳng',
  Cargo_DirectConsol: 'Tự LCL',
  Cargo_DirectConsolContainerNo: 'Số hộp tự LCL',
  Cargo_Direction: 'Hướng dẫn',
  Cargo_DirectServiceOrNot: 'Trực tiếp',
  Cargo_DiscrepancyExist: 'Có sự khác biệt',
  Cargo_DiscrepancyFound: 'Có những thứ khác nhau.',
  Cargo_DisplayAmountOfDifferential: 'Hiển thị số tiền chênh lệch',
  Cargo_DisplayAmountOfReconciliation: 'Hiển thị số tiền đối chiếu',
  Cargo_DisplayBatchOperation: 'Hiển thị hàng loạt hành động',
  Cargo_DisplayCashFlowItems: 'Dự án Cash Flow',
  Cargo_DisplayExpenseDetails: 'Hiển thị chi tiết chi phí',
  Cargo_DisplayMonthSelector: 'Hiện bộ chọn tháng hay không',
  Cargo_DisplayOrder: 'Thứ tự hiển thị',
  Cargo_DisplayTotalCost: 'Hiển thị tổng chi phí',
  Cargo_DisplayTotalIncome: 'Hiển thị Total Income',
  Cargo_DisplayUnCodedRecordsOnly: 'Chỉ xem mã là trống',
  Cargo_DisplayUnInvoicedAmount: 'Hiển thị số tiền chưa thanh toán',
  Cargo_DistributedReconciliationAmount: 'Số tiền đối chiếu chia sẻ',
  Cargo_DistributionCostOrNot: 'Chia sẻ chi phí',
  Cargo_District: 'Quận',
  Cargo_DLCCLCCTBE: 'Debt Local Coin/Credit Local Coin không thể để trống.',
  Cargo_DMROITE: 'Loại hóa đơn {0} có hồ sơ bảo trì lặp lại',
  Cargo_DNBTCBOHC: 'Chi nhánh nơi dữ liệu đang hoạt động không thuộc chi nhánh hiện tại hoặc chi nhánh cấp cao hơn, bạn có chắc muốn tiếp tục không?',
  Cargo_DORMBGTTDOR: 'Ngày hoàn trả phải lớn hơn ngày lấy lại.',
  Cargo_DOCOTS: 'Tên hàng hóa hoặc dịch vụ chịu thuế',
  Cargo_DocReleaseAgainstPayment: 'Thanh toán hay không',
  Cargo_DocumentationType: 'Loại Output',
  Cargo_DocumentCirculation: 'Dòng chảy chứng từ',
  Cargo_Documents: 'Chứng từ',
  Cargo_DOEICTBE: 'Tên mục chi phí không được để trống',
  Cargo_Domestic: 'Nội địa',
  Cargo_DomesticBill: 'Hóa đơn nội địa',
  Cargo_DomesticChargeInformation: 'Tình hình thu phí trong nước',
  Cargo_DomesticCollection: 'Thu tiền trong nước',
  Cargo_DomesticDirectClient: 'Khách nội địa',
  Cargo_DomesticDirectClientOrNot: 'Khách nội địa',
  Cargo_DomesticOrInternational: 'Trong nước/nước ngoài',
  Cargo_DomesticPayment: 'Thanh toán nội địa',
  Cargo_DomesticTrade: 'Thương mại nội bộ',
  Cargo_DoNotSelectMultipleItems: 'Không chọn nhiều',
  Cargo_Door: 'Điểm cửa',
  Cargo_DoorAddress: 'Địa chỉ cửa',
  Cargo_DoorLoadingDelivery: 'Điểm đóng gói/Pick Up',
  Cargo_DoorPickup: 'Pick up tại cửa',
  Cargo_DOPNCTBLTAC: 'Sự khác biệt tích cực không thể nhỏ hơn 1 xu.',
  Cargo_DoubleClickToView: 'Double Click để xem',
  Cargo_DownloadCompleted: 'Download thành công!',
  Cargo_DownloadFailed: 'Download thất bại!',
  Cargo_DrawABillOrNot: 'Tất cả hóa đơn',
  Cargo_DRIRORIOCA: 'Lãi suất phải thu Lãi suất phải thu Khác Hàng tồn kho Tài sản hiện tại khác',
  Cargo_DSAIM: 'Hiển thị phương thức thanh toán và phương thức thanh toán',
  Cargo_DSCSDSCS: 'Credit Credit Credit Credit Credit',
  Cargo_Dues: 'Đối phó',
  Cargo_DuesB: '(Ứng phó)',
  Cargo_DuesToCNY: 'Đối phó với CNY:',
  Cargo_EquivalentCNY: 'Số tiền khấu trừ CNY tương ứng:',
  Cargo_DuesCNY: 'CNY đối phó',
  Cargo_DuesEUR: 'EUR phải trả',
  Cargo_DuesGBP: 'GBP đối phó',
  Cargo_DuesHKD: 'HKD đối phó',
  Cargo_DuesJPY: 'JPY đối phó',
  Cargo_DuesNGN: 'NGN đối phó',
  Cargo_DuesP: 'Đối phó:',
  Cargo_DuesUSD: 'USD phải trả',
  Cargo_DuplicateCodePleaseTryItAgain: 'Mã lặp lại, vui lòng nhập lại.',
  Cargo_DuplicateContent: 'Sao chép nội dung',
  Cargo_DutyFree: 'Miễn thuế',
  Cargo_DynamicCurrencyDisplayColumn: 'Hiển thị động thanh tiền tệ',
  Cargo_ECDICA: 'Xóa những gì hiển thị ở giữa',
  Cargo_ECNETSFS: 'Vui lòng nhập tên mã, v.v. để quay lại truy vấn mờ',
  Cargo_ECSNMIR: 'Tình trạng xác nhận chi phí không phù hợp với yêu cầu lập hóa đơn',
  Cargo_ECSNMPAR: 'Tình trạng xác nhận phí không đáp ứng yêu cầu thanh toán',
  Cargo_ECSNMWOR: 'Tình trạng xác nhận chi phí không phù hợp với yêu cầu bán hàng',
  Cargo_EdiCode: 'Mã hóa EDI',
  Cargo_EdiInterfaceTypeOfEInvocing: 'Loại giao diện thanh toán điện tử bên ngoài',
  Cargo_EdiInterfaceTypeOfInvoicing: 'Loại giao diện thanh toán bên ngoài',
  Cargo_Edit: 'Chỉnh sửa',
  Cargo_EditAdjustment: 'Sửa đổi điều chỉnh',
  Cargo_EditAirFreightServiceItems: 'Dịch vụ vận chuyển hàng không',
  Cargo_EditAssociatedPort: 'Chỉnh sửa các cảng liên quan',
  Cargo_EditAwbSurcharge: 'Chỉnh sửa vận đơn vận chuyển hàng không',
  Cargo_EditBill: 'Biên tập hóa đơn',
  Cargo_EditBLType: 'Chỉnh sửa các loại vận đơn',
  Cargo_EditChargeFinancialDate: 'Sửa đổi chi phí Ngày tài chính',
  Cargo_EditCirculationDocumentType: 'Hiệu chỉnh các kiểu tệp dòng chảy',
  Cargo_CirculationDocumentType: 'Kiểu tập tin',
  Cargo_EditClientType: 'Chỉnh sửa loại khách hàng',
  Cargo_EditCommissionRules: 'Chỉnh sửa quy tắc trích phần trăm',
  Cargo_EditContract: 'Biên tập hợp đồng',
  Cargo_EditCustomizedServiceType: 'Chỉnh sửa Custom Business Type',
  Cargo_EditedSuccessfully: 'Sửa đổi thành công.',
  Cargo_EditField: 'Sửa trường',
  Cargo_EditFinancialDate: 'Sửa đổi ngày tài chính',
  Cargo_EditFormula: 'Chỉnh sửa công thức -',
  Cargo_EditKeyWord: 'Chỉnh sửa các từ nhạy cảm',
  Cargo_EditMscService: 'Biên tập MSC Service',
  Cargo_EditOppositeVoucherNo: 'Thay đổi số chứng từ của nhau',
  Cargo_EditOrNot: 'Sửa hay không',
  Cargo_EditRemarks: 'Ghi chú sửa đổi',
  Cargo_EditRoute: 'Chỉnh sửa lộ trình',
  Cargo_EDTTTC: 'Có thể chuyển vào chi phí ủy thác',
  Cargo_EDTTTCP: 'Có thể chuyển sang chi phí gửi thu:',
  Cargo_EffectiveDate: 'Ngày có hiệu lực',
  Cargo_EffectiveMonth: 'Tháng hợp lệ',
  Cargo_EICCMBU: '\'CộtColumn \'Giá trị đầu vào của CURRENCY CURRENCY Vi phạm ràng buộc duy nhất',
  Cargo_EINDWI: 'Hóa đơn có được nhập trực tiếp vào hóa đơn không?',
  Cargo_EInvoiceCanTBePrinted: 'Hóa đơn điện tử không thể được in.',
  Cargo_EInvoiceCanTBeVoided: 'Hóa đơn điện tử không thể hủy bỏ.',
  Cargo_EInvoicePaperInvoice: 'Hóa đơn điện tử Hóa đơn giấy',
  Cargo_EmailAddress: 'Thư điện tử',
  Cargo_EMailAlertForTestOnly: 'Thư nhắc nhở (dành riêng cho thử nghiệm)',
  Cargo_EmailSent: 'Thư đã được gửi.',
  Cargo_Empty: 'Trống rỗng',
  Cargo_EmptyData: 'Xóa dữ liệu',
  Cargo_EmptyEntries: 'Xóa input',
  Cargo_EmptyOriginalCurrency: 'Xóa tiền gốc',
  Cargo_EMSSCM: 'Email đã gửi thành công, xin chú ý kiểm tra và nhận',
  Cargo_EndDate: 'Thời hạn',
  Cargo_EnglishCargoName: 'Tên tiếng Anh',
  Cargo_EnglishCommodityNameMsc: 'Tên tiếng Anh (MSC)',
  Cargo_EnglishName: 'Tên tiếng Anh',
  Cargo_EnglishNameCanTBeEmpty: 'Tên tiếng Anh không được để trống',
  Cargo_Enter: 'Đăng nhập',
  Cargo_CannotDeleteUsedCustomerType: 'Loại khách hàng đã sử dụng không được phép xóa',
  Cargo_CannotDeleteUsedCustomerContactChannel: 'Không cho phép xóa các kênh liên hệ khách hàng đã sử dụng',
  Cargo_CannotDeleteUsedCustomerRating: 'Không được phép xóa các hạng đánh giá khách hàng đã sử dụng',
  Cargo_EnterBusinessTypeToStartSearch: 'Vui lòng nhập loại hình kinh doanh',
  Cargo_EnterExpenseName: 'Nhập tên phí',
  Cargo_EnterInvoiceNo: 'Nhập số hóa đơn',
  Cargo_EnterInvoiceNoDirectly: 'Nhập số hóa đơn trực tiếp',
  Cargo_EnterKeyWordsToStartFuzzySearch: 'Vui lòng nhập từ nhạy cảm cho truy vấn mờ',
  Cargo_EnterManually: 'NTHC',
  Cargo_EnterSpecialInvoiceNo: 'Nhập số hóa đơn chuyên dụng',
  Cargo_EnterVoucherInformation: 'Nhập thông tin chứng từ',
  Cargo_Entity: 'Thực thể',
  Cargo_EntryDate: 'Ngày nhập',
  Cargo_EntryOfNumber: 'Nhập số',
  Cargo_EqualTo: 'Tương đương',
  Cargo_Error: 'Sai rồi.',
  Cargo_ErrorNoDataFound: 'Sai rồi, không có dữ liệu.',
  Cargo_ESNMIR: 'Tình trạng chi phí không đáp ứng yêu cầu lập hóa đơn',
  Cargo_ESNMPAR: 'Tình trạng phí không đáp ứng yêu cầu thanh toán',
  Cargo_ESNMWOR: 'Tình trạng chi phí không phù hợp với yêu cầu bán hàng',
  Cargo_EstTimeOfWarehouseIn: 'Thời gian dự kiến vào kho',
  Cargo_EventOfSettlingParty: 'Sự kiện đối tượng thanh toán',
  Cargo_EventRecord: 'Sự kiện',
  Cargo_EventTime: 'Thời gian sự kiện',
  Cargo_EverCancelledWriteOff: 'Đã bao giờ hủy bỏ hoạt động bán hạt nhân chưa?',
  Cargo_ExcelExport: 'Xuất Excel',
  Cargo_ExcessiveOrNot: 'Có vượt quá hay không',
  Cargo_ExchangeCode: 'Mã trao đổi',
  Cargo_ExchangeCodeCanTBeEmpty: 'Mã hoán đổi không thể rỗng',
  Cargo_ExchangeCurrency: 'Đổi tiền tệ',
  Cargo_ExchangeGainsAndLosses: 'Lợi nhuận và thua lỗ',
  Cargo_ExchangeRate: 'Tỷ giá hối đoái',
  Cargo_ExchangeRateAdjustmentTable: 'Bảng điều chỉnh tỷ giá hối đoái',
  Cargo_ExchangeRateAdjustmentTableP: 'Bảng điều chỉnh tỷ giá hối đoái:',
  Cargo_ExchangeRateCanTBeEmpty: 'Tỷ giá hối đoái không thể rỗng',
  Cargo_ExchangeRateDifference: 'Giao dịch',
  Cargo_ExchangeRateHKD: 'Tỷ giá HKD',
  Cargo_ExchangeRateList: 'Danh sách tỷ giá hối đoái',
  Cargo_ExchangeRateOfHKD: 'Tỷ giá HKD',
  Cargo_ExchangeRateP: 'Tỷ giá hối đoái:',
  Cargo_ExchangeRateUSD: 'Tỷ giá USD',
  Cargo_ExclusionFilter: 'Lọc đẩy',
  Cargo_ExecutionMethodOfWindowClosure: 'Đóng cửa sổ',
  Cargo_Existed: 'Đã có rồi.',
  Cargo_ExpectedReviewDate: 'Ngày đánh giá dự kiến',
  Cargo_Expenditure: 'Chi phí',
  Cargo_ExpenseAdjustment: 'Điều chỉnh chi phí',
  Cargo_ExpenseAdjustmentOfCollection: 'Chi phí điều chỉnh',
  Cargo_ExpenseApprovalProcedure: 'Quy trình phê duyệt chi phí',
  Cargo_ExpenseDescriptionCanTBeEmpty: 'Tên chi phí không được để trống.',
  Cargo_ExpenseItemsCanTBeEmpty: 'Các khoản phí trong hóa đơn không được để trống.',
  Cargo_ExpenseListNonEntity: 'Danh sách chi phí phi thực thể',
  Cargo_ExpenseNotSelected: 'Không có phí được chọn.',
  Cargo_ExpenseRejectedSuccessfully: 'Phí từ chối thành công',
  Cargo_ExpenseRelated: 'Chi phí tương ứng.',
  Cargo_ExpenseReviewedBy: 'Kiểm toán chi phí',
  Cargo_ExpenseSearch: 'Yêu cầu chi phí',
  Cargo_ExpenseSelection: 'Lựa chọn chi phí',
  Cargo_ExpenseSettlingParty: 'Đối tượng thanh toán chi phí',
  Cargo_ExpenseWriteOffCanTBeEmpty: 'Chi phí tiêu thụ không thể để trống.',
  Cargo_ExpenseWrittenOffCanTBeSplit: 'Chi phí đã tiêu thụ, không thể chia cắt!',
  Cargo_ExpiryDateCanTBeEmpty: 'Ngày hết hạn không thể để trống',
  Cargo_Export: 'Xuất khẩu',
  Cargo_ExportBaiwangInvoice: 'Xuất hóa đơn Parkson',
  Cargo_ExportClientSuccessfully: 'Xuất khách hàng thành công',
  Cargo_ExportedSuccessfully: 'Xuất khẩu thành công.',
  Cargo_ExportExcel: 'Xuất Excel',
  Cargo_ExportExpenses: 'Xuất chi phí',
  Cargo_ExportFailed: 'Xuất thất bại.',
  Cargo_ExportOrNot: 'Xuất hay không',
  Cargo_ExportRecordsSuccessfully: 'Xuất bản ghi thành công',
  Cargo_ExportRequired: 'Cần xuất khẩu',
  Cargo_ExportResult: 'Xuất kết quả',
  Cargo_ExportSuccessfully: 'Xuất xong, thành công',
  Cargo_ExportVatInvoice: 'Xuất hóa đơn VAT',
  Cargo_ExportVatInvoiceXLS: 'Xuất hóa đơn VAT.xls',
  Cargo_ExportVoucher: 'Xuất chứng từ',
  Cargo_ExportWriteOffDetails: 'Xuất chi tiết bán hàng',
  Cargo_ExpressAddress: 'Địa chỉ chuyển phát nhanh',
  Cargo_ExpressInfo: 'Thông tin chuyển phát nhanh',
  Cargo_Extend: 'Được không?',
  Cargo_ExtendPeriod: 'Thời hạn gia hạn',
  Cargo_ExtensionAfterExpiration: 'Gia hạn sau khi hết hạn',
  Cargo_ExtensionCycle: 'Chu kỳ trì hoãn',
  Cargo_External: 'Bên ngoài',
  Cargo_Fax: 'Thư điện tử',
  Cargo_FCAEFAIIVWBIWBCCTV: 'Có {0} hóa đơn đã xuất chứng từ tài chính, nếu hủy bỏ hệ thống sẽ tạo ra hóa đơn đỏ, xác nhận hủy bỏ?',
  Cargo_FCAOCAE: 'Có kế toán ngoại tệ để tính toán số tiền gốc',
  Cargo_FCASPSCT: 'Đã chọn tài khoản ngoại tệ, vui lòng chọn loại tiền cần thanh toán',
  Cargo_FCL: 'Thùng đầy',
  Cargo_SpecialSize: 'Kích thước đặc biệt',
  Cargo_SpecialSizeTip: 'Sau khi đánh dấu, danh sách thông tin đóng gói có thể hiển thị thêm trường "Size Specifications (L * W * H Unit M)".',
  Cargo_FclLclTypeSeaExport: 'Loại đánh vần đầy đủ (ra biển)',
  Cargo_FclLclTypeSeaImport: 'Loại đánh vần đầy đủ (Hải Tiến)',
  Cargo_EstimatedArrivalTimeSeaExport: 'Thời gian dự kiến rời cảng (xuất khẩu đường biển)',
  Cargo_EstimatedArrivalTimeSeaImport: 'Thời gian dự kiến đến cảng (nhập khẩu đường biển)',
  Cargo_EstimatedArrivalTimeAirExport: 'Thời gian dự kiến đến (xuất khẩu hàng không)',
  Cargo_FDMOPPE0: 'Ngày được chỉ định hàng tháng hoặc kỳ hạn tài khoản lớn hơn 0',
  Cargo_February: 'Tháng Hai',
  Cargo_FeederOrNot: 'Sà lan',
  Cargo_FIAICTR: 'Đơn xin khai hóa đơn sau đây đã khai hóa đơn, không thể hủy bỏ!',
  Cargo_FIDSEC: 'Bạn đã chọn chi phí cho các đơn vị thanh toán khác nhau, bạn có chắc chắn tiếp tục hợp nhất các tài khoản bán hàng không?',
  Cargo_FileApplication: 'Đăng ký',
  Cargo_FileDocumentation: 'Tài liệu',
  Cargo_FileFormat: 'Định dạng tập tin',
  Cargo_FileHistory: 'Lịch sử tập tin',
  Cargo_FileLoadingFailed: 'Lỗi tải tập tin',
  Cargo_FileName: 'Tên tập tin',
  Cargo_FileNo: 'Số tập tin',
  Cargo_FileNotFoundInCloud: 'Lưu trữ đám mây không tìm thấy tệp',
  Cargo_FileRetrievedSuccessfully: 'Việc lấy tập tin đã thành công.',
  Cargo_FileSize: 'Cỡ tập tin',
  Cargo_FileStatus: 'Trạng thái tập tin',
  Cargo_FileType: 'Kiểu tập tin',
  Cargo_FileTypeDescription: 'Kiểu tập tinName',
  Cargo_Filter: 'Bộ lọc',
  Cargo_FilterP: 'Lọc:',
  Cargo_FinalDestination: 'Điểm đến cuối cùng',
  Cargo_FinancialApprovalDate: 'Ngày xét duyệt tài chính',
  Cargo_FinancialApproved: 'Đã được phê duyệt tài chính',
  Cargo_FinancialAudit: 'Kiểm toán tài chính',
  Cargo_FinancialAuditDetail: 'Kiểm toán tài chính - Chi tiết',
  Cargo_FinancialChangeReview: 'Kiểm toán hóa đơn tài chính',
  Cargo_FinancialCharges: 'Chi phí tài chính',
  Cargo_FinancialCode: 'Mã tài chính',
  Cargo_FinancialDate: 'Ngày tài chính',
  Cargo_FinancialExpenseIs: 'Chi phí tài chính là:',
  Cargo_FinancialPeriod: 'Thời gian tài chính',
  Cargo_FinancialReceived: 'Thực thu',
  Cargo_FinancialRemarks: 'Ghi chú tài chính',
  Cargo_FinancialSoftware: 'Phần mềm tài chính',
  Cargo_FinasialCheck: 'Phê duyệt tài chính',
  Cargo_FindExistingCurrencies: 'Tìm ra đồng tiền đã có',
  Cargo_FirstAccruedProfit: 'Lợi nhuận đầu tiên',
  Cargo_FirstAccruedTime: 'Thời gian đếm lần đầu',
  Cargo_FirstContactDate: 'Ngày liên lạc ban đầu',
  Cargo_FiscalPeriod: 'Kỳ kế toán',
  Cargo_Fit: 'Khách lẻ',
  Cargo_FixedAccountingCode: 'Mã hóa kế toán cố định',
  Cargo_FixedDateMonthly: 'Ngày quy định hàng tháng',
  Cargo_FJTLCTW: 'Các lệnh làm việc sau đây đã bị khóa và không thể được hoàn trả:',
  Cargo_FLCLType: 'Loại cắt dán hoàn chỉnh',
  Cargo_FlightVoyage: 'Chuyến bay',
  Cargo_FollowingBillsInTheTextNotFound: 'Các hóa đơn sau đây trong văn bản không được tìm thấy:',
  Cargo_ForAirBusiness: 'Sử dụng hàng không',
  Cargo_ForAirExportBusiness: 'Sử dụng xuất khẩu hàng không',
  Cargo_ForAirImportBusiness: 'Sử dụng hàng không nhập khẩu',
  Cargo_ForRailwayBusiness: 'Sử dụng kinh doanh đường sắt',
  Cargo_ForIntegratedJob: 'Sử dụng logistics toàn diện',
  Cargo_ForFbaSeaBusiness: 'FBA vận tải biển sử dụng',
  Cargo_ForFbaAirBusiness: 'FBA Air Sử dụng',
  Cargo_ForFbaRailwayBusiness: 'Sử dụng đường sắt FBA',
  Cargo_ForceDelete: 'Buộc gỡ bỏ',
  Cargo_ForeignCurrency: 'Ngoại tệ',
  Cargo_ForeignCurrencyAccounting: 'Kế toán ngoại tệ',
  Cargo_ForeignCurrencyAccountingExist: 'Có kế toán ngoại tệ',
  Cargo_ForeignTrade: 'Ngoại thương',
  Cargo_Format: 'Định dạng',
  Cargo_FormLayout: 'Bố trí biểu mẫu',
  Cargo_FormVerification: 'Xác minh hình thức',
  Cargo_ForOceanBusiness: 'Sử dụng đường biển',
  Cargo_ForOtherBusiness: 'Sử dụng kinh doanh khác',
  Cargo_ForRailwayExportBusiness: 'Sử dụng xuất khẩu đường sắt',
  Cargo_ForSeaExportBusiness: 'Sử dụng xuất khẩu bằng đường biển',
  Cargo_ForSeaImportBusiness: 'Sử dụng nhập khẩu bằng đường biển',
  Cargo_FreeDetension: 'Thời gian thuê miễn phí',
  Cargo_FreightForwardingFee: 'Phí giao nhận',
  Cargo_FristApprovalDate: 'Thời gian nộp đơn',
  Cargo_From: 'Từ',
  Cargo_Frozen: 'Đóng băng',
  Cargo_FrozenSuccessfully: 'Đóng băng thành công',
  Cargo_FullPayment: 'Thanh toán tất cả',
  Cargo_FullScreenDisplay: 'Hiển thị đầy màn hình',
  Cargo_Fumigation: 'Khử trùng',
  Cargo_FunctionOfSuccessfulAcquisition: 'Nhận hàm thành công',
  Cargo_FVOCPIOOPRECTBV: 'Hồ sơ thanh toán hiện tại đã được xuất khẩu chứng từ tài chính, không thể hủy bỏ.',
  Cargo_FVOVNP: 'Chứng từ 【{0}】 Xác minh sau đây không được thông qua:',
  Cargo_GeneralInvoice: 'Hóa đơn thông thường',
  Cargo_GeneralLedger: 'Trang chủ',
  Cargo_GeneralLedger2: 'Tổng tài khoản 2',
  Cargo_GeneralRate: 'Giá thông thường',
  Cargo_GeneratedAccountStatement: 'Đã tạo báo cáo chưa',
  Cargo_GeneratedBillsOrNot: 'Hóa đơn đã được tạo chưa',
  Cargo_GetBack: 'Lấy lại',
  Cargo_GoldenTaxationExportPrint: 'In xuất thuế vàng',
  Cargo_GoOn: 'Tiếp tục đi.',
  Cargo_ARAP_Locked: 'Công việc đã chọn đã bị khóa cả phải thu và phải trả, không thể thêm chi phí.',
  Cargo_AR_Locked: 'Công việc đã chọn đã bị khóa phải thu, không thể thêm chi phí phải thu.',
  Cargo_AP_Locked: 'Công việc đã chọn đã bị khóa phải trả, không thể thêm chi phí phải trả.',
  Cargo_Only_AR: 'Người dùng hiện tại chỉ có thể thêm chi phí phải thu.',
  Cargo_Only_AP: 'Người dùng hiện tại chỉ có thể thêm chi phí phải trả.',
  Cargo_Cannot_Add_Charge: 'Người dùng hiện tại không thể thêm chi phí.',
  Cargo_ChargeLockStatusChanged: 'Trạng thái khóa phải thu/phải trả của nghiệp vụ đã được cập nhật, vui lòng tra cứu lại và gửi thêm chi phí mới.',
  Cargo_GrandTotal: 'Tổng cộng',
  Cargo_GrandTotalP: 'Tổng cộng:',
  Cargo_GreaterThan: 'Lớn hơn',
  Cargo_GroupCompany: 'Nhóm công ty',
  Cargo_GroupExchangeRate: 'Tỷ giá nhóm',
  Cargo_GroupingConditions: 'Điều kiện nhóm',
  Cargo_GroupingConditions1: 'Điều kiện nhóm 1',
  Cargo_GroupingConditions2: 'Điều kiện nhóm 2',
  Cargo_GroupingConditions3: 'Điều kiện nhóm 3',
  Cargo_GroupingConditions4: 'Điều kiện nhóm 4',
  Cargo_GroupingConditions5: 'Điều kiện nhóm 5',
  Cargo_GroupingConditions6: 'Điều kiện nhóm 6',
  Cargo_GroupingMethod: 'Cách nhóm',
  Cargo_GroupingRulesOfJournalEntries: 'Quy tắc nhóm phân đoạn',
  Cargo_GroupingType: 'Loại gói',
  Cargo_GroupingTypesOfJournalEntries: 'Phân loại nhóm',
  Cargo_GroupingTypesOfJournalEntriesP: 'Phân loại nhóm:',
  Cargo_HalfMonthly: 'Nửa tháng Knot',
  Cargo_Harbour: 'Cảng biển',
  Cargo_HaulageCompany: 'Công ty vận tải',
  Cargo_HaveHas: 'Có',
  Cargo_HaveOrNot: 'Có hay không',
  Cargo_HazmatContained: 'Có chứa chất nguy hiểm không?',
  Cargo_HBLFreightTerm: 'Điều khoản cước vận chuyển',
  Cargo_HBLMode: 'Phương pháp HB/L B/L',
  Cargo_MBLMode: 'MB/L Phương pháp B/L',
  Cargo_HBLTransitTerm: 'Điều khoản vận chuyển Split Order',
  Cargo_HedgingInvoice: 'Hóa đơn Hedge',
  Cargo_HideQuantity: 'Ẩn số lượng',
  Cargo_HoldCargoOrNot: 'Có khấu trừ hàng hay không',
  Cargo_HoldDoc: 'Nút đơn',
  Cargo_SpecialApprovalOrder: 'Đặt hàng đặc biệt',
  Cargo_HoldSubmission: 'Tạm thời không đệ trình',
  Cargo_HqSWriteOffPendingConfirmation: 'Bộ chỉ huy đang chờ xác nhận.',
  Cargo_HsCode: 'Số HS',
  Cargo_IADBD: 'Ngày nộp đơn Ngày kinh doanh',
  Cargo_IARS: 'Hủy bỏ đơn xin khai hóa đơn thành công.',
  Cargo_IBOCR: 'Không đủ số dư trong hồ sơ thu tiền:',
  Cargo_ICDOOAABBD: 'Dữ liệu tổng hợp hàng không biển khởi tạo mặc định',
  Cargo_IDVOCVDCCIATTC: 'Giao diện chứng từ tùy chỉnh Giao diện hiển thị phiên bản Giao diện hiển thị giao diện tùy chỉnh tương ứng theo cấu hình',
  Cargo_Ignore: 'Bỏ qua',
  Cargo_IgnoreP: 'Bỏ qua',
  Cargo_IICS: 'Thông tin hóa đơn thành công.',
  Cargo_IINMCTBE: 'Bảo trì tên mục hóa đơn không thể để trống.',
  Cargo_Import: 'Nhập khẩu',
  Cargo_ImportBankSlip: 'Nhập hóa đơn nước',
  Cargo_ImportExcel: 'Excel nhập',
  Cargo_INABNCTBBE: 'Số hóa đơn hoặc số doanh nghiệp không được để trống',
  Cargo_INCBMDON: 'Có thể thay đổi số hóa đơn trực tiếp',
  Cargo_IncludedToBusinessNo: 'Số doanh nghiệp',
  Cargo_IncludedToBusinessNoP: 'Được tính vào số doanh nghiệp:',
  Cargo_InclusiveExpense: 'Bao gồm phí',
  Cargo_InclusiveExpenseP: 'Bao gồm phí:',
  Cargo_InclusiveOfAR: 'Có bao gồm chi phí phải thu không?',
  Cargo_Income: 'Thu nhận',
  Cargo_IncorrectWriteOffRecord: 'Hồ sơ bán hàng không chính xác',
  Cargo_IncoTerm: 'Điều khoản thương mại',
  Cargo_IncreaseAdjustment: 'Tăng điều chỉnh',
  Cargo_IncrementValueDuty: 'Thuế giá trị gia tăng',
  Cargo_ProductNameEn: 'Tên sản phẩm (Tiếng Anh)',
  Cargo_ContainerNumber: 'Номер контейнера',
  Cargo_TotalDataCount: 'Tổng cộng {0} mục dữ liệu',
  Cargo_PalletDetails: 'Chi tiết pallet',
  Cargo_PalletDimensions: 'Kích thước pallet',
  Cargo_ShippingCompanyWebsite: 'Trang web công ty tàu biển',
  Cargo_OverseasWarehouseAddress: 'Địa chỉ kho nước ngoài',
  Cargo_Index: 'Chỉ mục',
  Cargo_IndexCanTBeEmpty: 'Abstract không được để trống',
  Cargo_IndexName: 'Tên tóm tắt',
  Cargo_IndustrialTradingCompany: 'Công ty hội nhập công nghiệp và thương mại',
  Cargo_INEPREIN: 'Số hóa đơn đã tồn tại, vui lòng điền lại số hóa đơn',
  Cargo_Infomation: 'Thông tin',
  Cargo_InformationSentDate: 'Ngày gửi dữ liệu',
  Cargo_InformationSentTime: 'Thời gian gửi thông tin',
  Cargo_InitialBalance: 'Số dư ban đầu của đối tượng',
  Cargo_InitialBalanceImport: 'Nhập số dư ban đầu',
  Cargo_InitializePageSwitching: 'Chuyển đổi trang khởi tạo',
  Cargo_InitializingPleaseWait: 'Đang khởi tạo, xin vui lòng để sau......',
  Cargo_InitialPeriod: 'Giai đoạn đầu',
  Cargo_InitialPeriodCannotBeEmpty: 'Thời gian ban đầu không được để trống.',
  Cargo_InitialPeriodCanTBeEmpty: 'Thời gian ban đầu không được để trống.',
  Cargo_InitialPeriodOrNot: 'Nếu thời gian ban đầu',
  Cargo_InitialPeriodP: 'Giai đoạn đầu:',
  Cargo_InitiateContainerPickupRequest: 'Bắt đầu một yêu cầu kinh doanh tote',
  Cargo_INNECTCW: 'Số hóa đơn không được nhập, xác nhận đóng cửa sổ không?',
  Cargo_INNECTP: 'Số hóa đơn không được nhập, bạn có muốn tiếp tục in không?',
  Cargo_INNECTS: 'Số hóa đơn không được nhập, bạn có tiếp tục lưu không?',
  Cargo_InputBusinessNumber: 'Vui lòng nhập số doanh nghiệp',
  Cargo_InputTime: 'Thời gian nhập',
  Cargo_InsertJournalEntry: 'Chèn mục',
  Cargo_InsidePacking: 'Gói mảnh nhỏ',
  Cargo_InsideQuantity: 'Số mảnh nhỏ',
  Cargo_InstantMessengerQqWechatEtc: 'Thông tin tức thời (QQ wechat)',
  Cargo_InsufficientRecordBalance: 'Không đủ số dư hồ sơ:',
  Cargo_IntentionStage: 'Giai đoạn Intent',
  Cargo_InterfaceScheme: 'Sơ đồ giao diện',
  Cargo_Internal: 'Nội thất',
  Cargo_InternalCode: 'Mã hóa nội bộ',
  Cargo_InternalInvoice: 'Hóa đơn nội bộ',
  Cargo_International: 'Nước ngoài',
  Cargo_InternationalBill: 'Hóa đơn nước ngoài',
  Cargo_IntLFreight: 'Vận chuyển đại lý quốc tế',
  Cargo_IntLFreightForwardingServiceFee: 'Phí dịch vụ giao nhận quốc tế',
  Cargo_IntLOceanFreight: 'Phí vận chuyển đại lý quốc tế',
  Cargo_InUseByBusinessCanTBeDeleted: 'Đã được sử dụng bởi doanh nghiệp, không thể xóa',
  Cargo_Invalid: 'Hủy bỏ',
  Cargo_InvalidDate: 'Ngày hết hạn',
  Cargo_InvalidNavigation: 'Điều hướng không hợp lệ',
  Cargo_InvalidOrNot: 'Hủy bỏ hay không',
  Cargo_InvalidParameter: 'Tham số không hợp lệ',
  Cargo_InverseSelect: 'Chọn ngược',
  Cargo_Invoice: 'Hóa đơn',
  Cargo_Invoiceable: 'Hóa đơn có sẵn',
  Cargo_InvoiceAcquisition: 'Nhận hóa đơn',
  Cargo_InvoiceAfterARAPOffset: 'Hóa đơn bảo hiểm rủi ro phải được thu và nhận',
  Cargo_InvoiceAmount: 'Số lượng hóa đơn',
  Cargo_InvoiceAmountP: 'Số lượng hóa đơn:',
  Cargo_InvoiceConfirmation: 'Xác định thanh toán',
  Cargo_InvoiceContent: 'Nội dung hóa đơn',
  Cargo_InvoiceCurrency: 'Tiền tệ hóa đơn',
  Cargo_InvoiceCurrencyP: 'Hóa đơn tiền tệ:',
  Cargo_Invoiced: 'Đăng ký',
  Cargo_InvoiceDate: 'Ngày thanh toán',
  Cargo_InvoiceDateP: 'Ngày thanh toán:',
  Cargo_InvoicedBy: 'Trang chủ',
  Cargo_InvoicedByP: 'Người lập hóa đơn:',
  Cargo_InvoiceDeleted: 'Hóa đơn bị xóa',
  Cargo_InvoicedOrNot: 'Đã lập hóa đơn chưa?',
  Cargo_InvoiceHasBeenWrittenOff: 'Hóa đơn đã bán',
  Cargo_InvoiceHeader: 'Đầu hóa đơn',
  Cargo_InvoiceInformation: 'Thông tin hóa đơn',
  Cargo_InvoiceIssued: 'Hóa đơn',
  Cargo_InvoiceItemName: 'Tên dự án hóa đơn',
  Cargo_InvoiceItemNameSetup: 'Thiết lập tên mục hóa đơn',
  Cargo_InvoiceNo: 'Số hóa đơn',
  Cargo_InvoiceNoCanTBeEmpty: 'Số hóa đơn không được để trống.',
  Cargo_InvoiceNoEntry: 'Nhập số hóa đơn',
  Cargo_InvoiceNoExist: 'Có số hóa đơn',
  Cargo_InvoiceNoExistedContinue: 'Số hóa đơn đã tồn tại, bạn có tiếp tục không?',
  Cargo_InvoiceNoExistedContinueToSave: 'Số hóa đơn đã tồn tại, đã được lưu chưa?',
  Cargo_InvoiceNoExistedRewrite: 'Số hóa đơn [{0}] đã tồn tại, vui lòng điền lại số hóa đơn.',
  Cargo_InvoiceNoIsEmpty: 'Số hóa đơn trống.',
  Cargo_InvoiceNoIsEmptyContinue: 'Số hóa đơn trống có tiếp tục không?',
  Cargo_InvoiceNoMandatory: 'Số hóa đơn bắt buộc',
  Cargo_InvoiceNoNotEntered: 'Số hóa đơn không được nhập.',
  Cargo_InvoiceNoP: 'Số hóa đơn:',
  Cargo_InvoiceNoSegment: 'Số hóa đơn',
  Cargo_InvoiceNoStatus: 'Tình trạng số hóa đơn',
  Cargo_InvoicePrintedCanTBeDeleted: 'Hóa đơn đã được in và không thể xóa.',
  Cargo_InvoicePrinting: 'In hóa đơn',
  Cargo_InvoiceRecord: 'Hồ sơ hóa đơn',
  Cargo_InvoiceReIssued: 'Hóa đơn đã được mở lại',
  Cargo_InvoiceRemark: 'Ghi chú thanh toán',
  Cargo_InvoiceSavedSuccessfully: 'Lưu hóa đơn thành công',
  Cargo_InvoiceSaveFailed: 'Lưu hóa đơn thất bại',
  Cargo_InvoiceStatus: 'Tình trạng hóa đơn',
  Cargo_InvoiceTitle: 'Hóa đơn ngẩng đầu',
  Cargo_ChargeInvoiceTitle: 'Chi phí nâng cao',
  Cargo_InvoiceTitleInvoiceNo: 'Số hóa đơn',
  Cargo_InvoiceTitleNotMatched: 'Hóa đơn ngẩng đầu không thống nhất.',
  Cargo_InvoiceTitleP: 'Mở hóa đơn ngẩng đầu:',
  Cargo_InvoiceType: 'Loại hóa đơn',
  Cargo_InvoiceTypeIncompatible: 'Loại hóa đơn không thống nhất.',
  Cargo_InvoiceTypeP: 'Loại hóa đơn:',
  Cargo_InvoiceTypeSelection: 'Chọn loại hóa đơn',
  Cargo_InvoiceUse: 'Sử dụng hóa đơn',
  Cargo_InvoiceVoided: 'Hóa đơn đã bị hủy bỏ.',
  Cargo_InvoiceVoidedCanTBeDeleted: 'Hóa đơn đã bị hủy bỏ, không thể xóa.',
  Cargo_InvoiceVoucherAfterARAPOffset: 'Hóa đơn bảo hiểm rủi ro phải được thu và nhận',
  Cargo_InvoiceWrittenOffCanTBeDeleted: 'Hóa đơn đã bán không thể xóa',
  Cargo_InvoiceWrittenOffCanTBeVoided: 'Hóa đơn đã bán không thể hủy bỏ',
  Cargo_Invoicing: 'Đăng ký',
  Cargo_InvoicingAccordingToCurrency: 'Thanh toán bằng đồng xu',
  Cargo_InvoicingAddress: 'Địa chỉ thanh toán',
  Cargo_InvoicingAmount: 'Số tiền thanh toán',
  Cargo_InvoicingApplicationDate: 'Ngày nộp đơn',
  Cargo_InvoicingApplicationReview: 'Kiểm tra yêu cầu thanh toán',
  Cargo_InvoicingCompleted: 'Hóa đơn hoàn tất',
  Cargo_InvoicingCurrency: 'Đơn vị tiền tệ',
  Cargo_InvoicingDateBusinessDate: 'Ngày thanh toán Ngày kinh doanh',
  Cargo_InvoicingHeadCannotBeEmpty: 'Khai hóa đơn ngẩng đầu không thể để trống.',
  Cargo_InvoicingInformation: 'Thông tin thanh toán',
  Cargo_InvoicingListNo: 'Số danh sách thanh toán',
  Cargo_InvoicingMachineNo: 'Số hóa đơn',
  Cargo_InvoicingMethod: 'Phương thức thanh toán',
  Cargo_InvoicingMethodP: 'Phương thức kê đơn:',
  Cargo_InvoicingMode: 'Chế độ thanh toán',
  Cargo_InvoicingPerBill: 'Thanh toán hóa đơn',
  Cargo_InvoicingPerMonth: 'Thanh toán hàng tháng',
  Cargo_InvoicingRequirements: 'Yêu cầu thanh toán',
  Cargo_InvoicingSearch: 'Yêu cầu thanh toán',
  Cargo_InvoicingStatus: 'Trạng thái thanh toán',
  Cargo_InvoicingType: 'Loại Bill',
  Cargo_InvoicingVerification: 'Kiểm tra hóa đơn',
  Cargo_IOSPIM: 'Đối tượng thanh toán phải nhập thông tin',
  Cargo_IPCTFATROJE: 'Tham số không hợp lệ Không tìm thấy quy tắc đối tượng mục',
  Cargo_IsBroken: 'Đối với số bị hỏng',
  Cargo_IsExtended: 'Nếu quá hạn',
  Cargo_IsItAR: 'Có nên nhận hay không?',
  Cargo_IsItCollection: 'Có phải là thu tiền không?',
  Cargo_IsItDefaultExpense: 'Phí mặc định',
  Cargo_IsCharterFlightCosts: 'Chi phí thuê máy bay',
  Cargo_IsCharterVesselCosts: 'Cho dù chi phí bao bì',
  Cargo_IsCharterFlight: 'Điều lệ hoặc không',
  Cargo_IsCharterVessel: 'Có hay không tấm ốp',
  Cargo_Number_Of_Charter_Containers: 'Số lượng Charter Collector',
  Cargo_Charter_weight_Restrictions: 'Điều lệ trọng lượng hạn chế',
  Cargo_Charter_Volume_Restrictions: 'Điều lệ khối lượng hạn chế',
  Cargo_Description_of_the_package_Information: 'Mô tả thông tin ốp',
  Cargo_Pallets_can_be_loaded_in_Weight: 'Trọng lượng tải được của tấm ốp',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: 'Khối lượng tải được của tấm ốp',
  Cargo_The_Total_Cost_Amount: 'Tổng chi phí',
  Cargo_Unit_Load_Device: 'Bộ sưu tập',
  Cargo_MountingInformation: 'Thông tin lắp ráp',
  Cargo_Please_Load_The_Main_Ticket: 'Vui lòng đặt vé chính.',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: 'Vui lòng thực hiện thao tác dọn dẹp trên vé chính',
  Cargo_OtherBusinessUse: 'Sử dụng kinh doanh khác',
  Cargo_DefaultArSettlementObject: 'Mặc định phải thu các đối tượng thanh toán cố định',
  Cargo_DefaultArSettlementObjectNull: 'Các đối tượng cần nhận mặc định có trống không',
  Cargo_DefaultApSettlementObject: 'Đối tượng thanh toán cố định phải trả mặc định',
  Cargo_DefaultApSettlementObjectNull: 'Đối tượng phải trả mặc định có rỗng hay không',
  Cargo_IsItWriteOff: 'Bảo hiểm rủi ro',
  Cargo_IsoCode: 'Mã ISO',
  Cargo_IsShutOut: 'Đã hoàn quan',
  Cargo_IssuanceReceiptOfInvoice: 'Đăng ký nhận vé',
  Cargo_Issued: 'Đã xuất bản',
  Cargo_IssueHbl: 'Đăng ký HBL',
  Cargo_IssueInvoiceDirectly: 'Tạo hóa đơn trực tiếp',
  Cargo_IssueInvoiceDirectlyOrNot: 'Có nên lập hóa đơn trực tiếp hay không',
  Cargo_IssueOfTheYear: '{0} kỳ hàng năm {1}',
  Cargo_ISWBDC: 'Bạn có chắc chắn muốn xóa {0} dữ liệu này?',
  Cargo_Item: 'Dự án',
  Cargo_Item1: 'Dự án I',
  Cargo_Item2: 'Dự án II',
  Cargo_ItemNo: 'Số mặt hàng',
  Cargo_ItemNo2P: 'Mục số 2:',
  Cargo_ItemNoP: 'Số mặt hàng:',
  Cargo_ItemsAdded: 'Đã thêm {0}',
  Cargo_ItemsNBR: 'Số mảnh',
  Cargo_ReturnContainerAddress: 'Địa chỉ trả container',
  Cargo_LoadingAddress: 'Địa chỉ đóng hàng',
  Cargo_ITIOCBNMPCBITIITBCPOTS: 'Hiện nay nhận dạng đầu cuối kết thủ vé của chi nhánh không được bảo trì, xin vui lòng cấu hình nhận dạng đầu cuối kết thủ vé của Bách Vượng trong cấu hình cơ bản',
  Cargo_ITPIEI: 'Loại hóa đơn Hóa đơn giấy Hóa đơn điện tử',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: 'Nếu bạn đã xác định với người nộp đơn và quyết định hủy bỏ đơn xin lập hóa đơn, vui lòng nhấp vào "Có"; Nếu bạn giữ lại đơn đăng ký làm căn cứ để lập hóa đơn trong tương lai, hãy nhấp vào "Không", xác nhận bạn có muốn hủy bỏ đơn đăng ký không?',
  Cargo_January: 'Tháng Giêng',
  Cargo_JEODTD: 'Các mục có kiểu dữ liệu ({0}) đã bị xóa!',
  Cargo_JEOOSC: 'Trung tâm thanh toán nước ngoài',
  Cargo_JFOCP: 'lĩnh vực phân biệt trả tiền',
  Cargo_JobListSearched: 'Danh sách công việc đã được yêu cầu',
  Cargo_JobNo: 'Số công việc',
  Cargo_JobNoP: 'Số công việc:',
  Cargo_JobTypeImport: 'Nhập khẩu',
  Cargo_JournalEntryCategory: 'Kiểu phân loại',
  Cargo_JournalEntryRule: 'Quy tắc phân loại',
  Cargo_July: 'Tháng Bảy',
  Cargo_June: 'Tháng Sáu',
  Cargo_KeyWord: 'Từ nhạy cảm',
  Cargo_KeyWordCanTBeEmpty: 'Những từ nhạy cảm không được để trống',
  Cargo_KingdeeCloudApprove: 'Đánh giá Golden Butterfly Cloud',
  Cargo_KingdeeCloudReview: 'Kiểm toán đám mây bướm vàng',
  Cargo_LastAccrualTime: 'Thời gian tính toán mới nhất',
  Cargo_LastDate: 'Ngày cuối',
  Cargo_LastInvoiceNo: 'Số hóa đơn cuối cùng',
  Cargo_LastModificationTime: 'Thời gian sửa đổi cuối cùng:',
  Cargo_LastReceiveDate: 'Ngày nhận tiền cuối cùng',
  Cargo_LastReceivingDate: 'Ngày nhận tiền cuối cùng',
  Cargo_LastTimeBalance: 'Số dư cuối cùng',
  Cargo_LBNRYSTW: 'Nghiệp vụ liên quan vẫn chưa được xét duyệt, xác nhận phải trả lại đơn hàng sao?',
  Cargo_LegalUnit: 'Đơn vị pháp lý',
  Cargo_Lender: 'Cho vay',
  Cargo_LessThan: 'Nhỏ hơn',
  Cargo_Letter: 'Từ',
  Cargo_Level: 'Cấp bậc',
  Cargo_Level1AccountTitle: 'Chủ đề cấp 1',
  Cargo_Level2AccountTitle: 'Chủ đề cấp II',
  Cargo_Level3AccountTitle: 'Chủ đề cấp 3',
  Cargo_Level4AccountTitle: 'Chủ đề cấp 4',
  Cargo_Level5AccountTitle: 'Chủ đề cấp 5',
  Cargo_Level6AccountTitle: 'Chủ đề cấp 6',
  Cargo_Limit: 'Hạn mức',
  Cargo_LinkBills: 'Liên kết hóa đơn',
  Cargo_LinkOffsetExpenseDifferentials: 'Có liên quan đến chi phí phòng ngừa chênh lệch không?',
  Cargo_LinkPaymentRequests: 'Yêu cầu thanh toán có liên quan hay không',
  Cargo_LinkToInvoice: 'Liên kết với hóa đơn',
  Cargo_Load: 'Đang tải',
  Cargo_LoadCache: 'Đang tải bộ nhớ tạm',
  Cargo_Loaded: 'Tải xong',
  Cargo_LoadedAndSave: 'Tải xong, nhấn Save.',
  Cargo_LoadingAtDoor: 'Đóng gói điểm cửa',
  Cargo_LoadingAtFactory: 'Sản xuất',
  Cargo_LoadOrNot: 'Đang tải',
  Cargo_Loan: 'Cho vay',
  Cargo_LoanSwap: 'Trao đổi cho vay',
  Cargo_LocalAgent: 'Đại lý địa phương',
  Cargo_LocalCharge: 'Chi phí địa phương',
  Cargo_LocalChargeOrNot: 'Chi phí địa phương',
  Cargo_LocalCurrency: 'Tiền bản vị',
  Cargo_LocalizedName: 'Bản địa hoá Name',
  Cargo_Location: 'Địa điểm',
  Cargo_LocationOfCurrentVoucher: 'Vị trí của chứng từ hiện tại',
  Cargo_LockCancellationDate: 'Hủy khóa ngày',
  Cargo_LockTheBill: 'Danh sách khóa',
  Cargo_Log: 'Đăng nhập',
  Cargo_LogisticsCompany: 'Công ty Logistics',
  Cargo_LogRecord: 'Đăng nhập',
  Cargo_LOTFINMBGT3D: 'Số hóa đơn đầu tiên phải dài hơn ba chữ số.',
  Cargo_LowerCase: 'Chữ thường',
  Cargo_MainLineTransport: 'Vận tải đường bộ',
  Cargo_MaintenanceOfShippingTerms: 'Điều khoản vận chuyển Bảo trì',
  Cargo_ManagementOfWithdrawal: 'Quản lý hoàn trả',
  Cargo_ManageParameters: 'Quản lý các tham số truy vấn',
  Cargo_MANMWCSAISCTD: 'Địa chỉ chuyển phát nhanh khác với địa chỉ khách hàng trong dữ liệu bảo trì hệ thống, bạn có chắc chắn muốn gửi không?',
  Cargo_March: 'Tháng Ba',
  Cargo_Mark: 'Đánh dấu',
  Cargo_MarkTime: 'Thời gian đánh dấu',
  Cargo_Marker: 'Trang chủ',
  Cargo_MarkStatus: 'Trạng thái thẻ',
  Cargo_MarkCancelledSuccessfully: 'Hủy thẻ thành công',
  Cargo_MarkDate: 'Ngày kích thước',
  Cargo_Marked: 'Tagged thành công',
  Cargo_MarkedBy: 'Người đánh dấu',
  Cargo_MarkOfConfirmation: 'Đánh dấu xác nhận',
  Cargo_Marks: 'Nhãn hiệu vận chuyển',
  Cargo_MarkSymbols: 'Nhận dạng thẻ',
  Cargo_MasterBillNotSearched: 'Vé chính Không yêu cầu',
  Cargo_May: 'Tháng Năm',
  Cargo_MBACM: 'Sửa đổi cách tính số tiền thanh toán',
  Cargo_MBEIRPSUB: 'Các hóa đơn được đánh dấu tồn tại trong hồ sơ, vui lòng chọn hóa đơn không được đánh dấu.',
  Cargo_MBLAudit: 'Kiểm toán MBL',
  Cargo_MBLCargoDetention: 'MBL khấu trừ',
  Cargo_MBLFreightTerm: 'Điều khoản vận chuyển chính',
  Cargo_MblNo: 'Số đơn chính',
  Cargo_MBLPayable: 'MBL có thể thanh toán',
  Cargo_MBLPaymentTime: 'Thời gian thanh toán MBL',
  Cargo_MBLReviewTime: 'Thời gian kiểm tra MBL',
  Cargo_MBLTimeOfCargoHolding: 'MBL khấu trừ thời gian',
  Cargo_MBLTransitTerm: 'Điều khoản vận chuyển đơn chính',
  Cargo_MDEPSBP: 'Có dữ liệu đã được sửa đổi, xin lưu lại rồi in vẽ.',
  Cargo_MDEPSBPIN: 'Nếu có thay đổi dữ liệu, vui lòng lưu lại trước khi in [Số hóa đơn:{0}]',
  Cargo_Merge: 'Bắt đầu hợp nhất',
  Cargo_MergeOrNot: 'Hợp nhất hay không',
  Cargo_MethodOfClaim: 'Mẫu yêu cầu bồi thường',
  Cargo_MethodOfClaimP: 'Chế độ yêu cầu bồi thường:',
  Cargo_Metrics: 'Đo lường',
  Cargo_MfnTaxRate: 'Thuế suất MFN',
  Cargo_Mode: 'Chế độ',
  Cargo_ModelSpecification: 'Mô hình đặc điểm kỹ thuật',
  Cargo_ModificationOfCollection: 'Sửa đổi nhờ thu',
  Cargo_ModificationTime: 'Thời gian sửa đổi',
  Cargo_ModifiedDataNotSavedCancel: 'Dữ liệu đã sửa đổi không được lưu, xác nhận hủy bỏ?',
  Cargo_Modifier: 'Thay đổi người',
  Cargo_Modify: 'Sửa đổi',
  Cargo_ModifyAccountTitle: 'Sửa đổi đối tượng',
  Cargo_ModifyAccountTitleName: 'Thay đổi tên đối tượng',
  Cargo_ModifyAdjustBill: 'Hóa đơn - Điều chỉnh sửa đổi',
  Cargo_ModifyBillingInformation: 'Sửa đổi thông tin thanh toán',
  Cargo_ModifyCollectionInformation: 'Sửa đổi thông tin nhờ thu',
  Cargo_ModifyInvoice: 'Thay đổi hóa đơn',
  Cargo_ModifyPort: 'Sửa đổi cảng',
  Cargo_ModifyRailwayStation: 'Sửa đổi trạm đường sắt',
  Cargo_ModifyOverseaWarehouse: 'Biên tập viên kho hải ngoại',
  Cargo_AddOverseaWarehouse: 'Thêm Amazon Bin',
  Cargo_NewOverseaWarehouse: 'Nhà kho mới ở nước ngoài',
  Cargo_CannotDeleteWarehouse: '{0} Mã kho đã được sử dụng và không thể xóa!',
  Cargo_ModifyRateWithTax: 'Sửa đổi giá bao gồm thuế',
  Cargo_ModifySelectedInvoiceStatus: 'Thay đổi trạng thái hóa đơn đã chọn',
  Cargo_ModifyWriteOffRecord: 'Sửa đổi nucleopin record',
  Cargo_MOMAOB: 'Hỗ trợ khách hàng Bảo trì số dư ban đầu',
  Cargo_MonetaryEquivalent: 'Chiết khấu',
  Cargo_MonetaryEquivalentCNY: 'Chiết khấu số tiền CNY',
  Cargo_Month: 'Tháng',
  Cargo_FinanceMonthUnitTip: 'Tính theo tháng dương: mốc giới hạn lùi N tháng từ ngày 1 của tháng hiện tại, chỉ khóa dữ liệu trước mốc (không bao gồm ngày mốc). Ví dụ: cấu hình 2 tháng vào tháng 9 sẽ khóa dữ liệu trước ngày 1/7 (không bao gồm ngày 1/7)',
  Cargo_Monthly: 'Nút mặt trăng',
  Cargo_MonthlyReconciliation: 'Đối chiếu hàng tháng',
  Cargo_Months: 'Tháng',
  Cargo_MoreConditions: 'Thêm điều kiện',
  Cargo_MoreSearch: 'Thêm thông tin',
  Cargo_Motorcade: 'Trang chủ',
  Cargo_MscServiceCode: 'Mã dịch vụ',
  Cargo_MultipleChoiceBox: '【Nhiều hộp chọn】',
  Cargo_MultipleCurrenciesExit: 'Tồn tại nhiều loại tiền tệ.',
  Cargo_MultipleSettlingPartiesExist: 'Có nhiều đối tượng thanh toán.',
  Cargo_MUPIOOPFWO: 'Có nên sử dụng thanh toán thực hay không',
  Cargo_MustSelectTheSameClient: 'Phải chọn cùng một khách hàng.',
  Cargo_MVOACP: 'Có nên duy trì chứng từ trả trước hay không',
  Cargo_MVOARAPOI: 'Có nên duy trì chứng từ hóa đơn bảo hiểm rủi ro phải thu hay không',
  Cargo_Name: 'Tên',
  Cargo_NameCanTBeEmpty: 'Tên không được để trống.',
  Cargo_EnglishNameCheck: 'Tên tiếng Anh không được để trống.',
  Cargo_ExistDoorSite: 'Đã có cùng một thông tin cửa',
  Cargo_PleaseSelectCommissioningUnit: 'Vui lòng chọn đơn vị ủy thác trong số các đối tác',
  Cargo_PleaseInputOneDoorInfoAtLeast: 'Vui lòng nhập ít nhất một thông tin cửa',
  Cargo_LandTransportationDetails: 'Thông tin chi tiết về Land Transport',
  Cargo_NameP: 'Tên:',
  Cargo_NAMISANOSNBCWBRS2DPTED: 'Lưu ý: Nhắc nhở là"nhắc nhở hệ thống", hệ thống sẽ nhắc nhở lại 2 ngày trước khi hết hạn để cấm tạo cấu hình kinh doanh',
  Cargo_NatureOfSales: 'Tài sản bán hàng',
  Cargo_NBCTBGTC: 'Sự khác biệt tiêu cực không thể lớn hơn -1 xu.',
  Cargo_NECDFTIC: 'Không được vượt quá {0} một loại tiền tệ khác với loại tiền được lập hóa đơn',
  Cargo_BillPaymentCurrencyBeyond: 'Không được vượt quá {0} tiền tệ khác với tiền tệ thanh toán!',
  Cargo_PayByBillingRate: 'Thanh toán theo tỷ giá thanh toán',
  Cargo_NeedAccountingPeriod: 'Xin lỗi, phiên bản phần mềm của tài khoản bạn đang sử dụng"Phần mềm tài chính Water"Cần thiết lập kỳ kế toán để chỉnh sửa chủ đề',
  Cargo_NeedAccrue: 'Có kế hoạch hay không?',
  Cargo_NeedCustomsDeclare: 'Khai báo hải quan',
  Cargo_NeedHqToWriteOffOrNot: 'Có cần qua trụ sở chính không?',
  Cargo_NeedInvoiceOrNot: 'Có cần lập hóa đơn không?',
  Cargo_NeedMandatoryAccrue: 'Có bắt buộc hay không?',
  Cargo_NeedToBillCNYToCNY: 'Cần thu thập {0} {1}RMB',
  Cargo_NeedToConfiCNYankAccountOrNot: 'Cần xác nhận số tài khoản ngân hàng',
  Cargo_NeedToCreateBillOrNot: 'Bạn muốn tạo hóa đơn?',
  Cargo_NeedToExportOrNot: 'Nếu bạn cần xuất khẩu',
  Cargo_NeedToPayTo: 'Phải trả tiền cho {0} {1}RMB',
  Cargo_NEFEIDE: 'Bộ lọc không rỗng khi xuất mặc định',
  Cargo_NegotiationStage: 'Giai đoạn kinh doanh',
  Cargo_NEIAFPRPOCA: 'Không có lệ phí cho đơn đăng ký, vui lòng làm mới lại trang web hoặc liên hệ với quản trị viên hệ thống',
  Cargo_NEICTBD: 'Hóa đơn không điện tử không thể được tải xuống.',
  Cargo_NetWork: 'Mạng lưới',
  Cargo_NetworkName: 'Mạng lưới Name',
  Cargo_NetworkNameCanTBeEmpty: 'Tên mạng không được để trống',
  Cargo_New: 'Mới',
  Cargo_NewAccountStatement: 'Báo cáo mới',
  Cargo_NewAccountTitle: 'Đối tượng mới',
  Cargo_NewFiscalPeriod: 'Kỳ kế toán mới',
  Cargo_NewInvoiceNo: 'Số hóa đơn mới',
  Cargo_NewInvoiceNoP: 'Số hóa đơn mới:',
  Cargo_NewPaymentRequest: 'Tạo yêu cầu thanh toán',
  Cargo_NewValue: 'Giá trị mới',
  Cargo_Next: 'Tiếp theo',
  Cargo_NextItem: 'Tiếp theo',
  Cargo_NextStep: 'Nhiệm vụ tiếp theo',
  Cargo_NextStepToSave: 'Tiếp theo Save',
  Cargo_NFFICSPRE: 'Không tìm thấy tập tin lưu trữ đám mây Vui lòng xuất lại',
  Cargo_NFMKWPEAW: 'Lưu ý: Nhiều từ nhạy cảm xin vui lòng quay lại xe',
  Cargo_NFPAFTS: 'Không có khoảng thời gian tài chính có sẵn cho tài khoản này.',
  Cargo_NFPSCATWBSACYCTS: 'Vì không có kỳ kế toán, năm đối tượng hiện tại sẽ được thiết lập trong năm nay và xác nhận sẽ tiếp tục được lưu.',
  Cargo_NMT2MCTAIEAWO: 'Trong chi phí không thể xuất hiện hơn hai loại tiền tệ khác với tiền tiêu thụ.',
  Cargo_NNTCVFCOPL: 'Không cần tạo chứng từ lãi và lỗ',
  Cargo_NNTEIBOPLBFSOATBOTY: 'Sổ sách đầu năm sử dụng, không cần ghi vào số dư ban đầu tổn hại nha.',
  Cargo_No: 'Không',
  Cargo_NOATGCAAIODMBETTGMO: 'Điều kiện nhóm các môn học sắp xếp theo thứ tự, dữ liệu phải bằng với nhóm các môn học trừ một!',
  Cargo_NoBillToConfirm: 'Không có hóa đơn xác nhận.',
  Cargo_NoBillToCreateSoa: 'Không có hóa đơn để làm báo cáo.',
  Cargo_NoBillToWriteOff: 'Không có hóa đơn cần bán.',
  Cargo_NoBusinessNeedFinancialReview: 'Không có doanh nghiệp để kiểm toán tài chính.',
  Cargo_NoBusinessTypeSelected: 'Loại hình kinh doanh Chưa chọn',
  Cargo_NoCitySelectedToEdit: 'Chưa chọn thành phố để chỉnh sửa',
  Cargo_NoConfirmedBillToCancel: 'Không có hóa đơn xác nhận hủy bỏ.',
  Cargo_NoData: 'Không có dữ liệu.',
  Cargo_NoDataModifiedNoNeedToSave: 'Không có dữ liệu nào được sửa đổi và không cần lưu.',
  Cargo_NoDataSelected: 'Không có dữ liệu nào được chọn.',
  Cargo_NoDataSelectedToDelete: 'Chưa chọn dữ liệu cần xóa',
  Cargo_NoDataToExport: 'Không có dữ liệu để xuất.',
  Cargo_NoDataToModify: 'Không có dữ liệu có thể thay đổi',
  Cargo_NoDataToPreview: 'Không có dữ liệu để xem trước.',
  Cargo_NoDataToTransfer: 'Không có dữ liệu để gửi.',
  Cargo_NoDoNotLink: 'Không, tôi không liên quan.',
  Cargo_NOEGT1ICTSTNWBST1C: 'Số lượng chi phí lớn hơn 1, nếu tiếp tục chia chi phí sẽ đặt số lượng thành 1, bạn có chắc muốn tiếp tục không?',
  Cargo_NoElectronicInvoiceNoToCreate: 'Không có số hóa đơn điện tử nào được tạo ra.',
  Cargo_NoEligibleExpenseToPrint: 'Không có chi phí đủ điều kiện để in.',
  Cargo_NoEligibleRecord: 'Không có hồ sơ nào đủ điều kiện.',
  Cargo_NoEligibleRecordsFound: 'Không truy vấn hồ sơ đáp ứng yêu cầu',
  Cargo_NoExpenseDifferentialsToProcess: 'Không có chi phí chênh lệch để xử lý.',
  Cargo_NoExpenseToBill: 'Không có chi phí để làm hóa đơn.',
  Cargo_NoExpenseToInvoice: 'Không có chi phí để lập hóa đơn.',
  Cargo_NoExpenseToReject: 'Không có chi phí bị từ chối',
  Cargo_NoExpenseToReview: 'Không có chi phí kiểm toán',
  Cargo_NoExpenseToWriteOff: 'Không có chi phí bán hàng.',
  Cargo_NoFileToRetrieve: 'Không có tập tin để lấy lại.',
  Cargo_NoFileToRevoke: 'Không có tập tin để hủy bỏ',
  Cargo_NoForeignCurrencyAccounting: 'Không có kế toán ngoại tệ',
  Cargo_NoInvoiceNo: 'Không có số hóa đơn',
  Cargo_NoInvoiceNoForInvoiceAmounted: 'Hóa đơn với số tiền {0} không có số hóa đơn!',
  Cargo_NoInvoiceNoToCheck: 'Không có số hóa đơn cần kiểm tra',
  Cargo_NoMaintainedBankForClient: 'Khách hàng không duy trì ngân hàng',
  Cargo_NoMatchedRecordFound: 'Không có hồ sơ nào đáp ứng yêu cầu.',
  Cargo_NominatedAgent: 'Đại lý vận chuyển được chỉ định',
  Cargo_NonAccrual: 'Phi kế đề cập',
  Cargo_None: 'Không',
  Cargo_NoneAnyBillable: 'Không có chi phí để lập hóa đơn.',
  Cargo_NoNeedToRepeatConfirmation: 'Đã xác nhận, không cần xác nhận lại.',
  Cargo_NoNeedToSplitThisKeyWord: 'Từ nhạy cảm này không cần chia',
  Cargo_NonElectronicInvoice: 'Hóa đơn không điện tử',
  Cargo_NonSplitWriteOffExpense: 'Chi phí tiêu thụ hạt nhân không thể tách rời.',
  Cargo_NoNumberBreak: 'Không có số ngắt',
  Cargo_NoOfPages: 'Số trang',
  Cargo_NoParentAccountTitles: 'Không có đối tượng cấp trên',
  Cargo_NoPortSelected: 'Cảng không chọn',
  Cargo_NoRecordChecked: 'Hồ sơ không được đánh dấu.',
  Cargo_NoRecordSelected: 'Không có bản ghi nào được chọn.',
  Cargo_NoRecordToSave: 'Không có hồ sơ để lưu.',
  Cargo_NoRelease: 'Không đặt hàng',
  Cargo_NoReviewedExpenseToCancel: 'Không có chi phí hủy bỏ',
  Cargo_NoServiceTicketToDelete: 'Không có xác nhận chi phí có thể được xóa.',
  Cargo_NoSiteSelected: 'Trang web chưa chọn',
  Cargo_NoSobSetUpCurrently: 'Hiện tại không có tài khoản nào được thiết lập.',
  Cargo_NotAcquired: 'Không sử dụng',
  Cargo_NotAdjustedExpense: 'Chi phí không điều chỉnh',
  Cargo_NotAFinalAccountTitle: '【{0}}】 không phải là chủ đề cuối cùng.',
  Cargo_NotCarriedOver: 'Chưa kết thúc',
  Cargo_NotCollectAdvance: 'Ứng trước không thay thế',
  Cargo_NotCollected: 'Không nhận',
  Cargo_NotCollectedCNY: 'CNY không nhận',
  Cargo_NotCollectedEUR: 'EUR không nhận',
  Cargo_NotCollectedGBP: 'GBP không nhận',
  Cargo_NotCollectedHKD: 'HKD không nhận',
  Cargo_NotCollectedInFull: 'Không nhận đủ',
  Cargo_NotCollectedJPY: 'JPY không nhận',
  Cargo_NotCollectedNGN: 'NGN không nhận',
  Cargo_NotCollectedP: 'Không nhận:',
  Cargo_NotCollectedUSD: 'USD không nhận',
  Cargo_Collected: 'Đã nhận',
  Cargo_NotContracted: 'Chưa ký',
  Cargo_NotDisplayedIfMultipleItemsExist: 'Không hiển thị khi có nhiều hơn một',
  Cargo_NOTDIST: 'Hiển thị số mẫu trong thẻ truy vấn',
  Cargo_NotificationOfPaymentFreeze: 'Thông báo thanh toán đóng băng',
  Cargo_NotificationOfUnfrozenPayment: 'Thông báo thanh toán rã đông',
  Cargo_NotifyHq: 'Thông báo trụ sở',
  Cargo_NotifyId: 'Mã thông báo',
  Cargo_NotifyInfo: 'Thông tin thông báo',
  Cargo_NotifyParty: 'Thông báo',
  Cargo_NotifyPartySName: 'Tên thông báo',
  Cargo_NotifyUser: 'Nhắc nhở người dùng',
  Cargo_NotifyMethod: 'Thông báo',
  Cargo_NotInvoicedMoney: 'Số tiền chưa thanh toán',
  Cargo_NoTotal: '{0} Tổng số {1}',
  Cargo_NotReviewed: 'Chưa kiểm toán',
  Cargo_NotSent: 'Chưa gửi',
  Cargo_NotSet: 'Chưa đặt',
  Cargo_NotSubmittedCanTWithdraw: 'Chưa nộp không thể hoàn trả',
  Cargo_NotTaxFree: 'Không miễn thuế',
  Cargo_NotWrittenBack: 'Chưa đánh đỏ',
  Cargo_NotWrittenOff: 'Không có pin hạt nhân',
  Cargo_NotWrittenOff2: 'RMB chưa bán',
  Cargo_NotWrittenOffCurrency: 'Chưa bán ({0})',
  Cargo_NotWrittenOffHKD: 'Chưa bán (HKD)',
  Cargo_NotWrittenOffUSD: 'Chưa chốt (USD)',
  Cargo_NoUnInvoicedExpense: 'Không có chi phí chưa thanh toán.',
  Cargo_November: 'Tháng 11',
  Cargo_NPDOSB: 'Không có dữ liệu ban đầu về số dư phụ trợ.',
  Cargo_NRFTAL: 'Tự kéo tự gửi',
  Cargo_NSEFPCA: 'Không tìm thấy phí chia tách, vui lòng liên hệ với quản trị viên!',
  Cargo_NTWBWRLION: 'Bạn có muốn lập hóa đơn chữ đỏ không?',
  Cargo_Number: 'Số',
  Cargo_NumberS: 'Số',
  Cargo_NumberOfAttachedDocuments: 'Số lượng tài liệu đính kèm',
  Cargo_NumberOfCopies: 'Số bản sao',
  Cargo_NumberOfCopiesCanTBe0: 'Số phần không thể là 0.',
  Cargo_NumberOfExpenseWriteOffs: 'Số lượng chi phí bán hàng',
  Cargo_NumberOfNominatedAgents: 'Xác định số đại lý',
  Cargo_OBCILC: 'Số dư đầu kỳ (tổng hợp tiền bản vị)',
  Cargo_OBIMICMAWTCSCCPBR: 'Khi phương thức nhận tiền là séc Chuyển khoản ngân hàng Giấy chứng nhận chuyển khoản ngân hàng',
  Cargo_OceanExport: 'Xuất khẩu bằng đường biển',
  Cargo_OceanFreight: 'Vận chuyển',
  Cargo_OceanImport: 'Nhập khẩu bằng đường biển',
  Cargo_OceanImportExport: 'Xuất nhập khẩu bằng đường biển',
  Cargo_OCLWSPCBS: 'Chỉ có thể chọn khách hàng liên quan đến bán hàng',
  Cargo_October: 'Tháng Mười',
  Cargo_Oddment: 'Số lẻ.',
  Cargo_ODWSSCBP: 'Chỉ có thể in các chứng từ có cùng trạng thái.',
  Cargo_OEOSET: 'Tổng vốn chủ sở hữu hoặc vốn cổ đông',
  Cargo_OEVCBWB: 'Chỉ có thể đỏ vọt chứng từ đã xuất khẩu.',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: 'Thao tác không thành công, toàn bộ hoặc một phần phí đang trong quá trình phê duyệt thanh toán, vui lòng thực hiện sau khi quá trình hoàn tất.',
  Cargo_OFCIIFPRNRN: 'Đã bao gồm các khoản phí đã được lập hóa đơn, vui lòng chọn lại n Đơn yêu cầu thanh toán:',
  Cargo_OFCTCMT2: 'Thao tác thất bại, tiền tệ không thể vượt quá hai loại.',
  Cargo_OffsetDataSource: 'Hedge nguồn dữ liệu',
  Cargo_OffsetEntity: 'Thực thể phòng hộ',
  Cargo_OffsetOrNot: 'Bảo hiểm rủi ro',
  Cargo_MustInvoiceNoAndTitle: 'Phải điền số hóa đơn và thanh toán',
  Cargo_OFGTECOBUFEIIC: 'Thao tác thất bại, "xuất thuế vàng" chỉ có thể tác dụng trên hóa đơn điện tử có loại tiền tệ là nhân dân tệ.',
  Cargo_OFNBFSWWF: 'Không thể lập hóa đơn, không có chi phí lập hóa đơn.',
  Cargo_OFTAPFSDNMTIR: 'Tình trạng chi phí phải trả không đáp ứng yêu cầu lập hóa đơn',
  Cargo_OFTARFSDNMTIR: 'Tình trạng thu phí không đáp ứng yêu cầu lập hóa đơn',
  Cargo_OFTCBDNMTTINSIIITIEI: 'Thao tác thất bại, hiện tại chi nhánh không duy trì số nhận dạng người nộp thuế, nên không thể lập hóa đơn điện tử.',
  Cargo_OFTFRCWNM: 'Thao tác thất bại, không đáp ứng điều kiện xét duyệt tài chính.',
  Cargo_OFTFRCWNMCSRT: 'Không thể trực tiếp xét duyệt tài chính, thay đổi cấu hình rồi thử lại.',
  Cargo_OFTIISCBD: 'Hóa đơn, không thể xóa.',
  Cargo_OFTIRCBDTNIAF: 'Đơn xin khai hóa đơn sau đây đã khai hóa đơn, không thể xóa bỏ!',
  Cargo_OFTIRCBETNIAF: 'Đơn xin khai hóa đơn sau đây đã khai hóa đơn, không thể biên tập!',
  Cargo_OFTRFOTARFCBIITB: 'Chi phí trong hóa đơn bao gồm chi phí đỏ hoặc chi phí bị đỏ',
  Cargo_OFTUFSCBS: 'Thao tác không thành công, chi phí chưa lưu không thể tiến hành thao tác phân tách.',
  Cargo_OFTWOANTBETTSOREGALFE: 'Thao tác thất bại, kim ngạch tiêu thụ hạt nhân lần này cần bằng với kim ngạch thu tiền+tổn thất hối đoái+chi phí tài chính+tổng số lẻ.',
  Cargo_OFWTIARTARMBGTTAP: 'Hoạt động không thành công và khi loại thu chi là phải thu, tổng số phải thu phải lớn hơn tổng số phải trả.',
  Cargo_OIRWPSCBCAC: 'Chỉ có trạng thái đơn xin lập hóa đơn chờ lập hóa đơn mới có thể tạo ra danh sách vé!',
  Cargo_OIWWBCBP: 'Chỉ có thể in hóa đơn chưa đỏ.',
  Cargo_OnAccountHedge: '(Hàng rào sổ sách)',
  Cargo_OneClickRenewal: 'Đổi mới một lần nhấp',
  Cargo_OnlyCheckedRecordsCanBeCancelled: 'Chỉ có thể hủy bỏ các bản ghi đã được kiểm tra lại.',
  Cargo_OnlyReviewedVouchersCanBeDeleted: 'Bạn chỉ có thể xóa các chứng từ chưa được kiểm duyệt.',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: 'Bạn chỉ có thể xem lại các bản ghi chưa được xem lại.',
  Cargo_OOAPIICCTTTEPRCOEA: 'Nhờ thu chỉ có chi phí chưa trả, không thể chuyển tiếp chi phí nữa, xin làm nhờ thu hoặc xin chi phí khác!',
  Cargo_OORCBSFASBI: 'Một vé chỉ có thể chọn một bản ghi.',
  Cargo_OpeningAmountOfTheYear: 'Số đầu năm',
  Cargo_OpeningBalance: 'Số dư đầu kỳ',
  Cargo_OpeningBalanceCreditCNY: 'Bên cho vay số dư đầu kỳ (NDT)',
  Cargo_OpeningBalanceCreditUSD: 'Tín dụng số dư đầu kỳ (USD)',
  Cargo_OpeningBalanceDebitCNY: 'Bên cho vay số dư đầu kỳ (NDT)',
  Cargo_OpeningBalanceDebitUSD: 'Nợ số dư đầu kỳ (USD)',
  Cargo_OperateBy: 'Người vận hành',
  Cargo_OperatedSuccessfullyRefreshPage: 'Hành động Làm mới lại trang thành công',
  Cargo_OperatingCompany: 'Đơn vị kinh doanh',
  Cargo_Operation: 'Hoạt động',
  Cargo_OperationCompany: 'Công ty vận hành',
  Cargo_OperationComplete: 'Hoạt động thành công',
  Cargo_OperationDate: 'Ngày hoạt động',
  Cargo_OperationDepartment: 'Phòng điều hành',
  Cargo_OperationOffice: 'Chi nhánh hoạt động',
  Cargo_OperationFailed: 'Hoạt động thất bại',
  Cargo_OperationHistory: 'Lịch sử hoạt động',
  Cargo_OperationModeAir: 'Chế độ hoạt động (không khí)',
  Cargo_OperationModeAirExport: 'Chế độ hoạt động (trống)',
  Cargo_OperationModeAirImport: 'Chế độ hoạt động (trống)',
  Cargo_OperationRequirementType: 'Loại yêu cầu hoạt động',
  Cargo_OperationSuccessfully: 'Chiến dịch thành công.',
  Cargo_HblTeleReleaseGuarantee: 'Bảo lãnh kiểm tra in điện phóng HBL',
  Cargo_TeleReleaseBillType: 'Các loại vận đơn điện tử',
  Cargo_OperationSymbol: 'Biểu tượng hoạt động',
  Cargo_OperationType: 'Loại hoạt động',
  Cargo_OperationTypeCanTBeEmpty: 'Loại yêu cầu hoạt động không được để trống',
  Cargo_Operator: 'Nhà điều hành',
  Cargo_OperatorOfWithdrawal: 'Trả lại người qua tay',
  Cargo_OppositeVoucherNo: 'Số chứng từ của nhau',
  Cargo_OppositeVoucherNoP: 'Số chứng từ của đối phương:',
  Cargo_OPVWES: 'Điều này chỉ có thể được thực hiện trên các chứng từ có trạng thái được xem xét.',
  Cargo_Order: 'Cấp bậc',
  Cargo_OrdinaryTaxRate: 'Thuế suất thông thường',
  Cargo_ORDM: 'Yêu cầu hoạt động Mô tả Bảo trì thông tin',
  Cargo_Original: 'Nguyên bản',
  Cargo_OriginalAmount: 'Số tiền gốc',
  Cargo_OriginalAmountCNY: 'Số tiền gốc CNY',
  Cargo_OriginalAmountInBill: 'Số hóa đơn gốc',
  Cargo_OriginalAmountUSD: 'USD Số tiền ban đầu',
  Cargo_OriginalContent: 'Nội dung gốc',
  Cargo_OriginalCurrency: 'Tiền gốc',
  Cargo_OriginalCurrencyInBill: 'Hóa đơn tiền tệ gốc',
  Cargo_OriginalCurrencyNotWrittenOff: 'Tiền tệ gốc chưa bán',
  Cargo_OriginalCurrencyP: 'Nguyên tệ:',
  Cargo_OriginalExchangeRateInBill: 'Tỷ giá gốc hóa đơn',
  Cargo_OriginalExpense: 'Phí gốc',
  Cargo_OriginalExpenseAmount: 'Số tiền phí gốc',
  Cargo_OriginalExpenseP: 'Phí gốc:',
  Cargo_OriginalInvoiceNo: 'Số hóa đơn gốc',
  Cargo_OriginalInvoiceNoP: 'Số hóa đơn gốc:',
  Cargo_OriginalInvoiceTitle: 'Hóa đơn đầu tiên',
  Cargo_OriginalInvoiceTitleP: 'Hóa đơn gốc ngẩng đầu:',
  Cargo_OriginalValue: 'Giá trị gốc',
  Cargo_ChargeItemView: 'Xem dự án thu phí',
  Cargo_ORORDCBO: 'Chỉ có thể thao tác chứng từ đã lấy lại hoặc đã trả lại.',
  Cargo_ORVCBE: 'Chỉ có thể xuất các chứng từ đã được xem xét.',
  Cargo_OSVBMP: 'Chỉ tìm kiếm chứng từ cơ chế',
  Cargo_Other: 'Khác',
  Cargo_OtherChargeItem: 'Vận đơn vận chuyển hàng không',
  Cargo_OtherContact: 'Hợp đồng khác',
  Cargo_OtherConversionAP: 'Các khoản chiết khấu khác phải trả',
  Cargo_OtherConversionAPCNY: 'Đối phó CNY khác',
  Cargo_OtherConversionAPEUR: 'Tỷ giá EUR phải trả',
  Cargo_OtherConversionAPGBP: 'Đối phó GBP khác',
  Cargo_OtherConversionAPHKD: 'Các khoản thanh toán HKD khác',
  Cargo_OtherConversionAPJPY: 'Đối phó JPY khác',
  Cargo_OtherConversionAPNGN: 'NGN trả lời khác',
  Cargo_OtherConversionAR: 'Các khoản chiết khấu khác phải thu',
  Cargo_OtherConversionARCNY: 'CNY phải trả',
  Cargo_OtherConversionAREUR: 'Tỷ giá EUR khác',
  Cargo_OtherConversionARGBP: 'GBP khác phải thu',
  Cargo_OtherConversionARHKD: 'Chi phí HKD khác',
  Cargo_OtherConversionARJPY: 'Các loại JPY khác phải thu',
  Cargo_OtherConversionARNGN: 'NGN khác phải thu',
  Cargo_OtherCurrencies: 'Tiền tệ khác',
  Cargo_OtherCurrencyExchangeRates: 'Tỷ giá tiền tệ khác',
  Cargo_OtherExchangeRates: 'Tỷ giá khác',
  Cargo_OtherOutstandingConversionAP: 'Các khoản chiết khấu khác chưa thanh toán',
  Cargo_OtherOutstandingConversionAPCNY: 'CNY không thanh toán',
  Cargo_OtherOutstandingConversionAPEUR: 'Tỷ giá EUR chưa thanh toán',
  Cargo_OtherOutstandingConversionAPGBP: 'GBP chưa thanh toán',
  Cargo_OtherOutstandingConversionAPHKD: 'HKD chưa thanh toán',
  Cargo_OtherOutstandingConversionAPJPY: 'Các khoản chiết khấu khác JPY chưa thanh toán',
  Cargo_OtherOutstandingConversionAPNGN: 'NGN khác Chưa thanh toán',
  Cargo_OtherOutstandingConversionAR: 'Các khoản chiết khấu khác không được tính',
  Cargo_OtherOutstandingConversionARCNY: 'CNY không tính phí',
  Cargo_OtherOutstandingConversionAREUR: 'Tỷ giá EUR không tính',
  Cargo_OtherOutstandingConversionARGBP: 'GBP khác không tính',
  Cargo_OtherOutstandingConversionARHKD: 'HKD không nhận',
  Cargo_OtherOutstandingConversionARJPY: 'JPY khác không được tính',
  Cargo_OtherOutstandingConversionARNGN: 'NGN khác không nhận',
  Cargo_OTNSOSICBD: 'Chưa gửi và đã gửi mới có thể xóa.',
  Cargo_OTWOOCCI: 'Chỉ có bản thân người tiêu thụ mới có thể hủy bỏ tiêu thụ.',
  Cargo_OTWOOCMI: 'Chỉ có người tiêu thụ mới có thể sửa đổi sổ sách tiêu thụ.',
  Cargo_OurAccount: 'Tài khoản của chúng tôi',
  Cargo_OurBank: 'Ngân hàng của chúng tôi',
  Cargo_OurBankIsEmptySaveBankReceipt: 'Ngân hàng của chúng tôi trống rỗng, có giữ hóa đơn nước không?',
  Cargo_Outcomes: 'Kết quả',
  Cargo_OutstandingAP: 'Đối phó với Unsaled',
  Cargo_OutstandingAPP: 'Đối phó với Unsaled:',
  Cargo_OutstandingConversionAPInCNY: 'CNY chưa thanh toán',
  Cargo_OutstandingConversionAPInCurrency: '{0} Chưa thanh toán',
  Cargo_OutstandingConversionPaidInCurrency: '{0} đã trả',
  Cargo_OutstandingPaymentParties: 'Đơn vị thanh toán chưa thanh toán',
  Cargo_OutstandingWrittenOffItemsExist: 'Có tài khoản chưa bán',
  Cargo_OVDCBUFPLAT: 'Các môn tổn hại, chỉ có thể lựa chọn ngành ảo.',
  Cargo_Virtual: 'Ảo',
  Cargo_Over90DaysShpt: 'Trên 90 ngày (vé)',
  Cargo_OverdueExpenses: 'Phí quá hạn',
  Cargo_Overseas: 'Nước ngoài',
  Cargo_OverseasAgencyContract: 'Hợp đồng đại lý ở nước ngoài',
  Cargo_OverseasAgent: 'Đại lý nước ngoài',
  Cargo_OverseasAgentOrNot: 'Đại lý nước ngoài',
  Cargo_OverseasCollection: 'Thu tiền nước ngoài',
  Cargo_OverseasDirectClient: 'Khách nước ngoài',
  Cargo_OverseasDirectClientOrNot: 'Khách nước ngoài trực tiếp',
  Cargo_OverseasDomestic: 'Nước ngoài trong nước',
  Cargo_OverseasOrNot: 'Nước ngoài hay không',
  Cargo_OverseasPayment: 'Thanh toán nước ngoài',
  Cargo_OverseasWriteOff: 'Tài khoản bán hàng ở nước ngoài',
  Cargo_OverseasWriteOffOrNot: 'Có bán ở nước ngoài không?',
  Cargo_OverseasWriteOffSearch: 'Kiểm tra bán hàng ở nước ngoài',
  Cargo_OVICBETGTEI: 'Hóa đơn thuế giá trị gia tăng mới có thể xuất hóa đơn điện tử thuế vàng.',
  Cargo_OVWCSNCBE: 'Chỉ có thể xuất các chứng từ có số chứng từ liên tục.',
  Cargo_OVWUSCBE: 'Chỉ những chứng từ có trạng thái không được kiểm duyệt mới có thể được xem xét.',
  Cargo_OWCICGTSEEI: 'Đơn vị tiền tệ là {0} để xuất hóa đơn điện tử thuế vàng',
  Cargo_OwningDept: 'Sở hữu',
  Cargo_Package: 'Đóng gói',
  Cargo_PackageExistsOrSelectNull: 'Gói đã tồn tại hoặc không có hồ sơ nào được chọn',
  Cargo_PackageMaintenance: 'Bảo trì bao bì',
  Cargo_PackingInformationNotSelected: 'Thông tin đóng gói không được chọn.',
  Cargo_PADS: 'Yêu cầu từ chối thanh toán đã thành công.',
  Cargo_Page: 'Trương',
  Cargo_Paid: 'Thanh toán',
  Cargo_PaidInFull: 'Thanh toán',
  Cargo_PaidInOutOfPocket: 'Thanh toán thực tế',
  Cargo_ReceiptPaymentpVoucher: 'Chứng từ thanh toán thực',
  Cargo_PANMWEAPCAOCA: 'Đơn yêu cầu phí không khớp với số tiền phí, vui lòng kiểm tra số tiền hoặc liên hệ với quản trị viên!',
  Cargo_ParentAccountTitle: 'Đối tượng cấp trên',
  Cargo_PARGMSA: 'Yêu cầu thanh toán có cần Tổng giám đốc phê duyệt hay không',
  Cargo_Parter: 'Đối tác',
  Cargo_CreditAccountingPeriod: 'Thời hạn thanh toán tín dụng',
  Cargo_CreditLine: 'Hạn mức tín dụng',
  Cargo_ExceededAmount: 'Vượt quá, {0}',
  Cargo_Exceeded: 'Đã vượt quá',
  Cargo_PartialConfirmation: 'Xác nhận một phần',
  Cargo_PartialExpense: 'Một phần chi phí',
  Cargo_PartialPayment: 'Thanh toán một phần',
  Cargo_PartialReversalCompleted: 'Một phần quay lại thành công.',
  Cargo_PartialWriteOff: 'Phần nucleopin',
  Cargo_Participant: 'Người tham gia',
  Cargo_PartnerCanTBeEmpty: 'Đối tác không thể để trống',
  Cargo_PartnerSCreditLimitExceeded: 'Tài khoản đối tác đã vượt quá',
  Cargo_Password: 'Mật khẩu',
  Cargo_PasswordField: 'Khu vực mật mã',
  Cargo_PAWOCTBD: 'Yêu cầu thanh toán không thể xóa',
  Cargo_Pay: 'Thanh toán',
  Cargo_Payable: 'Thanh toán sẵn có',
  Cargo_PayableNeedPay: 'Thanh toán (phải trả)',
  Cargo_PayableOrNot: 'Có thể thanh toán',
  Cargo_PayablesWriteOfStatus: 'Đối phó với tình trạng bán hạt nhân',
  Cargo_Payee: 'Người nhận tiền',
  Cargo_PayeeP: 'Người nhận tiền:',
  Cargo_Payment: 'Thanh toán',
  Cargo_PaymentAccount: 'Số tài khoản thanh toán',
  Cargo_PaymentAgainstMonthlySoa: 'Thanh toán hàng tháng/Ticket Knot',
  Cargo_PaymentAmount: 'Số tiền thanh toán',
  Cargo_PaymentApplicationDirectlySent: 'Yêu cầu thanh toán trực tiếp',
  Cargo_PaymentApplicationInformation: 'Thông tin yêu cầu thanh toán',
  Cargo_PaymentApplicationNo: 'Số yêu cầu thanh toán',
  Cargo_PaymentAppliedSuccessfully: 'Yêu cầu thanh toán đã thành công.',
  Cargo_PaymentApprovalSlipDetails: 'Chi tiết phê duyệt thanh toán',
  Cargo_PaymentApprovalSlipNo: 'Số đơn phê duyệt thanh toán',
  Cargo_PaymentCompany: 'Đơn vị thanh toán',
  Cargo_PaymentCompanyName: 'Tên công ty.',
  Cargo_PaymentCycle: 'Chu kỳ tài khoản',
  Cargo_PaymentDate: 'Ngày thanh toán',
  Cargo_PaymentDateCanTBeEmpty: 'Ngày thanh toán không được để trống.',
  Cargo_PaymentMethod: 'Phương thức thanh toán',
  Cargo_PaymentNotApplied: 'Không yêu cầu thanh toán',
  Cargo_PaymentNotificationNo: 'Số thông báo thanh toán',
  Cargo_PaymentPeriod: 'Thời hạn thanh toán',
  Cargo_PaymentPeriodExceeded: 'Tài khoản vượt quá',
  Cargo_PaymentPeriodRange: 'Phạm vi thanh toán',
  Cargo_PaymentReceiveMethod: 'Phương thức thanh toán',
  Cargo_PaymentReceiveMethodP: 'Phương thức thu và nhận:',
  Cargo_PaymentReceiveType: 'Loại thanh toán',
  Cargo_PaymentReceiveTypeP: 'Loại thu và nhận:',
  Cargo_PaymentRequest: 'Yêu cầu thanh toán',
  Cargo_PaymentRequestBusiness: 'Yêu cầu thanh toán - Kinh doanh',
  Cargo_PaymentRequestDetail: 'Yêu cầu thanh toán - Chi tiết',
  Cargo_PaymentRequested: 'Yêu cầu thanh toán',
  Cargo_PaymentRequestedNotRequested: 'Yêu cầu thanh toán/Không yêu cầu thanh toán',
  Cargo_PaymentRequestsCreatedOrNot: 'Yêu cầu thanh toán đã được mở chưa',
  Cargo_PaymentTime: 'Thời gian thanh toán',
  Cargo_PaymentToBeChecked: 'Thanh toán để kiểm tra',
  Cargo_CarryForwardList: 'Danh sách chuyển tiếp',
  Cargo_PaymentType: 'Loại thanh toán',
  Cargo_PaymentVerification: 'Kiểm toán thanh toán',
  Cargo_PayReceive: 'Nhận và nhận',
  Cargo_PayReceiveDate: 'Ngày nhận',
  Cargo_PayUnit: 'Đơn vị thanh toán',
  Cargo_PCAOCO: 'Vui lòng xác nhận rằng số tiền này là:',
  Cargo_PCHIUV: 'Khách hàng được đánh giá trên biển',
  Cargo_PCITIHBI: 'Vui lòng kiểm tra xem hóa đơn đã được thanh toán chưa.',
  Cargo_INVOICE_NO_FILE: 'Không tìm thấy tài liệu hóa đơn điện tử tương ứng trong hóa đơn này.',
  Cargo_Pcs: 'Một',
  Cargo_PCSALOA: 'Vui lòng chọn nhiều hơn một ứng dụng.',
  Cargo_PCSALOI: 'Vui lòng chọn nhiều hơn một hóa đơn.',
  Cargo_Pcst: 'Thanh',
  Cargo_PCTAOTCPI: 'Vui lòng xác nhận: Khoản thanh toán thực tế lần này là:',
  Cargo_PCTOOPAIWOADSA: 'Vui lòng xác nhận: Số tiền thực hiện lần này là: {0}, n Số tiền bán là: {1}, n Sự khác biệt là: {2} Là một khoản thanh toán ngắn bằng không!',
  Cargo_PDDPAF: 'Chỉ một phần dữ liệu được hiển thị, hãy tăng bộ lọc điều kiện truy xuất.',
  Cargo_PeakSeason: 'Mùa cao điểm kinh doanh',
  Cargo_PEALTVJE: 'Vui lòng nhập ít nhất hai mục hợp lệ',
  Cargo_PEATGR: 'Vui lòng nhập quy tắc nhóm đối tượng.',
  Cargo_PECCI: 'Vui lòng nhập đầy đủ thông tin chuyển phát nhanh.',
  Cargo_PECINSWACONIO: 'Vui lòng nhập đúng số hóa đơn và hệ thống sẽ tự động nhập các số khác theo thứ tự!',
  Cargo_PEERAVC: 'Đã tạo ra chứng từ chuyển khoản cuối kỳ:',
  Cargo_PEFEA: 'Chuyển khoản cuối kỳ',
  Cargo_PEFEA2: 'Chuyển khoản cuối kỳ 2',
  Cargo_PEFEAS: 'Chuyển khoản cuối kỳ thành công',
  Cargo_PendingBusinessApplication: 'Đăng ký kinh doanh',
  Cargo_PendingPrice: 'Đang được xem xét',
  Cargo_People: 'Người',
  Cargo_PerformLetterFiltering: 'Lọc ký tự',
  Cargo_PERFROIRF: 'Vui lòng nhập lý do khởi động lại trong ghi chú.',
  Cargo_Period: 'Giai đoạn',
  Cargo_PeriodEndAmount: 'Số cuối kỳ',
  Cargo_PeriodEndBalance: 'Số dư cuối kỳ',
  Cargo_PeriodEndBalanceCreditCNY: 'Bên cho vay số dư cuối kỳ (NDT)',
  Cargo_PeriodEndBalanceCreditUSD: 'Số dư cuối kỳ (USD)',
  Cargo_PeriodEndBalanceDebitCNY: 'Số dư cuối kỳ (NDT)',
  Cargo_PeriodEndBalanceDebitUSD: 'Số dư nợ cuối kỳ (USD)',
  Cargo_PeriodEndExchangeRateAdjustment: 'Chuyển khoản cuối kỳ',
  Cargo_PeriodRange: 'Khoảng thời gian',
  Cargo_Periods: 'Thời gian',
  Cargo_PermissionCheck: 'Kiểm tra quyền',
  Cargo_PermissionControl: 'Kiểm soát quyền',
  Cargo_PermissionToSubmitExpense: 'Quyền nộp phí',
  Cargo_PESAI: 'Vui lòng nhập thông tin kế toán phụ {1} cho 【{0}】.',
  Cargo_PESAIN: 'Vui lòng nhập thông tin số dự án kế toán phụ trợ cho 【{0}】',
  Cargo_PESCSBA: 'Vui lòng nhập số tài khoản ngân hàng của đơn vị bán hàng.',
  Cargo_PETSAINO: 'Vui lòng nhập thông tin số dự án phụ trợ của 【{0}】.',
  Cargo_PETSFIIB: 'Vui lòng nhập thông tin chi phí tách ra bên dưới',
  Cargo_PEWOIPETS: 'Vui lòng nhập thông tin bán hàng',
  Cargo_PFAEFTS: 'Thanh toán bằng đường hàng không Thượng Hải',
  Cargo_PICNENCTSFS: 'Vui lòng nhập tên tiếng Trung, tên tiếng Anh, mã, yêu cầu mờ ngắn',
  Cargo_PlaceOfDelivery: 'Nơi giao hàng',
  Cargo_PlaceOfMblPayment: 'Nơi thanh toán đơn hàng chính',
  Cargo_PlaceOfReceipt: 'Địa điểm nhận hàng',
  Cargo_PlanDescription: 'Mô tả chương trình',
  Cargo_PlatformCode: 'Mã hóa nền tảng',
  Cargo_PlatformCustomerService: 'Hỗ trợ nền tảng',
  Cargo_CustomerServiceOverSea: 'Dịch vụ khách hàng nước ngoài',
  Cargo_PLCOS: 'Chuyển nhượng thành công',
  Cargo_PleaseAddAtLeastOneContactPerson: 'Khách hàng điền ít nhất một',
  Cargo_PleaseAddContactPerson: 'Vui lòng điền thông tin liên hệ',
  Cargo_PleaseAddExpense: 'Vui lòng thêm phí.',
  Cargo_PleaseAddNominationCargoAgent: 'Vui lòng điền thông tin đại lý',
  Cargo_PleaseAddNominationCargoAgentP: 'Vui lòng điền vào đại lý hàng hóa được chỉ định:',
  Cargo_PleaseAddTelNumbers: 'Vui lòng điền số điện thoại',
  Cargo_PleaseBatchSelectInvoiceNo: 'Vui lòng chọn {0} số hóa đơn',
  Cargo_PleaseCheckClient: 'Vui lòng đánh dấu khách hàng',
  Cargo_PleaseCheckInvoice: 'Vui lòng kiểm tra hóa đơn.',
  Cargo_PleaseChooseData: 'Vui lòng chọn dữ liệu.',
  Cargo_PleaseChooseFeeName: 'Vui lòng chọn tên chi phí.',
  Cargo_PleaseChooseSettlementEntity: 'Vui lòng chọn đơn vị thanh toán.',
  Cargo_PleaseClickSelectAnInvoice: 'Vui lòng chọn hóa đơn.',
  Cargo_PleaseClickSelectARecord: 'Vui lòng chọn một bản ghi.',
  Cargo_PleaseConfirmPaymentMade: 'Vui lòng xác nhận rằng {0} đã được thanh toán!',
  Cargo_PleaseConfirmReviewDate: 'Vui lòng xác nhận ngày xét duyệt:',
  Cargo_PleaseConfirmTheDueAmount: 'Vui lòng xác nhận: Số tiền này sẽ là:',
  Cargo_PleaseConfirmThePaidInAmountIs: 'Xin vui lòng xác nhận rằng số tiền thanh toán lần này là:',
  Cargo_PleaseConfirmThisTime: 'Vui lòng xác nhận rằng số tiền này là:',
  Cargo_PleaseDeleteAfterVoid: 'Vui lòng hủy bỏ trước khi xóa.',
  Cargo_PleaseEnterAccountTitle: 'Vui lòng nhập tên đối tượng.',
  Cargo_PleaseEnterAmount: 'Vui lòng nhập số tiền',
  Cargo_PleaseEnterClientName: 'Vui lòng nhập tên khách hàng.',
  Cargo_PleaseEnterCode: 'Vui lòng nhập mã.',
  Cargo_PleaseEnterCorrectAmount: 'Vui lòng nhập đúng số tiền.',
  Cargo_PleaseEnterCorrectBillingParty: 'Vui lòng nhập đúng đối tượng thanh toán.',
  Cargo_PleaseEnterCorrectExchangeRate: 'Vui lòng nhập tỷ giá hối đoái chính xác.',
  Cargo_PleaseEnterCorrectNumber: 'Vui lòng nhập đúng số.',
  Cargo_PleaseEnterCurrencyExchangeRate: 'Vui lòng nhập tỷ giá hối đoái cho đồng tiền 【{0}】.',
  Cargo_PleaseEnterDate: 'Vui lòng nhập ngày',
  Cargo_PleaseEnterDateOfReceipt: 'Vui lòng nhập ngày nhận tiền.',
  Cargo_PleaseEnterDifferential: 'Vui lòng nhập chênh lệch',
  Cargo_PleaseEnterExpenseDescription: 'Vui lòng nhập tên chi phí.',
  Cargo_PleaseEnterExpenseDetails: 'Vui lòng nhập chi tiết chi phí',
  Cargo_PleaseEnterFinancialCode: 'Vui lòng nhập mã tài chính.',
  Cargo_ApAndArCodeIsEmpty: 'Hiện tại 【Mã hóa cần thu】/【Đối phó với mã hóa】 là trống, hãy thử lại sau khi hoàn thiện dữ liệu.',
  Cargo_PleaseEnterFinancialDate: 'Vui lòng nhập ngày tài chính',
  Cargo_PleaseEnterHsCode: 'Vui lòng nhập HSCode',
  Cargo_PleaseEnterInformationOf: 'Vui lòng nhập thông tin kế toán phụ trợ {1} cho 【{0}】.',
  Cargo_PleaseEnterInvoiceInformation: 'Vui lòng nhập thông tin hóa đơn',
  Cargo_PleaseEnterInvoiceNo: 'Vui lòng nhập số hóa đơn.',
  Cargo_PleaseEnterInvoiceNoP: 'Vui lòng nhập số hóa đơn:',
  Cargo_PleaseEnterMailingAddress: 'Vui lòng nhập địa chỉ chuyển phát nhanh.',
  Cargo_PleaseEnterName: 'Vui lòng nhập tên.',
  Cargo_PleaseEnterNewInvoiceNo: 'Vui lòng nhập số hóa đơn mới.',
  Cargo_PleaseEnterNewInvoiceTitle: 'Vui lòng nhập hóa đơn mới Head Up.',
  Cargo_PleaseEnterOperationCode: 'Vui lòng nhập toán tử.',
  Cargo_PleaseEnterOurBankAccountNo: 'Vui lòng nhập số tài khoản ngân hàng của chúng tôi.',
  Cargo_PleaseEnterPaidInAmount: 'Vui lòng nhập số tiền nhận và trả.',
  Cargo_PleaseEnterPaidInDate: 'Vui lòng nhập ngày nhận.',
  Cargo_PleaseEnterPaymentParty: 'Vui lòng nhập đơn vị thanh toán',
  Cargo_PleaseEnterPaymentTerm: 'Vui lòng nhập thời hạn thanh toán.',
  Cargo_PleaseEnterPlanName: 'Vui lòng nhập tên sơ đồ',
  Cargo_PleaseEnterGuarantrrName: 'Vui lòng nhập tên bảo lãnh',
  Cargo_PleaseEnterRecipientSName: 'Vui lòng nhập tên người nhận.',
  Cargo_PleaseEnterReturnedCourierNo: 'Vui lòng nhập số chuyển phát nhanh trở lại.',
  Cargo_PleaseEnterSalesCompanySBank: 'Vui lòng nhập đơn vị bán hàng để mở tài khoản.',
  Cargo_PleaseEnterScarletLetterNumber: 'Vui lòng nhập số thông báo màu đỏ',
  Cargo_PleaseEnterSearchInformation: 'Vui lòng nhập thông tin truy vấn.',
  Cargo_PleaseEnterSettlingParty: 'Vui lòng nhập đối tượng thanh toán',
  Cargo_PleaseEnterSobCode: 'Vui lòng nhập mã tài khoản.',
  Cargo_PleaseEnterSobName: 'Vui lòng nhập tên tài khoản.',
  Cargo_PleaseEnterSplitAmount: 'Vui lòng nhập số tiền chia.',
  Cargo_PleaseEnterTableName: 'Vui lòng nhập tên bảng',
  Cargo_PleaseEnterTelNo: 'Vui lòng nhập số điện thoại liên lạc.',
  Cargo_PleaseEnterUserName: 'Vui lòng nhập User',
  Cargo_PleaseEnterValueOfCondition: 'Vui lòng nhập giá trị có điều kiện.',
  Cargo_PleaseEnterVoucherLetter: 'Vui lòng nhập từ chứng từ.',
  Cargo_PleaseEnterVoucherNo: 'Vui lòng nhập số chứng từ',
  Cargo_PleaseEnterVoucherType: 'Vui lòng nhập loại chứng từ.',
  Cargo_PleaseInputJobNo: 'Vui lòng nhập số công việc',
  Cargo_PleaseReselectTheVoucherToExport: 'Vui lòng chọn lại chứng từ bạn muốn xuất.',
  Cargo_PleaseSelect: 'Vui lòng chọn',
  Cargo_PleaseSelectP: '- Vui lòng chọn -',
  Cargo_PleaseSelect2OrMoreApplications: 'Vui lòng chọn nhiều hơn 2 mẫu đơn.',
  Cargo_PleaseSelectAccountTitle: 'Vui lòng chọn đối tượng',
  Cargo_PleaseSelectAnAdvanceReceipt: 'Vui lòng chọn mục Pre-Receive.',
  Cargo_PleaseSelectAnExpenseItem: 'Vui lòng chọn một khoản phí.',
  Cargo_PleaseSelectAnInvoice: 'Vui lòng chọn hóa đơn.',
  Cargo_PleaseSelectAPAndARExpense: 'Vui lòng chọn chi phí phải trả và phải thu.',
  Cargo_PleaseSelectApplication: 'Vui lòng chọn ứng dụng.',
  Cargo_PleaseSelectARecord: 'Vui lòng chọn một bản ghi.',
  Cargo_PleaseSelectBill: 'Vui lòng chọn Bill',
  Cargo_PleaseSelectBillToMark: 'Vui lòng chọn hóa đơn cần đánh dấu.',
  Cargo_PleaseSelectBillToPrint: 'Vui lòng chọn Hóa đơn để in.',
  Cargo_PleaseSelectBillToRemove: 'Vui lòng chọn hóa đơn bạn muốn xóa.',
  noRowsToShow: 'Không có kết quả truy vấn',
  Cargo_PleaseSelectBranch: 'Vui lòng chọn chi nhánh',
  Cargo_SelectBranch: 'Chọn chi nhánh',
  Cargo_ApplicationBranch: 'Chi nhánh vận hành ứng dụng',
  Cargo_ApplicationDepartment: 'Bộ phận vận hành ứng dụng',
  Cargo_MoreBusinessConditions: 'Thêm điều kiện kinh doanh',
  Cargo_MoreConditionsOptions: 'Thêm tùy chọn điều kiện',
  Cargo_BusinessConditionsOptions: 'Điều kiện kinh doanh Tùy chọn',
  Cargo_PleaseSelectBusiness: 'Vui lòng chọn Business',
  Cargo_PleaseSelectBusinessDate: 'Vui lòng chọn ngày kinh doanh.',
  Cargo_PleaseSelectBusinessOrderRecord: 'Vui lòng chọn Business Single Record.',
  Cargo_PleaseSelectBusinessType: 'Vui lòng chọn loại hình kinh doanh',
  Cargo_PleaseSelectGuaranteeType: 'Vui lòng chọn loại bảo lãnh',
  Cargo_PleaseSelectClosureTime: 'Vui lòng chọn thời gian kết thúc.',
  Cargo_PleaseSelectContentToModify: 'Vui lòng chọn những gì cần sửa đổi.',
  Cargo_PleaseSelectCurrency: 'Vui lòng chọn đồng tiền',
  Cargo_PleaseSelectData: 'Vui lòng kiểm tra dữ liệu.',
  Cargo_PleaseSelectContainerGroup: 'Vui lòng chọn một nhóm container để thực hiện thao tác thêm.',
  Cargo_AutomaticReleaseTips: 'B/L trạng thái đặt hàng tồn tại mà không cần đặt hàng lô đặc biệt.',
  Cargo_PleaseSelectDataToDelete: 'Vui lòng chọn dữ liệu bạn muốn xóa.',
  Cargo_PleaseSelectDataToRevoke: 'Vui lòng chọn dữ liệu bạn muốn hủy bỏ.',
  Cargo_SuredRevokeJob: 'Xác định hủy bỏ nghiệp vụ đã chọn sao?',
  Cargo_PleaseSelectDataToExport: 'Vui lòng chọn dữ liệu cần xuất.',
  Cargo_PleaseSelectDataType: 'Vui lòng chọn kiểu dữ liệu.',
  Cargo_PleaseSelectDataTypeToCreate: 'Chọn kiểu dữ liệu bạn muốn tạo.',
  Cargo_PleaseSelectDate: 'Vui lòng chọn ngày',
  Cargo_PleaseSelectExpense: 'Vui lòng chọn phí.',
  Cargo_PleaseSelectExpenseToConfirm: 'Vui lòng chọn chi phí để xác nhận.',
  Cargo_PleaseSelectExpenseToSplit: 'Vui lòng chọn chi phí để chia.',
  Cargo_PleaseSelectExpenseToWriteOff: 'Vui lòng chọn chi phí cần bán.',
  Cargo_PleaseSelectFile: 'Vui lòng chọn tập tin',
  Cargo_OwnFileDelete: 'Không đủ quyền hạn: Không thể xóa các tập tin được tải lên bởi người dùng khác',
  Cargo_PleaseSelectFileType: 'Vui lòng chọn loại tập tin',
  Cargo_PleaseSelectGroupingCondition: 'Vui lòng chọn điều kiện nhóm',
  Cargo_PleaseSelectGroupingCondition2: 'Vui lòng chọn điều kiện nhóm 1.',
  Cargo_PleaseSelectIncludedBizNo: 'Vui lòng chọn tính vào số doanh nghiệp',
  Cargo_PleaseSelectInvoice: 'Vui lòng chọn Invoice',
  Cargo_PleaseSelectInvoiceNo: 'Vui lòng chọn số hóa đơn.',
  Cargo_PleaseSelectOurBank: 'Vui lòng chọn ngân hàng của chúng tôi.',
  Cargo_PleaseSelectPaymentApplication: 'Vui lòng chọn ứng dụng thanh toán.',
  Cargo_PleaseSelectTheRecord: 'Vui lòng chọn bản ghi cần sửa đổi',
  Cargo_batchChangePaymentSuccess: 'Sửa đổi số lượng lớn Yêu cầu thanh toán thành công',
  Cargo_batchChangePaymentFailed: 'Yêu cầu thanh toán sửa đổi hàng loạt không thành công',
  Cargo_NotEmptyChangePaymentTime: 'Thời gian thanh toán không được để trống',
  Cargo_ApprovedSuccess: 'Phê duyệt thành công.',
  Cargo_ApprovedFaild: 'Phê duyệt thất bại.',
  Cargo_ReturnedSuccess: 'Trở về thành công.',
  Cargo_ReturnedFaild: 'Trở về thất bại.',
  Cargo_NoBusinessApproval: 'Không có dữ liệu cần phê duyệt nghiệp vụ.',
  Cargo_NoDeptApproval: 'Không có dữ liệu yêu cầu phê duyệt của bộ phận.',
  Cargo_NoFinanceApprovalData: 'Không có dữ liệu cần phê duyệt tài chính',
  Cargo_NoSupervisorApprovalData: 'Không có dữ liệu cần phê duyệt của giám sát',
  Cargo_PleaseSelectPeriodRange: 'Vui lòng chọn khoảng thời gian',
  Cargo_PleaseSelectRecord: 'Vui lòng chọn Record.',
  Cargo_PleaseSelectRecordToInvoice: 'Vui lòng chọn bản ghi bạn muốn lập hóa đơn.',
  Cargo_PleaseSelectRecordToReview: 'Hãy chọn bản ghi mà bạn muốn kiểm tra lại.',
  Cargo_PleaseSelectRecordToCancelReview: 'Chọn bản ghi mà bạn muốn hủy kiểm tra.',
  Cargo_PleaseSelectRecordToWriteOff: 'Vui lòng chọn bản ghi bạn muốn bán.',
  Cargo_PleaseSelectReviewDate: 'Vui lòng chọn ngày xét duyệt.',
  Cargo_PleaseSelectSameInvoiceType: 'Vui lòng chọn cùng loại hóa đơn.',
  Cargo_PleaseSelectServiceTicket: 'Vui lòng chọn mẫu xác nhận chi phí.',
  Cargo_PleaseSelectSettlingParty: 'Vui lòng chọn đối tượng thanh toán.',
  Cargo_AddTag: 'Thêm thẻ',
  Cargo_NotFoundNeedSaveCharges: 'không có chi phí nào trong danh sách này.',
  Cargo_SureSaveBilling: 'bạn có chắc chắn rằng bạn có thể lưu và tạo ra các hóa đơn?',
  Cargo_SureSaveChargeOnly: 'bạn có chắc là chỉ lưu chi phí?',
  Cargo_SureCancelEdit: 'Thực sự thôi soạn thảo không?',
  Cargo_JobBillingChargeNotEqual: 'Các khoản phí không phù hợp với hóa đơn, xin vui lòng loại bỏ các khoản phí không phù hợp trước khi chúng được sửa đổi!',
  Cargo_SaveGenerateBills: 'lưu và tạo ra các hóa đơn',
  Cargo_GenerateExpensesOnly: 'chỉ tạo chi phí',
  Cargo_PleaseSelectSoa: 'Vui lòng chọn Report.',
  Cargo_PleaseSelectSob: 'Vui lòng chọn tài khoản.',
  Cargo_PleaseSelectStartTime: 'Vui lòng chọn thời gian bắt đầu.',
  Cargo_PleaseSelectThePurchaser: 'Vui lòng chọn người mua.',
  Cargo_PleaseSelectTypeOfJournalEntries: 'Vui lòng chọn loại phân loại.',
  Cargo_PleaseSelectVatInvoice: 'Vui lòng chọn hóa đơn VAT.',
  Cargo_PleaseSelectVatEiInvoice: 'Vui lòng chọn vé điện VAT.',
  Cargo_PleaseSelectVoucher: 'Vui lòng chọn Credentials.',
  Cargo_PleaseSelectVoucherGroupingRule: 'Vui lòng chọn quy tắc nhóm chứng từ',
  Cargo_PleaseSelectVoucherToCancel: 'Vui lòng chọn chứng từ cần hủy.',
  Cargo_PleaseSelectVoucherToReview: 'Vui lòng chọn chứng từ cần xem xét.',
  Cargo_PleaseSelectWriteOffDetails: 'Vui lòng chọn chi tiết tiêu thụ.',
  Cargo_PleaseSelectWriteOffRecord: 'Vui lòng chọn bản ghi bán hàng.',
  Cargo_PleaseSpecifyPaymentPeriodRange: 'Vui lòng xác định khoảng thời gian thanh toán',
  Cargo_PleaseUseComponent: 'Vui lòng sử dụng Components',
  Cargo_PlsInput: 'Vui lòng nhập',
  Cargo_PLVDCTBE: 'Ngày chứng từ lỗ không được để trống',
  Cargo_PLVDNITP: 'Ngày chứng từ lợi nhuận và thua lỗ không có trong thời gian',
  Cargo_PLVFCTBE: 'Chứng từ thiệt hại không được để trống',
  Cargo_PLVNAPATCTBE: 'Chứng từ lợi nhuận chưa được phân phối đối tượng lợi nhuận không được để trống',
  Cargo_PoaCustomsDeclaration: 'KBHQ',
  Cargo_PODcode: 'Mã cảng',
  Cargo_FileFromQuotation: 'Tệp được nhập từ Quản lý Báo giá không thể xóa',
  Cargo_FileFromInquiry: 'Tệp được nhập từ Quản lý Yêu cầu báo giá không thể xóa',
  Cargo_PodSea: 'Cảng dỡ hàng (cảng biển)',
  Cargo_Unloading: 'Tải xuống',
  Cargo_ArrivalNotice: 'Thông báo đến',
  Cargo_PickUp: 'Nhận hàng',
  Cargo_AircraftGISPositioning: 'Máy bay định vị GIS',
  Cargo_PointOfPermission: 'Điểm đặc quyền',
  Cargo_PointsToNote: 'Có đặc thù hay không',
  Cargo_Pol: 'Cảng bốc hàng',
  Cargo_PolAgent: 'Đại lý cảng khởi hành',
  Cargo_POLCannotBeNull: 'Cảng khởi hành không được để trống',
  Cargo_PolSea: 'Cảng khởi hành (cảng biển)',
  Cargo_Port: 'Cảng',
  Cargo_PortCodeCanTBeEmpty: 'Mã cảng không được để trống',
  Cargo_PortGroup: 'Nhóm cảng',
  Cargo_PortGroupCanTBeEmpty: 'Cảng không thể để trống',
  Cargo_PortOfDestinationCode: 'Mã cảng đích',
  Cargo_PortOfDischarge: 'Cảng dỡ hàng',
  Cargo_PortOfDischargeCannotBeNull: 'Cảng hàng không được để trống',
  Cargo_PortOfLoading: 'Cảng khởi hành',
  Cargo_PortOfLoadingSea: 'Cảng khởi hành (bằng đường biển)',
  Cargo_PortOfLoadingAir: 'Cảng khởi hành (bằng đường hàng không)',
  Cargo_PortPrompt: 'Vui lòng nhập cảng',
  Cargo_PortRequirement: 'Yêu cầu cảng',
  Cargo_PositiveOperation: 'Hoạt động tích cực',
  Cargo_Post: 'Bài viết',
  Cargo_PotentialStage: 'Giai đoạn tiềm năng',
  Cargo_PPNCASA: 'Như một khoản thanh toán ngắn bằng không, không có khoản thanh toán trước được tạo ra.',
  Cargo_PRCTBCFWOE: 'Phí/doanh nghiệp đã được bán hạt nhân không thể tạo yêu cầu thanh toán.',
  Cargo_PreCollection: 'Thu trước',
  Cargo_PreferredAgentAtDestination: 'Ưu tiên đại lý cảng đích',
  Cargo_PreferredAirline: 'Ưu tiên hãng hàng không',
  Cargo_PreferredAirport: 'Ưu tiên cảng hàng không',
  Cargo_PreferredAirportAir: 'Cảng ưu tiên (Airport)',
  Cargo_PreferredCustomsBroker: 'Dịch vụ khai hải quan ưu tiên',
  Cargo_PreferredOceanCarrier: 'Hãng tàu Preferred',
  Cargo_PreferredPort: 'Ưu tiên cảng biển',
  Cargo_PreferredPortSea: 'Cảng ưu tiên (cảng biển)',
  Cargo_PreferredShippingMethod: 'Thích loại hàng hóa',
  Cargo_PreferredShippingRoute: 'Đường bay ưu tiên',
  Cargo_PreferredShippingTerms: 'Ưu tiên điều khoản vận chuyển',
  Cargo_PreferredTrucker: 'Sở thích xe kéo',
  Cargo_PreferredTruckingService: 'Ưu tiên dịch vụ Trailer',
  Cargo_PrepaidOrNot: 'Trả trước hay không',
  Cargo_PreparedBy: 'Chế độ đơn',
  Cargo_PreparedByP: 'Chế độ một người:',
  Cargo_PrepareServiceTicket: 'Xác nhận chi phí sản xuất',
  Cargo_PrePayment: 'Thu trước hay không',
  Cargo_PrepaymentRecordedSuccessfully: 'Đăng ký trả trước thành công.',
  Cargo_PreReviewStatus: 'Tình trạng sơ thẩm',
  Cargo_PreReviewAllStatus: 'Tình trạng sơ thẩm (review)',
  Cargo_PreSubmission: 'Gửi trước',
  Cargo_PreviewEmailContent: 'Xem thử nội dung thư',
  Cargo_Previous: 'Trước',
  Cargo_PrimeCost: 'Chi phí',
  Cargo_Print: 'In ấn',
  Cargo_PrintAll: 'In tất cả',
  Cargo_PrintBill: 'In hóa đơn',
  Cargo_PrintedSuccessfully: 'In thành công.',
  Cargo_PrintInvoice: 'In hóa đơn',
  Cargo_PrintList: 'In danh sách',
  Cargo_PrintOrNot: 'In hay không',
  Cargo_LACKINVOICE: 'Thiếu hóa đơn hay không',
  Cargo_Printout: 'Kết quả in',
  Cargo_PrintPaymentList: 'In danh sách thanh toán',
  Cargo_PrintSoa: 'Báo cáo in',
  Cargo_PrintStatusSaved: 'Lưu trạng thái in vẽ thành công.',
  Cargo_PrintTheProfit: 'In lợi nhuận',
  Cargo_PrintVerification: 'Xác minh in',
  Cargo_PrintWithdrawalList: 'In (Danh sách hoàn trả)',
  Cargo_ProcessedAsShortAccount: 'Tài khoản ngắn Zero Head',
  Cargo_ProcessedBy: 'Người xử lý',
  Cargo_ProcessingChangeRemarks: 'Xử lý các ghi chú điều chỉnh',
  Cargo_ProcessingPleaseWait: 'Xin chờ một chút, đang xử lý...',
  Cargo_ProcessingRemarks: 'Ghi chú xử lý',
  Cargo_ProcessingTime: 'Thời gian xử lý',
  Cargo_ProductName: 'Tên chương trình',
  Cargo_Profit: 'Lợi nhuận',
  Cargo_ProfitLossAccount: 'Đối tượng lợi nhuận và tổn thất',
  Cargo_ProfitLoss: 'Bảng lợi nhuận',
  Cargo_ProfitLoss2: 'Bảng lợi nhuận 2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: 'Số chứng từ lỗ không được để trống',
  Cargo_ProfitLossVoucherNotInThePeriod: 'Chứng từ thiệt hại không có trong thời gian',
  Cargo_Prompt: 'Nhắc nhở',
  Cargo_Proof: 'Chứng từ',
  Cargo_ProofDate: 'Ngày chứng từ',
  Cargo_ProofDateP: 'Ngày chứng từ:',
  Cargo_ProofOrNot: 'Có tạo chứng từ hay không',
  Cargo_Property: 'Thuộc tính',
  Cargo_Province: 'Tỉnh',
  Cargo_PRSCSCRICP: 'Ghi chép nhờ thu của công ty tàu, xin vui lòng đến trang nhờ thu ký hủy bỏ.',
  Cargo_PSALOAPAARE: 'Vui lòng chọn ít nhất một khoản phí phải trả và phải thu.',
  Cargo_PSALOER: 'Vui lòng chọn ít nhất một bản ghi chi phí.',
  Cargo_PSALOGODC: 'Vui lòng chọn ít nhất một bộ điều kiện ngày.',
  Cargo_PSALOGODC2: 'Vui lòng chọn ít nhất một điều kiện lọc.',
  Cargo_SelectLockOrderCondition: 'Chọn điều kiện khóa đơn',
  Cargo_PSBOTSSP: 'Vui lòng chọn hóa đơn cho cùng đơn vị thanh toán',
  Cargo_PSCI: 'Vui lòng chọn thông tin ủy thác',
  Cargo_PSDTOVG: 'Vui lòng chọn loại dữ liệu nhóm chứng từ.',
  Cargo_PSEDTRWO: 'Vui lòng chọn chi tiết chi phí mà bạn muốn hủy bỏ doanh số bán hàng.',
  Cargo_PSFDD: 'Đăng nhập chứng từ hải quan',
  Cargo_PSFPOTSY: 'Vui lòng chọn cùng một năm cho kỳ kế toán.',
  Cargo_PleaseSelectVoucherRange: 'Vui lòng chọn khoảng chứng từ',
  Cargo_PSGROJE: 'Vui lòng chọn quy tắc nhóm mục',
  Cargo_PSOR: 'Vui lòng chọn yêu cầu hoạt động',
  Cargo_PSPAF: 'Vui lòng chọn hình thức thanh toán.',
  Cargo_PSPATD: 'Vui lòng chọn yêu cầu thanh toán mà bạn muốn xóa.',
  Cargo_PSPATW: 'Vui lòng chọn yêu cầu thanh toán mà bạn muốn rút.',
  Cargo_PSPATR: 'Vui lòng chọn yêu cầu thanh toán để trả lại.',
  Cargo_PSPATS: 'Vui lòng chọn yêu cầu thanh toán bạn muốn gửi.',
  Cargo_PSROACP: 'Vui lòng chọn Bản ghi nhận thanh toán thực tế.',
  Cargo_PSRTCPA: 'Vui lòng chọn hồ sơ mà bạn muốn thực hiện yêu cầu thanh toán.',
  Cargo_PSRTCV: 'Vui lòng chọn bản ghi mà bạn muốn tạo chứng từ.',
  Cargo_PSSDOCD: 'Vui lòng chọn ngày bắt đầu hoặc ngày kết thúc.',
  Cargo_PSUSPAF: 'Vui lòng chọn mẫu yêu cầu thanh toán chưa nộp.',
  Cargo_PSSPAF: 'Chỉ có thể rút đơn xin thanh toán chưa được phê duyệt',
  Cargo_PSVOFS: 'Vui lòng chọn phiên bản phần mềm tài chính.',
  Cargo_CurrencyMismatch: '{0} Tiền tệ không tương ứng với tài khoản ngân hàng, vui lòng sửa đổi tài khoản thanh toán',
  Cargo_PublicClientHub: 'Khách hàng trên biển',
  Cargo_Publish: 'Xuất bản',
  Cargo_PublishStatus: 'Trạng thái phát hành',
  Cargo_PurchasedBy: 'Người mua',
  Cargo_PurchaseRecord: 'Hồ sơ mua hàng',
  Cargo_PurchaseRegisteredSuccessfully: 'Đăng ký mua thành công.',
  Cargo_PurchaseRegistration: 'Đăng ký mua hàng',
  Cargo_PurchasingParty: 'Trang chủ',
  Cargo_PurchasingUnit: 'Đơn vị mua hàng',
  Cargo_PUSBAANMRIDSS: 'Ngân hàng và tài khoản của đơn vị mua hàng không phải là tài khoản ngân hàng thuộc sở hữu của {0}, có cần lưu không?',
  Cargo_PutARItemsOnTop: 'Nên đặt lên trên.',
  Cargo_PYPALAA: 'Điều chỉnh lợi nhuận hàng năm',
  Cargo_PYPALAAP: 'Các môn điều chỉnh thiệt hại hàng năm trước đây:',
  Cargo_Query: 'Yêu cầu',
  Cargo_QueryFailed: 'Truy vấn không thành công.',
  Cargo_QueryInvoice: 'Yêu cầu hóa đơn',
  Cargo_QuickSearch: 'Truy vấn đơn giản',
  Cargo_QuotaCurrency: 'Hạn mức tiền tệ',
  Cargo_QuotaRange: 'Khoảng hạn mức',
  Cargo_RAIAV: 'Số tiền đối chiếu sau khi lấy giá trị tuyệt đối',
  Cargo_Railway: 'Đường sắt',
  Cargo_RailwayExport: 'Xuất khẩu đường sắt',
  Cargo_RailwayImport: 'Nhập khẩu đường sắt',
  Cargo_RailwayBusiness: 'Kinh doanh đường sắt',
  Cargo_IntegratedJob: 'Logistics tích hợp',
  Cargo_FbaOrder: 'Đặt hàng FBA',
  Cargo_FbaSea: 'Vận tải biển FBA',
  Cargo_FbaAir: 'Vận chuyển hàng không FBA',
  Cargo_FbaRailway: 'Đường sắt FBA',
  Cargo_RailwayRoute: 'Tuyến đường sắt',
  Cargo_RCAFTPOY: 'Thanh toán ngược {0} năm {1} kỳ',
  Cargo_RCBDIDL: 'Làm mới dữ liệu chi nhánh thả xuống hiện tại',
  Cargo_RealPaid: 'Thanh toán thực',
  Cargo_RealPaidP: 'Thanh toán thực tế:',
  Cargo_ReasonNotEntered: 'Lý do chưa điền',
  Cargo_ReasonOfCargoDetention: 'Lý do khấu trừ',
  Cargo_ReasonOfCargoDetentionP: 'Nguyên nhân khấu trừ:',
  Cargo_ReCalculateBillingAmount: 'Tính toán lại số tiền thanh toán',
  Cargo_Receipt: 'Nhận tiền',
  Cargo_ReceiptAmount: 'Số tiền thu',
  Cargo_Receivable: 'Phải nhận',
  Cargo_ReceivableToCNY: 'CNY thu được:',
  Cargo_ReceivableB: '(Cần thu)',
  Cargo_ReceivedCNY: 'CNY nhận',
  Cargo_PayPaidCNY: 'CNY trả tiền',
  Cargo_ReceivedUSD: 'USD đã nhận',
  Cargo_ReceivedEUR: 'EUR đã nhận',
  Cargo_ReceivedGBP: 'GBP đã nhận',
  Cargo_ReceivedHKD: 'HKD đã nhận',
  Cargo_ReceivedJPY: 'JPY nhận',
  Cargo_ReceivedNGN: 'NGN nhận',
  Cargo_PayPaidUSD: 'USD đã trả',
  Cargo_PayPaidEUR: 'EUR đã trả',
  Cargo_PayPaidGBP: 'GBP trả tiền',
  Cargo_PayPaidHKD: 'HKD trả tiền',
  Cargo_PayPaidJPY: 'JPY trả tiền',
  Cargo_PayPaidNGN: 'NGN trả tiền',
  Cargo_OtherConversionReceivedUSD: 'Tỷ giá USD đã được thanh toán',
  Cargo_OtherConversionReceivedEUR: 'Tỷ giá EUR đã nhận',
  Cargo_OtherConversionReceivedGBP: 'GBP đã được thu hồi',
  Cargo_OtherConversionReceivedHKD: 'HKD đã nhận',
  Cargo_OtherConversionReceivedJPY: 'Các loại JPY khác',
  Cargo_OtherConversionReceivedNGN: 'NGN đã nhận',
  Cargo_OtherConversionPayPaidUSD: 'Tỷ giá USD đã thanh toán',
  Cargo_OtherConversionPayPaidEUR: 'Tỷ giá EUR đã thanh toán',
  Cargo_OtherConversionPayPaidGBP: 'GBP đã thanh toán',
  Cargo_OtherConversionPayPaidHKD: 'HKD đã thanh toán',
  Cargo_OtherConversionPayPaidJPY: 'Thanh toán JPY khác',
  Cargo_OtherConversionPayPaidNGN: 'NGN đã thanh toán',
  Cargo_OtherConversionReceivedCNY: 'CNY đã nhận',
  Cargo_OtherConversionPayPaidCNY: 'CNY đã thanh toán',
  Cargo_ReceivableCNY: 'CNY nhận',
  Cargo_ReceivableEUR: 'EUR nhận',
  Cargo_ReceivableGBP: 'GBP nhận',
  Cargo_ReceivableHKD: 'HKD nhận',
  Cargo_ReceivableJPY: 'JPY nhận',
  Cargo_ReceivableNGN: 'NGN nhận',
  Cargo_ReceivableP: 'Nên thu:',
  Cargo_ReceivablesInvoicingDate: 'Ngày thanh toán',
  Cargo_ReceivablesInvoicingStatus: 'Trạng thái thanh toán',
  Cargo_ReceivablesWriteOfStatus: 'Tình trạng bán hạt nhân',
  Cargo_ReceivableUSD: 'USD phải thu',
  Cargo_Receive: 'Nhận',
  Cargo_RevocationOfReceipt: 'Thu hồi nhận',
  Cargo_Received: 'Đã nhận',
  Cargo_ReceivedDate: 'Ngày nhận tiền',
  Cargo_ReceiveMethod: 'Phương thức thu tiền',
  Cargo_Receiver: 'Lấy lại người',
  Cargo_Receiver2: 'Người nhận',
  Cargo_ReceiverCompanyName: 'Đơn vị nhận',
  Cargo_ReceivingBank: 'Ngân hàng nhận tiền',
  Cargo_ReceivingBankAccount: 'Tài khoản thu tiền',
  Cargo_ReceivingDate: 'Lấy ngày',
  Cargo_Recheck: 'Nhân đôi',
  Cargo_RecheckDate: 'Ngày xem lại',
  Cargo_ReCheckedSuccessfully: 'Kiểm tra lại thành công.',
  Cargo_ReCheckedFailed: 'Tái kiểm tra thất bại.',
  Cargo_CancelReCheckedSuccessfully: 'Hủy kiểm tra lại thành công.',
  Cargo_RecheckOrNot: 'Có hay không',
  Cargo_RecheckP: 'Kiểm tra lại:',
  Cargo_ReCheckPermission: 'Quyền xem lại',
  Cargo_RecipientOfWithdrawal: 'Người nhận hoàn tiền',
  Cargo_RecipientSCompanyOfWithdrawal: 'Đơn vị nhận hàng hoàn trả',
  Cargo_ReconcileOrNot: 'Đối chiếu hay không',
  Cargo_Reconciliation: 'Đối chiếu',
  Cargo_ReconciliationAmount: 'Số lượng đối chiếu',
  Cargo_ReconciliationConfirmation: 'Xác nhận đối chiếu',
  Cargo_ReconciliationDate: 'Ngày đối chiếu',
  Cargo_ReconciliationOfAR: 'Phải đối chiếu',
  Cargo_ReconciliationStatus: 'Tình trạng đối chiếu',
  Cargo_ReconciliationStatusControl: 'Kiểm soát trạng thái đối chiếu',
  Cargo_ReconciliationType: 'Các loại đối chiếu',
  Cargo_SendEmailByReconciliationDiff: 'Đồng bộ hóa thư khi lưu Chi phí thông báo Người tạo đối chiếu số tiền không nhất quán',
  Cargo_ReconciliationDiffConfirm: 'Xử lý chênh lệch đối chiếu',
  Cargo_ReconciliationDiffReason: 'Lý do khác biệt',
  Cargo_ReconciliationDiffConfirmTip: 'Có nên gửi thư thông báo đối chiếu số tiền không nhất quán khi lưu hay không',
  Cargo_Record: 'Hồ sơ đăng ký',
  Cargo_RecordCount: 'Số lượng hồ sơ',
  Cargo_Recorder: 'Người ghi âm',
  Cargo_RecordLabel: 'Ghi nhãn',
  Cargo_RecordNoOfPaidIn: 'Số đăng ký thanh toán',
  Cargo_RecordOrNot: 'Đăng ký',
  Cargo_RecordOutOfPocket: 'Đăng ký trả góp',
  Cargo_RecordPrepayment: 'Đăng ký trả trước',
  Cargo_RecordsFound: 'Truy vấn tới {0} bản ghi',
  Cargo_RecordsWithEmptyInvoiceTypeExist: 'Có hồ sơ với loại hóa đơn trống',
  Cargo_RecordTime: 'Thời gian ghi âm',
  Cargo_RedChargesOrNot: 'Hồng Kông có chi phí nước ngoài không có tài khoản hợp lệ',
  Cargo_ReDeliveryOrNot: 'Có phải lần thứ hai đưa ra?',
  Cargo_ReferralFromExistingClient: 'Giới thiệu khách quen',
  Cargo_Reflush: 'Cập nhật',
  Cargo_RefNbr: 'Số đóng',
  Cargo_Refresh: 'Làm mới',
  Cargo_RefreshCompleteStatus: 'Cập nhật hoàn tất.',
  Cargo_RefreshSearch: 'Làm mới truy vấn',
  Cargo_RefundAdvanceReceipt: 'Trả lại tiền trước',
  Cargo_RefundOfLclBusiness: 'Trả lại tiền cho LCL?',
  Cargo_Refuse: 'Từ chối',
  Cargo_Region: 'Khu vực',
  Cargo_RegisteredCapital: 'Tiền đăng ký công ty',
  Cargo_RegisteredCapitalIn10Thousand: 'Tiền đăng ký công ty/vạn',
  Cargo_RegistrationNumber: 'Số nhận dạng người nộp thuế',
  Cargo_RegistrationNumberP: 'Số nhận dạng người nộp thuế:',
  Cargo_ReIssuedInvoiceNo: 'Mở lại số hóa đơn mới',
  Cargo_ReIssuedInvoiceNoP: 'Mở lại số hóa đơn mới:',
  Cargo_ReIssueInvoice: 'Mở lại hóa đơn',
  Cargo_ReIssueVoidedInvoice: 'Tái lập hóa đơn sau khi hủy bỏ',
  Cargo_RelatedBLNo: 'Số vận đơn liên quan',
  Cargo_Release: 'Phát hành',
  Cargo_ReleaseHbl: 'Đặt hàng riêng lẻ',
  Cargo_Releasing: 'Đặt hàng',
  Cargo_ReleasingStatus: 'Trạng thái đặt hàng',
  Cargo_RemainingAmount: 'Số tiền còn lại',
  Cargo_RemainingPledgedAmount: 'Số tiền yêu cầu còn lại',
  Cargo_Remarks: 'Ghi chú',
  Cargo_SupervisorComments: 'Giám sát khu vực bình luận',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: 'Ghi chú không thể trống khi bỏ qua số 0.',
  Cargo_RemarksOnAROrAPItems: 'Ghi chú đối tượng thu phí',
  Cargo_RemarksOnPayment: 'Ghi chú thanh toán',
  Cargo_RemarksP: 'Ghi chú:',
  Cargo_ArOriginalCurrency: 'Phải thu (loại tiền gốc)',
  Cargo_ApOriginalCurrency: 'Đối phó (tiền tệ gốc)',
  Cargo_RemarkTheLengthCannotExceedP: 'Chiều dài ghi chú không được vượt quá',
  Cargo_RemarkTheLengthCannotExceedP256: 'Độ dài ghi chú không được vượt quá 256.',
  Cargo_RemittanceFee: 'Tiền gửi',
  Cargo_Remove: 'Xóa',
  Cargo_RemoveConfig: 'Xoá cấu hình',
  Cargo_AddConfig: 'Thêm cấu hình',
  Cargo_RemoveBillCharge: 'Phí loại bỏ',
  Cargo_RemoveDetails: 'Xóa chi tiết',
  Cargo_RemoveExpenseRemoveAll: 'Loại bỏ chi phí/Loại bỏ tất cả',
  Cargo_RemoveParameterFunction: 'Loại bỏ chức năng tham số',
  Cargo_RemovePartial: 'Xóa phần',
  Cargo_OrderType: 'Loại lệnh',
  Cargo_TruckTrailer: 'Bộ sưu tập Trailer',
  Cargo_WholeVehicleAndLessThanCarload: 'Toàn bộ xe/Zero Train',
  Cargo_RemovePermissionToSubmitExpense: 'Hủy quyền nộp phí',
  Cargo_RemoveSelectedData: 'Bỏ dữ liệu đã chọn',
  Cargo_RemoveSelectedExpense: 'Loại bỏ phí lựa chọn',
  Cargo_RenderStyle: 'Vẽ kiểu dáng',
  Cargo_Renew: 'Gia hạn',
  Cargo_RenewContract: 'Gia hạn hợp đồng',
  Cargo_ReOpen: 'Mở lại',
  Cargo_ReOpenedSuccessfully: 'Khởi động lại thành công.',
  Cargo_RepeatedMaintenance: 'Bảo trì lặp lại',
  Cargo_ReplaceBill: 'Hóa đơn thay thế',
  Cargo_ReportTo: 'Báo cáo đối tượng',
  Cargo_Reset: 'Đặt lại',
  Cargo_ResetFilter: 'Đặt lại điều kiện',
  Cargo_Restore: 'Phục hồi',
  Cargo_RestoreSelectedClient: 'Khách hàng xác nhận lựa chọn khôi phục',
  Cargo_RetreatASingle: 'Danh sách hoàn trả',
  Cargo_RetrievalFailureReturnFunction: 'return function không thành công',
  Cargo_RetrievalFunction: 'Chức năng truy xuất',
  Cargo_RetrievalType: 'Loại truy xuất',
  Cargo_RetrievalTypeP: 'Loại truy xuất:',
  Cargo_Retrieved: 'Đã lấy lại',
  Cargo_RetrievedButNotReturned: 'Đã lấy lại (không hoàn lại)',
  Cargo_RetrieveMark: 'Đánh dấu lấy lại',
  Cargo_Return: 'Trả lại',
  Cargo_ReturnDate: 'Ngày hoàn trả',
  Cargo_Returned: 'Trả lại',
  Cargo_ReturnedSuccessfully: 'Hoàn trả thành công.',
  Cargo_ReturnExpressNumber: 'Trả lại số Express',
  Cargo_ReturnOrderExpressNumber: 'Số chuyển phát nhanh',
  Cargo_ReturnQuery: 'Quay lại yêu cầu',
  Cargo_ReturnToSearch: 'Quay lại truy vấn',
  Cargo_Revenue: 'Thu nhập',
  Cargo_RevenueAndExpenditureType: 'Loại thu và thanh toán',
  Cargo_RevenueOrExpenditure: 'Thu và thanh toán',
  Cargo_Reverse: 'Xác nhận Red Rush',
  Cargo_ReversedCloseAccountSuccessfully: 'Thanh toán ngược thành công',
  Cargo_CloseAccountSuccessfully: 'Thanh toán thành công',
  Cargo_ReverseReview: 'Chống kiểm toán',
  Cargo_ReverseReviewedSuccessfully: 'Chống kiểm toán thành công',
  Cargo_ReviewCancelledSuccessfully: 'Hủy xét duyệt thành công.',
  Cargo_ReviewedOrNot: 'Đã kiểm tra chưa',
  Cargo_ReviewOverallSearch: 'Kiểm tra truy vấn toàn cục',
  Cargo_ReviewTime: 'Thời gian xét duyệt',
  Cargo_ReviewVoucher: 'Chứng từ kiểm toán',
  Cargo_Revoke: 'Hủy bỏ',
  Cargo_RevokeClaim: 'Thu hồi yêu cầu bồi thường',
  Cargo_RevokedSuccessfully: 'Hoàn tác thành công.',
  Cargo_RevokeInvoicingApplication: 'Hủy bỏ yêu cầu thanh toán',
  Cargo_RevokeOrNot: 'Hủy bỏ',
  Cargo_PushFailByCBMS: 'Giao hàng thất bại, vui lòng liên hệ nhân viên kiểm tra',
  Cargo_PushSuccessByCBMS: 'Đẩy doanh nghiệp thành công',
  Cargo_RevokeReview: 'Hủy kiểm toán',
  Cargo_RevokeSelection: 'Bỏ chọn',
  Cargo_RevokeWithdrawal: 'Hoàn tiền',
  Cargo_RevokeWithdrawalList: 'Danh sách hoàn tiền',
  Cargo_RevokingRetrievalFailed: 'Việc thu hồi thất bại.',
  Cargo_RFPNMIS: 'Trong sổ sách không có thời gian tài chính tương ứng.',
  Cargo_RITSS: 'Đăng nhập thành công vào hệ thống.',
  Cargo_RTGTEOMCACC: 'Lặp lại thao tác xuất thuế vàng có thể gây thêm chi phí, có xác định muốn xuất thuế vàng một lần nữa không?',
  Cargo_RTIAFRODI: 'Nếu bạn không chọn "Xóa xác nhận phí cùng một lúc", hãy trả lại hóa đơn để xem xét yêu cầu lập hóa đơn hoặc xóa hóa đơn và xác nhận phí',
  Cargo_RTPIRS: 'Đã được đặt lại để kiểm tra yêu cầu thanh toán',
  Cargo_Rule: 'Quy tắc',
  Cargo_SABID: 'Bỏ qua việc điền thông tin cơ bản',
  Cargo_SADNSUICAT: 'Các mục hiện nay không có mục hạt nhân phụ trợ.',
  Cargo_SailingDate: 'Ngày khởi hành',
  Cargo_SailingDay: 'Ngày khởi hành',
  Cargo_ETD: 'ETD',
  Cargo_ETA: 'ETA',
  Cargo_ATD: 'ATD',
  Cargo_ATA: 'ATA',
  Cargo_LookDetail: 'Xem chi tiết',
  Cargo_Sales: 'Bán hàng',
  Cargo_SalesP: 'Bán hàng:',
  Cargo_SalesBranchCompany: 'Chi nhánh bán hàng',
  Cargo_SalesCommission: 'Chiết khấu bán hàng',
  Cargo_SalesCompany: 'Công ty bán hàng',
  Cargo_SalesDepartment: 'Bộ phận bán hàng',
  Cargo_SalesFreeHand: 'Bán hàng tự động',
  Cargo_Salesman: 'Nhân viên kinh doanh',
  Cargo_SalesmanP: 'Nhân viên nghiệp vụ:',
  Cargo_SalesParty: 'Bên bán hàng',
  Cargo_SalesPerson: 'Nhân viên bán hàng',
  Cargo_SALOGROEI: 'Bạn cần chọn ít nhất một điều kiện nhóm hoặc nhập tên tóm tắt.',
  Cargo_SameYear: 'Cùng năm',
  Cargo_SAPPMBI: 'Các đơn vị thanh toán trả góp/trả góp được chọn phải giống nhau.',
  Cargo_Save: 'Lưu',
  Cargo_SaveAll: 'Lưu tất cả',
  Cargo_SaveAndAdd: 'Lưu và thêm',
  Cargo_SaveAndCalculateTotalAmount: 'Lưu và tính tổng số tiền',
  Cargo_SaveBill: 'Tiết kiệm hóa đơn',
  Cargo_SaveCurrentSelection: 'Lưu vùng chọn hiện tại',
  Cargo_CurrentSelection: 'Chọn hiện thời',
  Cargo_Saved: 'Cứu xong rồi.',
  Cargo_SaveEditing: 'Lưu sửa đổi',
  Cargo_SaveEntity: 'Lưu khối đặc',
  Cargo_SaveExchangeRateToCache: 'Lưu tỷ giá hối đoái vào bộ nhớ cache',
  Cargo_SaveFailed: 'Cứu thất bại.',
  Cargo_SaveGroupInfo: 'Lưu thông tin nhóm',
  Cargo_SaveInvoice: 'Lưu hóa đơn',
  Cargo_SaveInvoiceNo: 'Lưu số hóa đơn',
  Cargo_SaveOrNot: 'Có phải cứu lớn không?',
  Cargo_SaveQueryP: 'Lưu tham số truy vấn',
  Cargo_SaveReconciliation: 'Lưu đối chiếu',
  Cargo_SaveSucceed: 'cứu thành công.',
  Cargo_Saving: 'Đang lưu',
  Cargo_SBRASPATFRD: 'Yêu cầu thanh toán không yêu cầu đánh giá doanh nghiệp, được gửi trực tiếp đến đánh giá tài chính',
  Cargo_SBSPISB: 'Cùng một chi nhánh được tổng hợp theo đối tượng thanh toán',
  Cargo_ScaleOfCompany: 'Quy mô công ty',
  Cargo_ScaleOfCompanyEmployees: 'Quy mô công ty/người',
  Cargo_SCNEIPMSL: 'Mô-đun đối tác đã tồn tại Doanh nghiệp có tên tương tự cần liên kết',
  Cargo_SCOCCSC: 'Chiết khấu cho hoạt động bán hàng Chiết khấu cho dịch vụ khách hàng',
  Cargo_SDNCCNTFL: 'Có báo cáo dữ liệu chưa tải xong, vui lòng nhấp vào tải tiếp theo.',
  Cargo_SDNMBR: 'Tình trạng thanh toán không đáp ứng yêu cầu thanh toán',
  Cargo_SDNMWOR: 'Tình trạng thanh toán không đáp ứng yêu cầu thanh toán',
  Cargo_SeaportOfDischarge: 'Cảng dỡ hàng (cảng biển)',
  Cargo_Search: 'Truy xuất',
  Cargo_SearchAlreadyExisted: 'Query đã tồn tại',
  Cargo_SearchAPWriteOffs: 'Trả lời yêu cầu bán hàng',
  Cargo_SearchARWriteOff: 'Cần thanh toán hóa đơn bán hàng',
  Cargo_SearchCompleted: 'Truy vấn thành công.',
  Cargo_SearchConditions: 'Điều kiện yêu cầu',
  Cargo_SearchCreated: 'Truy vấn đã tạo',
  Cargo_SearchDisplayColumn: 'Truy vấn hiển thị cột',
  Cargo_SearchError: 'Truy vấn bị lỗi.',
  Cargo_SearchForBill: 'Yêu cầu thanh toán',
  Cargo_SearchForBusinessDeptApproved: 'Truy vấn phê duyệt nghiệp vụ và phê duyệt bộ phận',
  Cargo_SearchForBusinessOfSameGroup: 'Tìm kiếm doanh nghiệp cùng nhóm',
  Cargo_SearchForData: 'Truy vấn dữ liệu',
  Cargo_SearchForDataAsPerPermission: 'Truy vấn dữ liệu theo quyền',
  Cargo_SearchForExpenses: 'Chi phí điều tra',
  Cargo_SearchForMore: 'Hỏi thêm',
  Cargo_SearchForOverseasExpense: 'Hỏi chi phí ở nước ngoài',
  Cargo_SearchForParameterTemplateList: 'Danh sách mẫu tham số truy vấn',
  Cargo_SearchInformation: 'Thông tin',
  Cargo_SearchMark: 'Thẻ truy vấn',
  Cargo_SearchOperation: 'Hành động truy vấn',
  Cargo_SecondNotifyParty: 'Thông báo thứ hai',
  Cargo_SecondVoyage: 'Thuyền lần',
  Cargo_SecureBusiness: 'Khóa doanh nghiệp',
  Cargo_SEFInput: 'Nhập chứng từ khai hải quan',
  Cargo_Select: 'Chọn',
  Cargo_SelectAddPlatfoCNYLMethod: 'Nền tảng B/L Phương pháp Chọn Thêm',
  Cargo_SelectAddPlatformContainerType: 'Thêm lựa chọn loại hộp nền tảng',
  Cargo_SelectAddPlatformCurrency: 'Lựa chọn tiền tệ nền tảng Thêm',
  Cargo_ShippingAddress: 'Địa chỉ giao hàng',
  Cargo_AddModel: 'Bảo trì mô hình',
  Cargo_maintenance: 'Bảo trì Collector',
  cargo_container_type: 'Loại Collector',
  cargo_container_code: 'Bộ sưu tập Mã',
  cargo_container_number: 'Số bộ sưu tập',
  cargo_pallet: 'Tấm ốp',
  cargo_container_max_weight: 'Bộ sưu tập có thể chứa trọng lượng hàng hóa',
  cargo_container_max_capacity: 'Bộ sưu tập có thể chứa hàng hóa',
  cargo_loading_rate: 'Tỷ lệ tải',
  Cargo_Container_Type_Not_Configured: 'Bạn không duy trì bộ sưu tập và có thể đến 【Dữ liệu cơ bản - Bộ sưu tập】 để duy trì dữ liệu tương ứng',
  cargo_please_enter_the_container: 'Vui lòng nhập bộ sưu tập',
  cargo_please_enter_the_container_code: 'Vui lòng nhập mã bộ sưu tập',
  cargo_Please_select_a_container: 'Vui lòng chọn Collector',
  cargo_Charter_package_board_statistics: 'Thống kê bảng điều lệ',
  cargo_please_enter_the_cost: 'Vui lòng nhập chi phí',
  Cargo_please_enter_flight_costs: 'Chuyến bay thuê bao/bảng gói, vui lòng nhập chi phí chuyến bay.',
  Cargo_Please_enter_charter_details_or_flight_costs: 'Chuyến bay trọn gói, vui lòng nhập thông tin trọn gói hoặc chi phí chuyến bay.',
  cargo_can_only_be_dragged_under_a_container: 'Chỉ có thể kéo xuống bộ sưu tập.',
  cargo_requires_dragging_across_containers: 'Cần kéo qua bộ nạp',
  cargo_not_allowed_reconfiguration: 'Ngoài trạng thái hoạt động, các nghiệp vụ khác không được phép thay đổi.',
  Cargo_cross_flight_tips: 'Các chuyến bay liên kết với bộ sưu tập mới và xóa bỏ tất cả thông tin về bộ sưu tập liên kết kinh doanh ban đầu, xin xác nhận xem có tiếp tục không?',
  Cargo_CheckUldWeightOrCubage: 'Mã bộ sưu tập: {0} Hàng hóa {1} vượt quá khả năng tải {2}, vui lòng xác nhận nếu nó được lưu?',
  Cargo_master_reconfiguration_tips: 'Sau khi thay đổi, tất cả hóa đơn dưới phiếu chính đều liên quan đến bộ sưu tập, có tiếp tục hay không?',
  cargo_no_flight_information: 'Không có chuyến bay cho doanh nghiệp hiện tại và không có thông tin chuyến bay cho vị trí mục tiêu, không cần xử lý',
  cargo_unloaded_container_business: 'Bộ sưu tập không tải',
  Cargo_SelectAddPlatformPackages: 'Lựa chọn gói nền tảng Thêm',
  Cargo_SelectAddPlatformShippingTerms: 'Nền tảng Điều khoản vận chuyển Chọn Thêm',
  Cargo_SelectAddPlatformTradeMethod: 'Nền tảng Phương thức giao dịch Chọn Thêm',
  Cargo_SelectAddPlatformTradeTerms: 'Nền tảng Điều khoản thương mại Chọn Thêm',
  Cargo_SelectAll: 'Chọn tất cả',
  Cargo_SelectBusinessDateRange: 'Chọn phạm vi ngày kinh doanh',
  Cargo_SelectCopyContent: 'Chọn nội dung sao chép',
  Cargo_SelectCurrency: 'Chọn loại tiền tệ',
  Cargo_Selected: 'Đã chọn',
  Cargo_SelectedByDefault: 'Chọn mặc định',
  Cargo_SelectedData: 'Dữ liệu đã chọn',
  Cargo_SelectedEntity: 'Thực thể đã chọn',
  Cargo_SelectedExpenseConfirmedExpense: 'Phí đã chọn Phí đã xác nhận',
  Cargo_SelectedInvoice: 'Hóa đơn đã chọn',
  Cargo_SelectedItems: 'Đã chọn: {0}',
  Cargo_SelectedP: 'Đã chọn:',
  Cargo_SelectedVoucher: 'Chứng từ đã chọn',
  Cargo_SelectedVoucherCantOver100: 'Chứng từ {0} đã chọn, không được vượt quá 100.',
  Cargo_SelectEventStatus: 'Vui lòng chọn trạng thái sự kiện',
  Cargo_SelectEventToApprove: 'Vui lòng chọn mục phê duyệt',
  Cargo_SelectFilesToDownload: 'Vui lòng chọn tập tin cần tải xuống',
  Cargo_SelectInvoiceNo: 'Chọn số hóa đơn',
  Cargo_SelectNewInvoiceNo: 'Chọn số hóa đơn mới',
  Cargo_SelectOrAddInvoiceNo: 'Chọn hoặc điền số hóa đơn',
  Cargo_SelectPaperInvoiceByDefault: 'Chọn hóa đơn giấy mặc định',
  CargoMsg_Information_Supplement: 'Bổ sung thông tin',
  Cargo_SelectRecordsToExport: 'Vui lòng chọn bản ghi cần xuất',
  Cargo_SelectSalesPerson: 'Vui lòng chọn bán',
  Cargo_SelectSalesPersonDep: 'Vui lòng chọn bộ phận bán hàng',
  Cargo_SelectCsr: 'Vui lòng chọn dịch vụ khách hàng',
  Cargo_SelectCsrDep: 'Vui lòng chọn dịch vụ khách hàng',
  Cargo_SelectDoc: 'Vui lòng chọn chứng từ',
  Cargo_SelectDocDep: 'Vui lòng chọn bộ phận chứng từ',
  Cargo_SelectOverseaOp: 'Vui lòng chọn dịch vụ khách hàng nước ngoài',
  Cargo_SelectOverseaOpDep: 'Vui lòng chọn dịch vụ khách hàng nước ngoài',
  Cargo_SelectCargoSales: 'Vui lòng chọn Range Rover Sale',
  Cargo_SelectPlanner: 'Vui lòng chọn người dẫn đường',
  Cargo_SelectPlannerDep: 'Vui lòng chọn bộ phận phụ trách đường bay',
  Cargo_invalidBatchModifyBusiness: 'Không tìm thấy chi nhánh hoạt động và chi nhánh bán hàng giống nhau, vui lòng thử lại sau khi chọn lại',
  Cargo_SelectSob: 'Chọn tài khoản',
  Cargo_SelectSubject: 'Vui lòng chọn chủ đề',
  Cargo_SelectToCopyInFutureDoNotAsk: 'Sau này sao chép theo lựa chọn này không cần hỏi nữa',
  Cargo_SelectVoucherDate: 'Chọn ngày chứng từ',
  Cargo_SelfDeclaration: 'Tự khai hải quan',
  Cargo_SelfDeclareToCustoms: 'Tự khai hải quan',
  Cargo_SelfDelivery: 'Tự gửi',
  Cargo_SpecialApprovalIssuance: 'Phát hành đặc biệt',
  Cargo_CurrentAvailableQuantity: 'Số lượng có sẵn hiện tại',
  Cargo_OccupiedBusinessNumber: 'Số hiệu công việc đã chiếm dụng',
  Cargo_RemainingAvailableQuantity: 'Số lượng có sẵn còn lại',
  Cargo_SpecialApprovalCreateBusiness: 'Khi đối tượng thanh toán vượt quá kiểm soát tín dụng và được cấu hình với [Không thể lưu], có thể sử dụng phê duyệt đặc biệt để tạo doanh nghiệp trong quá trình phát hành số.',
  Cargo_CopyResult: 'Đã sao chép thành công {0} mục, sao chép thất bại {1} mục',
  Cargo_SellingPrice: 'Giá bán',
  Cargo_SellTitle: 'Đơn vị bán hàng',
  Cargo_Send2: 'Gửi đi',
  Cargo_SendAll: 'Gửi tất cả',
  Cargo_SendAllP: 'Gửi tất cả',
  Cargo_SendBack: 'Trả lại',
  Cargo_SendConfirmationStatus: 'Gửi trạng thái xác nhận',
  Cargo_SendFailed: 'Gửi thất bại.',
  Cargo_SendingDate: 'Ngày gửi',
  Cargo_SendMessage: 'Gửi tin nhắn',
  Cargo_SendPartial: 'Gửi một phần',
  Cargo_SendToBranchCompany: 'Gửi văn phòng chi nhánh',
  Cargo_Sent: 'Đã gửi',
  Cargo_SentDate: 'Ngày gửi',
  Cargo_SeparateNumber: 'Số phụ',
  Cargo_September: 'Tháng Chín',
  Cargo_SequenceNumber: 'Số sê-ri',
  Cargo_UNNumber: 'Số UN',
  Cargo_ChargeUnit: 'Đơn vị thanh toán/đơn vị',
  Cargo_DangerousGoods: 'Hàng nguy hiểm',
  Cargo_IndicatesRequired: '* Số có nghĩa là bắt buộc',
  Cargo_NewTo: 'Mới',
  Cargo_EditTo: 'Chỉnh sửa',
  Cargo_AccountingPeriodRange: 'Vui lòng xác định phạm vi tài khoản.',
  Cargo_SerialNoOfBankReceipt: 'Số dòng chảy đơn nước',
  Cargo_AutoUpdateNote: 'Có nên tự động cập nhật ghi chú không?',
  Cargo_ConfirmBeforeEnable: 'Vui lòng xác nhận với đội ngũ kỹ thuật trước khi mở. Không nên mở một cách tùy ý.',
  Cargo_MultiHeaderBankMode: 'Chế độ ngân hàng nhiều tiêu đề',
  Cargo_ServiceCodeCannotBeNull: 'Mã dịch vụ không được để trống',
  Cargo_ServiceItems: 'Dự án dịch vụ',
  Cargo_ServiceName: 'Tên dịch vụ',
  Cargo_AutoGenerateFeeName: 'Tự động tạo tên chi phí',
  Cargo_AutoGenerateTaxRate: 'Tự động tạo thuế suất',
  Cargo_TaxNameRateConsistency: 'Tên thuế suất/chi phí và Thuế suất phải được nhập đồng thời hoặc để trống đồng thời.',
  Cargo_AutoGenerateOrDefaultTaxExclusive: 'Tự động tạo thuế suất và Thuế suất mặc định không thể được bật cùng lúc; chỉ có một tùy chọn được phép hoạt động.',
  Cargo_ServiceNameCanTBeEmpty: 'Tên dịch vụ không được để trống',
  Cargo_ServiceRequestAddressForEInvoice: 'Địa chỉ yêu cầu dịch vụ hóa đơn điện tử',
  Cargo_ServiceTicket: 'Xác nhận chi phí',
  Cargo_ServiceTicketState: 'Xác nhận trạng thái đơn',
  Cargo_ServiceTicketCreatedOrNot: 'Đã xác nhận chi phí chưa?',
  Cargo_ServiceTicketIssued: 'Đã xác nhận',
  Cargo_SetAging: 'Thiết lập tuổi sổ sách',
  Cargo_SetDefault: 'Đặt mặc định',
  Cargo_SetDefaultItemDescription: 'Đặt tên dự án mặc định',
  Cargo_SetDefaultItemName: 'Mặc định tên dự án',
  Cargo_SetFocusToFileNoTextTable: 'Đặt tiêu điểm vào hộp văn bản số tập tin',
  Cargo_SetName: 'Đặt tên',
  Cargo_SetsOfBooks: 'Tài khoản',
  Cargo_SetsOfBooksP: 'Sổ sách:',
  Cargo_SetText: 'Đặt văn bản',
  Cargo_SettleAccountsTo: 'Đối tượng thanh toán',
  Cargo_SettleByMonthly: 'Thanh toán hàng tháng',
  Cargo_SettleByWeekly: 'Thanh toán theo tuần',
  Cargo_SettlementAgent: 'Đại lý thanh toán',
  Cargo_SettlementAgentError: 'Lỗi đại lý thanh toán, vui lòng chọn lại!',
  Cargo_SettlementByBill: 'Đăng ký',
  Cargo_SettlementCompany: 'Đơn vị thanh toán',
  Cargo_SettlementMethod: 'Phương thức thanh toán',
  Cargo_SettlementMethodP: 'Phương thức thanh toán',
  Cargo_SettlementNotByBill: 'Không có phiếu',
  Cargo_SettlementNotice: 'Thông báo thanh toán',
  Cargo_SettlementPartyDoesNotExist: 'Đối tượng thanh toán không tồn tại.',
  Cargo_SettlementStatus: 'Trạng thái thanh toán',
  Cargo_SettlementType: 'Loại Settlement',
  Cargo_DoNotSpecify: 'Không xác định',
  Cargo_DomesticAndForeign: 'Trong nước/ngoài nước',
  Cargo_CurrencyRequirements: 'Yêu cầu tiền tệ',
  Cargo_NotSpecified: 'Chưa xác định',
  Cargo_Appoint: 'Xác định',
  Cargo_PaymentInOriginalCurrency: 'Thanh toán bằng tiền gốc',
  Cargo_SettlingAgentInconsistent: 'Đại lý thanh toán không nhất quán.',
  Cargo_SettlingCompanyMustBeIdentical: 'Các đơn vị thanh toán phải giống nhau.',
  Cargo_SettlingCompanySAbbreviation: 'Đơn vị thanh toán (gọi tắt)',
  Cargo_SettlingCompanySCode: 'Đơn vị thanh toán (Mã)',
  Cargo_SettlingPartyCanTBeEmpty: 'Đối tượng thanh toán không được trống.',
  Cargo_SettlingPartyIncompatible: 'Đối tượng thanh toán không thống nhất.',
  Cargo_SettlingPartyInconsistent: 'Các đối tượng thanh toán không nhất trí.',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: 'Đối tượng thanh toán hoặc đại lý thanh toán không phù hợp',
  Cargo_SettlingPartyIsMandatory: 'Đối tượng thanh toán phải nhập.',
  Cargo_SettlingPartyMustBeConsistent: 'Đối tượng thanh toán phải nhất trí.',
  Cargo_ProjectNumberNotNull: 'Số doanh nghiệp không được để trống',
  Cargo_SettlingPartyOfPayables: 'Đơn vị thanh toán có thể thanh toán',
  Cargo_SetToCurrentSob: 'Thiết lập tài khoản hiện tại',
  Cargo_SetUpDefaultsInBatch: 'Thiết lập hàng loạt Mặc định',
  Cargo_SetUpServiceTypesInBatch: 'Thiết lập hàng loạt các loại dịch vụ',
  Cargo_SFEDOCSP: 'Truy vấn chi tiết về các đối tượng thanh toán hiện hành',
  Cargo_CollectFeeType: 'Loại phí',
  Cargo_Shipper: 'Gửi hàng',
  Cargo_ShipperId: 'Mã vận chuyển',
  Cargo_ShipperInfo: 'Thông tin người gửi hàng',
  Cargo_ShipperSName: 'Tên người gửi hàng',
  Cargo_ShippingCompanyContractNo: 'Công ty tàu',
  Cargo_ShippingCompanySAbbreviation: 'Công ty tàu (gọi tắt)',
  Cargo_ShippingCompanySCode: 'Công ty tàu (Mã)',
  Cargo_ShippingInformation: 'Thông tin vận chuyển',
  Cargo_ShippingRouteArea: 'Đường bay/Khu vực',
  Cargo_ShortAccountIs: 'Số lẻ là:',
  Cargo_ShowDetailedTitles: 'Hiển thị đối tượng chi tiết',
  Cargo_ShowAdjustRateEntry: 'Bao gồm chuyển khoản cuối kỳ',
  Cargo_ShowDetails: 'Hiển thị chi tiết',
  Cargo_ShowedByVessel: 'Hiển thị theo tên tàu',
  Cargo_ShowFromTo2: 'Đến',
  Cargo_ShowInvoiceDetails: 'Hiển thị chi tiết hóa đơn',
  Cargo_ShowOpeningBalance: 'Số dư đầu kỳ',
  Cargo_ShowRows: 'Hiện số thanh',
  Cargo_ShowStatementInformation: 'Hiển thị thông tin sao kê',
  Cargo_ShutOut: 'Đã đóng',
  Cargo_SIATEPIISOTT: 'Phân đoạn ban đầu của mẫu được gán cho mỗi người một không gian',
  Cargo_SignContract: 'Đăng ký',
  Cargo_SingleBillPrinting: 'In vé đơn',
  Cargo_SITCINCOSDHBFLBS: 'Tổng cộng: {0} sao kê, hiện tại là: {1} sao kê (đảm bảo rằng dữ liệu sao kê khác được tải xong khi lưu)',
  Cargo_SiteVisit: 'Thăm thực địa',
  Cargo_Size: 'Kích thước',
  Cargo_SkipPreviousStep: 'Đi qua các bước trước',
  Cargo_SLNECTS: 'Số thông báo chữ đỏ không được nhập, có tiếp tục lưu không?',
  Cargo_SoaConfirmed: '[0] Báo cáo đã được xác nhận.',
  Cargo_SoaCreated: 'Hóa đơn đã được sao kê.',
  Cargo_SoaCreatedM: '[{0}] Hóa đơn đã được thanh toán',
  Cargo_SoaCreatedAlready: 'Hóa đơn đã được sao kê.',
  Cargo_SoaNoAlreadyCreated: 'Số đối chiếu đã được tạo.',
  Cargo_SobCode: 'Mã tài khoản',
  Cargo_SobCodeAlreadyExists: 'Mã tài khoản đã tồn tại.',
  Cargo_SobDataLoadingFailed: 'Tải dữ liệu sổ sách thất bại.',
  Cargo_SobList: 'Danh sách tài khoản',
  Cargo_SobName: 'Tên tài khoản',
  Cargo_SobNameP: 'Tên sổ sách:',
  Cargo_SobSetup: 'Thiết lập tài khoản',
  Cargo_Soc: 'Hộp chính',
  Cargo_IsSoc: 'Có hay không hộp chính',
  Cargo_SoftwareVersion: 'Phiên bản phần mềm',
  Cargo_SolicitationType: 'Loại Range Rover',
  Cargo_SOSINTU: 'Cập nhật Chọn số hóa đơn Trạng thái',
  Cargo_SOSINTUIU: 'Cập nhật số hóa đơn đã chọn Trạng thái đã sử dụng',
  Cargo_SourceOfClient: 'Nguồn khách hàng',
  Cargo_SOWLC: 'Kho đóng gói bên trong',
  Cargo_Sp1: 'Liên kết hóa đơn',
  Cargo_Sp17: 'Mở rộng chi tiết',
  Cargo_Sp18: 'Chi tiết hợp nhất',
  Cargo_Sp24: 'Mô tả tài chính',
  Cargo_Sp27: 'Ký doanh nghiệp',
  Cargo_Sp31: 'Chia phí',
  Cargo_SPABNCTBBE: 'Đối tượng thanh toán và số lượng nghiệp vụ không thể đều trống.',
  Cargo_Space2: 'Ngày hóa đơn',
  Cargo_SPBNMNAL1SCR: 'Đối tượng thanh toán, số nghiệp vụ, số chính, điều kiện truy vấn ngày tháng phải điền vào một cái.',
  Cargo_SpecialApproval: 'Đặc biệt',
  Cargo_SpecialApprovalValidUntil: 'Thời hạn đặc biệt có hiệu lực đến',
  Cargo_BusinessExpirationDate: 'Ngày hết hạn kinh doanh',
  Cargo_SpecialApprovalTip: 'Lưu ý: Khi thời hạn có hiệu lực là trống, đợt đặc biệt có hiệu lực trong một thời gian dài.',
  Cargo_SpecialGoods: 'Sản phẩm có đặc biệt hay không',
  Cargo_SpecialInvoice: 'Hóa đơn chuyên dụng',
  Cargo_SpecialInvoiceGeneralInvoice: 'Hóa đơn chuyên dụng/Hóa đơn thông thường',
  Cargo_SpecialInvoiceInternalInvoice: 'Hóa đơn chuyên dụng/Hóa đơn nội bộ',
  Cargo_SpecialPrice: 'Giá đặc biệt',
  Cargo_SpecialPriceInstructions: 'Mô tả đặc biệt',
  Cargo_SpecifyCollectionPayment: 'Phân biệt thu và nhận',
  Cargo_SPIANA: 'Đối tượng thanh toán không nhất trí và không có quan hệ quy thuận.',
  Cargo_SPIANA_DiffSettlementAgent: 'Đối tượng thanh toán không nhất trí và không có quan hệ quy tịnh, đại lý thanh toán cũng không nhất trí.',
  Cargo_Split: 'Tách',
  Cargo_SplitBillingFees: 'Chi phí chia hóa đơn',
  Cargo_SplitBL: 'Mở hóa đơn',
  Cargo_SplitExpense: 'Chi phí chia tách',
  Cargo_SplitExpenseP: 'Phí chia tách:',
  Cargo_SplitHBL: 'HBL hủy',
  Cargo_SplitMBL: 'MBL Hủy',
  Cargo_SplitOldDataToNew: 'Tách (dữ liệu cũ trở thành dữ liệu mới)',
  Cargo_SplitSuccessfully: 'Chia thành công',
  Cargo_SPNETRSC: 'Đối tượng thanh toán không tồn tại, xin hãy đặt lại bộ nhớ thử.',
  Cargo_SPWPWO: 'Đối tượng thanh toán hóa đơn',
  Cargo_SSNMIR: 'Tình trạng thanh toán không đáp ứng yêu cầu thanh toán',
  Cargo_SSNMWOR: 'Tình trạng báo cáo không đáp ứng yêu cầu bán hàng',
  Cargo_SSSFPR: 'Lưu trạng thái preview đã được đệ trình thành công',
  Cargo_STAEONRS: 'Điều khoản vận chuyển đã tồn tại hoặc hồ sơ không được chọn',
  Cargo_Staff: 'Nhân viên',
  Cargo_StaffP: 'Nhân viên:',
  Cargo_StampOfSalesUnit: 'Đơn vị tiêu thụ: (Chương)',
  Cargo_StartDateOfContainerReturn: 'Ngày bắt đầu trả lại',
  Cargo_StartDateOfFinancialPeriod: 'Ngày bắt đầu kỳ tài chính',
  Cargo_StartingAccountTitle: 'Chủ đề bắt đầu',
  Cargo_StartNo: 'Bắt đầu số',
  Cargo_StartReconciliation: 'Đối chiếu bằng tay',
  Cargo_StatementOfBalance: 'Bảng cân bằng qua lại',
  Cargo_StatementOfBalance2: 'Bảng cân đối qua lại 2',
  Cargo_Statistics: 'Thống kê',
  Cargo_StatisticsWithoutMblExpenses: 'Không tính phí Master Ticket',
  Cargo_Status: 'Trạng thái',
  Cargo_StatusChanged: 'Thay đổi trạng thái',
  Cargo_StatusOfAdvanceReceipt: 'Tình trạng tiền thu',
  Cargo_STCCOTB: 'Bạn có chắc chắn muốn hủy xác nhận hóa đơn này không?',
  Cargo_STDTATM: 'Xác nhận rằng bạn muốn xóa bản đồ đối tượng này?',
  Cargo_STDTATNRAD: 'Bạn có chắc chắn muốn xóa chủ đề này? Không thể phục hồi sau khi xóa!',
  Cargo_STDTPA: 'Xác nhận rằng bạn muốn xóa các yêu cầu thanh toán này?',
  Cargo_STWTPA: 'Xác nhận rằng bạn muốn rút các yêu cầu thanh toán này?',
  Cargo_STDTSPT: 'Bạn có chắc chắn muốn xóa mẫu tham số truy vấn này không?',
  Cargo_STDTSRRAVWBDT: 'Có chắc là bạn muốn xóa sổ sách không? Các quy tắc và chứng từ liên quan đến sổ sách cũng sẽ bị xóa.',
  Cargo_STDTSVRJEWBDT: 'Bạn có chắc chắn muốn xóa chứng từ đã chọn này? Danh mục chứng từ liên quan đến nó cũng sẽ bị xóa.',
  Cargo_STDTSVRJEWBDTM: 'Bạn có chắc chắn muốn xóa {0} chứng từ đã chọn này không? Danh mục chứng từ liên quan đến nó cũng sẽ bị xóa.',
  Cargo_STDTVGR: 'Xác nhận rằng bạn muốn xóa quy tắc nhóm chứng từ này?',
  Cargo_STOAOWO: 'Hiển thị tổng số tiền chưa bán',
  Cargo_Storage: 'Kho bãi',
  Cargo_SendToEachRecipientSeparately: 'Gửi riêng cho từng người nhận',
  Cargo_SyncSendCCAddress: 'Đồng bộ địa chỉ gửi cc',
  Cargo_SearchForTheDataYouWantToInsert: 'Tìm kiếm dữ liệu bạn muốn chèn',
  Cargo_StorageRequired: 'Kho hoặc không',
  Cargo_STRAEAAWORWBRC: 'Bạn chắc chắn muốn hủy bỏ? Tất cả các chi phí điều chỉnh và hồ sơ bán hàng sẽ được đặt lại.',
  Cargo_StreetAddress: 'Chi tiết địa chỉ đường phố',
  Cargo_StreetAddressCanTBeEmpty: 'Địa chỉ đường phố không được để trống',
  Cargo_STRTWOREAIIWBR: 'Có chắc là muốn hủy bỏ hoạt động bán hàng này không? Chi phí tương ứng và thông tin hóa đơn sẽ được đặt lại.',
  Cargo_Stuff: 'Điền',
  Cargo_STWBTSV: 'Bạn có chắc chắn về {0} chứng từ mà bạn muốn được đánh dấu đỏ?',
  Cargo_SubCategoryOfAccountTitle: 'Subclass Đối tượng',
  Cargo_Submit: 'Giới thiệu',
  Cargo_SubmitExpenseForReviewDirectly: 'Có nên nộp trực tiếp phí xét duyệt hay không',
  Cargo_SubmitPaymentNotice: 'Gửi thông báo thanh toán',
  Cargo_SubmitStatusSelection: 'Chọn trạng thái cam kết',
  Cargo_Submitted: 'Đã gửi',
  Cargo_SubmittedForPreReviewStatus: 'Có nên nộp trạng thái sơ thẩm hay không',
  Cargo_SubmittedSuccessfully: 'Gửi thành công.',
  Cargo_SpecialFeeLimitReleaseApply: 'Đề nghị gỡ bỏ hạn chế chi phí đặc biệt',
  Cargo_SpecialFeeLimitReleaseApplyContent: 'Đề nghị gỡ bỏ hạn chế chi phí đặc biệt cho {0}',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: 'Đề nghị gỡ bỏ hạn chế chi phí đặc biệt',
  Cargo_ReleaseDocumentNumberApplication: 'Đơn xin phát hành tài liệu/số',
  Cargo_ReleaseNumberDocument: 'Phát hành số/tài liệu',
  Cargo_IsPaymentReceived: 'Đã nhận thanh toán hay chưa',
  Cargo_PaymentTime2: 'Thời gian nhận thanh toán',
  Cargo_ReleaseNumberQuantity: 'Số lượng số phát hành',
  Cargo_RelatedAttachments: 'Tệp đính kèm liên quan',
  Cargo_ReleaseNumber: 'Phát hành số',
  Cargo_ReleaseDocument: 'Phát hành tài liệu',
  Cargo_RemainingTemporaryReleaseQuantity: 'Số lượng phát hành tạm thời còn lại',
  Cargo_TemporaryDocumentReleaseApplication: 'Đơn xin phát hành tài liệu tạm thời',
  Cargo_TemporaryNumberReleaseApplication: 'Đơn xin phát hành số tạm thời',
  Cargo_SubscribePOL: 'Nơi khởi hành',
  Cargo_SubsidiaryAccounting: 'Kế toán phụ trợ',
  Cargo_SubsidiaryAccountingClient: 'Hỗ trợ kế toán khách hàng',
  Cargo_SubsidiaryAccountingCondition1: 'Điều kiện kế toán phụ trợ 1',
  Cargo_SubsidiaryAccountingCondition2: 'Điều kiện kế toán phụ trợ 2',
  Cargo_SubsidiaryAccountingCondition3: 'Điều kiện kế toán phụ trợ 3',
  Cargo_SubsidiaryAccountingCondition4: 'Điều kiện kế toán phụ trợ 4',
  Cargo_SubsidiaryAccountingCondition5: 'Điều kiện kế toán phụ trợ 5',
  Cargo_SubsidiaryAccountingCondition6: 'Điều kiện kế toán phụ trợ 6',
  Cargo_SubsidiaryAccountingItems: 'Dự án kế toán phụ trợ',
  Cargo_SubsidiaryAccountingStaff: 'Nhân viên kế toán phụ trợ',
  Cargo_SubsidiaryLedger: 'Chi tiết',
  Cargo_SubsidiaryLedger2: 'Chi tiết 2',
  Cargo_SubtitlesOfAccount: 'Đối tượng phụ',
  Cargo_SubTotal: 'Tổng phụ',
  Cargo_SubTotalOfOpeningBalance: 'Tổng số dư đầu kỳ',
  Cargo_Success: 'Thành công',
  Cargo_SummarizeDistributionExpense: 'Có thống kê chi phí chia sẻ hay không',
  Cargo_SummarizeMblExpense: 'Thống kê chi phí vé chính',
  Cargo_SupervisionMethod: 'Phương pháp quy định',
  Cargo_SupplierContract: 'Hợp đồng nhà cung cấp',
  Cargo_Surcharge: 'Phụ phí',
  Cargo_Controlled: 'Mục kiểm soát',
  Cargo_NeedInvoice: 'Yêu cầu thanh toán',
  Cargo_SurchargeOrNot: 'Có hay không phụ phí',
  Cargo_SureToAddToBlackList: 'Bạn có chắc chắn muốn vào danh sách đen?',
  Cargo_SureToBatchConfirmTheBill: 'Bạn có chắc chắn muốn xác nhận hóa đơn này với số lượng lớn?',
  Cargo_SureToBatchReviewTheExpense: 'Bạn có chắc chắn muốn kiểm tra hàng loạt {0} chi phí này?',
  Cargo_SureToCancel: 'Bạn chắc chắn muốn hủy bỏ?',
  Cargo_SureToCancelConfirmation: 'Bạn chắc chắn muốn hủy xác nhận?',
  Cargo_SureToCancelConfirmationYes: 'Bạn có chắc chắn muốn hủy xác nhận?',
  Cargo_SureToCancelReviewOfTheExpense: 'Bạn có chắc chắn muốn hủy bỏ khoản phí {0} này không?',
  Cargo_SureToCancelReviewOfTheVoucher: 'Xác nhận rằng bạn muốn hủy kiểm tra {0} chứng từ này?',
  Cargo_SureToCancelReviewOfTheExpenseCheck: 'Chi phí đã chọn tồn tại {0} <br/>',
  Cargo_Billinged: 'Hóa đơn được tạo',
  Cargo_WriteOffed: 'Đã đăng ký',
  Cargo_SureToCancelVerification: 'Bạn có chắc chắn về Cancel Audit?',
  Cargo_SureToCarryOver: 'Anh có xác nhận tiến hành thao tác chuyển giao không?',
  Cargo_SureToConfirmWriteOffRecord: 'Bạn có chắc chắn muốn xác nhận hồ sơ bán hạt nhân?',
  Cargo_SureToCreateInvoice: 'Bạn có chắc chắn về việc tạo hóa đơn?',
  Cargo_SureToCreateListOfCombinedBills: 'Có chắc chắn về danh sách sản xuất và vé không?',
  Cargo_SureToDelete: 'Bạn có chắc chắn rằng bạn muốn xóa nó?',
  Cargo_SureToDeleteWarehouse: 'Sau khi xóa, tất cả thông tin vào vị trí sẽ bị xóa, có tiếp tục không?',
  Cargo_SureToDeleteInvoice: 'Bạn có chắc chắn về việc xóa hóa đơn?',
  Cargo_SureToDeleteSelectedRecord: 'Hãy chắc chắn để xóa các bản ghi đã chọn',
  Cargo_SureToDeleteTheAbstractRule: 'Bạn chắc chắn muốn loại bỏ quy tắc tóm tắt này?',
  Cargo_SureToDeleteTheAdvanceReceipt: 'Bạn có chắc chắn muốn xóa khoản thu trước này không?',
  Cargo_SureToDeleteTheBill: 'Bạn có chắc chắn để xóa hóa đơn này?',
  Cargo_SureToDeleteTheExchangeRate: 'Xác nhận rằng bạn muốn xóa tỷ giá hối đoái này?',
  Cargo_SureToDeleteTheInvoice: 'Bạn có chắc chắn muốn xóa hóa đơn này không?',
  Cargo_SureToDeleteTheMapping: 'Xác nhận bạn muốn xóa bản đồ này?',
  Cargo_SureToDeleteTheRecord: 'Bạn chắc chắn muốn xóa bản ghi này?',
  Cargo_SureToDeleteTheRule: 'Xác nhận rằng bạn muốn xóa quy tắc này?',
  Cargo_SureToDeleteThisSoaItem: 'Bạn có chắc chắn xóa bản sao kê này không?',
  Cargo_SureToDeliverToBranch: 'Xác nhận bạn muốn gửi chi nhánh?',
  Cargo_SureToDeny: 'Bạn chắc chắn muốn từ chối?',
  Cargo_SureToFreezeApplication: 'Bạn có chắc chắn muốn đóng băng ứng dụng?',
  Cargo_SureToHoldSubmission: 'Có chắc là chưa nộp không?',
  Cargo_SureToIssueCombinedInvoice: 'Có chắc là hợp nhất không?',
  Cargo_SureToModifyBillingDate: 'Bạn chắc chắn muốn thay đổi ngày thanh toán?',
  Cargo_SureToPrint: 'Anh chắc là muốn in chứ?',
  Cargo_SureToPrintDetailList: 'Bạn có chắc chắn về danh sách in?',
  Cargo_SureToReIssueInvoice: 'Có chắc là muốn viết lại không?',
  Cargo_SureToRejectIt: 'Có chắc là từ chối không?',
  Cargo_SureToRejectTheExpenseItem: 'Bạn có chắc chắn muốn loại bỏ khoản phí {0} này không?',
  Cargo_SureToRemoveTheBill: 'Xác nhận bạn muốn xóa {0} hóa đơn này?',
  Cargo_SureToRemoveTheExpenseItem: 'Xác nhận bạn muốn loại bỏ khoản phí {0} này?',
  Cargo_SureToReturnApplication: 'Bạn có chắc chắn muốn hoàn lại đơn đăng ký?',
  Cargo_SureToReviewTheBills: 'Bạn có chắc chắn về việc xem xét các danh sách này?',
  Cargo_SureToReviewTheVoucher: 'Xác nhận bạn muốn kiểm tra {0} chứng từ này?',
  Cargo_SureToRevokeContractWith: 'REFERENCES [Tên bảng tham chiếu] (',
  Cargo_SureToRevokeRetrieval: 'Có chắc là rút lại không?',
  Cargo_SureToRevokeWithdrawal: 'Bạn có chắc chắn về việc hủy bỏ hoàn trả?',
  Cargo_SureToVoid: 'Có chắc là muốn hủy bỏ không?',
  Cargo_SureToVoidInvoice: 'Bạn có chắc chắn muốn hủy bỏ hóa đơn?',
  Cargo_SureToVoidTheInvoice: 'Bạn có chắc chắn muốn hủy bỏ hóa đơn này?',
  Cargo_SureToVoidTheInvoiceM: 'Bạn có chắc chắn muốn hủy bỏ hóa đơn này?',
  Cargo_SUSBODNMWBACTS: 'Ngân hàng mở tài khoản của đơn vị tiêu thụ không khớp với tài khoản ngân hàng, xác nhận có cần lưu không?',
  Cargo_SUSBODNMWRISCTS: 'Tài khoản ngân hàng của đơn vị tiêu thụ không khớp với bảo trì trong hệ thống, xác nhận có cần lưu không?',
  Cargo_SUTCPALVIBC: 'Thiết lập thông tin chứng từ lợi nhuận trước khi thanh toán',
  Cargo_SVSFPHBC: 'Thời gian tài chính thuộc về ngày chứng từ được chọn hiện tại đã được thanh toán.',
  Cargo_SVSMHBC: 'Chứng từ hiện tại được chọn, tháng thuộc về đã được thanh toán.',
  Cargo_SWDE: 'Không thống kê chi phí chia sẻ',
  Cargo_Switch: 'Chuyển đổi',
  Cargo_SwitchBasisToAcquireDocument: 'Chuyển đổi theo lấy chứng từ',
  Cargo_SwitchCurrency: 'Chuyển đổi tiền tệ',
  Cargo_SwitchFile: 'Chuyển đổi tập tin',
  Cargo_SwitchInvoice: 'Chuyển hóa đơn',
  Cargo_SwitchMethodOfClaim: 'Chuyển đổi chế độ yêu cầu bồi thường',
  Cargo_SwitchSob: 'Chuyển đổi tài khoản',
  Cargo_Symbol: 'Biểu tượng',
  Cargo_SynchronousCodingPartners: 'Mã hóa khách hàng đồng bộ',
  Cargo_SystemAlertForPayment: 'Tài khoản hệ thống',
  Cargo_SystemBusy: 'Hệ thống bận rộn',
  Cargo_SystemBusyPRL: 'Hệ thống đang bận, vui lòng thử lại sau.',
  Cargo_TableFilter: 'Lọc bảng',
  Cargo_TakeByCustomsBroker: 'Tự khai hải quan',
  Cargo_TAOPLFESAMBETCWOA: 'Kim ngạch+tổng hợp tổn thất+chi phí tài chính+số lẻ phải bằng với kim ngạch tiêu thụ hạt nhân lần này.',
  Cargo_TAOPLFESAMBETCWOANoFinance: 'Kim ngạch+tổng hợp tổn thất+số lẻ phải bằng kim ngạch tiêu thụ hạt nhân lần này.',
  Cargo_TAOPLFESAMBETCWOAPC: 'Kim ngạch+tổng hợp tổn thất+chi phí tài chính+số lẻ phải bằng với kim ngạch tiêu thụ hạt nhân lần này, xin kiểm tra.',
  Cargo_TAPBACTBLTARAWIETIAP: 'Khi loại thu và thanh toán là phải trả, tổng số hóa đơn phải trả không được nhỏ hơn tổng số hóa đơn phải trả.',
  Cargo_Tax: 'Tiền thuế',
  Cargo_TaxAmount: 'Số tiền thuế',
  Cargo_TaxAmountP: 'Số tiền thuế:',
  Cargo_TaxationNbr: 'Số đăng ký thuế',
  Cargo_TaxExcludedPrice: 'Giá chưa bao gồm thuế',
  Cargo_TaxExcludedPriceP: 'Giá chưa bao gồm thuế:',
  Cargo_TaxFreeAmount: 'Số tiền chưa bao gồm thuế',
  Cargo_TaxIncludedPrice: 'Giá đã bao gồm thuế',
  Cargo_TaxIncludedPriceP: 'Giá có thuế:',
  Cargo_TaxpayerAuthorizationCode: 'Mã ủy quyền của người nộp thuế',
  Cargo_TaxRate: 'Thuế suất',
  Cargo_TaxRateNotNull: 'Vui lòng điền thuế suất',
  Cargo_TaxRateP: 'Thuế suất:',
  Cargo_TaxRatePct: 'Thuế suất (%)',
  Cargo_TBTRS: 'Quay lại đối chiếu thành công.',
  Cargo_TDCBODNBTTCBOTULBC: 'Chi nhánh nơi dữ liệu đang hoạt động không thuộc chi nhánh hiện tại hoặc chi nhánh cấp cao hơn. Anh có chắc là anh muốn tiếp tục không?',
  Cargo_TeamLeader: 'Đội trưởng',
  Cargo_TeamLeaderAssignment: 'Trưởng nhóm phân công',
  Cargo_Tel: 'Điện thoại',
  Cargo_TelexReleaseApplicant: 'Ứng viên phóng điện',
  Cargo_TelexReleaseApplicationDate: 'Thời gian áp dụng điện phóng',
  Cargo_TelexReleaseFee: 'Phí phóng điện',
  Cargo_TelexReleaseMaterial: 'Thông tin phóng điện',
  Cargo_TelexReleaseNo: 'Số xả điện',
  Cargo_ExpenseBoxNo: 'Số hộp phí',
  Cargo_TemplateDownload: 'Tải mẫu',
  Cargo_TemplateDownloadFailed: 'Mô-đun tải không thành công.',
  Cargo_TenDigitCode: 'Mã mười chữ số',
  Cargo_TenThousandYuan: '10.000 đô.',
  Cargo_TEYAPHBMBSEC: 'Chi phí hoạt động của bạn đã được người khác sửa đổi, bạn có muốn tiếp tục không?',
  Cargo_TFCFDTECNIPSDOACS: 'Các khách hàng còn lại đã đăng ký thành công vì khách hàng đã có số sau trong đối tác đã không đăng ký thành công.',
  Cargo_TFOTPCTBCWOP: 'Phạm vi thời gian trong thời gian không thể giao nhau với các phạm vi thời gian khác.',
  Cargo_TFSIIUDNA: 'Các trang web sau đây đã được sử dụng cho doanh nghiệp và không được phép xóa',
  Cargo_The1StInvoiceNoCanTBeEmpty: 'Số hóa đơn đầu tiên không được để trống.',
  Cargo_TheAmountOfWrittenOff: 'Số tiền đã bán',
  Cargo_TheExpenseNotBoundToInvoice: 'Chi phí này không có hóa đơn ràng buộc.',
  Cargo_TheLast: 'Tấm cuối cùng.',
  Cargo_TheLastPage: 'Trang trước',
  Cargo_TheNextPage: 'Tiếp theo',
  Cargo_TheOppositeSideAccount: 'Tài khoản đối phương',
  Cargo_TheOppositeSideBank: 'nhau ngân hàng.',
  Cargo_TheOppositeSideCompany: 'Đơn vị đối diện',
  Cargo_TheOppositeSideInvoiceNo: 'Số hóa đơn của nhau',
  Cargo_ThisFeeHasBeenInvoiced: 'Chi phí này đã khai hóa đơn không thể chia cắt!',
  Cargo_ThisFeeHasBeenWrittenOff: 'Chi phí này đã tiêu thụ hạt nhân không thể chia cắt!',
  Cargo_ThisTimeBalance: 'Số dư hiện tại',
  Cargo_ThisTimeWriteOff: 'Lần này bán hạt nhân',
  Cargo_ThisTimeWriteOffEq: 'Tiêu thụ hạt nhân lần này=kim ngạch thu+tổng lợi nhuận+chi phí tài chính+số lẻ',
  Cargo_ThisWriteOffNoIs: 'Số hiệu tiêu thụ lần này là:',
  Cargo_TIBYEIB: 'Số dư ban đầu bạn đã nhập',
  Cargo_TIBYEIUPDCTBSAIS: 'Số dư ban đầu bạn nhập không cân bằng, vui lòng kiểm tra cẩn thận "Bảng cân đối kế toán" và "Bảng lợi nhuận"',
  Cargo_Time: 'Thời gian',
  Cargo_TimeFrame: 'Khoảng thời gian',
  Cargo_TimeOfCargoHolding: 'Thời gian khấu trừ',
  Cargo_TimeOfDocHolding: 'Thời gian khấu trừ',
  Cargo_TimeOfPurchase: 'Thời gian mua hàng',
  Cargo_TimeOfPurchaseCanTBeEmpty: 'Thời gian mua không được để trống',
  Cargo_TimeOfUse: 'Thời gian sử dụng',
  Cargo_TimeOfUseCanTBeEmpty: 'Thời gian sử dụng không được để trống.',
  Cargo_Tips: 'Mẹo',
  Cargo_PleaseSelectTheSailingScheduleBelow: 'Vui lòng chọn ngày tàu như sau:',
  Cargo_ChooseShippingSchedulesTips1: '1. Vui lòng chọn thông tin thời gian tàu tương ứng. Nếu không đưa ra lựa chọn, sẽ tồn tại thời gian rời bến theo kế hoạch, thời gian mở cửa, thời gian rời bến thực tế không thể có được.',
  Cargo_ChooseShippingSchedulesTips2: 'Nếu bạn không thể xác nhận ngày tàu, bạn có thể nhấn nút [Không chọn] và sau khi xác nhận, nhấn nút [Chọn ngày tàu] để chọn ngày tàu.',
  Cargo_MoreShippingSchedulesTips: 'Thời gian vận chuyển trở lại nhiều bến cảng sẽ ảnh hưởng đến việc hiển thị thông tin thời gian vận chuyển và đẩy, vui lòng chọn thông tin thời gian vận chuyển bạn muốn',
  Cargo_ChooseShippingSchedules: 'Chọn ngày tàu',
  Cargo_NoSelectYet: 'Tạm thời không chọn',
  Cargo_ChangePayment: 'Sửa đổi yêu cầu thanh toán',
  Cargo_PaymentTimeLimit: 'Hạn TT',
  Cargo_Title: 'Tiêu đề',
  Cargo_TitleOfAccount: 'Chủ đề kế toán',
  Cargo_TLOOSE: 'Tổng số nợ và vốn chủ sở hữu hoặc vốn cổ đông',
  Cargo_TMAEONRS: 'Phương thức giao dịch đã tồn tại hoặc không có hồ sơ nào được chọn',
  Cargo_To: 'Đ.',
  Cargo_FROM: 'Từ',
  Cargo_ToDetermineIfEditableWhenViewing: 'Để đánh giá xem có thể chỉnh sửa khi xem hay không',
  Cargo_TOEIAADFIA: 'Tổng số tiền mặt hàng chi phí không giống với số tiền hóa đơn.',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: 'Số tiền mục chi phí không được lớn hơn số tiền hóa đơn.',
  Cargo_ChargeAlreadyAssociatedInvoice: 'Chi phí {0} đã được liên kết với hóa đơn.',
  Cargo_TORFRS: 'Tìm thấy {0} bản ghi, chọn {1} bản ghi',
  Cargo_Total0: 'Tổng số: {0}',
  Cargo_TotalAmount: 'Tổng số tiền',
  Cargo_TotalAmountNotWrittenOff: 'Tổng số tiền chưa bán',
  Cargo_TotalAmountOfCurrentPeriod: 'Tổng số kỳ này',
  Cargo_TotalAmountPJ: 'Tổng số tiền -',
  Cargo_TotalAmountP: 'Tổng số tiền:',
  Cargo_TotalAmountToWriteOff: 'Tổng số tiền có thể bán',
  Cargo_TotalAPAmount: 'Tổng chi phí phải trả',
  Cargo_TotalARAmount: 'Tổng chi phí phải thu',
  Cargo_TotalBalance: 'Tổng số dư',
  Cargo_TotalCommissionAmount: 'Tổng số tiền chiết khấu',
  Cargo_TotalCommissionAmountP: 'Kim ngạch trích phần trăm cộng lại:',
  Cargo_TotalCost: 'Tổng chi phí',
  Cargo_TotalCurrency: 'Tổng số đồng xu',
  Cargo_TotalCurrentLiabilities: 'Tổng nợ hiện tại',
  Cargo_TotalIncome: 'Tổng thu nhập',
  Cargo_TotalLiabilities: 'Nợ tổng cộng',
  Cargo_TotalNonCurrentAssets: 'Tổng tài sản không lưu động',
  Cargo_TotalNonCurrentLiabilities: 'Tổng số nợ không lưu động',
  Cargo_TotalOfVouchersEntered: 'Tổng số chứng từ',
  Cargo_TotalOutstandingAmountByCurrency: 'Tổng số tiền chưa bán',
  Cargo_TotalPriceWithTaxInWords: 'Giá cả, thuế cộng lại.',
  Cargo_TotalProfit: 'Tổng lợi nhuận',
  Cargo_TotalRevenue: 'Tổng thu nhập',
  Cargo_TotalWriteOffAmount: 'Tổng giá trị bán hạt nhân',
  Cargo_Choose: 'Chọn',
  Cargo_TotalWriteOffs: 'Tổng số pin hạt nhân',
  Cargo_TotalWriteOffsP: 'Tổng số tín dụng:',
  Cargo_TPOPNOINOE: 'Tổng lợi nhuận Lợi nhuận hoạt động Thu nhập ngoài hoạt động Chi phí ngoài hoạt động',
  Cargo_TPTODIDDYCTMAGV: 'Loại thanh toán hoặc phương thức thanh toán khác nhau, bạn có muốn kết hợp để tạo chứng từ không?',
  Cargo_TradeTerm: 'Phương thức giao dịch',
  Cargo_TradeTerms: 'Điều khoản giao dịch',
  Cargo_TradeTermsMaintenance: 'Bảo trì điều khoản thương mại',
  Cargo_TradeType: 'Loại giao dịch',
  Cargo_TradingCompany: 'Công ty thương mại',
  Cargo_Transfer: 'Xoay',
  Cargo_TransferAllToReconciliation: 'Tất cả quay lại đối chiếu',
  Cargo_TransferBackAmount: 'Số tiền quay lại',
  Cargo_TransferBackGrandTotal: 'Quay lại Tổng số tiền',
  Cargo_TransferBackToReconciliation: 'Quay lại đối chiếu',
  Cargo_TransferCash: 'Chuyển tiền mặt',
  Cargo_TransferExpense: 'Phí chuyển nhượng',
  Cargo_TransferIntoCollection: 'Chuyển sang nhờ thu',
  Cargo_TransferOutToCollection: 'Chuyển thu nhập',
  Cargo_TransferPort: 'Cảng trung chuyển',
  Cargo_TransferToCNY: 'Chuyển CNY',
  Cargo_TransitPortSea: 'Cảng trung chuyển (cảng biển)',
  Cargo_TransitTerm: 'Điều khoản vận chuyển',
  Cargo_Transportation: 'Vận chuyển',
  Cargo_TRAYEINR: 'Số tiền bạn nhập không hợp lý!',
  Cargo_TRFRBLFDAF: 'Phí điện tử thay đổi phí điện tử',
  Cargo_TrialBalance: 'Cân bằng thử nghiệm',
  Cargo_TrialBalanceCheck: 'Kiểm tra cân bằng thử nghiệm',
  Cargo_TRNAPUCWOFISI: 'Không thể hủy bỏ toàn bộ, hãy sử dụng tính năng hủy bỏ tiêu thụ trong giao diện truy vấn.',
  Cargo_TruckCompany: 'Công ty xe tải',
  Cargo_TSASOBMBTS: 'Đại lý thanh toán hóa đơn phải giống nhau!',
  Cargo_TSBADNCTCC: 'Tài khoản ngân hàng đã chọn không bao gồm đồng tiền này.',
  Cargo_TTAEONRS: 'Điều khoản thương mại đã tồn tại hoặc không có hồ sơ nào được chọn',
  Cargo_TTOAFNTCCPM: 'Đối tượng chỉ tính: {0}, không tính tiền hiện tại: {1}, xin vui lòng sửa đổi',
  Cargo_TUPAOTPALVCBE: 'Chứng từ lợi nhuận chưa được phân phối đối tượng lợi nhuận không được để trống',
  Cargo_TWORHBRCC: 'Hồ sơ tiêu thụ này đã nổi tiếng, không cho phép hủy bỏ.',
  Cargo_Type: 'Loại',
  Cargo_MaximumTakeOffWeight: 'Trọng lượng cất cánh tối đa',
  Cargo_Charter_Flights_Tips: 'Đối với các chuyến bay thuê bao/bảng điều khiển"Đối với các chuyến bay thuê bao, chi phí chuyến bay có thể được duy trì ở đây"',
  Cargo_Charter_package_board: 'Điều lệ/tấm ốp',
  Cargo_Board_Tips: 'Kinh doanh bao bì được sử dụng để phân tích khả năng chịu tải và lợi nhuận tiếp theo',
  Cargo_Flight_costs: 'Chi phí chuyến bay',
  Cargo_NumberOfCartridges: 'Số bộ sưu tập',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: 'Chọn model cần edit',
  Cargo_Please_Select_The_Model_To_Be_Deleted: 'Vui lòng chọn model cần xóa',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: 'Chọn bộ sưu tập cần chỉnh sửa',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: 'Vui lòng chọn bộ sưu tập cần xóa',
  Cargo_WeightRestrictions: 'Giới hạn trọng lượng',
  Cargo_VolumeLimit: 'Giới hạn khối lượng',
  Cargo_LoadableCapacity: 'Khả năng tải',
  Cargo_LoadableWeight: 'Trọng lượng tải được',
  Cargo_DeadWeight: 'Trọng lượng',
  Cargo_LSize: 'Kích thước (Chiều dài)',
  Cargo_WSize: 'Kích thước (W)',
  Cargo_HSize: 'Kích thước (H)',
  Cargo_ApplicableModels: 'Mô hình áp dụng',
  Cargo_ApplicableContainerType: 'Loại Collector',
  Cargo_ApplicableContainerCode: 'Bộ sưu tập Mã',
  Cargo_ApplicableContainerNumber: 'Số bộ sưu tập',
  Cargo_CharterPack: 'Điều lệ/tấm ốp',
  Cargo_TypeOfBill: 'Loại Ticket',
  Cargo_TypeOfGoods: 'Loại hàng hóa',
  Cargo_TypeOfPort: 'Loại Port',
  Cargo_UBEIRPSMB: 'Sự hiện diện của hóa đơn không được đánh dấu trong hồ sơ, vui lòng chọn hóa đơn được đánh dấu',
  Cargo_UCOVEIIDPCTD: 'Dữ liệu được nhập hiện tại tồn tại mà khách hàng hoặc nhà cung cấp không duy trì trong hệ thống, hãy nhấp vào Tải xuống.',
  Cargo_Unbilled: 'Chưa thanh toán',
  Cargo_Uncommitted: 'Chưa gửi',
  Cargo_Unconfirmed: 'Không xác nhận',
  Cargo_UnderConfirmation: 'Trong xác nhận',
  Cargo_UnfrozenSuccessfully: 'Băng tan thành công.',
  Cargo_UnInvoiced: 'Không có hóa đơn',
  Cargo_Unissued: 'Chưa đăng',
  Cargo_UnissuedServiceTicket: 'Không xác nhận',
  Cargo_Unit: 'Đơn vị',
  Cargo_UnitOfMeasurement: 'Đơn vị đo lường',
  Cargo_UnitOfPaymentPeriod: 'Đơn vị tài khoản',
  Cargo_UnitPrice: 'Đơn giá',
  Cargo_UnitPriceP: 'Đơn giá:',
  Cargo_Unknown: 'Không rõ',
  Cargo_UnKnownStatus: 'Trạng thái không rõ',
  Cargo_Unlimited: 'Không giới hạn',
  Cargo_Unpaid: 'Chưa thanh toán',
  Cargo_UnpaidClear: 'Chưa thanh toán',
  Cargo_UnpaidCNY: 'CNY chưa thanh toán',
  Cargo_UnpaidEUR: 'EUR chưa thanh toán',
  Cargo_UnpaidGBP: 'GBP chưa thanh toán',
  Cargo_UnpaidHKD: 'HKD chưa thanh toán',
  Cargo_UnpaidJPY: 'JPY chưa thanh toán',
  Cargo_UnpaidNGN: 'NGN chưa thanh toán',
  Cargo_UnpaidP: 'Chưa thanh toán:',
  Cargo_SimpleUnpaidP: 'Chưa thanh toán',
  Cargo_UnpaidUSD: 'USD chưa thanh toán',
  Cargo_ReceivedP: 'Đã nhận',
  Cargo_PaidP: 'Đã thanh toán',
  Cargo_EmptyValue: 'Trống rỗng',
  Cargo_UnsavedNewExpenseCanTBeSplit: 'Không thể chia nhỏ chi phí chưa lưu mới!',
  Cargo_UpdateBar: 'Thanh cập nhật',
  Cargo_UpdateBusinessDate: 'Sửa đổi ngày kinh doanh',
  Cargo_UpdatedSuccessfully: 'Update thành công',
  Cargo_UpdateFailed: 'Update thất bại',
  Cargo_UpdatePageDisplay: 'Cập nhật hiển thị trang',
  Cargo_UpdatePrintButtonStatus: 'Cập nhật trạng thái nút in',
  Cargo_Upload: 'Tải lên',
  Cargo_UploadAttachment: 'Tải lên tệp đính kèm',
  Cargo_DeleteAttachment: 'Xóa tệp đính kèm',
  Cargo_UploadContract: 'Tải lên hợp đồng',
  Cargo_UploadContractAttachments: 'Tải lên tệp đính kèm hợp đồng',
  Cargo_UploadData: 'Tải lên dữ liệu',
  Cargo_URVUTSWBRIKC: 'Các chứng từ chưa được kiểm toán trong sổ sách này sẽ được kiểm toán bởi Golden Butterfly Cloud, bạn có chắc mình muốn tiếp tục không?',
  Cargo_USD: 'Đô la Mỹ',
  Cargo_USDAmount: 'Đô la Mỹ',
  Cargo_USDExchangeRate: 'Tỷ giá USD',
  Cargo_USDInvoiceNo: 'Số hóa đơn USD',
  Cargo_USDP: 'Đô la Mỹ:',
  Cargo_Use: 'Sử dụng',
  Cargo_Used: 'Đã sử dụng',
  Cargo_UseGroupExchangeRate: 'Sử dụng Group Rate',
  Cargo_UseOriginalTemporarily: 'Tạm thời dùng',
  Cargo_User: 'Người dùng',
  Cargo_UserCanTBeEmpty: 'Người dùng không thể để trống.',
  Cargo_UseShouldBeTemporarily: 'Nơi này tạm thời dùng hẳn là',
  Cargo_ValidityOfInvoice: 'Hóa đơn hợp lệ',
  Cargo_Value: 'Giá trị',
  Cargo_VatGeneralInvoice: 'Hóa đơn VAT thông thường',
  Cargo_VatInvoice: 'Hóa đơn VAT',
  Cargo_VatInvoiceIssuingMachineNo: 'Số hóa đơn VAT',
  Cargo_VatSpecialInvoice: 'Hóa đơn đặc biệt VAT',
  Cargo_Vendor: 'Nhà cung cấp',
  Cargo_VendorCantBeEmpty: 'Nhà cung cấp không được để trống',
  Cargo_VendorClient: 'Khách hàng nhà cung cấp',
  Cargo_VendorModification: 'Sửa đổi nhà cung cấp',
  Cargo_VendorP: 'Nhà cung cấp:',
  Cargo_VendorSInvoiceNo: 'Số hóa đơn nhà cung cấp',
  Cargo_VerificationCancelled: 'Hủy kiểm tra',
  Cargo_VerificationPassed: 'Có vượt qua kiểm toán hay không',
  Cargo_VerificationRejected: 'Kiểm toán từ chối',
  Cargo_VerifiedSuccessfullyClickToSave: 'Xác minh thành công, click Save.',
  Cargo_VerifiedSuccessfullyClickToExport: 'Xác minh thành công, nhấp vào Export.',
  Cargo_Verify: 'Kiểm tra',
  Cargo_VerifyARAPExpense: 'Xác minh chi phí phải trả',
  Cargo_VerifyInvoiceNo: 'Kiểm tra số hóa đơn',
  Cargo_VerifyJournalEntry: 'Xác minh mục',
  Cargo_VesselAndVoyage: 'Tên tàu/Chuyến đi',
  Cargo_VesselVoyageFlight: 'Tên tàu Chuyến bay',
  Cargo_VGIVSI: 'VAT Hóa đơn thông thường VAT Hóa đơn đặc biệt VAT',
  Cargo_VHBCFSACCTBC: 'Kế toán phụ trợ 【Khách hàng】 đã tạo chứng từ và không thể hủy bỏ.',
  Cargo_VHBCFSADCTBC: 'Kế toán phụ trợ 【Trang chủ】 đã tạo chứng từ và không thể hủy bỏ.',
  Cargo_VHBCFSAICTBC: 'Kế toán phụ trợ 【Dự án】 đã tạo chứng từ và không thể hủy bỏ.',
  Cargo_VHBCFSASCTBC: 'Kế toán phụ trợ 【Nhân viên】 đã tạo chứng từ và không thể hủy bỏ.',
  Cargo_VHBCFSAVCTBC: 'Kế toán phụ trợ 【Nhà cung cấp】 đã tạo chứng từ và không thể hủy bỏ.',
  Cargo_ASCCCTBC: 'Công ty đã gửi xác nhận, không thể hủy bỏ.',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: 'Hồ sơ tiếp thị hạt nhân này đã được xuất khẩu chứng từ tài chính, nếu hủy bỏ hệ thống tiếp thị hạt nhân sẽ tạo ra một bản ghi xung đỏ, xác nhận xung đỏ?',
  Cargo_View: 'Xem thêm',
  Cargo_ViewAllBusiness: 'Xem tất cả doanh nghiệp',
  Cargo_ViewAllExpenses: 'Xem tất cả chi phí',
  Cargo_ViewBill: 'Xem hóa đơn',
  Cargo_ViewBusinessOfSameGroup: 'Xem cùng một nhóm doanh nghiệp',
  Cargo_ViewDetail: 'Xem chi tiết',
  Cargo_ViewDetails: 'Xem chi tiết',
  Cargo_ViewDetailsOfRemovals: 'Xem chi tiết xóa',
  Cargo_ViewedByFee: 'Xem chi phí',
  Cargo_ViewedByJob: 'Xem theo doanh nghiệp',
  Cargo_ViewExpensesOfSameGroup: 'Xem chi phí cho cùng một nhóm',
  Cargo_ViewFile: 'Xem tập tin',
  Cargo_ViewInvoice: 'Xem hóa đơn',
  Cargo_ViewSelfBusiness: 'Xem doanh nghiệp của riêng bạn',
  Cargo_ViewSoa: 'Xem báo cáo',
  Cargo_ViewUploadedDeclarationDocInfo: 'Xem thông tin tập tin hải quan tải lên',
  Cargo_ViewVoucher: 'Xem chứng từ',
  Cargo_ViolationOfUniquenessConstraint: 'Vi phạm Unique Constraint',
  Cargo_VOCMEICSR: 'Bản ghi hiện được chọn chứa chứng từ cho tháng đã thanh toán.',
  Cargo_VoidCompleted: 'Hoàn thành phế thải.',
  Cargo_Voided: 'Đã hủy',
  Cargo_VoidedBy: 'Làm phế nhân',
  Cargo_VoidedInvoice: 'Hóa đơn hủy bỏ',
  Cargo_VoidedInvoiceNo: 'Số hóa đơn hủy bỏ',
  Cargo_VoidedInvoiceNoP: 'Số hóa đơn bị hủy bỏ:',
  Cargo_VoidedSuccessfully: 'Hủy bỏ thành công.',
  Cargo_VoidStatus: 'Trạng thái hủy bỏ',
  Cargo_VoidTime: 'Thời gian hủy bỏ',
  Cargo_AssociatedExpenseID: 'ID chi phí liên kết',
  Cargo_ChargeID: 'Chi phí ID',
  Cargo_VOPLCOCTBD: 'Chứng từ kết chuyển tổn hại không thể xóa bỏ.',
  Cargo_StateDeleteError: 'Đã nhập thành công hệ thống chứng từ, không thể xóa',
  Cargo_VoucherAbstract: 'Tóm tắt chứng từ',
  Cargo_VoucherCannotBeEmpty: 'Chứng từ không thể để trống!',
  Cargo_VoucherCreatedOrNot: 'Đã tạo chứng từ chưa?',
  Cargo_VoucherCreatedSuccessfully: 'Tạo {0} chứng từ thành công',
  Cargo_VoucherDateCanTBeEmpty: 'Ngày chứng từ không được để trống',
  Cargo_VoucherEntryCanTBeEmpty: 'Danh mục chứng từ không thể để trống.',
  Cargo_VoucherGroupingRule: 'Quy tắc nhóm chứng từ',
  Cargo_VoucherGroupingType: 'Loại nhóm chứng từ',
  Cargo_VoucherGroupingTypeP: 'Loại nhóm chứng từ:',
  Cargo_VoucherLetter: 'Chứng từ',
  Cargo_VoucherLetterCanTBeEmpty: 'Chứng từ không thể để trống',
  Cargo_VoucherLetterNo: 'Cỡ chứng từ',
  Cargo_VoucherLetterP: 'Chữ chứng cứ:',
  Cargo_VoucherList: 'Danh sách chứng từ',
  Cargo_VoucherMonth: 'Chứng từ tháng',
  Cargo_VoucherNo: 'Số chứng từ',
  Cargo_VoucherNoCanTBeEmpty: 'Số chứng từ không được để trống',
  Cargo_VoucherNoP: 'Số chứng từ:',
  Cargo_VoucherNotCreatedCreateItNow: 'Không tạo chứng từ, có tạo chứng từ không?',
  Cargo_VoucherOfAdvance: 'Chứng từ trả trước',
  Cargo_VoucherPeriod: 'Trong thời gian chứng từ',
  Cargo_VoucherPeriodCanTBeEmpty: 'Không được để trống trong thời gian chứng từ',
  Cargo_VoucherRule: 'Quy tắc chứng từ',
  Cargo_VoucherSearch: 'Yêu cầu chứng từ',
  Cargo_VoucherStatus: 'Trạng thái chứng từ',
  Cargo_VoucherType: 'Loại Credentials',
  Cargo_VoyageFlight: 'Chuyến bay/Chuyến bay',
  Cargo_VoyageNo: 'Chuyến bay',
  Cargo_VRDBR: 'Xem chi tiết xóa theo đối chiếu',
  Cargo_VSRAOGTEPAEIADPERAPIT: 'Thuế vàng xuất hóa đơn giấy, hóa đơn điện tử và địa chỉ yêu cầu dịch vụ khác nhau, xin căn cứ vào chủng loại hóa đơn mà xuất.',
  Cargo_Warehouse: 'Trang chủ',
  Cargo_WarehouseDoor: 'Kho bãi/Điểm cửa',
  Cargo_WarehouseLoading: 'Đóng gói trong kho',
  Cargo_WarehouseLoadingStorage: 'Đóng gói/lưu trữ bên trong',
  Cargo_WarehouseNo: 'Số lượng thùng vào',
  Cargo_WBOWBVCTBD: 'Chứng từ xung đỏ hoặc chứng từ bị xung đỏ không thể xóa bỏ.',
  Cargo_WBOWBVCTBWB: 'Chứng từ xông đỏ hoặc chứng từ bị xông đỏ không được xông đỏ.',
  Cargo_REVERSE: 'Chứng từ Hồng Xung thành công.',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: 'Sau khi chọn, truy vấn này sẽ hiển thị các cột chi tiết của các loại tiền tệ khác nhau theo kết quả tra được, bỏ qua các thiết lập tùy chỉnh. Kết quả được hiển thị động không ghi đè lên cấu hình ban đầu.',
  Cargo_WDPCCS: 'Dữ liệu sai, xin liên hệ với dịch vụ khách hàng.',
  Cargo_Wechat: 'Trang chủ',
  Cargo_Week: 'Tuần',
  Cargo_Weight: 'Cân nặng',
  Cargo_WHCode: 'Số cabin',
  Cargo_WhetherOrNotBroken: 'Phá vỡ',
  Cargo_WipeOut: 'Bỏ qua Zero Head',
  Cargo_WithdrawalAddress: 'Địa chỉ hoàn trả',
  Cargo_WithdrawalListOfLinkedConsignors: 'Danh sách hoàn trả đơn vị ủy quyền liên kết',
  Cargo_WithdrawExpense: 'Chi phí rút tiền',
  Cargo_WONCPPC: 'Xác nhận tài khoản thanh toán đã hoàn tất',
  Cargo_WORIPCPARO: 'Hồ sơ bán hàng không chính xác, vui lòng đóng trang để mở lại',
  Cargo_WorkSetAfterSearch: 'Bộ công việc sau khi truy vấn',
  Cargo_WriteBack: 'Đỏ Rush',
  Cargo_WriteBackVoucher: 'Chứng từ Red Rush',
  Cargo_WriteOff: 'Tài khoản bán hàng',
  Cargo_WriteOffAll: 'Tất cả nucleopin',
  Cargo_WriteOffAllP: 'Tất cả các nuclear',
  Cargo_WriteOffAmount: 'Số tiền bán',
  Cargo_WriteOffAmountCNY: 'Số tiền bán hàng CNY',
  Cargo_WriteOffAmountIs: 'Kim ngạch tiêu thụ là:',
  Cargo_WriteOffAmountUSD: 'Số tiền bán USD',
  Cargo_WriteOffAR: 'Phải thu sổ sách bán hàng',
  Cargo_WriteOffBalance: 'Số dư bán hàng',
  Cargo_WriteOffBalanceIs: 'Số dư bán hàng là:',
  Cargo_WriteOffCurrency: 'Đồng tiền hạt nhân',
  Cargo_WriteOffDate: 'Ngày bán hàng',
  Cargo_WriteOffDetails: 'Chi tiết bán hàng',
  Cargo_WriteOffEntry: 'Nhập tài khoản bán hàng',
  Cargo_WriteOffFailed: 'Bán hàng thất bại',
  Cargo_WriteOffInputError: 'Chi phí tiếp thị hạt nhân được chọn bao gồm chi phí yêu cầu thanh toán tham gia, vui lòng tiếp thị hạt nhân sau khi quá trình xem xét yêu cầu thanh toán hoàn tất.',
  Cargo_WriteOffList: 'Chi tiết bán hàng',
  Cargo_WriteOffListPDF: 'Chi tiết bán hàng.pdf',
  Cargo_WriteOffListXLS: 'Chi tiết tiêu thụ.',
  Cargo_WriteOffNo: 'Số tài khoản bán hàng',
  Cargo_WriteOffOfAdvance: 'Trả trước nuclear pin',
  Cargo_WriteOffOrNot: 'Có bán hay không',
  Cargo_WriteOffP: 'Bán sổ sách -',
  Cargo_WriteOffPerson: 'Người bán hàng',
  Cargo_WriteOffRate: 'Tỷ giá bán hạt nhân',
  Cargo_WriteOffRecordsNotSelected: 'Không có hồ sơ bán hàng nào được chọn.',
  Cargo_WriteOffRemarks: 'Ghi chú bán hàng',
  Cargo_WriteOffReverseWriteOff: 'Pin hạt nhân/pin chống hạt nhân',
  Cargo_WriteOffRevokedSuccessfully: 'Hủy bỏ tiêu thụ thành công.',
  Cargo_WriteOffSerialNumber: 'Lưu lượng bán hàng',
  Cargo_WriteOffStartingPeriod: 'Thời gian đầu bán hạt nhân',
  Cargo_WriteOffStartingPeriodP: 'Thời gian tiêu thụ hạt nhân:',
  Cargo_WriteOffStatus: 'Tình trạng bán hàng',
  Cargo_WriteOffType: 'Trang chủ',
  Cargo_WriteOffTypeP: 'Loại tài khoản bán hàng:',
  Cargo_WrittenOff: 'Đã bán',
  Cargo_WrittenOff2: 'Đã bán RMB',
  Cargo_WrittenOffItemsCanTBeModified: 'Đã bị tiêu thụ hạt nhân, không thể bị sửa đổi.',
  Cargo_WrittenOffItemsExist: 'Đã bán',
  Cargo_WrittenOffNotWrittenOff: 'Đã bán Chưa bán',
  Cargo_WrittenOffSuccessfully: 'Bán hàng thành công',
  Cargo_WrongInvoicingMachineNoEntered: 'Số máy khai hóa đơn nhập sai.',
  Cargo_WroteOff: 'Có bán hạt nhân không?',
  Cargo_WroteOffOrNot: 'Đã bán hạt nhân chưa?',
  Cargo_X10: 'Mười',
  Cargo_X100: 'Hàng trăm',
  Cargo_X1000: 'ngàn',
  Cargo_X10000: 'Vạn',
  Cargo_YadongKingdee: 'Bướm vàng Á Đông',
  Cargo_Year: 'Năm',
  Cargo_Years: 'Năm',
  Cargo_Yes: 'Vâng',
  Cargo_YesControlled: 'Kiểm soát',
  Cargo_NotControlled: 'Không kiểm soát',
  Cargo_YesLink: 'Tôi muốn liên lạc.',
  Cargo_YesNo: 'Không',
  Cargo_Yuan: 'Nguyên',
  Cargo_ContentIsEmpty: 'Nội dung trống rỗng.',
  Cargo_PleaseSelectExpenseToProcess: 'Vui lòng chọn chi phí để xử lý.',
  Cargo_EditSoa: 'Báo cáo biên tập',
  Cargo_InvalidParameterCFR: 'Tham số không hợp lệ, không tìm thấy quy tắc đối tượng mục.',
  Cargo_SuccessItemsFailedItems: 'Thành công, thất bại.',
  Cargo_BADNMOPRTB: 'Đại lý thanh toán hóa đơn {0} không phù hợp với người thanh toán hóa đơn sao kê, vui lòng xóa hóa đơn đó trước khi lưu.',
  Cargo_IVCNBVPDTORTI: 'Có {0} hóa đơn đã tạo chứng từ không thể hủy bỏ, vui lòng xóa chứng từ hoặc đỏ.',
  Cargo_Temp: '- Trống rỗng -',
  Cargo_OperationCommission: 'Chiết khấu hoạt động',
  Cargo_CSCommission: 'Hỗ trợ khách hàng',
  Cargo_ViewPaymentRequest: 'Xem đơn yêu cầu thanh toán',
  Cargo_WantToAddThemToTheBill: 'Các khoản phí đã chọn bao gồm các khoản phí đã được phân phối, bạn có tiếp tục tham gia hóa đơn không?',
  Cargo_AddAllToTheBill: 'Thêm tất cả vào hóa đơn',
  Cargo_OnlyTheUnwrittenOffExpenses: 'Chỉ thêm chi phí chưa bán hạt nhân',
  Cargo_ImportAndQueryOfBillNumber: 'Nhập số hóa đơn Truy vấn',
  Cargo_DebitAmountCN: 'Số tiền ghi nợ',
  Cargo_CreditAmountCN: 'Số tiền tín dụng',
  Cargo_PushMiddleTable: 'Đẩy bảng trung gian',
  Cargo_IfError: 'Báo lỗi hay không',
  Cargo_ErrorInfo: 'Thông tin sai',

  Cargo_AIOCER: 'Tỷ giá hối đoái Số tiền gốc',
  Cargo_BalanceInRmb: 'Số dư CNY',
  Cargo_BalanceInUsd: 'Số dư USD',
  Cargo_CanTDeleteInvoicedItems: 'Đã lập hóa đơn không thể xóa',
  Cargo_CanTDeleteIssuedInvoice: 'Hóa đơn không thể xóa!',
  Cargo_CardAccessControl: 'Kiểm soát quyền thẻ',
  Cargo_CCTBEVCTBE: 'Khách hàng không thể để trống, nhà cung cấp không thể để trống',
  Cargo_ConfirmAPP: 'Xác nhận chi phí phải trả',
  Cargo_ConfirmBill: 'Xác nhận hóa đơn',
  Cargo_CreditSideRmb: 'Bên cho vay (NDT)',
  Cargo_CreditSideUsd: 'Tín dụng (USD)',
  Cargo_CurrencyIncompatible: 'Đồng tiền không thống nhất',
  Cargo_CustomizedField: 'Trường tùy chỉnh',
  Cargo_IssuedUnissued: 'Đã đăng Chưa đăng',
  Cargo_NoExpensesToBeInvoiced: 'Không thể lập hóa đơn, không có chi phí lập hóa đơn',
  Cargo_OVICBETGTEI_2: 'Hóa đơn VAT có thể hủy bỏ thuế điện tử',
  Cargo_OWCICGTSEEI_2: 'Đơn vị tiền tệ là RMB để hủy hóa đơn điện tử',
  Cargo_PleaseSelectAnBillPayment: 'Vui lòng chọn một yêu cầu thanh toán',
  Cargo_PleaseSelectPurchaser: 'Vui lòng chọn người mua.',
  Cargo_SelectAddPlatformBLMethod: 'Nền tảng B/L Phương pháp Chọn Thêm',
  Cargo_SettlingPartyMustBeIdentical: 'Đối tượng thanh toán phải giống nhau',
  Cargo_Space5: 'Nửa tháng Knot',
  Cargo_TARBACTBLTAPAWIETIAR: 'Tổng số hóa đơn phải thu tại thời điểm thu không được nhỏ hơn tổng số hóa đơn phải trả',
  Cargo_CanNotRemovedAllCharge: 'Không thể loại bỏ toàn bộ chi phí!',
  Cargo_BillNotAllowEditEtowerOne: 'Hóa đơn của EtowerOne không được phép hoạt động!',
  Cargo_NoSubmit_SR: 'Chưa gửi',
  Cargo_AwaitApproval_SR: 'Đang phê duyệt',
  Cargo_Approved_SR: 'Hoàn thành phê duyệt',
  Cargo_ModifyFilter: 'Điều kiện tăng và giảm',
  Cargo_SaveChanges: 'Lưu sửa đổi',
  Cargo_SaveAsScheme: 'Lưu dưới dạng chương trình',
  Cargo_QueryScheme: 'Đề án yêu cầu',
  Cargo_QuerySchemeManagement: 'Quản lý chương trình truy vấn',
  Cargo_SelectQueryCriteria: 'Chọn điều kiện truy vấn',
  Cargo_ApplicationForm: 'Đơn đăng ký',
  Cargo_ApprovalHistory: 'Lịch sử phê duyệt',
  Cargo_AllQueryCriteria: 'Tất cả điều kiện truy vấn',
  Cargo_MyQueryCriteria: 'Điều kiện yêu cầu của tôi',
  Cargo_DisplayName: 'Hiện tên',
  Cargo_ConditionalExpression: 'Biểu thức điều kiện',
  Cargo_ProcessingDifference: 'Xử lý chênh lệch',
  Cargo_NotFoundTemplate: 'Không tìm thấy mẫu in tương ứng!',
  Cargo_NoPaymentMethodPermissionOfReconciliation: 'Quyền hạn không đủ, xin liên hệ với quản trị viên cấu hình quyền hạn phương thức thanh toán trang đối chiếu!',
  Cargo_NoFeeTypePermissionOfReconciliation: 'Không đủ quyền hạn, vui lòng liên hệ với quản trị viên để cấu hình quyền loại phí kiểm tra trang đối chiếu!',
  Cargo_SearchDataForReconciliation: 'Vui lòng truy cập dữ liệu trước, sau đó bắt đầu đối chiếu!',
  Cargo_ChargeUpdateFailed: 'Có {0} phí đã được sửa đổi bởi người khác, không cập nhật thành công!',
  Cargo_SaveReconciliationSuccess: 'Tiết kiệm đối chiếu thành công!',
  Cargo_RemoveAll: 'Xóa tất cả',
  Cargo_ViewDeleteChargeDetail: 'Xem/Xóa chi tiết',
  Cargo_DeleteAdjustment: 'Xoá điều chỉnh',
  Cargo_PleaseSelectedCancelConfirmCharge: 'Vui lòng chọn khoản phí yêu cầu hủy xác nhận',
  Cargo_PleaseSelectedConfirmCharge: 'Vui lòng chọn chi phí cần xác nhận',
  Cargo_PleaseSelectedBillingDate: 'Vui lòng chọn ngày thanh toán!',
  PleaseSelectSplitCharge: 'Vui lòng chọn chi phí cần chia nhỏ!',
  OnlySelectOneChargeToSplit: 'Chỉ có thể lựa chọn một cái phí tổn tiến hành phân chia!',
  ChargeHasInvoicedOrWriteOff: 'Phí này đã được lập hóa đơn hoặc đã bán, vui lòng chọn lại!',
  NoChargeForSplit: 'Không có chi phí thực tế để chia nhỏ, vui lòng chọn lại!',
  Cargo_exportExcelAll: 'Xuất tất cả',
  Cargo_PleaseInputKeyWordsForQuery: 'Vui lòng nhập truy vấn từ khóa',
  Cargo_AccountNumber: 'Số tài khoản',
  Cargo_OwnerBankOfDeposit: 'Ngân hàng của tôi.',
  Cargo_JoinBill: 'Tham gia Bill',
  Cargo_SelectedUnConfirmedCharge: 'Vui lòng chọn phí để hủy xác nhận!',
  Cargo_NoChargeForSplit: 'Không có chi phí chia nhỏ thực tế, vui lòng chọn lại!',
  Cargo_InputTaxAmount: 'Vui lòng nhập giá bao gồm thuế!',
  Cargo_ReconciliationTypeP: 'Loại đối chiếu:',
  Cargo_ByFee: 'Theo phí',
  Cargo_SelectBill: 'Chọn hóa đơn',
  Cargo_BillOfType: 'Loại hóa đơn:',
  Cargo_BillDateP: 'Ngày thanh toán:',
  Cargo_StatementDateP: 'Báo cáo ngày:',
  Cargo_RegistrationAddress: 'Địa chỉ người nộp thuế',
  Cargo_OriginalCurrency2: 'Tiền tệ gốc',
  Cargo_ExchangeRate2: 'Tỷ giá hối đoái',
  Cargo_BillRateEmpty: 'Tỷ giá hối đoái của hóa đơn không thể để trống!',
  Cargo_BillCurrencyMore: 'Chi phí hóa đơn không thể vượt quá ba loại tiền tệ!',
  Cargo_BillCurrencyEmpty: 'Hóa đơn tiền tệ không thể để trống!',
  Cargo_SettlementAgentEmpty: 'Đại lý thanh toán không thể để trống!',
  Cargo_IncludingTaxAmountZero: 'Giá bao thuế không thể bằng 0!',
  RequiredAccrueDate: 'Vui lòng nhập ngày dự kiến',
  RequiredCancelDate: 'Vui lòng nhập ngày hủy',
  Cargo_NoChargeForBillPayment: 'Không có phí để tạo một yêu cầu thanh toán!',
  Cargo_CancelSpecialApproval: 'Hủy bỏ lô đặc biệt',
  Cargo_LockTheBillTime: 'Khóa thời gian đơn',
  Cargo_CreditControlObject: 'Đối tượng tin cậy',
  Cargo_SpecialApprovalTime: 'Thời gian đặc biệt',
  Cargo_SpecialApprovalUser: 'Người đặc biệt',
  Cargo_AmountExceeded: 'Quá mức',
  Cargo_DateExceeded: 'Quá hạn',
  Cargo_CreditControlInfo: 'Tình hình kiểm soát tín dụng',
  Cargo_OperateTime: 'Thời gian hoạt động',
  Cargo_DownloadLog: 'Tải xuống bản ghi',
  Cargo_Times: 'Thứ hai',
  Cargo_LockTheBillDate: 'Khóa ngày đơn',
  Cargo_SpecialApprovalDate: 'Ngày đặc biệt',
  Cargo_OperateDate: 'Ngày hoạt động',
  Cargo_LockTheBillUser: 'Khóa đơn',
  Cargo_sono: 'SoNo',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: 'Cảng khởi hành (Airport)',
  Cargo_keyWordsTip: 'Vui lòng nhập từ khóa',
  Cargo_sopDoubleClickTip: 'Bấm đúp chuột vào hộp văn bản để chọn truy vấn trạng thái núi.',
  Cargo_SchemeName: 'Tên chương trình',
  Cargo_NewQueryScheme: 'Chương trình truy vấn mới',
  Cargo_TheQueryItemSelected: 'Mục truy vấn 【{0}】 đã được chọn',
  Cargo_SchemeSaveSuccess: 'Chương trình lưu thành công',
  Cargo_BillLogManagement: 'Quản lý nhật ký vận đơn',
  Cargo_ModifyContent: 'Sửa đổi nội dung',
  Cargo_CheckPermission: 'Bạn không có quyền xem doanh nghiệp!',
  Cargo_CheckBusinessType: 'Vui lòng chọn cùng loại hình kinh doanh!',
  Cargo_MasterChargeWhetherShareOrNot: 'Chi phí vé chính có được chia không?',
  Cargo_DepartmentPrefixNotSelected: 'Không có bộ phận thanh toán nào được chọn.',
  Cargo_SalesIsEmpty: 'Khách hàng hiện tại đang bán hàng trống, không thể ký tên!',
  Cargo_Distribution: 'Phân phối',
  Cargo_SalesNotSelected: 'Bán hàng không được chọn!',
  Cargo_ReviewedByLeader: 'Đã phân phối, khách hàng này đợi tổ trưởng cũ xét duyệt:',
  Cargo_AllocationSucceeded: 'Phân phối thành công!',
  Cargo_FormerGroupLeader: 'Trưởng nhóm cũ',
  Cargo_ChineseNameIsEmpty: 'Tên tiếng Trung của khách hàng là rỗng!',
  Cargo_OriginalTeamLeaderIsEmpty: 'Tên tổ trưởng cũ là Trống rỗng!',
  Cargo_DoNotOperate: 'Hành động trên khách hàng hiện tại bị cấm, vui lòng liên hệ với quản lý bán hàng để giải quyết!',
  Cargo_RestoreCurrentCustomer: 'Xác nhận bạn muốn khôi phục khách hàng hiện tại?',
  Cargo_CustomerInformationIsEmpty: 'Thông tin khách hàng trống rỗng!',
  Cargo_CannotBeDeleted: 'Khách hàng này đã được doanh nghiệp sử dụng và không thể xóa!',
  Cargo_DeleteSuccessfully: 'Việc xóa thành công và khách hàng đó được chuyển vào thùng rác của khách hàng!',
  Cargo_AreYouSureDelete: 'Bạn có chắc chắn muốn xóa nó?',
  Cargo_PleaseSelectForDelete: 'Vui lòng chọn khách hàng mà bạn muốn xóa!',
  Cargo_ChineseNameAlreadyExists: 'Tên Trung Quốc đã tồn tại',
  Cargo_EnglishNameAlreadyExists: 'Tên tiếng Anh đã tồn tại',
  Cargo_ChineseOrEnglishAlreadyExists: 'Tên Trung Quốc hoặc tên tiếng Anh đã tồn tại',
  Cargo_ContactPersonToFillInA: 'Khách hàng có ít nhất một liên hệ!',
  Cargo_PleaseInvoicingRequirementsTab: 'Vui lòng điền vào yêu cầu tiền tệ của trang yêu cầu khai hóa đơn!',
  Cargo_SignOrNot: 'Đăng ký',
  Cargo_DangerousChemicals: 'Có nguy hiểm không?',
  Cargo_DaysNotFollowedUp: 'Số ngày không theo dõi',
  Cargo_CustomerNotSelected: 'Khách hàng không chọn!',
  Cargo_AssignedClientsSuccessfully2: '{0} Khách hàng được chỉ định',
  Cargo_examine: 'Khách hàng được giám sát bởi trưởng nhóm',
  Cargo_DistributionSales: 'Khách hàng phân phối bán hàng thành công',
  Cargo_MoreThan1Year: 'Hơn 1 năm',
  Cargo_list: 'Danh sách',
  Cargo_MyClients: 'Khách hàng của tôi',
  Cargo_CustomersInThisGroup: 'Nhóm khách hàng',
  Cargo_CustomerRecycleBin: 'Thùng rác của khách hàng',
  Cargo_PleaseSelectTheCustomerToExport: 'Vui lòng chọn khách hàng cần xuất khẩu!',
  Cargo_city: 'Thành phố',
  Cargo_email: 'Hộp thư',
  Cargo_add: 'Thêm',
  Cargo_Append: 'Bổ sung',
  Cargo_PSCF: 'Vui lòng chọn liên hệ trước!',
  Cargo_NCS: 'Không có liên lạc nào được chọn!',
  Cargo_CNATCBE: 'Tên liên lạc và số điện thoại không được để trống!',
  Cargo_ERF: 'Lỗi xóa tập tin!',
  Cargo_FDS: 'Xóa tập tin thành công!',
  Cargo_AYSDF: 'Bạn chắc chắn muốn xóa tập tin?',
  Cargo_PSAEF: 'Vui lòng chọn sự kiện trước',
  Cargo_theme: 'Chủ đề',
  Cargo_FTMFT: 'Sửa đổi kiểu tập tin không thành công',
  Cargo_EventStatus: 'Trạng thái sự kiện',
  Cargo_TaskTime: 'Thời gian làm việc',
  Cargo_CustomerChineseName: 'Khách hàng Trung Quốc Name',
  Cargo_CustomerEnglishName: 'Tên tiếng Anh của khách hàng',
  Cargo_NextTask: 'Nhiệm vụ tiếp theo',
  Cargo_RWSR: 'Thành công từ chối {0} kỷ lục',
  Cargo_isActive: 'Có hiệu quả hay không',
  Cargo_OverdueLimit: 'Hạn mức quá hạn',
  Cargo_OverdueDays: 'Số ngày quá hạn',
  Cargo_Enable: 'Bật',
  Cargo_Disable: 'Tắt',
  Cargo_EnableStatus: 'Trạng thái bật',
  Cargo_Enabled: 'Đã bật',
  Cargo_Disabled: 'Đã tắt',
  Cargo_amount: 'Số dải',
  Cargo_HasChosen: 'Đã chọn',
  Cargo_RemoveToBlackList: 'Di chuyển ra khỏi danh sách đen',
  Cargo_SureToRemoveToBlackList: 'Bạn có chắc chắn muốn thoát khỏi danh sách đen?',
  Cargo_Flight: 'Chuyến bay',
  Cargo_OutstandingAmount: 'Số tiền chưa bán (chi phí)',
  Cargo_WriteOffAmountCharge: 'Kim ngạch tiêu thụ hạt nhân (chi phí)',
  Cargo_ReceivableExcludingTax: 'Phải thu chưa bao gồm thuế (hóa đơn)',
  Cargo_TaxIncludedReceivable: 'Phải thu thuế (hóa đơn)',
  Cargo_PayableExcludingTax: 'Chưa bao gồm thuế (hóa đơn)',
  Cargo_TaxPayable: 'Đã bao gồm thuế (hóa đơn)',
  Cargo_TotalExcludingTax: 'Tổng cộng chưa bao gồm thuế (hóa đơn)',
  Cargo_TotalTaxIncluded: 'Tổng cộng bao gồm thuế (hóa đơn)',
  Cargo_PleaseEnterBoxTypeOrBoxType: 'Vui lòng nhập loại hộp hoặc loại hộp!',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: 'Ngày có hiệu lực phải nhỏ hơn ngày hết hạn',
  Cargo_MaintenanceOfExpenseDetails: 'Chi phí bảo trì chi tiết',
  Cargo_CustomerQuickSearch: 'Truy cập nhanh: Tên tiếng Trung/tiếng Anh của khách hàng',
  Cargo_WechatAccount: 'Vi tín hiệu',
  Cargo_Download: 'Tải về',
  Cargo_ChineseNamed: 'Trung QuốcName',
  Cargo_EnglishNamed: 'Tên tiếng Anh',
  Cargo_SignContractTip: 'Mô-đun đối tác đã tồn tại các doanh nghiệp có tên tương tự, có cần liên kết không?',
  Cargo_SignContractTipYes: 'Vâng, tôi muốn kết nối.',
  Cargo_SignContractTipNo: 'Không, tôi không liên quan.',
  Cargo_CooperationStage: 'Giai đoạn hợp tác',
  Cargo_Financial_Year: 'Năm tài chính',
  Cargo_ConfirmCloseWindow: 'Xác nhận đóng cửa sổ?',
  Cargo_NoteUpdatedSuccessfully: 'Ghi chú Cập nhật thành công',
  Cargo_PleaseSelectAPieceOfData: 'Vui lòng chọn một dữ liệu.',
  Cargo_SelectDataIsNotAuditState: 'Chỉ hỗ trợ các nghiệp vụ tạm thời không trình lên trạng thái dự thẩm là đợi xét duyệt, xin chọn lại một lần nữa.',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: 'Chỉ hỗ trợ các doanh nghiệp có trạng thái đệ trình sơ thẩm tạm thời không đệ trình hoặc đã từ chối, vui lòng đánh dấu lại.',
  Cargo_SelectAtLeastOneRecord: 'Vui lòng chọn ít nhất một bản ghi',
  Cargo_FieldDisplay: 'Hiển thị trường',
  Cargo_ControlSelection: 'Chọn điều khiển',
  Cargo_EnumValue: 'Giá trị liệt kê',
  Cargo_StatusIsNotPending: 'Trạng thái không phải để xét duyệt.',
  Cargo_NotSubmittedAndRejectedStatusTips: 'Chỉ có thể chọn trạng thái tạm thời không đệ trình và bị từ chối.',
  Cargo_subimitPreStatusTips: 'Có chắc chắn về tình trạng nộp đơn trước khi xét xử không?',
  Cargo_TransitCannotBeNull: 'Cảng trung chuyển không được để trống',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: 'Đơn vị ủy thác này không thuộc về khách hàng của bạn, vui lòng chọn mới',
  Cargo_ThereAreBargesTips: 'Có xà lan. Vui lòng nhập ngày đóng xà lan.',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: 'Ngày đóng cửa không được lớn hơn ngày khởi hành',
  Cargo_ClosingDateOfBargeTips: 'Ngày đóng tàu sà lan không được lớn hơn ngày đóng tàu',
  Cargo_CurrentAccount: 'Đối tượng giao lưu',
  Cargo_BusinessNoAndChargeName: 'Số doanh nghiệp/Tên chi phí',
  Cargo_BusinessNum: 'Số lượng doanh nghiệp',
  Cargo_VoucherLineNumberSetting: 'Cài đặt số dòng chứng từ',
  Cargo_VoucherLine: 'Số dòng chứng từ',
  Cargo_UseRmbEntrytypeByInvoice: 'Biên lai chứng từ hóa đơn có trực tiếp lấy số tiền gốc hay không, tỷ giá hối đoái 1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '(Tách biệt với "","1=Các khoản phải thu 3=Các khoản phải trả 5=Thu nhập hoạt động 7=Chi phí hoạt động)',
  Cargo_UseRmbEntrytypeByFact: 'Biên lai chứng từ nhận thanh toán có trực tiếp lấy số tiền gốc hay không, tỷ giá hối đoái 1',
  Cargo_UseRmbEntrytypeByFactTip: '(Tách biệt với "","1=Các khoản phải thu 3=Các khoản phải trả 73=Các khoản phải trả (Cá nhân) 40=Các khoản phải thu (hợp nhất) 41=Các khoản phải trả (hợp nhất) 42=Thu nhập hoạt động (hợp nhất) 43=Chi phí hoạt động (hợp nhất))',
  Cargo_UseRmbEntrytypeByPre: 'Chứng từ trả trước có được rút trực tiếp từ số tiền gốc không, tỷ giá hối đoái 1',
  Cargo_UseRmbEntrytypeByPreTip: '(Tách biệt với "","1=phải thu 3=phải trả 26=trước thu 44=trả trước)',
  Cargo_UploadTime: 'Thời gian tải lên',
  Cargo_Finished: 'Hoàn thành',
  Cargo_OperationRequirement: 'Yêu cầu hoạt động',
  Cargo_measurements: 'Kích thước CM (L * W * H * Số mảnh)',
  Cargo_Note: 'Mô tả',
  Cargo_ChooseEdiTemplate: 'Chọn mẫu EDI',
  Cargo_OperatedFailed: 'Hoạt động thất bại',
  Cargo_SelectPurchaseRecord: 'Vui lòng chọn lịch sử mua hàng.',
  Cargo_SelectAcquiredRecord: 'Vui lòng chọn Record.',
  Cargo_CheckInvoiceInvalidState: 'Lựa chọn hiện tại bao gồm số hóa đơn đã hết hạn hoặc đã sử dụng.',
  Cargo_CheckInvoiceUsedState: 'Chưa chọn hóa đơn hoặc không chọn trạng thái đã đăng ký.',
  Cargo_InvoiceRestoreSuccessfully: 'Hóa đơn khôi phục thành công.',
  Cargo_CheckInvoiceRestoreState: 'Các lựa chọn hiện hành có chứa số hóa đơn không bị hủy bỏ.',
  Cargo_ConfirmRestoreInvoice: 'Bạn có chắc chắn muốn khôi phục hóa đơn bị hủy bỏ?',
  Cargo_InvoiceInvalidSuccessfully: 'Hóa đơn hủy bỏ thành công.',
  Cargo_CheckInvoiceType: 'Các loại hóa đơn không phù hợp',
  Cargo_CheckInvoiceRecipientState: 'Lựa chọn hiện tại bao gồm các bản ghi đã đăng ký.',
  Cargo_LocalAmount: 'Tiền bản vị',
  Cargo_SourceAmount: 'Tiền gốc',
  Cargo_DebitAmountOccurredLocal: 'Tiền bản vị (Local coin)',
  Cargo_DebitAmountOccurredSource: 'Tiền vay (tiền gốc)',
  Cargo_CreditAmountOccurredLocal: 'Số tiền phát sinh tín dụng (bản vị)',
  Cargo_CreditAmountOccurredSource: 'Số tiền phát sinh của bên cho vay (tiền gốc)',
  Cargo_dispPop: 'Mở rộng Statistics',
  Cargo_hidePop: 'Click vào Close Statistics',
  Cargo_SchemeUserTips: 'Lưu ý: Gói cước dành cho người dùng được duy trì và chỉ áp dụng cho người dùng trong danh sách dưới đây',
  Cargo_NoDataCanBeModified: 'Không có dữ liệu để thay đổi.',
  Cargo_BalanceLocal: 'Số dư (Local Coin)',
  Cargo_BalanceSource: 'Số dư (tiền gốc)',
  Cargo_DebitAmountLocal: 'Số tiền ghi nợ (Local Coin)',
  Cargo_DebitAmountSource: 'Số tiền vay (tiền gốc)',
  Cargo_DebitSideLocal: 'Ghi nợ (tiền bản vị)',
  Cargo_DebitSideSource: 'Ghi nợ (tiền gốc)',
  Cargo_CreditAmountLocal: 'Tiền bản vị (Local coin)',
  Cargo_CreditAmountSource: 'Cho vay (tiền gốc)',
  Cargo_BatchUpload: 'Tải lên hàng loạt',
  Cargo_PleaseSelectBusinessData: 'Vui lòng chọn tên tập tin để khớp dữ liệu nghiệp vụ',
  Cargo_DocumentsBack: 'Chứng từ lấy lại',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: 'Chi phí trong và ngoài nước không cho phép đồng thời tiêu thụ hạt nhân!',
  Cargo_CurrencyMustBeTheSame: 'Tiền tệ phải giống nhau!',
  Cargo_AccountContacts: 'Đơn vị thanh toán Liên hệ',
  Cargo_AccountAddr: 'Địa chỉ đơn vị thanh toán',
  Cargo_AccountContactsTel: 'Điện thoại liên lạc',
  Cargo_CustomsDeclarationInformationOujian: 'Thông tin khai hải quan (hiện tại không hỗ trợ mô hình thông quan cho khu vực quản lý đặc biệt)',
  Cargo_ChargeSubmit: 'Chi phí có được nộp hay không',
  Cargo_ContractRatePropertySE: 'B5-03=giá trị thông số Ki, (cài 3)',
  Cargo_ContractRatePropertySI: 'Tính chất ước tính (Hải Tiến)',
  Cargo_TaxRevenueShortName: 'Mã hóa',
  Cargo_TaxRevenueName: 'Mã số thuế Name',
  Cargo_TaxRevenueToolTip: 'Ghi chú: Mã là mã thống nhất thuế quốc gia, ví dụ: 304080200200000; Đơn vị đứng tên đăng ký:6- Văn phòng Đại diện Công Ty Action Chimique Et Terapeutique (',
  Cargo_CargoSourceTip: 'Có nên thay đổi kiểu Range Rover không?',
  Cargo_AccountingMonthMaintain: 'Bảo trì tài chính hàng tháng',
  Cargo_FclApproximatePrice: 'Xấp xỉ số lượng giá cho FCL',
  Cargo_LclApproximatePrice: 'LCL về số lượng giá',
  Cargo_AddContractNo: 'Thêm số xấp xỉ',
  Cargo_Income20: '20\'Điều chỉnh',
  Cargo_Income40: '40\'Điều chỉnh',
  Cargo_Income40HC: '40HC\'Điều chỉnh',
  Cargo_Income45: '45\'Điều chỉnh',
  Cargo_WeightPriceAdjust: 'Điều chỉnh giá trọng lượng',
  Cargo_CubagePriceAdjust: 'Điều chỉnh giá khối lượng',
  Cargo_MinimumPriceAdjust: 'Điều chỉnh giá thấp nhất',
  Cargo_GrossMargin: 'Biên lợi nhuận gộp',
  Cargo_IncorrectExpenseStatus: 'Trạng thái chi phí không đúng!',
  Cargo_ExpenseStatusModifiedSuccessfully: 'Sửa đổi trạng thái chi phí thành công!',
  Cargo_DestinationSelection: 'Chọn điểm đến',
  Cargo_AciPortCode: 'Mã cổng aci',
  Cargo_InlandLocation: 'Vị trí nội địa',
  Cargo_SubLocationCode: 'Mã vị trí con',
  Cargo_DeleteBillTips: 'Chỉ có thể xóa các hóa đơn có số hóa đơn chưa được tạo và trạng thái hóa đơn chưa được xác nhận!',
  Cargo_ForceDeleteBillTips: 'Bạn chỉ có thể xóa các hóa đơn có trạng thái hóa đơn chưa được xác nhận, đã xác nhận, đã in, đã hết hạn!',
  Cargo_ConfirmDeleteCategoryAndType: 'Bạn có chắc chắn muốn xóa phân loại và loại được chọn?',
  Cargo_RangeAndGE: 'Giới hạn số (bao gồm)',
  Cargo_RangeAndLT: 'Giới hạn trên (không bao gồm)',
  Cargo_FinancialDateCheckNull: 'Ngày tài chính không thể để trống!',
  Cargo_CurrencyCheckNull: 'Tiền không cho phép làm trống!',
  Cargo_FinancialDateCheckBefore: 'Chọn ngày không thể trễ hơn ngày hiện tại',
  Cargo_OperatingCompanyCannotBeEmpty: 'Công ty không thể để trống',
  Cargo_DeliveryCannotBeNull: 'Nơi giao hàng không thể để trống',
  Cargo_DesignatedCannotBeNull: 'Đại lý chỉ định không thể để trống!',
  Cargo_SalesCannotBeEmpty: 'Bán hàng không được để trống',
  Cargo_ItemNumberCannotBeEmpty: 'Số mục không được để trống!',
  Cargo_PleaseSelectLoadingPort: 'Vui lòng chọn cảng bốc hàng!',
  Cargo_PleaseChooseTheDestinationPort: 'Vui lòng chọn cảng đích!',

  Cargo_UserManagement: 'Quản lý người dùng',
  Cargo_Search2: 'Tìm kiếm',
  Cargo_RecordAmount: 'Số lượng hồ sơ',
  Cargo_RoleUserSettings: 'Thiết lập người dùng vai trò',
  Cargo_SystemAdministrator: 'Quản trị hệ thống',
  Cargo_UserCode: 'Mã người dùng',
  Cargo_UserDepartment: 'Bộ phận người dùng thuộc về',
  Cargo_UserCompany: 'Công ty sở hữu người dùng',
  Cargo_IncludingElectricitySupplierAccount: 'Bao gồm tài khoản thương mại điện tử',
  Cargo_ValidOrNot: 'Có hiệu quả hay không',
  Cargo_Valid: 'Hiệu quả',
  Cargo_Invalid2: 'Mất hiệu lực',
  Cargo_LoginName: 'Đăng nhập',
  Cargo_MobilePhoneNo: 'Điện thoại',
  Cargo_PasswordExpirationDate: 'Ngày hết hạn mật khẩu',
  Cargo_NetworkManagementCode: 'Mã lưới',
  Cargo_Superior: 'Cấp trên',
  Cargo_OfficeAndDep: 'Chi nhánh/Bộ phận trực thuộc',
  Cargo_ConfirmBatchModifyUser: 'Chọn thay thế hàng loạt dữ liệu tương ứng 【{0}】',
  Cargo_BatchModifyUserSucceed: 'Sửa đổi thành công {0} dữ liệu thanh 【{1}】 thành 【{2}】',
  Cargo_Activation: 'Kích hoạt',
  Cargo_ElectricitySupplierAccountOrNot: 'Tài khoản thương mại điện tử',
  Cargo_SystemAdministratorOrNot: 'Quản trị hệ thống',
  Cargo_BatchModify: 'Sửa đổi hàng loạt',
  Cargo_TheCompanyToWhichTheAccountBelongs: 'Công ty sở hữu tài khoản',
  Cargo_EditPermission: 'Quyền sửa đổi',
  Cargo_AddUser: 'Thêm người dùng',
  Cargo_DeleteUser: 'Xoá người dùng',
  Cargo_RemoveUser: 'Xóa người dùng',
  Cargo_Filter2: 'Điều kiện lọc',
  Cargo_Import2: 'Nhập hàng loạt',
  GOODS_INFO_IMPORT: 'Nhập thông tin hàng hóa',
  Cargo_ContinueToCreate: 'Đối tác này đã được duy trì theo {0}, bạn có tiếp tục tạo không?',
  Cargo_AssignRolesToUsers: 'Name',
  Cargo_SelectARangeOfUsers: 'Chọn User Scope',
  Cargo_NotSubmittedOrRejectedTips: 'Chỉ cho phép xóa các doanh nghiệp tạm thời không được gửi hoặc bị từ chối, vui lòng chọn lại',
  Cargo_SelectedMoreThenNPieces: 'Bạn đã chọn dữ liệu vượt quá giới hạn {0} thanh, vui lòng chọn lại',
  Cargo_SmallTicketCannotBeRemoved: 'Chi phí chia sẻ có trong hóa đơn nhỏ và không thể loại bỏ.',
  Cargo_invoiceNotInconsistent: 'Loại hóa đơn, loại hóa đơn không nhất quán, bạn có tiếp tục hoạt động không?',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: 'Chỉ có thể nộp hóa đơn có số tài khoản',
  Cargo_SureDoThis: 'Chắc chắn để làm điều này?',
  Cargo_BillHasBeenSubmitted: 'Hóa đơn (0) đã được nộp',
  Cargo_BillWasNotSubmitted: 'Hóa đơn [{0}] không phải là trạng thái đã nộp',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: 'Chỉ có thể bán hóa đơn có số hóa đơn',
  Cargo_BillsHasBeenPaidInFull: 'Thanh toán{0}Đã thanh toán toàn bộ, không thể bán lại.',
  Cargo_NotAllowWriteOffFee: 'Trong số các chi phí tiếp thị hạt nhân, có các chi phí phải trả chưa được thực hiện yêu cầu thanh toán hoặc quá trình yêu cầu thanh toán chưa hoàn thành và không được phép tiếp thị hạt nhân.',
  Cargo_BillsAlreadyWriteOffFee: 'Hóa đơn {0} đã được bán và không thể trả lại',
  Cargo_RevokeAll: 'Hủy bỏ tất cả',
  Cargo_ConfirmAndNotityHQ: 'Có chắc là báo cho trụ sở không?',
  Cargo_AllBillingHasBeenSentToBranches: 'Các đối tượng thanh toán được chọn hiện tại đã được gửi tất cả các công ty quá hạn',
  Cargo_Sender: 'Gửi người',
  Cargo_SendDate: 'Thời gian EDI',
  Cargo_VersionNo: 'Số phiên bản',
  Cargo_BookingLog: 'Nhật ký đặt phòng',
  Cargo_BookingSubscribe: 'Đăng ký',
  Cargo_BookingSubscribeSync: 'Đồng bộ dữ liệu',
  Cargo_BookingSubscriptionStatus: 'Chi tiết đăng ký',
  Cargo_SubscribeDataType: 'Loại dữ liệu',
  Cargo_SubscribeStatus: 'Trạng thái đăng ký',
  Cargo_BatchUpdateExchangeRate: 'Cập nhật hàng loạt tỷ giá hối đoái',
  Cargo_UpdateExchangeRate: 'Cập nhật tỷ giá hối đoái',
  Cargo_SelectAccountAndCurrency: 'Vui lòng chọn đối tượng thanh toán và loại tiền tệ để sửa đổi tỷ giá hối đoái:',
  Cargo_InputRate: 'Nhập tỷ giá hối đoái:',
  Cargo_ConfirmUpdateExchangeRate: 'Xác nhận cập nhật tỷ giá hối đoái?',
  Cargo_PleaseInputRate: 'Vui lòng nhập tỷ giá hối đoái cần thay đổi!',
  Cargo_PleaseSelectAccountAndCurrency: 'Vui lòng chọn đối tượng thanh toán/loại tiền tệ cần thay đổi tỷ giá hối đoái!',
  Cargo_ValidateUpdateRateTips: 'Thao tác thất bại, đơn vị thanh toán/loại tiền tệ cập nhật tỷ giá hối đoái lần này không nằm trong nghiệp vụ đánh dấu lần này!',
  Cargo_UpdateRateConfirmTipsHead: 'Khối lượng cập nhật tỷ giá hối đoái bao gồm thế hệ',
  Cargo_UpdateRateConfirmTipsTail: 'Chi phí, lần này chỉ cập nhật tỷ giá hối đoái ban đầu, sau khi sửa đổi dữ liệu không thể khôi phục, có tiếp tục hay không?',
  Cargo_BillVoidTipForState: 'Hóa đơn chỉ có thể bị hủy trong trạng thái "không xác nhận"!',
  Cargo_BillVoidTipForReview: 'Hóa đơn chỉ có thể bị hủy trong trạng thái "chưa được kiểm tra"!',
  Cargo_DuplicatedCode: 'Mã này được lặp lại, vui lòng nhập lại.',
  Cargo_PlatformCertifiedPartner: 'Chọn đối tác được chứng nhận nền tảng',
  Cargo_Examine: 'Kiểm toán hay không',
  Cargo_NameOfApplicant: 'Đăng ký tên doanh nghiệp',
  Cargo_CreateSource: 'Nguồn',
  Cargo_Tenant: 'Trang chủ',
  Cargo_Platform: 'Nền tảng',
  Cargo_AdvertisingManagement: 'Quản lý quảng cáo',
  Cargo_AdvertisingNo: 'Số quảng cáo',
  Cargo_AdvertisingContent: 'Nội dung quảng cáo',
  Cargo_System: 'Hệ thống sở hữu',
  Cargo_Module: 'Module sở hữu',
  Cargo_PageIndex: 'Trang liên kết',
  Cargo_AdvertisingSpace: 'Quảng cáo Bit',
  Cargo_AdvertisingSubject: 'Đối tượng quảng cáo',
  Cargo_PromotionCycle: 'Chu kỳ khuyến mãi',
  Cargo_DataTime: 'Ngày dữ liệu',
  Cargo_AdvertisingSpaceNo: 'Số quảng cáo',
  Cargo_billPaymentNo: 'Đơn yêu cầu thanh toán',
  Cargo_RangeSmaller: 'Đề nghị sử dụng phạm vi nhỏ',
  Cargo_SyncFinanceCode: 'Động thái này sẽ viết mã đối tác vào mã khách hàng, có tiếp tục không?',
  Cargo_SyncFinanceCodeSuccess: 'Mã khách hàng đồng bộ thành công',
  Carge_ConfirmDate: 'Thời gian xác nhận',
  Carge_ConfirmUser: 'Người xác nhận',
  Carge_BillingConfirmDate: 'Thời gian xác nhận hóa đơn',
  Carge_BillingConfirmUser: 'Xác nhận hóa đơn',
  Carge_BillingGroupConfirmDate: 'Thời gian xác nhận thanh toán',
  Carge_BillingGroupConfirmUser: 'Xác nhận đối chiếu',
  Carge_ChinessNameExist: 'Tên Trung Quốc đã tồn tại, vui lòng sửa đổi',
  Carge_EnglishNameExist: 'Tên tiếng Anh đã tồn tại, vui lòng sửa đổi',
  Cargo_Dep: 'Bộ phận nhập',
  Cargo_contactInformationCopy: 'Thông tin liên hệ - Sao chép số một',
  Cargo_contactInformationCode: 'Thông tin liên hệ - Mã truy xuất',
  Cargo_auditResult: 'Kết quả kiểm toán',
  Cargo_number: 'Số',
  Cargo_PlatformCode2: 'Mã nền tảng',
  Cargo_InterchaneeCode: 'Mã trao đổi',
  Cargo_abbreviation: 'Viết tắt',
  Cargo_TemplateDescribe: 'Description',
  Cargo_Describe: 'Mô tả',
  Cargo_BillingHeaderName: 'Đặt tên',
  Cargo_EnglishNameOfBank: 'Tên tiếng Anh của ngân hàng',
  Cargo_ContactName: 'Tên liên lạc',
  Cargo_TenantID: 'ID đối tượng thuê',
  Cargo_AppendQuery: 'Truy vấn thêm',
  Cargo_CollapseList: 'Thu gọn danh sách',
  Cargo_SetAsDefault: 'Đặt làm mặc định',
  Cargo_MultipleWorkNoEnter: 'Vui lòng nhập nhiều số công việc bằng cách sử dụng Enter',
  Cargo_DeleteConfirm: 'Dữ liệu sẽ không thể phục hồi sau khi xóa, bạn có muốn tiếp tục không?',
  Cargo_EachPage: 'Mỗi trang',
  Cargo_DataBar: 'Dữ liệu',
  Cargo_ClientNumberMaintenance: 'Bảo trì số đĩa thuế',
  Cargo_BillingPointCode: 'Mã điểm thanh toán',
  Cargo_UseDepartment: 'Bộ phận sử dụng',
  Cargo_CanNotEmpty: 'Không thể để trống!',
  Cargo_CanNotRepeat: 'Không thể lặp lại!',
  Cargo_BeforeCurrentDisplay: 'Trước hiển thị',
  Cargo_ReceivableChargeInput: 'Chi phí phải thu có được ghi vào hay không?',
  Cargo_CostChargeInput: 'Chi phí phải trả có được ghi vào hay không',
  Cargo_ConvertToCnyAr: 'Nên thu: Chiết khấu RMB',
  Cargo_ConvertToCnyAp: 'Ứng phó: Chiết khấu RMB',
  Cargo_FeeModifier: 'Thay đổi chi phí',
  Cargo_FeeModifyDate: 'Thời gian sửa đổi chi phí',
  Cargo_SoNoChangeTips: 'Số lượng số lượng số lượng đóng cửa xảy ra thay đổi, có đổi mới chi phí theo số đóng cửa vốn có hay không?',
  Cargo_EditSaleInfo: 'Điều chỉnh thông tin bán hàng',
  Cargo_PleaseSelectChargeApplyData: 'Vui lòng chọn dữ liệu kiểm tra chi phí.',
  Cargo_PleaseSelectExportChargeDetailData: 'Vui lòng kiểm tra hồ sơ đăng ký và thử lại',
  Cargo_BeyondMaxExportChargeDetailData: 'Hồ sơ đăng ký xuất khẩu không được vượt quá 5.000, vui lòng chọn lại',
  Cargo_ExportChargeDetailDataSucceed: 'Xuất chi tiết thành công',
  Cargo_NotSameEtd: 'Đánh dấu ngày khởi hành của doanh nghiệp tháng không phù hợp!',
  Cargo_BatchModifyJobNoMore: 'Số hiệu nghiệp vụ sửa đổi một lần không được vượt quá 100 điều.',
  Cargo_BatchModifyJobNoSuccess: 'Thay đổi hàng loạt thành công: {0}',
  Cargo_VolumeIsChanged: 'Thể tích thực tế xảy ra thay đổi, có phải làm mới chi phí ban đầu theo giá thể tích là đơn vị không?',
  Cargo_DealingsCustomer: 'Số dư giao dịch theo đơn hàng kinh doanh',
  Cargo_AllowsExceptionProofExport: 'Cho phép xuất chứng từ ngoại lệ bỏ qua',
  Cargo_ChargeChanger: 'Thay đổi chi phí',
  Cargo_ChargeCreadBy: 'Chi phí tạo bởi',
  Cargo_DeleteData: 'Dữ liệu đã bị xóa, vui lòng liên hệ với quản trị viên',
  Cargo_MasterTicketShareCharge: 'Chi phí của phiếu chính đã được chia, phiếu nhỏ mới gia nhập xin chia lại chi phí.',
  Cargo_CreateBillNo: 'Tạo số hóa đơn',
  Cargo_CalcShareAmount: 'Tính toán số tiền chia sẻ',
  Cargo_CalcShareAmountTip: 'Vui lòng xác nhận sau khi tính toán lại bằng cách nhấp vào nút Tính toán số tiền chia sẻ.',
  Cargo_CancelOrder: '{0} lệnh đã bị hủy thành công và {1} lệnh đã không bị hủy. Chỉ hỗ trợ hủy các đơn đặt hàng trong trạng thái hoạt động tích cực.',
  Cargo_CancelOrderTip1: 'Các đơn đặt hàng sau đây không thể hủy bỏ, bạn có muốn tiếp tục không?',
  Cargo_CancelOrderTip2: 'Đơn đặt hàng này đã khởi hành và có số giao dịch chính, không thể hủy bỏ',
  Cargo_CancelOrderTip3: 'Lệnh này đã khởi hành và không thể hủy bỏ',
  Cargo_CancelOrderTip4: 'Đơn đặt hàng này đã có mã số giao dịch chính và không thể hủy bỏ',
  Cargo_CancelOrderTip5: 'Bạn có muốn hủy hàng loạt {0} lệnh này không?',
  Cargo_CancelOrderTip6: 'Hủy đặt hàng',
  Cargo_CancelOrderTip7: 'Lần này để nộp {0} đơn đặt hàng. Các đơn đặt hàng sau đây không thể bị hủy, bạn có muốn tiếp tục không?',
  Cargo_CancelOrderTip8: 'Trạng thái đặt hàng là {0}, không thể hủy',
  Cargo_Reason: 'Nguyên nhân',
  Cargo_PushResultLog: 'Dữ liệu Push Results Record',
  Cargo_SendContent: 'Gửi nội dung',
  Cargo_ResultSuccess: 'Trạng thái gửi',
  Cargo_ResultMessage: 'Nguyên nhân thất bại',
  Cargo_DesignatedCargoWarehouseNo: 'Khi chỉ định hàng hóa, số lượng đến bằng số tham chiếu kinh doanh',
  Cargo_SelfCargoWarehouseNo: 'Số lượng vào kho tương đương với số tham chiếu kinh doanh khi tự Range Rover',
  Cargo_BusinessMark: 'Thương hiệu',
  Cargo_ModifyBusiness: 'Sửa đổi Tạo lại doanh nghiệp',
  Cargo_SelectJobNo: 'Vui lòng chọn số doanh nghiệp',
  Cargo_ClosingRecord: 'Đăng nhập',
  Cargo_ClosingAudit: 'Kiểm toán đóng tài khoản',
  Cargo_AccountKeeper: 'Người đóng tài khoản',
  Cargo_ClosingMonth: 'Tháng đóng cửa',
  Cargo_ClosingBranch: 'Đóng chi nhánh',
  Cargo_AccountClosingType: 'Loại tài khoản đóng',
  Cargo_ClosingDate: 'Ngày đóng tài khoản',
  Cargo_FinancialClosing: 'Tài chính',
  Cargo_BusinessClosing: 'Đăng ký kinh doanh',
  Cargo_SelectClosingDate: 'Chọn ngày đóng tài khoản',
  Cargo_SelectDeleteTip: 'Vui lòng chọn thông tin mẫu bạn cần xóa',
  Cargo_SelectDeleteTip2: 'Đã được sử dụng và không thể xóa',
  Cargo_SelectDeleteTip3: 'Bạn chắc chắn muốn xóa cấu hình đã chọn? Giao diện gọi sẽ không còn trả về dữ liệu sau khi xóa',
  Cargo_SameCurrencyForMultipleRecord: 'Vui lòng chọn ghi chép thực thu cùng loại tiền tệ để tiến hành tiêu thụ!',
  Cargo_SamePayReceiveDateForMultipleRecord: 'Vui lòng chọn bản ghi thanh toán có cùng ngày thanh toán để bán hàng!',
  Cargo_DefaultTaxRete: 'Thuế suất mặc định',
  Cargo_TaxRateRange: 'Phạm vi thuế suất có sẵn',
  Cargo_TaxRateRangeLimit: '{0}, thuế suất hiện tại không có sẵn, vui lòng xác minh và nếu cần thiết, vui lòng liên hệ với người giám sát để duy trì chi phí 【Thuế suất có sẵn】',
  Cargo_BargeETD: 'Xà lan ETD',
  Cargo_DataModifyDate: 'Thời gian thay đổi dữ liệu',
  Cargo_sendOcOrder: 'Gửi lại thông tin đặt hàng',
  Cargo_sendOcTracking: 'Gửi lại thông tin theo dõi',
  Cargo_sendOcFile: 'Gửi lại thông tin tập tin',
  Cargo_sendOcBilling: 'Gửi lại thông tin thanh toán',
  Cargo_chargeUpdater: 'Cập nhật chi phí',
  Cargo_WriteOffForMultipleRemainTipAr: 'Kim ngạch thực thu lựa chọn lần này không đủ, đề nghị sửa đổi kim ngạch tiêu thụ lần này!',
  Cargo_SharedChargeRecord: 'Hồ sơ chia sẻ chi phí',
  Cargo_ExcludingTaxAmount: 'Số tiền chưa thuế',
  Cargo_IncludedTaxAmount: 'Số tiền đã bao gồm thuế',
  Cargo_ShareScheme: 'Cách chia sẻ',
  Cargo_ChargeSyncStatus: 'Trạng thái đồng bộ hóa chi phí',
  Cargo_ChargeSyncConfirmStatus: 'Đồng bộ xác nhận trạng thái',
  Cargo_WriteOffForMultipleRemainTipAp: 'Kim ngạch thực trả lựa chọn lần này không đủ, đề nghị sửa đổi kim ngạch tiêu thụ lần này!',
  Cargo_ConsolidatedProfitLossIs2: 'Hối đoái tổn hại là:',
  Cargo_GroupScene: 'Nhóm cảnh',
  Cargo_GroupName: 'Tên nhóm',
  Cargo_GroupType: 'Loại nhóm',
  Cargo_CcPerson: 'CC bởi',
  Cargo_UpdatePerson: 'Cập nhật bởi',
  Cargo_Common: 'Công cộng',
  Cargo_Personal: 'riêng tư',
  Cargo_ReleasePerson: 'Đặt một mình.',
  Cargo_MailGroupType: 'Vui lòng chọn ít nhất một loại.',
  Cargo_MailGroupName: 'Vui lòng nhập tên nhóm.',
  Cargo_MailGroupEmail: 'Vui lòng nhập ít nhất 1 địa chỉ email.',
  Cargo_MailGroupCheckEmail: 'Vui lòng kiểm tra định dạng thư đã nhập.',
  Cargo_MailGroupDelete: 'Thao tác xóa không thể phục hồi, vui lòng xác nhận xóa dữ liệu?',
  Cargo_ChargeRate: 'Tỷ giá hối đoái',
  Cargo_BillingRate: 'Tỷ giá thanh toán',
  Cargo_GroupChargeRate: 'Tỷ giá phí nhóm',
  Cargo_BranchRate: 'Tỷ giá chi nhánh',
  Cargo_EnabledChildOffice: 'Tỷ giá hối đoái hiện tại có hiệu lực đối với các công ty con cấp dưới',
  Cargo_ShowParentRateOffice: 'ứng dụng: {0} Tỷ giá hối đoái',
  Cargo_SetEnabledChild: 'Thiết lập công ty con có hiệu lực',
  Cargo_SetEnabledChildDialog: 'Cài đặt có hiệu lực cho các công ty con cấp dưới',
  Cargo_SetEnabledChildCheckbox: 'Có hiệu lực đối với các công ty con cấp dưới',
  Cargo_CopyOfficeRate: 'Sao chép tỷ giá chi nhánh',
  Cargo_CopyHqRate: 'Sao chép tỷ giá nhóm',
  Cargo_ConfirmCopyBillingRateTip: 'Ghi đè lên dữ liệu hiện có?',
  Cargo_Cover: 'Ghi đè',
  Cargo_NotCover: 'Không ghi đè',
  Cargo_PleaseSelectExportData: 'Vui lòng chọn dữ liệu bạn muốn xuất!',
  Cargo_UploadRateTip: 'Tập tin tải lên chỉ có thể ở định dạng xls, xlsx!',
  Cargo_UploadDataSizeMore: 'Kích thước tập tin không được lớn hơn 2MB!',
  Cargo_UploadDataFailed: 'Nhập không thành công, vui lòng liên hệ với quản trị viên!',
  Cargo_UploadFailedCheckExcel: 'Nhập không thành công, vui lòng kiểm tra nội dung mẫu!',
  Cargo_ValidateUploadRateTip1: 'Giá trị tiền tệ ban đầu là {0} và giá trị tiền tệ cơ sở là {1} trùng lặp với các dữ liệu khác trong Excel!',
  Cargo_ValidateUploadRateTip2: 'Giá trị tiền tệ ban đầu là {0}, giá trị tiền tệ cơ bản là {1} trùng lặp với dữ liệu đã có trong bảng!',
  Cargo_ValidateUploadRateTip3: 'Dữ liệu và dữ liệu đã có trong bảng trùng lặp!',
  Cargo_DefaultReceivableMode: 'Chế độ thu mặc định',
  Cargo_DefaultReceivableRate: 'Giá mặc định phải thu',
  Cargo_SecondReceivableRate: 'Tỷ lệ thứ hai phải được tính',
  Cargo_ChargeableAmountInterval: 'Phạm vi tính phí',
  Cargo_ReceivableIntervalType: 'Loại Receive Range',
  Cargo_DefaultUnitPrice: 'Đơn giá mặc định',
  Cargo_DefaultRate: 'Giá mặc định',
  Cargo_Suit: 'Áp dụng',
  Cargo_DefaultPayableMode: 'Chế độ trả lời mặc định',
  Cargo_DefaultPayableRate: 'Phải trả giá mặc định',
  Cargo_SecondRatePayable: 'Đối phó với tỷ lệ thứ hai',
  Cargo_PayableAmountInterval: 'Khoảng phí phải trả',
  Cargo_PayableIntervalType: 'Phân loại Response Range',
  Cargo_EDIFileType: 'Loại tệp EDI khi gửi(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: 'Kiểm tra trang cơ bản {0} đã thay đổi, bạn có làm mới dữ liệu kiểm tra trang B/L không?',
  Cargo_ShareChargeCheckCurrency: 'Chi phí chia sẻ loại tiền tệ và phương hướng thu chi phải nhất trí.',
  Cargo_ShareChargeCheck: 'Tổng chi phí chia sẻ hóa đơn nhỏ không bằng chi phí ban đầu!',
  Cargo_PleaseSelectedSalesForCustomer: 'Xin hãy giữ khách hàng tương ứng với việc bán hàng!',
  Cargo_PleaseSelectedLevelForCustomer: 'Xin hãy duy trì khách hàng tương ứng với cấp độ khách hàng!',
  AutomaticReconciliation: 'Đối chiếu tự động',
  AutomaticReconciliationHistory: 'Lịch sử đối chiếu tự động',
  CheckHistory: 'Lịch sử đối chiếu',
  ReconciliationResult: 'Kết quả đối chiếu',
  ImportReconciliationExcel: 'Nhập bảng đối chiếu Excel',
  Cargo_BatchUpdateChargeConfirmSerialNumber: 'Sửa đổi lô hàng loạt',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: 'Các khoản phí đã chọn sẽ được sửa đổi thành các số lô sau:',
  Cargo_InputChargeConfirmSerialNumber: 'Vui lòng nhập số lô',
  Cargo_ChargeConfirmSerialNumber: 'Số lô xác nhận chi phí',
  Cargo_ChargeConfirmSerialNumberLengthMore: 'Số lô không thể vượt quá 20 chữ số!',
  Cargo_PleaseSelectSolicitationType: 'Vui lòng chọn loại Range Rover!',
  Cargo_WriteoffSeqNo: 'Số lô bán hàng',
  Cargo_CustomerContactChannel: 'Kênh liên hệ khách hàng',
  Cargo_AgentBilling: 'Đại lý chia hóa đơn',
  Cargo_AgentBillingCanNotEdit: 'Đại lý chia hóa đơn không thể tiến hành chỉnh sửa!',
  Cargo_RecheckBillingCanNotEdit: 'Hóa đơn đã kiểm tra lại không thể chỉnh sửa!',
  Cargo_ContainsAgentBilling: 'Có hóa đơn chia sẻ đại lý, vui lòng chọn một đối chiếu khác để hoạt động!',
  Cargo_HasAgentBilling: 'Có hóa đơn chia sẻ đại lý, vui lòng chọn hóa đơn khác để hành động!',
  Cargo_ForeignBillStatusError: 'Trạng thái hóa đơn nước ngoài không đáp ứng yêu cầu in ấn.',
  Cargo_ExportBillVoucherStatus: 'Xuất trạng thái chứng từ hóa đơn',
  Cargo_BillGeneratedNoCancel: 'Số hóa đơn đã được tạo, không thể hủy xem xét',
  Cargo_OverseasBillReverseRule1: 'Hóa đơn nước ngoài cần có số hóa đơn mới được điều chỉnh ngược',
  Cargo_WriteOffStatusReverseRule: 'Trạng thái đã thanh toán không thể điều chỉnh ngược',
  Cargo_VoidStatusReverseRule: 'Hóa đơn đã hủy không thể điều chỉnh ngược',
  Cargo_AlreadyReversedRule: 'Hóa đơn đã điều chỉnh ngược không thể điều chỉnh ngược lại',
  Cargo_NoBillToReverse: 'Không có hóa đơn nào để điều chỉnh ngược',
  Cargo_ConfirmReverseBills: 'Bạn có chắc chắn muốn điều chỉnh ngược {0} hóa đơn này không?',
  Cargo_ReversedBillNoInvoice: 'Hóa đơn đã điều chỉnh ngược không thể lập hóa đơn lại',
  Cargo_BillInvoicedNoReverse: 'Hóa đơn đã được lập hóa đơn, không thể điều chỉnh ngược',
  Cargo_BillPaymentAppliedNoReverse: 'Hóa đơn đã được sử dụng cho đơn xin thanh toán, không thể điều chỉnh ngược',
  Cargo_BillStatementMadeNoReverse: 'Hóa đơn đã được dùng làm đối chiếu, không thể điều chỉnh ngược',
  Cargo_BillWrittenOffNoReverse: 'Hóa đơn đã được thanh lý, không thể điều chỉnh ngược',
  Cargo_Config: 'Cấu hình',
  Cargo_OrderTemplateName: 'Name',
  Cargo_TemplateTips: 'Lời khuyên:',
  Cargo_Blue: 'Xanh dương',
  Cargo_MusetSelectd: 'Các mục bắt buộc, không thể xóa, phải cấu hình tên tiêu đề của mẫu, nếu mẫu không có giá trị cấu hình mặc định thứ tự',
  Cargo_StartLine: 'Nhập dòng bắt đầu (bao gồm tiêu đề)',
  Cargo_TemplateDefault: 'Nếu không có trường bắt buộc trong mẫu, bạn có thể duy trì giá trị mặc định của đơn đặt hàng được tạo nhập khẩu ở đây',
  Cargo_TemplateDefaultValue: 'Giá trị mẫu',
  CargoFieldDescription: 'Description',
  Cargo_FieldDropdownValue: 'Giá trị hộp thả xuống trường',
  Cargo_ActualFieldName: 'Name',
  Cargo_TemplateHeaderName: 'Đầu bảng mẫu Name',
  Cargo_TemplateImportValue: 'Nhập giá trị mẫu',
  Cargo_OrderDefaultValue: 'Mặc định đặt hàng',
  Cargo_OrderOperation: 'Hoạt động',
  Cargo_OrderDelete: 'Xoá',
  Cargo_CloseAccountTips1: 'Ngày điều chỉnh hiện tại đã đóng, vui lòng chọn lại.',
  Cargo_CloseAccountTips2: 'Ngày tài chính hiện tại đã đóng, vui lòng chọn lại.',
  Cargo_PayableOrderCreationDate: 'Ngày tạo hóa đơn phải trả',
  Cargo_InvoiceHistoryEmail: 'Lịch sử hóa đơn Mail',
  Cargo_SendCc: 'Đồng bộ địa chỉ gửi cc',
  Cargo_DoInvoiceTip: 'Chỉ có {0} quyền, không hoạt động để nhận vé',
  Cargo_DoInvoiceTip2: 'Chỉ có {0} quyền, không thể hoạt động, phải nhận thanh toán hỗn hợp',
  Cargo_CallBackTip: 'Hồ sơ bảo hiểm của 【Đã nộp, đã xuất】 không thể quay lại bước trước',
  Cargo_CabinSpaceSerialNo: 'Lưu lượng cabin',
  Cargo_CabinSpaceStatus: 'Trạng thái cabin',
  Cargo_CabinSpaceNote: 'Ghi chú cabin',
  Cargo_AllocationStatus: 'Trạng thái phân phối',
  Cargo_QuantityInconsistency: 'Số lượng S/O hoặc MBL không phù hợp với số lượng cabin',
  Cargo_VesselCallSign: 'Biển hiệu tàu',
  Cargo_SORecognitionNewAdd: 'Xác định thêm',
  Cargo_ShutOut2: 'Tái chế',
  Cargo_CabinSpaceBackFill: 'Làm đầy khoang',
  Cargo_RevokeAllocation: 'Thu hồi phân phối',
  Cargo_CancelCabinReservation: 'Thoát khỏi cabin',
  Cargo_AllocateCabinSpace: 'Phân phối cabin',
  Cargo_Allocate1: 'Phân phối - Kinh doanh liên kết',
  Cargo_Allocate2: 'Phân phối - Tạo doanh nghiệp',
  Cargo_SelectBusinessTip: 'Vui lòng chọn một doanh nghiệp sửa đổi bản sao',
  Cargo_GuidedSellingPrice: 'Hướng dẫn giá bán',
  Cargo_CabinCancellationNote: 'Trở lại Cabin Ghi chú',
  Cargo_CutOffDate: 'Ngày cắt',
  Cargo_DeclarationCutOffDate: 'Chặn ngày khai báo',
  Cargo_CutOffDate2: 'Ngày đóng cửa của khách hàng',
  Cargo_ReturnDateForCustoms: 'Ngày hoàn thuế của khách hàng',
  Cargo_CutOffTime: 'Khách hàng mất thời gian',
  Cargo_FreeStorageDays: 'Số ngày miễn phí',
  Cargo_TotalPiecesMismatchContinue: 'Tổng số kiện không khớp, có tiếp tục thao tác không?',
  Cargo_BasicData: 'Dữ liệu cơ bản',
  Cargo_CustomerVendorRating: 'Xếp hạng khách hàng/nhà cung cấp',
  Cargo_DeliveryOperator: 'Người thao tác giao hàng',
  Cargo_DeliveryOperationTime: 'Thời gian thao tác giao hàng',
  Cargo_DeliveryOperationMethod: 'Phương thức thao tác giao hàng',
  Cargo_PartnerApprovalRequired: 'Đối tác được chọn cần khởi tạo quy trình phê duyệt, chỉ có hiệu lực sau khi được duyệt và không khả dụng trong thời gian chờ. Bạn có muốn phê duyệt ngay bây giờ không?',
  Cargo_ContractApprovalRequired: 'Hợp đồng này cần khởi tạo quy trình phê duyệt mới có hiệu lực; trong thời gian chờ không được sửa/ gia hạn/ quản lý tài liệu. Bạn có muốn phê duyệt ngay bây giờ không?',
  Cargo_ViewPartnerDetails: 'Xem chi tiết đối tác',
  Cargo_PartnerApplicationForm: 'Đơn đăng ký đối tác',
  Cargo_ContractApplicationForm: 'Đơn đề nghị hợp đồng',
  Cargo_PartnerApplicationApprovalProcess: 'Quy trình nộp đơn và phê duyệt đối tác',
  Cargo_ContractApplicationApprovalProcess: 'Quy trình nộp đơn và phê duyệt hợp đồng',
  Cargo_UnderReview: 'Đang chờ duyệt',
  Cargo_CanSubmitOnlyUnreviewedPartner: 'Chỉ có thể nộp đối tác ở trạng thái “Chưa duyệt”. Vui lòng chọn lại và thử lại.',
  Cargo_DataUnderReviewCheckRetry: 'Có dữ liệu đang chờ duyệt; vui lòng kiểm tra và thử lại',
  Cargo_ViewContractDetails: 'Xem chi tiết hợp đồng',
  Cargo_WeightOutOperator: 'Người thao tác xuất cân',
  Cargo_WeightOutOperationTime: 'Thời gian thao tác xuất cân',
  Cargo_WeightOutOperationMethod: 'Phương thức thao tác xuất cân',
  Cargo_ConfirmBatchOperation: 'Có xác nhận thực hiện hàng loạt không?',
  Cargo_AutomationConfig: 'Cấu hình tự động hóa',
  Cargo_TaskScenario: 'Bối cảnh nhiệm vụ',
  Cargo_TimingMethod: 'Phương thức hẹn giờ',
  Cargo_LastExecutionTime: 'Thời gian thực hiện cuối',
  Cargo_ExecutionFrequency: 'Tần suất thực hiện',
  Cargo_PerHour: 'Mỗi giờ',
  Cargo_Daily: 'Mỗi ngày',
  Cargo_Weekly: 'Mỗi tuần',
  Cargo_Monthly2: 'Mỗi tháng',
  Cargo_VesselEnglishName: 'Tên tàu tiếng Anh',
  Cargo_ActualSailingTime: 'Thời gian tàu khởi hành thực tế',
  Cargo_EstimatedSailingTime: 'Thời gian tàu khởi hành dự kiến',
  Cargo_ShippingCompanyName2: 'Tên công ty tàu',
  Cargo_ActualAmount: 'Số tiền thực tế (số tiền cuối cùng của chi phí)',
  Cargo_FeeCreationTime: 'Thời gian tạo chi phí',
  Cargo_StartExecutionTime: 'Thời gian bắt đầu',
  Cargo_Every: 'Mỗi',
  Cargo_Hour: 'giờ',
  Cargo_EffectiveTime: 'Thời điểm hiệu lực',
  Cargo_TaskResult: 'Kết quả nhiệm vụ',
  Cargo_TaskResultReminder: 'Thông báo kết quả (email kèm file Excel)',
  Cargo_ScenarioName: 'Tên kịch bản',
  Cargo_AutomationTask: 'Tác vụ tự động',
  Cargo_SpecifiedWeekday: 'Ngày trong tuần chỉ định',
  Cargo_SpecifiedDay: 'Ngày chỉ định',
  Cargo_LastDayOfMonth: 'Ngày cuối cùng của tháng',
  Cargo_Day29to31Fallback: 'Khi chọn ngày 29, 30 hoặc 31 mà tháng đó không tồn tại, hệ thống sẽ tự động chạy vào ngày cuối cùng của tháng.',
  Cargo_ExecuteCommand: 'Thực thi lệnh',
  Cargo_AutoInvoicing: 'Tự động xuất hóa đơn',
  Cargo_TaskName: 'Tên nhiệm vụ',
  Cargo_MultiLegVoyageManagement: 'Quản lý hành trình nhiều chặng',
  Cargo_ScheduleSelection: 'Chọn chuyến tàu',
  Cargo_Leg1: 'Chặng 1',
  Cargo_Leg2: 'Chặng 2',
  Cargo_Leg3: 'Chặng 3',
  Cargo_Leg4: 'Chặng 4',
  Cargo_Leg5: 'Chặng 5',
  Cargo_OnlyOneVoucherForCopy: 'Chỉ được chọn một chứng từ để sao chép!',
  Cargo_VoyageInfoCannotBeEmpty: '{0} trong thông tin hành trình không được để trống',
  Cargo_AutoExecute: 'Tự động thực hiện',
  Cargo_TaskNameCannotBeEmpty: 'Tên nhiệm vụ không được để trống!',
  Cargo_TaskNameAlreadyExists: 'Tên nhiệm vụ "{0}" đã tồn tại, không được trùng lặp!',
  Cargo_TaskScenarioAutoExecuteCannotDelete: 'Bối cảnh nhiệm vụ này đã được cấu hình thực hiện tự động, không thể xóa!',
  Cargo_EnabledStatusCannotDelete: '{0} Đang ở trạng thái đã bật, vui lòng tắt trước khi xóa.',
  Cargo_ConfirmDeleteTaskScenario: 'Bạn có chắc chắn muốn xóa bối cảnh nhiệm vụ này không?',
  Cargo_ScenarioSettings: 'Cài đặt kịch bản',
  Cargo_TransmissionRule: 'Transmission Rule',
  Cargo_Script: 'Script',
  Cargo_AccountPassword: 'Account & Password',
  Cargo_GetTokenUrl: 'Token Acquisition URL',
  Cargo_InterfaceUrl: 'Interface URL',
  Cargo_TransmissionSample: 'Transmission Format Sample',
  Cargo_RuleSettings: 'Cài đặt quy tắc',
  Cargo_CommandSettings: 'Cài đặt lệnh',
  Cargo_DataScript: 'Kịch bản dữ liệu',
  Cargo_DataDisplay: 'Hiển thị dữ liệu',
  Cargo_DeleteFromLastLeg: 'Vui lòng xóa từ chặng cuối cùng',
  Cargo_PreviewData: 'Xem trước dữ liệu',
  Cargo_NotificationPersonnel: 'Nhân viên được thông báo',
  Cargo_DebugExecute: 'Gỡ lỗi thực thi',
  Cargo_ConditionName: 'Tên điều kiện',
  Cargo_SendToExchangeTime: 'Thời gian gửi đến Sở Giao dịch Hàng hải',
  Cargo_EnterYourRequirement: 'Vui lòng nhập yêu cầu của bạn',
  Cargo_ConfigExecuteCommands: 'Cấu hình lệnh thực thi (thực hiện theo số thứ tự)',
  Cargo_CommandName: 'Tên lệnh',
  Cargo_SelectCommand: 'Chọn lệnh',
  Cargo_ConfirmRuleSettings: 'Vui lòng xác nhận cài đặt quy tắc',
  Cargo_ScenarioDescription: 'Mô tả kịch bản',
  Cargo_Command: 'Lệnh',
  Cargo_ExecutionTime: 'Thời gian thực hiện',
  Cargo_HistoryDetails: 'Chi tiết lịch sử',
  Cargo_ExecutionScenario: 'Kịch bản thực hiện',
  Cargo_DataID: 'ID dữ liệu',
  Cargo_ExecuteCommandName: 'Tên lệnh thực hiện',
  Cargo_ManualRun: 'Chạy thủ công',
  Cargo_AsyncExecutingCheckLogLater: 'Đang thực thi không đồng bộ, vui lòng kiểm tra nhật ký thực hiện sau',
  Cargo_ExecutionLog: 'Nhật ký thực hiện',
  Cargo_Execute: 'Thực hiện',
  Cargo_NoOutboundCommandConfirmPickList: '{0},Chưa có lệnh xuất kho, bạn có chắc muốn tạo phiếu lấy hàng không?',
  Cargo_CabinSpaceAllocationDate: 'Ngày cấp phát cabin',
  Cargo_AssociatedBusinessNo: 'Số doanh nghiệp liên kết',
  Cargo_AssociatedBusinessStatus: 'Tình trạng kinh doanh liên kết',
  Cargo_FirstTimeSalesAllocation: 'Phân phối bán hàng đầu tiên',
  Cargo_FirstTimeAllocationEntrustingUnit: 'Lần đầu giao đơn vị ủy thác',
  Cargo_CabinCancellationExplanation: 'Description',
  Cargo_CabinSpaceRecord: 'Hồ sơ cabin',
  Cargo_VoyageInformation: 'Thông tin chuyến bay',
  Cargo_AssociatedBusinessStatus2: 'Tình trạng kinh doanh liên kết',
  Cargo_UploadFileOver50: 'Tải lên có thể chậm hơn do khối lượng dữ liệu quá lớn, vui lòng kiểm tra lại sau.',
  Cargo_UserSecurityPolicy: 'Chính sách bảo mật người dùng',
  Cargo_RoleGroupManagement: 'Quản lý nhóm vai trò',
  Cargo_RoleGroupName: 'Tên nhóm vai trò',
  Cargo_UnmaintainedRoleGroupPermissions: 'Quyền hạn của nhóm vai trò tương ứng chưa được duy trì',
  Cargo_RoleGroup: 'Nhóm vai trò',
  Cargo_RoleGroupCountLessThanTwo: 'Số lượng nhóm vai trò < 2',
  Cargo_PolicySettings: 'Cài đặt chính sách:',
  Cargo_EnableUserSecurityPolicy: 'Bật chính sách bảo mật người dùng',
  Cargo_PasswordLengthRange: 'Khoảng độ dài mật khẩu:',
  Cargo_MaxLengthRange8to20: 'Độ dài tối đa 8-20 ký tự',
  Cargo_CompositionRule: 'Quy tắc thành phần:',
  Cargo_RequireNumUpperLower: 'Phải có chữ số, chữ hoa và chữ thường',
  Cargo_MustIncludeSpecialChars: 'Bắt buộc chứa ký tự đặc biệt: !,$,%,&,_,|,-,@,#,*,=',
  Cargo_PasswordHistoryCheck: 'Kiểm tra lịch sử mật khẩu:',
  Cargo_HistoryLength0to10: 'Thiết lập 0-10; 0 = không kiểm tra, 3 = không trùng 3 mật khẩu gần nhất',
  Cargo_PasswordErrorLock: 'Khóa khi nhập sai mật khẩu:',
  Cargo_LockLength0to10: 'Thiết lập 0-10; 0 = không khóa, khác 0 sẽ vô hiệu hóa tài khoản',
  Cargo_AdminApplication: 'Áp dụng cho quản trị viên:',
  Cargo_AdminPwdFollowPolicy: 'Quản trị viên cũng phải tuân thủ chính sách trên',
  Cargo_NoRepeatLastNPasswords: 'Không được trùng với {0} mật khẩu trước đó',
  Cargo_PasswordRulePrompt: 'Vui lòng đặt theo quy tắc: độ dài {0}-{1}, phải có chữ số, chữ hoa và chữ thường',
  Cargo_Allocated: 'Đã gán',
  Cargo_NotAllocated: 'Chưa gán',
  Cargo_PriceAuditEventFclTitle: 'Cập nhật giá vận chuyển nhắc nhở',
  Cargo_FillSO: 'Điền vào S/O',
  Cargo_FillMBL: 'Điền MBL',
  Cargo_FillALL: 'Điền vào cả MBL và S/O',
  Cargo_CustomsReturnAndRecovery: 'Phục hồi cabin từ doanh nghiệp đã đóng cửa',
  Cargo_CheckDTip: 'MBL NO. hoặc SO NO. đã tồn tại, xác nhận bạn muốn tiếp tục tạo?',
  Cargo_BatchUpdateTitle1: 'Sửa đổi hàng loạt - lấp đầy khoang',
  Cargo_WindowTip1: '* Cập nhật hàng loạt thông tin về đơn vận chuyển.',
  Cargo_WindowTip2: '** Nếu có sự khác biệt về số lượng hộp trong các đơn đặt hàng được đánh dấu số lượng lớn, vui lòng điền vào các khoang riêng lẻ để điền lại.',
  Cargo_CheckDTip2: 'Không thể hoạt động ở trạng thái "đã trả lại cabin" hoặc "đã được chỉ định".',
  Cargo_CheckDTip3: 'Vui lòng chọn khoang có kích thước hộp phù hợp để vận hành',
  Cargo_NoItems_NoAudit: 'Không có {0}, không cần kiểm tra',
  Cargo_Audited_NoNeedAudit: 'Đã kiểm tra, không cần kiểm tra lại',
  Cargo_AvailableCabinSpace: 'Cabin HT',
  Cargo_QueryTip: 'Bản mẫu:Cabin pipeline',
  Cargo_PriceUpdateUser: 'Thay đổi giá vận chuyển',
  Cargo_BookingPreAudit: 'Đặt phòng trước',
  Cargo_UniversalIntelligentRecognition: 'Nhận dạng thông minh chung',
  Cargo_PromptWords: 'Từ gợi ý',
  Cargo_PleaseUploadFile: 'Vui lòng upload file',
  Cargo_BatchImportAr1: 'Nhập hàng loạt các khoản thu',
  Cargo_BatchImportAp1: 'Số lượng lớn nhập thanh toán bán hàng',
  Cargo_BatchImportAr2: 'Tải về mẫu nhập khẩu thu tiền',
  Cargo_BatchImportAp2: 'Tải về thanh toán Import Template',
  Cargo_ImportingDataSuccess1: 'Đây là một hoạt động không đồng bộ, bạn có thể',
  Cargo_ImportingDataSuccess2: 'Lưu trữ tệp ->Tải lên nhật ký',
  Cargo_ImportingDataSuccess3: 'Xem kết quả Import',
  Cargo_RecordsWrittenOff: 'Đã thanh lý {0} bản ghi.',
  Cargo_lockLabel1: 'Khóa giá mua',
  Cargo_lockLabel2: 'Khóa giá bán',
  Cargo_lockLabel3: 'Mở khóa giá mua',
  Cargo_lockLabel4: 'Mở khóa giá bán',
  Cargo_UnLockLabel: 'Mở khóa',
  Cargo_LockLabel: 'Khóa',
  Cargo_LockSuccess: 'Thành công',
  Cargo_DisplayByBillOfLading: 'Hiển thị bởi B/L',
  Cargo_DisplayByDateAndVoyageNo: 'Hiển thị theo ngày',
  Cargo_ShowSeaExportJob: 'Kiểm tra dữ liệu tàu biển',
  Cargo_OperatingSpaceOnly: 'Chỉ hoạt động cabin, không hoạt động đơn đặt hàng',
  Cargo_IsCabinSpace: 'Sử dụng cabin hiện tại',
  Cargo_CheckBoxTip: 'Kích thước hộp không phù hợp với cabin, vui lòng kiểm tra',
  Cargo_CheckBoxTip2: 'Tên tàu, chuyến đi, công ty tàu, ETD của đơn đặt hàng không phù hợp với vị trí, vui lòng xác nhận tiếp tục không?',
  Cargo_CheckBoxTip3: 'MBL NO hoặc SO NO không liên quan',
  Cargo_AllocationSuccess: 'Phân phối thành công!',
  Cargo_AllocationCancel: 'Xác nhận hủy bỏ phân phối?',
  Cargo_CabinReturn: 'Thoát khỏi cabin cùng một lúc',
  Cargo_CabinReturnTip: 'Vui lòng điền vào hướng dẫn trả phòng.',
  Cargo_CancelCabinTip1: 'Hoàn tất thu hồi',
  Cargo_CancelCabinTip2: 'Hoàn thành việc rút lui.',
  Cargo_CancelCabinTip3: 'Đối với các doanh nghiệp có liên quan, vui lòng hủy liên kết trước.',
  Cargo_CancelCabinTip4: 'Các hoạt động liên quan đến khoang vẫn đang trong giai đoạn sơ thẩm đặt chỗ, nếu cần hủy bỏ việc phân phối, vui lòng từ chối trong giai đoạn sơ thẩm đặt chỗ.',
  Cargo_CancelCabinTip5: 'Các dịch vụ liên quan đến khoang chưa được hoàn thuế, vui lòng hoàn thuế trước',
  Cargo_CancelCabinTip6: 'Có các khoang chưa được chỉ định, vui lòng kiểm tra',
  Cargo_BusinessProcessStage: 'Giai đoạn lưu chuyển nghiệp vụ',
  Cargo_PleaseSelectDataAndUpload: 'Vui lòng tải lên tập tin hàng loạt sau khi đánh dấu dữ liệu.',
  Cargo_PleaseSelectDataAndUpload2: 'Vui lòng tải lên tập tin hàng loạt sau khi chọn cùng loại hình kinh doanh.',
  Cargo_BatchUploadFile: 'Tải lên tập tin hàng loạt',
  Cargo_BatchUploadFile2: 'Tải lên không thành công Không hỗ trợ định dạng này',
  Cargo_Allocate3: 'Phân phối - Tạo doanh nghiệp',
  Cargo_CabinCreate1: 'Tạo ra trước khi đặt hàng',
  Cargo_CabinCreate2: 'Tạo đặt hàng bằng đường biển',
  Cargo_CabinCreate3: 'Số doanh nghiệp đã tạo:',
  Cargo_CloseAndCopyNumber: 'Đóng và sao chép số đơn',
  Cargo_AllocateCheck1: 'Dữ liệu đã được phân bổ tồn tại, vui lòng kiểm tra',
  Cargo_AllocateCheck2: 'Có dữ liệu không lưu trữ, vui lòng kiểm tra',
  Cargo_OnlyReturnTheCabin: 'Chỉ có thể xóa dữ liệu về trạng thái rời khỏi cabin',
  Cargo_CabinManagement: 'Quản lý cabin',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: 'Trường phông chữ màu đỏ, sẽ bao gồm xuất khẩu đường biển với giá trị quản lý cabin',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: 'Trường phông chữ màu xanh, sẽ giữ giá trị xuất khẩu ban đầu bằng đường biển, sẽ không được bảo hiểm',
  Cargo_ImportedMultipleBusiness: 'Name',
  Cargo_UploadedRepeatedly: 'Tải lên lặp lại',
  Cargo_BoxType2: 'Loại hộp tương ứng Loại hộp',
  Cargo_BoxTypeAndCategory: 'Loại hộp Loại hộp',
  Cargo_CheckBoxSize: 'Vui lòng điền vào loại hộp',
  Cargo_UsedQuota: 'Hạn mức sử dụng (Hedge)',
  Cargo_PleaseSelectTheConsignee: 'Vui lòng chọn người nhận hàng',
  Cargo_ViewingMessage: 'Xem bản tin gốc',
  Cargo_ChangeSettlement: 'Thay đổi đối tượng thanh toán',
  Cargo_CanNotEditTips: 'Đã bao gồm các khoản phí không thể chỉnh sửa, vui lòng kiểm tra lại!',
  Cargo_PleaseSelectExpenseToModify: 'Vui lòng chọn chi phí cần sửa đổi.',
  Cargo_ArChargeSettlementCannotModify: 'Không thể sửa đổi đối tượng thanh toán của chi phí phải thu.',
  Cargo_ChargeSettledCannotModify: 'Chi phí đã lập hóa đơn/xuất hóa đơn/đề nghị thanh toán/đã đối soát, không thể sửa đổi.',
  Cargo_ArChargeSettlementCannotModifyDetail: 'Chi phí {0} là phí phải thu, không thể sửa đối tượng thanh toán.',
  Cargo_ChargeSettledCannotModifyDetail: 'Chi phí {0} đã lập hóa đơn/xuất hóa đơn/đề nghị thanh toán/đã đối soát, không thể sửa đổi.',
  Cargo_CanNotEditChargeDetail: 'Chi phí {0} không có quyền chỉnh sửa, không thể sửa đổi.',
  Cargo_CheckChargeDetailBranchDetail: 'Chi phí {0} thuộc chi nhánh không thể thao tác.',
  Cargo_BeforeAdjustment: 'Trước điều chỉnh',
  Cargo_AfterAdjustment: 'Sau điều chỉnh',
  Cargo_EstimateListQuery: 'Truy vấn tạm thời',
  Cargo_MappingConfiguration: 'Cấu hình bản đồ',
  Cargo_CreateEstimate: 'Tạo một ước tính',
  Cargo_SendSharingCenter: 'Gửi Trung tâm chia sẻ',
  Cargo_GenerateExpenseAmount: 'Số tiền chi phí phát sinh',
  Cargo_GenerateExpenseMode: 'Mô hình chi phí thế hệ',
  Cargo_GenerateInReceivables: 'Tạo ra trong thu nhập',
  Cargo_GenerateInPay: 'Tạo ra trong đối phó',
  Cargo_GenerateAll: 'Được tạo ra riêng biệt để đáp ứng',
  Cargo_ChargeAmount: 'Vui lòng điền vào số tiền phí tạo',
  Cargo_PushDate: 'Ngày đẩy',
  Cargo_GetSendResult: 'Nhận kết quả gửi',
  Cargo_ALittleSend: 'Đẩy như khách hàng lẻ tẻ',
  Cargo_MappingEditor: 'Sửa bản đồ',
  Cargo_NewMapping: 'Bản đồ mới',
  Cargo_Recipient: 'Gửi đối tượng',
  Cargo_DataRepetition: 'Dữ liệu trùng lặp tồn tại',
  Cargo_checkTip2: '{0} hoặc {1}',
  Cargo_ErrorExcel: 'Lỗi mẫu',
  Cargo_ImportException: 'Nhập ngoại lệ',
  Cargo_SelectiveFinanceMonth: 'Chọn tháng tài chính',
  Cargo_FinancialMonth: 'Tháng tài chính',
  Cargo_PushLog: 'Bản ghi đẩy',
  Cargo_ConfirmImport: 'Xác nhận nhập khẩu',
  Cargo_SETitle: 'Thời gian khởi hành dự kiến/Thời gian đến cảng dự kiến',
  Cargo_CurentSETitle: 'Thời gian khởi hành hiện tại (Current ETD)/Current ETA',
  Cargo_OriginalSETitle: 'Original ETD/Original ETA (Thời gian khởi hành theo lịch ban đầu)',
  Cargo_AETitle: 'Thời gian khởi hành dự kiến/Thời gian đến dự kiến',
  Cargo_SEAtdAtaTitle: 'Thời gian khởi hành thực tế (ATD)/Thời gian đến cảng thực tế (ATA)',
  Cargo_AEAtdAtaTitle: 'Thời gian khởi hành thực tế (ATD)/Thời gian đến thực tế (ATA)',
  Cargo_UpdateAtdAtaDateTip: 'Vui lòng nhập thời gian khởi hành thực tế, thời gian đến cảng thực tế cần sửa đổi',
  Cargo_UpdateAtdAtaDateTip2: 'Vui lòng nhập thời gian khởi hành thực tế, thời gian đến thực tế cần sửa đổi',
  Cargo_UpdateDateTip: 'Vui lòng nhập thời gian khởi hành theo lịch trình, thời gian đến cảng dự kiến cần sửa đổi',
  Cargo_UpdateDateTip2: 'Vui lòng nhập thời gian khởi hành dự kiến, thời gian đến dự kiến cần sửa đổi',
  Cargo_BusinessNotPositiveOperation: '{0} không hoạt động tích cực và không thể thay đổi thời gian',
  Cargo_SuccessTip: 'Thành công {0} thanh, thất bại 0',
  Cargo_SuccessTip1: 'Thành công {0} thanh, thất bại {1} thanh,< <br/>Thất bại: <br/>{2} không hoạt động tích cực và không thể thay đổi thời gian',
  Cargo_SuccessTip2: 'Thành công: {0}, Thất bại: {1}.<br/>Lý do thất bại: <br/> {2} không ở trạng thái có thể thao tác, không thể sửa đổi <br/> {3} chỉ chọn vận đơn nhỏ không chọn thông tin vận đơn chính, không thể sửa đổi',
  Cargo_ErrorCause: 'Nguyên nhân bất thường',
  Cargo_PushMessage: 'Thông báo đẩy',
  Cargo_PushMessageRsp: 'Nhận thông điệp',
  Cargo_ViewMessage: 'Xem báo cáo',
  Cargo_Message: 'Thông báo',
  Cargo_BusinessApplicationContext: 'Áp dụng kịch bản kinh doanh',
  Cargo_ConfigureEmailTemplate: 'Cấu hình mẫu thư',
  Cargo_SendingPosition: 'Gửi bài',
  Cargo_DeleteEmailTip: 'Xác nhận xóa mẫu thư đã đánh dấu?',
  Cargo_UpdateEmailTip: 'Tên mẫu thư không được để trống!',
  Cargo_UpdateEmailTip2: 'Đối tượng gửi: {1}, đã có cài đặt liên quan, xin vui lòng không lặp lại!',
  Cargo_UpdateEmailTip3: 'Tên mẫu 【{0}】 đã tồn tại và tên mẫu thư không thể lặp lại!',
  Cargo_EmailTemplate: 'Mẫu thư',
  Cargo_OrganizeClearing: 'Tổ chức giải quyết',
  Cargo_DocumentCode: 'Số tài liệu',
  Cargo_BillDate2: 'Ngày tài liệu',
  Cargo_EndDate2: 'Ngày hết hạn',
  Cargo_doTip: 'Nền đang được xử lý không đồng bộ, vui lòng kiểm tra lại sau!',
  Cargo_TypeOfExchange: 'Loại giao dịch',
  Cargo_CurrentAccountCode: 'Mã hóa hộ gia đình',
  Cargo_PE: 'Dự đoán/Estimated',
  Cargo_ENo: 'Số đơn vị ước tính',
  Cargo_OrderChannel: 'Kênh đặt hàng áp dụng',
  Cargo_MonthlyFinancial: 'Tài chính tháng',
  Cargo_DocumentId: 'ID tài liệu hệ thống kinh doanh',
  Cargo_SourceSystemCoding: 'Mã hóa hệ thống nguồn',
  Cargo_businessShipAgency: 'Loại hình kinh doanh (Shipman)',
  Cargo_CoinsReceivable: 'Phải thu tiền.',
  Cargo_ArApAmount: 'Số tiền phải thu/phải trả',
  Cargo_CostItem: 'Dự án chi phí. Mã hóa',
  Cargo_TaxNumber: 'Số thuế',
  Cargo_IsDefaultTitle: 'Có phải là tiêu đề mặc định không',
  Cargo_SingleTitleMode: 'Chế độ một tiêu đề',
  Cargo_MultipleTitleMode: 'Chế độ nhiều tiêu đề',
  Cargo_UnitPrice2: 'Đơn giá đã bao gồm thuế',
  Cargo_TaxRateCode: 'Thuế suất. Mã hóa',
  Cargo_Discount: 'Cách giảm giá',
  Cargo_CanNotChargeTips: 'Đã có chi phí không thể chỉnh sửa, xin hãy xử lý kịp thời!',
  Cargo_RefreshChargeTips: 'Đã tồn tại chi phí, có phải chi phí làm mới không?',
  Cargo_ArAmount: 'Số tiền phải thu',
  Cargo_MonthCode: 'Mã hóa tháng',
  Cargo_BeforeChange1: 'Lợi nhuận ước tính trước khi thay đổi',
  Cargo_BeforeChange2: 'Lợi nhuận ước tính sau khi thay đổi',
  Cargo_TaxPolicyCoding: 'Mã chính sách thuế',
  Cargo_SendingSharingCenter: 'Gửi Trung tâm chia sẻ',
  Cargo_SendingResult: 'Đẩy thành công: {0} thanh, thất bại: {1} thanh',
  Cargo_System2: 'Hệ thống',
  Cargo_FileDelete: 'xóa tập tin: xóa',
  Cargo_BillsPayable: 'Thanh toán',
  Cargo_PaymentSlipDataNo: 'Chỉ thanh toán theo số',
  Cargo_Payer: 'Đối tượng thanh toán',
  Cargo_Prepaid: 'Trả trước',
  Cargo_TypeOfInvoice: 'Loại hóa đơn',
  Cargo_UploadInvoiceCloudStatus: 'Tải lên trạng thái đám mây hóa đơn',
  Cargo_AccountToBeCredited: 'Tài khoản nhận tiền',
  Cargo_BankConnectionNo: 'Mã ngân hàng/SWIFT CODE',
  Cargo_BankConnectionNo2: 'Số dòng/SWIFT',
  Cargo_OriginalPaymentSlipNo: 'Đơn hàng thanh toán gốc',
  Cargo_ProcessNumber: 'Số dòng chảy',
  Cargo_FinancialPayStatus: 'Tình trạng thanh toán tài chính',
  Cargo_PaymentRequisitionStatus: 'Tình trạng yêu cầu thanh toán',
  Cargo_DefaultDetailItems: 'Chi tiết Mặc định',
  Cargo_GeneratePay: 'Tạo hóa đơn phải trả',
  Cargo_MergeGeneratePay: 'Hợp nhất để tạo ra phải trả',
  Cargo_PrintChannel: 'Kênh in',
  Cargo_BookingConfirmed: 'Đặt phòng',
  Cargo_OrderRecorded: 'Danh sách đã ghi',
  Cargo_CreateBillsPayable: 'Tạo Pay-to-Pay',
  Cargo_FinancialPayAreSent: 'Gửi thanh toán tài chính',
  Cargo_PaymentRequestSent: 'Gửi yêu cầu thanh toán',
  Cargo_DetailEntryID: 'ID phân loại chi tiết',
  Cargo_PayableSingleAttribute: 'Tài sản phải trả',
  Cargo_SelectAp2: 'Vui lòng chọn yêu cầu thanh toán phù hợp',
  Cargo_SelectAp: 'Vui lòng chọn thanh toán',
  Cargo_LookAp: 'Xem thanh toán',
  Cargo_IdentifyTheCustomsTips: 'Có một tập tin đang được phân tích hoặc đã được phân tích.',
  Cargo_IdentifyTheCustomsDeclaration: 'Xác định tờ khai hải quan',
  Cargo_RefreshCustomsDeclaration: 'Làm mới tờ khai hải quan',
  Cargo_ContactMultiple: 'Một hợp đồng bao gồm nhiều thỏa thuận hợp đồng',
  Cargo_CustomsActivatedTip: 'Không mở chức năng dịch vụ nhận dạng hải quan',
  Cargo_CustomsActivatedTip2: 'Số dư không đủ, vui lòng liên hệ',
  Cargo_CustomsDeclarationNo: 'Số tờ khai hải quan',
  Cargo_AnalysisStatus: 'Trạng thái phân tích',
  Cargo_SystemFee: 'Phí hệ thống',
  Cargo_InsurancePremium: 'Phí bảo mật',
  Cargo_ProcessingFee: 'Phí chế biến',
  Cargo_FOBValue: 'Giá trị FOB',
  Cargo_ExportCustomsDeclaration: 'Xuất tờ khai hải quan',
  Cargo_Nonstop: 'Xem trực tiếp',
  Cargo_InternationalRoute: 'Xem đường dây quốc tế',
  Cargo_SelectNoDeleteAp: '【Thanh toán】 Đã đẩy, không thể xóa',
  Cargo_SelectInvoiceAR: 'Vui lòng chọn Hóa đơn phải thu',
  Cargo_SelectInvoiceAR2: 'Vui lòng chọn dữ liệu đã được đẩy để lấy trạng thái.',
  Cargo_SelectNoPushData: 'Vui lòng chọn dữ liệu chưa được đẩy',
  Cargo_SelectNoDelete: '【Danh sách tạm thời】 Đã đẩy, không thể xóa',
  Cargo_SendSharedCenter: 'Gửi trạng thái Trung tâm chia sẻ',
  Cargo_SelectInvoiceType: 'Vui lòng chọn loại hóa đơn',
  Cargo_EditAp: 'Chỉnh sửa thanh toán',
  Cargo_NotPushAP: 'Thu nhập, không cần đẩy 【Tài chính phải trả】',
  Cargo_NotPushAP2: 'Số dòng/SWIFT rỗng, không thể gửi',
  Cargo_AttachmentName: 'Tên tập tin đính kèm',
  Cargo_AccessoriesAddress: 'Địa chỉ phụ kiện',
  Cargo_canNotEdit: 'Đã đẩy, không thể chỉnh sửa',
  Cargo_GetTheWriteOffResult: 'Nhận kết quả nuclear marketing',
  Cargo_RemarkTip1: 'Ghi chú hóa đơn Tổng số từ hơn 230 ký tự',
  Cargo_RemarkTip2: 'Khi mở vé, cần phải mở vé ngẩng đầu, điền tên dự án.',
  Cargo_PortOfTransferCheck: 'Chọn "Transit port"',
  Cargo_BatchServiceLocking: 'Khối lượng kinh doanh Lockout',
  Cargo_UnlockServicesInBatches: 'Mở khóa hàng loạt doanh nghiệp',
  Cargo_SetAMarginAlert2: 'Đặt nhắc nhở',
  Cargo_SetAMarginAlert: 'Đặt nhắc nhở phụ cấp',
  Cargo_ApplicableBranch: 'Chi nhánh áp dụng',
  Cargo_AdditionalRemark: 'Hướng dẫn bổ sung',
  Cargo_FixedLastNumber: 'Số đuôi cố định 00',
  Cargo_GenerativeRule: 'Quy tắc tạo',
  Cargo_StartNumber: 'Số đơn bắt đầu',
  Cargo_EndNumber: 'Kết thúc số đơn',
  Cargo_MarginTip1: 'Số dư công ty không đủ nhắc nhở',
  Cargo_MarginTip2: 'Thiếu người nhắc nhở',
  Cargo_MarginTip3: 'Nếu bạn cần nhắc nhở, hãy nhập một số dư lượng không đủ vào trường tương ứng.',
  Cargo_useTip: 'Số đơn phải chưa được sử dụng',
  Cargo_useTip2: 'Số đơn đã hết hạn Không thể gán',
  Cargo_DeleteTip: 'Chỉ có thể xóa các số đơn đã bị hủy bỏ',
  Cargo_PrefixTip: 'Tiền tố số đơn chính không chính xác',
  Cargo_StarTip: 'Số bắt đầu, số kết thúc không phù hợp với quy tắc',
  Cargo_StarNoTip: 'Số khởi đầu bất thường',
  Cargo_MarginTip4: 'Vui lòng điền người dùng',
  Cargo_NumberErrTip: '* Không đủ số đơn vị',
  Cargo_NumberErrTip2: 'Số đơn không phù hợp với quy tắc tạo',
  Cargo_AlreadyExistTip: 'Nhập không thành công, số đơn đã nhập đã tồn tại.< br/>{0}',
  Cargo_ImportStarTip: 'Nhập khẩu không thành công, nhập khẩu tiền tố số đơn không chính xác.< br/>{0}',
  Cargo_ImportNoTip: 'Nhập khẩu không thành công, nhập khẩu ngoại lệ số đơn.< br/>{0}',
  Cargo_EmptyNoTip: 'Tệp Excel đã nhập không có số MBL',
  Cargo_CarrierCheck: 'Vui lòng nhập vào công ty tàu.',
  Cargo_NumberMarginUse: 'Phụ cấp đơn vị người dùng hiện tại thấp hơn {0}',
  Cargo_NumberMarginCompany: 'Công ty hiện tại phụ cấp số đơn dưới {0}',
  Cargo_receiveTip: 'Số đơn bạn nhập đã được nhận, xin vui lòng xác nhận có tiếp tục không?',
  Cargo_receiveTip2: 'Số đơn chính không phù hợp với dữ liệu được duy trì bởi "Quản lý đơn chính", bạn có chắc chắn muốn tiếp tục sử dụng số đơn đó không?',
  Cargo_EstimatedDeliveryDate: 'Thời gian giao hàng dự kiến',
  Cargo_CheckWarehouseInConfig: 'Vui lòng chọn kho',
  Cargo_SelectScales: 'Vui lòng chọn Weighbridge',
  Cargo_PleaseEnterPieceCount: 'Vui lòng nhập số lượng',
  Cargo_PleaseConfirm: 'Vui lòng xác nhận số dòng chảy/số giao hàng',
  Cargo_WarehouseInState: 'Tình trạng nhập kho nghiệp vụ',
  Cargo_LocationConfigurationError: 'Pallet không thể lặp lại hoặc đã bị chiếm đóng, vui lòng kiểm tra',
  Cargo_KeyNull: 'AppKey chưa được cấu hình',
  Cargo_TokenNull: 'Token được rỗng',
  Cargo_CameraNull: 'Cấu hình máy ảnh sai',
  Cargo_Reading: 'Đọc',
  Cargo_ReadingTip: 'Nhiều kích cỡ sử dụng dấu phẩy\',\'hoặc dấu chấm phẩy\';\'Định dạng phân tách n: L * W * H/số lượng phần; L × W × H/số mảnh n Ví dụ: 35 * 40 * 30/3; 35×40×30/3;',
  Cargo_ReadingTip2: 'Vui lòng chỉ định cấu hình cân trong kho',
  Cargo_CargoTerminalGrossWeight: 'Tổng trọng lượng trạm (KG)',
  Cargo_FileUpload: 'Tải tệp ĐK',
  Cargo_inputMblTip: 'Vui lòng quét/nhập số đơn vị chính',
  Cargo_OutboundWeight2: 'Hoạt động xả',
  Cargo_FileInfo: 'Thông tin đính kèm',
  Cargo_DeliveryOperation: 'Hoạt động giao hàng',
  Cargo_MasterAirwayBill: 'Số vận đơn chính',
  Cargo_DeliveryCargoStation: 'Trạm giao hàng',
  Cargo_SplitOrderNumber: 'Số điểm',
  Cargo_TotalPieces: 'Tổng số mảnh',
  Cargo_TotalGrossWeight: 'Tổng trọng lượng',
  Cargo_TotalChargeableWeight: 'Tổng trọng lượng',
  Cargo_TotalVolume: 'Tổng khối lượng',
  Cargo_PrintCheck1: 'Phạm vi in hoặc số lượng bản sao không chính xác, vui lòng kiểm tra',
  Cargo_PrintRange: 'Phạm vi in',
  Cargo_PrintNumber: 'Số bản in',
  Cargo_GrossWeight3: 'Trọng lượng đối trọng',
  Cargo_DimensionsEntry: 'Nhập kích thước',
  Cargo_WarehouseTip3: 'Hủy lệnh xuất kho hoàn tất',
  Cargo_WarehouseTip2: 'Lệnh xuất kho hoàn thành',
  Cargo_WarehouseTip1: 'Chưa hoàn thành giao hàng, vui lòng kiểm tra',
  Cargo_CancelOutboundOrder: 'Hủy lệnh Exit',
  Cargo_OutboundOrder: 'Lệnh xuất kho',
  Cargo_GoodsArrived: 'Hàng đã đến đông đủ.',
  Cargo_Pallet3: 'Trang chủ',
  Cargo_WeightedInfo: 'Thông tin cân nặng',
  Cargo_ScaleReading: 'Đọc Weighbridge',
  Cargo_ScalePhoto: 'Weighbridge hình ảnh',
  Cargo_Tip: 'Gợi ý: Hỗ trợ số dòng chảy vào kho/số đơn gửi kho',
  Cargo_ReadScale: 'Đọc Pound',
  Cargo_TakePhoto: 'Chụp ảnh',
  Cargo_Weighing: 'Cân nặng Pound',
  Cargo_WeightRecord: 'Bảng ghi',
  Cargo_WeightHandling: 'Xử lý trọng lượng Pound',
  Cargo_SaveDone: 'Lưu trữ và nhập kho hoàn thành',
  Cargo_DeliverySecurityCheck: 'Giao hàng',
  Cargo_OutboundWeight: 'Tải trọng',
  Cargo_NetGrossWeight: 'Tổng trọng lượng ròng',
  Cargo_VolumeWeight: 'Trọng lượng khối lượng',
  Cargo_BatchEnterDimensions: 'Kích thước nhập hàng loạt',
  Cargo_CoveringSizeAndQuantity: 'Lưu ý: Sẽ ghi đè toàn bộ thông tin kích thước và số lượng hiện có',
  Cargo_Recognition: 'Nhận dạng',
  Cargo_EstimatedDeliveryDateError: 'Xác định lỗi',
  Cargo_ScaleWeight: 'Cân nặng',
  Cargo_OurPallet: 'Khay của tôi',
  Cargo_TareWeight: 'Trọng lượng bì',
  Cargo_GrossWeight2: 'Đối trọng',
  Cargo_Location2: 'Thư viện Bit',
  Cargo_FrontEndWarehouseOperation: 'Hoạt động vị trí trước',
  Cargo_CargoTerminalOperation: 'Vận hành kho hàng',
  Cargo_FileSizeCannotExceed20m2: 'Kích thước tập tin không được vượt quá 20M, hỗ trợ định dạng.xls và.xlsx',
  Cargo_StateUpdate: 'Cập nhật trạng thái',
  Cargo_CheckInventory: 'Kiểm tra hàng tồn kho',
  Cargo_ReleaseLocation: 'Giải phóng bit thư viện',
  Cargo_LocationCode: 'Mã hóa bit thư viện',
  Cargo_Warehouse2: 'Kho thuộc sở hữu',
  Cargo_LocationType: 'Kiểu Library Bit',
  Cargo_LocationStatus: 'Trạng thái bit thư viện',
  Cargo_LocationDeleteTip: 'Thư viện bị chiếm dụng và không thể xóa',
  Cargo_ReadFailure: 'Lỗi đọc',
  Cargo_PalletDeleteTip: 'Khay hiện tại đã được sử dụng và không thể xóa',
  Cargo_NoLocationSelected: 'Không có bit thư viện được chọn',
  Cargo_PackingCondition: 'Tình hình đóng gói',
  Cargo_SpecialHandling: 'Điều trị đặc biệt',
  Cargo_PalletNumber: 'Ban giấy số',
  Cargo_InventoryCheck: 'Xem hàng tồn kho',
  Cargo_ApplyRuleToAllScenarios: 'Áp dụng cài đặt quy tắc cho toàn bộ kịch bản',
  Cargo_DocumentsWithCargo: 'Tài liệu đính kèm hàng hóa',
  Cargo_CurrentBusinessAlreadyWeighedOut: 'Hoạt động hiện tại đã được cân xuất, không được phép thao tác lặp lại.',
  Cargo_CurrentBusinessAlreadyDelivered: 'Hoạt động hiện tại đã được giao hàng, không được phép thao tác lặp lại.',
  Cargo_PalletConfiguration: 'Quản lý pallet',
  Cargo_Pallet2: 'Khay',
  Cargo_PalletID: 'Số pallet',
  Cargo_PalletStatus: 'Trạng thái pallet',
  Cargo_PalletMaterial: 'Chất liệu pallet',
  Cargo_RecyclingType: 'Loại Recycle',
  Cargo_PalletTareWeight: 'Trọng lượng pallet',
  Cargo_AirCargoTerminal: 'Cảng hàng không',
  Cargo_WarehouseType: 'Loại kho',
  Cargo_WarehouseCode2: 'Mã kho',
  Cargo_WarehouseName: 'Tên kho',
  Cargo_WarehouseAddress: 'Địa chỉ kho',
  Cargo_Terminal: 'Trạm hàng hóa',
  Cargo_TerminalCode: 'Mã kho hàng',
  Cargo_TerminalName: 'Name',
  Cargo_AirportCode: 'Mã sân bay',
  Cargo_TerminalAddress: 'Địa chỉ kho hàng',
  Cargo_DeliveryMap: 'Bản đồ giao hàng',
  Cargo_RecipientContact: 'Liên hệ nhận hàng',
  Cargo_RecipientContactPhone: 'Số điện thoại nhận hàng',
  Cargo_SecurityCheckMachineWidthLimit: 'Giới hạn chiều rộng của máy kiểm tra an ninh',
  Cargo_SecurityCheckMachineHeightLimit: 'Giới hạn an ninh cao',
  Cargo_CustomsCode: 'Mã hải quan',
  Cargo_WeighbridgeNumber: 'Số cân nặng',
  Cargo_WeighbridgeBaudRate: 'Tỷ lệ baud Weighbridge',
  Cargo_Checksum: 'Kiểm tra bit',
  Cargo_AutoFinanceAuditLockOrder: 'Khóa đơn tự động khi kiểm toán tài chính',
  Cargo_UnSubmittedBusinessLockOrder: 'Các nghiệp vụ chưa gửi sẽ tự động thực hiện khóa đơn (Trạng thái nghiệp vụ: Đang thực hiện -> Đã kiểm toán)',
  Cargo_PollingFrequency: 'Tần suất kiểm tra định kỳ',
  Cargo_SpecificDateMonthly: 'Ngày chỉ định hàng tháng',
  Cargo_DailyOnce: 'Một lần mỗi ngày',
  Cargo_PhotoTaken: 'Chụp ảnh hay không',
  Cargo_CameraConfiguration: 'Cấu hình máy ảnh',
  Cargo_WeighbridgeTest: 'Kiểm tra cân nặng',
  Cargo_Test: 'Thử nghiệm',
  Cargo_MonitoringInterface: 'Giao diện giám sát',
  Cargo_DeviceNumber: 'Số thiết bị',
  Cargo_MonitoringChannel: 'Kênh giám sát',
  Cargo_MonitoringInterface1: 'Mây huỳnh thạch',
  Cargo_DeleteTip1: 'Bạn sẽ xóa 【{0}】 các {1} thông tin, vui lòng thực hiện cẩn thận',
  Cargo_GeneralCargoWarehouse: 'Kho hàng phổ biến',
  Cargo_WarehouseStorageLocation: 'Kho chứa Bit',
  Cargo_WoodenPackagingType: 'Loại bao bì bằng gỗ',
  Cargo_ClearSave: 'Xóa và lưu',
  Cargo_OrderModificationTimes: 'Thay đổi số lần',
  Cargo_ServiceStatisticalArea: 'Khu vực thống kê doanh nghiệp',
  Cargo_DangerousGoodPackage: 'Đóng gói hàng nguy hiểm',
  Cargo_DangerousGoodPackageCode: 'Mã đóng gói hàng nguy hiểm',
  Cargo_OOGTEU: 'Số lượng OOG TEU',
  Cargo_SeaRailTransport: 'Vận chuyển đường sắt biển',
  Cargo_BoxOneWay: 'Với hộp (một chiều/chu kỳ)',
  Cargo_OOGTEUTip: 'Vui lòng điền số lượng OOG TEU',
  Cargo_OneWay: 'Một chiều',
  Cargo_Circulation: 'Vòng lặp',
  Cargo_Grade: 'Loại hình kinh doanh tùy chỉnh cấp 2',
  Cargo_Grade2: 'Loại hình kinh doanh tùy chỉnh cao hơn',
  Cargo_LotteryDraw: 'Vé mở',
  Cargo_SchoolMonth: 'Tháng mở',
  Cargo_WithdrawTheEntrustment: 'Hủy bỏ delegate',
  Cargo_checkData1: 'Không tìm thấy dữ liệu ủy quyền hoặc đã được kiểm toán',
  Cargo_ContractTip: 'Nếu cần điều chỉnh hợp đồng thì phải hủy hợp đồng trước.',
  Cargo_DetailMakeInvoice: 'Chi tiết hóa đơn',
  Cargo_SplitMakeInvoice: 'Chia đơn vị tiền tệ',
  Cargo_RemarkAddContent: 'Ghi chú bổ sung',
  Cargo_RemarkAddContent3: 'Ghi chú thanh toán Nội dung tỷ giá hối đoái',
  Cargo_SaveAndConfirm: 'Lưu và xác nhận',
  Cargo_ExportUndoHistory: 'Xuất lịch sử thu hồi',
  Cargo_RevocationBy: 'Người hủy bỏ',
  Cargo_RevocationByDate: 'Thời gian hủy bỏ',
  Cargo_billingTip: 'Lập hóa đơn theo yêu cầu thanh toán',
  Cargo_remarkAddContent2: 'Thêm nội dung ghi chú',
  Cargo_detailMakeInvoice2: 'Chi tiết hóa đơn',
  Cargo_splitMakeInvoice2: 'Chia đơn vị tiền tệ',
  Cargo_rmbGoodsName: 'CNY hóa đơn',
  Cargo_usdGoodsName: 'Hóa đơn USD',
  Cargo_CarrierCode: 'Mã tàu EDI',
  Cargo_identifyTheResult: 'Xác định kết quả',
  Cargo_identifyTheResult2: 'Xác định thông tin vận đơn',
  Cargo_SystemResult: 'Thông tin vận đơn hệ thống',
  Cargo_ContrastingSystem: 'Hệ thống tương phản',
  Cargo_SaveBillData: 'Lưu thông tin vận đơn hệ thống',
  Cargo_SaveBill2: 'Xác định lớp phủ thông tin và lưu B/L',
  Cargo_InAnalysis: 'Đang phân tích, xin chờ một chút.',
  Cargo_UnopenedService: 'Không mở dịch vụ, không sử dụng được',
  Cargo_F17Verify: 'Khi gửi F17 phải đảm bảo số vận đơn chính và số vận đơn phụ trùng nhau',
  Cargo_Will: 'Sẽ',
  Cargo_DFI: 'Kéo đến đây để nhận dạng, hoặc',
  Cargo_seaFile: 'Hồ sơ ủy thác biển',
  Cargo_siFile: 'Hồ sơ vận đơn của Hải Tiến',
  Cargo_seBillFile: 'Tài liệu B/L từ Sea Out',
  Cargo_GenerateSiBusiness: 'Tạo doanh nghiệp nhập khẩu đường biển',
  Cargo_MaritimeIdentification: 'Nhận dạng biển',
  Cargo_ApplicationIdentificationType: 'Loại nhận dạng ứng dụng',
  Cargo_IdentificationType: 'Loại nhận dạng',
  Cargo_IdentificationChannel: 'Xác định kênh',
  Cargo_OriginalMessage: 'Bản tin gốc',
  Cargo_DataSource: 'Nguồn dữ liệu',
  Cargo_InvoiceExport: 'Xuất hóa đơn',
  Cargo_InvoiceNoImport: 'Nhập số hóa đơn',
  Cargo_profitMargin: 'Biên lợi nhuận',
  Cargo_Payment1: 'Thanh toán',
  Cargo_PaymentCode: 'Mã bên thanh toán',
  Cargo_PaymentName1: 'Tên liên hệ của bên thanh toán',
  Cargo_PaymentName: 'Tên bên thanh toán',
  Cargo_SelectPayment: 'Chọn bên thanh toán',
  Cargo_ShowTab: 'Hiển thị thẻ trang bổ sung',
  Cargo_MscBookingInfo: 'Thông tin đặt phòng MSC',
  Cargo_PaymentInfo: 'Thông tin bên thanh toán',
  Cargo_PaymentInfo1: 'Định dạng bên thanh toán',
  Cargo_PaymentEnterpriseCode: 'Mã doanh nghiệp bên thanh toán',
  Cargo_Payment2: 'Tên doanh nghiệp của bên thanh toán',
  Cargo_Payment3: 'Chi tiết địa chỉ của bên thanh toán',
  Cargo_Payment4: 'Số điện thoại bên thanh toán',
  Cargo_Payment5: 'Địa chỉ email của bên thanh toán',
  Cargo_Payment6: 'Số Telex của bên thanh toán',
  Cargo_Province1: 'Tỉnh/Bang',
  Cargo_GeneralFormat: 'Định dạng chung',
  Cargo_DetailFormat: 'ĐD Chi tiết',
  Cargo_BringInData: 'Nhập dữ liệu',
  Cargo_DefaultInvoiceIssuer: 'Người xuất hóa đơn mặc định',
  Cargo_checkCabinTip: 'Dữ liệu về dòng chảy khoang và dòng chảy không khoang không thể hoạt động cùng nhau',
  Cargo_checkCabinTip2: 'Lệnh bạn đã đánh dấu sẽ thực hiện quy trình thu hồi cabin',
  Cargo_RecoverText: 'Có xác nhận không?',
  Cargo_RecoverRemark: 'Description',
  Cargo_RecoverTips: 'PH & TL Cabin',
  Cargo_LinesArAp: 'Số dòng phải thu/Số dòng phải trả',
  Cargo_RInPay: 'Phải thu bao gồm phải trả',
  Cargo_market: 'Bán hàng',
  Cargo_GPExplain: 'Mô tả GP',
  Cargo_ServiceLockSetting1: 'Cài đặt khóa kinh doanh tự động',
  Cargo_ServiceLockSettings: 'Cài đặt khóa doanh nghiệp',
  Cargo_LockTheNumberOfDeferredDays: 'Thời gian trễ khóa từ 3-120 ngày',
  Cargo_checkBillingGroup: '【{0}】 Trạng thái thanh toán không phải là"{1}"',
  Cargo_AutoLock: 'Khóa tự động',
  Cargo_BusinessDate1: 'Sau ngày kinh doanh',
  Cargo_Days1: '(Ngày)',
  Cargo_SendBookingFail: 'Gửi đơn đặt hàng thất bại',
  Cargo_OrderTemplateSaveSuccess: 'Cấu hình mẫu đơn đặt hàng đã lưu thành công',
  Cargo_ContinueSave: 'Tên tiêu đề mẫu không được cấu hình sẽ sử dụng tên trường nghiệp vụ thực tế, bạn có muốn tiếp tục không?',
  Cargo_OrderTemplateSaveFail: 'Lưu cấu hình mẫu đơn hàng không thành công',
  Cargo_DownImportTemplate: 'Tải xuống mẫu nhập khẩu',
  Cargo_DownImportTemplate_Simple: 'Tải xuống Nhập mẫu đơn',
  Cargo_DownImport_Simport: 'Nhập đơn',
  Cargo_ImportingData: 'Nhập dữ liệu...',
  Cargo_ImportingDataSuccess: 'Hành động này là không đồng bộ và bạn có thể xem kết quả nhập khẩu tại File Storage ->Upload Log',
  Cargo_WriteOffHeader: 'Tiêu đề xóa sổ',
  Cargo_PackageNo: 'Số gói:',
  Cargo_DeletePackage: 'Xóa gói',
  Cargo_WareHoused: 'Những gói hàng này đã được đưa vào kho.',
  Cargo_NotWareHoused: 'Những gói hàng này không có trong kho.',
  Cargo_CheckPackage: 'Có xác định xóa các gói tương ứng không? Nếu xác định, dữ liệu thực tế vào kho cũng sẽ bị xóa.',
  Cargo_SureDeletePackageIn: 'Những bao bì này đã vào kho, có xác định xóa bỏ bao bì tương ứng không? Nếu xác định, dữ liệu thực tế vào kho cũng sẽ bị xóa.',
  Cargo_SelectPackage: 'Vui lòng chọn dữ liệu gói cần xóa',
  Cargo_SureDeleteAbovePackage: 'Bạn có xác nhận xóa các gói trên không?',
  Cargo_BalanceSheetQuarter: 'Báo cáo hàng quý của bảng cân đối kế toán',
  Cargo_ProfitLossQuarter: 'Báo cáo lợi nhuận hàng quý',
  Cargo_BalanceSheetYear: 'Báo cáo thường niên của bảng cân đối kế toán',
  Cargo_ProfitLossYear: 'Báo cáo lợi nhuận hàng năm',
  Cargo_ReasonForJudgment: 'Nguyên nhân trách nhiệm',
  Cargo_CheckSavePoInfoItem: 'Sản phẩm này đã được liên kết với bao bì, xin vui lòng hủy liên kết trước!',
  Cargo_HasBillingGroup: 'Danh sách này đã được tạo báo cáo và không thể được chỉnh sửa!',
  Cargo_HasInvoice: 'Hóa đơn này đã được kê đơn, không thể bị biên tập!',
  Cargo_HasWriteOff: 'Đơn hàng này đã được bán hạt nhân, không thể chỉnh sửa!',
  Cargo_HasConfirm: 'Danh sách này đã được xác nhận và không thể được chỉnh sửa!',
  Cargo_ContinueOperation: 'Tiếp tục hoạt động',
  Cargo_CancelOperation: 'Hủy hành động',
  Cargo_BackTopPreviousVersion: 'Quay lại phiên bản cũ',
  Cargo_Combine: 'Hợp nhất',
  Cargo_DataEnableSuccess: 'Kích hoạt dữ liệu thành công!',
  Cargo_DataDisEnableSuccess: 'Vô hiệu hóa dữ liệu thành công!',
  Cargo_CombineChargeItem: 'Dự án thu phí hợp nhất',
  Cargo_ConsolidatedChargeItem: 'Dự án thu phí được hợp nhất:',
  Cargo_ChargeItemHasUsedForCombine: '{0} đã bị vô hiệu hóa, vui lòng chọn mục có phí khác để hợp nhất!',
  Cargo_CombineChargeItemTips: 'Sau khi sáp nhập sẽ làm mới tất cả {1} chi phí liên quan đến {0} và thiết lập để vô hiệu hóa, bạn có tiếp tục không?',
  Cargo_CombineChargeItemTipsOne: 'Đang hợp nhất, xin chờ một chút.',
  Cargo_CombineChargeItemTipsTwo: 'Bạn có thể rời khỏi giao diện này và dự kiến sẽ hoàn thành việc sáp nhập trong 10 phút, vui lòng kiểm tra lại sau.',
  Cargo_CombineChargeItemTipsThree: 'Vui lòng chọn các khoản phí khác nhau để hợp nhất!',
  Cargo_PayService: 'Dự án thu phí:',
  InvoiceTitleCannotBeBlank: 'Hóa đơn không được để trống',
  InvoiceTitleCannotBeDuplicate: 'Hóa đơn không lặp lại',
  TaxControlPanelCannotBeDuplicate: 'Một bảng điều khiển thuế 【{0}】 không được phép liên kết với nhiều đầu phiếu',
  CheckTaxControlPanelNo: '【{0}】 Duy trì nhiều số kiểm soát thuế, bạn có tiếp tục không?',
  TaxControlPanelNoHasInvoiceTitle: 'Thông tin kiểm soát thuế đã liên kết, không thể xóa bỏ, xin hủy bỏ liên kết trước!',
  ChinaAdditionalTaxRateIsEmpty: '【Trung Quốc tăng thuế suất】 Trường trống, xác nhận bạn có tiếp tục lưu không?',
  SpecialCharactersExcept: 'Sự hiện diện của các ký tự đặc biệt khác ngoài tiếng Anh, số, dấu câu',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: 'Doanh nghiệp vé này đã gửi bản kê khai trước. Import thất bại.',
  EstimatedDeliveryDate: 'Ngày giao hàng dự kiến',
  ActualDeliveryDate: 'Ngày giao hàng thực tế',
  LatestDeliveryDate: 'Ngày giao hàng muộn nhất',
  DischargingWay: 'Cách dỡ hàng',
  Cargo_DownloadSource: 'Tải xuống dữ liệu',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: 'Chỉ có thể là chữ hoa và số',
  Cargo_numbersNotLetters: 'Số, không bao gồm chữ cái',
  Cargo_pleaseSelectShippingTerms: 'Vui lòng chọn điều khoản vận chuyển',
  Cargo_pleaseSelectTheTypeOfGoods: 'Vui lòng chọn loại hàng hóa',
  Cargo_pleaseSelectTheBillOfLadingMethod: 'Vui lòng chọn phương thức vận đơn',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: 'Vui lòng nhập tên đầy đủ bằng tiếng Anh',
  Cargo_PortOfDischargeTipText: 'Trung chuyển điền cảng trung chuyển, trực tiếp điền cảng đích',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: 'Chỉ có thể là chữ cái, số, dấu cách.',
  Cargo_PortPreRateCode: 'Mã giá trước cảng',
  Cargo_SideLineType: 'Loại tuyến phụ',
  Cargo_EndRouteRateCode: 'Mã giá tuyến cuối',
  Cargo_DeliveryAddressType: 'Loại địa chỉ giao hàng',
  Cargo_DirectHaul: 'Vận chuyển trực tiếp',
  Cargo_SideLine: 'Tuyến phụ',
  Cargo_HuzhouSeaRail: 'Vận tải biển-đường sắt Huzhou',
  Cargo_HaiNingBranch: 'Chi nhánh Hải Ninh',
  Cargo_ZhapuSideLine: 'Tuyến phụ Cháp Phố',
  Cargo_OriginPortInfo: 'Thông tin cảng xuất phát',
  Cargo_ChargeByContainerType: 'Mục phí theo loại container',
  Cargo_ChargeNotByContainerType: 'Mục phí không theo loại container',
  Cargo_SpecialRemark: 'Ghi chú đặc biệt',
  Cargo_AddEntry: 'Thêm mục',
  Cargo_FreeUseContainer: 'Container miễn phí sử dụng',
  Cargo_FreeStorage: 'Lưu trữ miễn phí',
  Cargo_ThirdPartyAddress: 'Địa chỉ bên thứ ba',
  Cargo_AmazonWarehouse: 'Kho Amazon',
  Cargo_WalmartWarehouse: 'Kho Walmart',
  Cargo_YiCang: 'Kho YiCang',
  Cargo_DestinationPortInfo: 'Thông tin cảng đến',
  Cargo_Shelving: 'Lên kệ',
  Cargo_PleaseSelectNonNormalRateForShelving: 'Vui lòng chọn giá cước không phải trạng thái "bình thường" để lên kệ.',
  Cargo_PleaseSelectValidRateForShelving: 'Vui lòng chọn giá cước có hiệu lực để lên kệ.',
  Cargo_PleaseSelectNormalRateForUnShelving: 'Vui lòng chọn giá cước trạng thái "bình thường" để hạ kệ.',
  Cargo_SeaFreightFullContainer: 'Vận chuyển biển đầy container',
  Cargo_SeaFreightLessThanContainer: 'Vận chuyển biển ít hơn container',
  Cargo_EnquiryNumber: 'Số yêu cầu báo giá',
  Cargo_EnquirySource: 'Nguồn yêu cầu báo giá',
  Cargo_Enquirer: 'Người yêu cầu báo giá',
  Cargo_EnquiryStatus: 'Trạng thái yêu cầu báo giá',
  Cargo_FirstLegQuoteStatus: 'Trạng thái báo giá trước cảng',
  Cargo_MainlineQuoteStatus: 'Trạng thái báo giá tuyến chính',
  Cargo_LastLegQuoteStatus: 'Trạng thái báo giá giai đoạn cuối',
  Cargo_PalletType: 'Loại pallet',
  Cargo_DirectOrTransshipment: 'Thẳng/Chuyển tiếp',
  Cargo_Range: 'Khoảng',
  Cargo_Dimensions: 'Chiều dài, Chiều rộng, Chiều cao',
  Cargo_Terms: 'Điều khoản dịch vụ',
  Cargo_DeliveryAddress: 'Địa chỉ giao hàng',
  Cargo_NameHSCode: 'Tên sản phẩm (HS Code)',
  Cargo_MainlineRate: 'Tỷ lệ vận chuyển tuyến chính',
  Cargo_PrePortRate: 'Tỷ lệ vận chuyển trước cảng',
  Cargo_EndRouteRate: 'Tỷ lệ vận chuyển cuối tuyến',
  Cargo_RateCode: 'Mã tỷ lệ vận chuyển',
  Cargo_MatchQuote: 'Báo giá phù hợp',
  Cargo_Select_Inquiry_Responsible: 'Chọn người chịu trách nhiệm báo giá',
  Cargo_Multiple_Route_Leaders: 'Tìm thấy nhiều người phụ trách tuyến đường. Vui lòng chọn người cần khởi tạo yêu cầu báo giá:',
  Cargo_Pre_Port_Rate_Leader: 'Người phụ trách giá cước trước cảng',
  Cargo_Mainline_Rate_Leader: 'Người phụ trách giá cước tuyến chính',
  Cargo_End_Route_Rate_Leader: 'Người phụ trách giá cước cuối tuyến',
  Cargo_NoMatchFound: 'Không tìm thấy sự khớp [{0}]',
  Cargo_CombinationPlanQuery: 'Tra cứu kế hoạch kết hợp',
  Cargo_FillQueryConditions: 'Điền điều kiện truy vấn',
  Cargo_SelectMatchingRate: 'Chọn mức giá phù hợp',
  Cargo_GenerateCombinationPlan: 'Tạo kế hoạch kết hợp',
  Cargo_ReturnToPreviousStep: 'Quay lại bước trước',
  Cargo_PrePortPrice: 'Giá trước cảng',
  Cargo_MainlinePrice: 'Giá tuyến chính',
  Cargo_LastMilePrice: 'Giá chặng cuối',
  Cargo_AssociatedPrePortQuoteNumber: 'Số báo giá trước cảng liên quan',
  Cargo_AssociatedLastMileQuoteNumber: 'Số báo giá chặng cuối liên quan',
  Cargo_20GPQuantity: 'Số lượng 20GP',
  Cargo_40GPQuantity: 'Số lượng 40GP',
  Cargo_40HCQuantity: 'Số lượng 40HC',
  Cargo_45HCQuantity: 'Số lượng 45HC',
  Cargo_20NORQuantity: 'Số lượng 20NOR',
  Cargo_40NORQuantity: 'Số lượng 40NOR',
  Cargo_20FootNORQuantity: 'Số lượng 20\' NOR',
  Cargo_40FootNORQuantity: 'Số lượng 40\' NOR',
  Cargo_SubmitQuotation: 'Gửi báo giá',
  Cargo_WithdrawQuotation: 'Rút lại báo giá',
  Cargo_RejectQuotation: 'Từ chối báo giá',
  Cargo_InquiryManagement: 'Quản lý yêu cầu báo giá hàng hóa',
  Cargo_PrePort: 'Tiền cảng',
  Cargo_FinalMile: 'Chặng cuối',
  Cargo_OriginAreaSelection: 'Chọn khu vực xuất phát',
  Cargo_ShippingAddressSelection: 'Chọn địa chỉ giao hàng',
  Cargo_AddArea: '+Thêm khu vực',
  Cargo_AddAddress: '+Thêm địa chỉ',
  Cargo_AddressDisabledTip: 'Có thể thêm nhiều khu vực. Khi chọn 2 khu phố/thị trấn trở lên, địa chỉ chi tiết sẽ bị vô hiệu hóa.',
  Cargo_PleaseMaintainAtLeastOne: 'Vui lòng duy trì ít nhất một cái.',
  Cargo_CannotMatchPleaseFill: '{0} không thể khớp, vui lòng điền vào [{1}].',
  Cargo_Match: 'Khớp',
  Cargo_QuoteStatusNotAllowedSave: 'Không thể lưu trong trạng thái đã báo giá',
  Cargo_SaveDraft: 'Lưu bản nháp',
  Cargo_PublishDirectly: 'Đăng ngay',
  Cargo_SelectPendingQuoteSubmittedCancel: 'Vui lòng chọn đơn hỏi giá đang chờ và đã gửi để hủy',
  Cargo_LastMileDeliveryAddress: 'Địa chỉ giao hàng chặng cuối',
  Cargo_PackingDoorPoint: 'Điểm cửa đóng gói',
  Cargo_BoxTypeNotAllowedDuplicate: 'Loại hộp không được phép trùng lặp',
  Cargo_PrePortBusinessLeader: 'Trưởng bộ phận kinh doanh trước cảng',
  Cargo_MainlineBusinessLeader: 'Trưởng bộ phận kinh doanh tuyến chính',
  Cargo_LastMileBusinessLeader: 'Trưởng bộ phận kinh doanh chặng cuối',
  Cargo_OverseaTracker: 'Người phụ trách theo dõi nước ngoài',
  Cargo_EndCommerceSynced: 'Đã đồng bộ',
  Cargo_EndCommerceAudited: 'Đã duyệt',
  Cargo_EndCommerceNotSynced: 'Chưa đồng bộ',
  Cargo_EndCommercePleaseSelectAtLeastOne: 'Vui lòng chọn ít nhất một bản ghi',
  Cargo_EndCommerceOnlySelectOne: 'Chỉ có thể chọn một bản ghi cho thao tác này',
  Cargo_EndCommerceRecordNotAllowEdit: 'Bản ghi hiện tại không được phép chỉnh sửa',
  CargoMsg_CurrentIdentityNotice: 'Danh tính hiện tại của bạn sẽ liên kết với các quyền truy cập sau. Nếu bạn muốn gửi yêu cầu với vai trò khác, vui lòng chuyển đổi chi nhánh và phòng ban ở góc trên bên phải của giao diện trước.',

  Cargo_enterTheVoyageThereCanBeNoV: 'Không thể có V.',
  Cargo_inputVoyage: 'Vui lòng nhập chuyến bay',
  Cargo_pleaseSelectAShippingGeneration: 'Vui lòng chọn Shipman',
  Cargo_pleaseSelectAShippingCompany: 'Vui lòng chọn công ty tàu',
  Cargo_pleaseEnterAnAddressWithin140Characters: 'Vui lòng nhập địa chỉ trong vòng 140 ký tự',
  Cargo_pleaseEnterTheEnterpriseCode: 'Vui lòng nhập mã doanh nghiệp, cần bao gồm "+"+"+trước và sau không được bao gồm khoảng trắng.',
  Cargo_pleaseEnterAPhoneNumber: 'Vui lòng nhập số điện thoại',
  Cargo_pleaseEnterANameWithin140Characters: 'Vui lòng nhập tên, trong vòng 140 ký tự',
  Cargo_pleaseEnterANameWithin140Characters2: 'Vui lòng nhập tên, trong vòng 70 ký tự',
  Cargo_pleaseSelectACountryCode: 'Vui lòng chọn mã quốc gia',
  Cargo_pleaseEnterTheActualContactName: 'Vui lòng nhập tên liên hệ thực tế',
  Cargo_ViewShipGenerations: 'Xem thế hệ tàu',
  Cargo_ReferenceShipGenerations: 'Giới thiệu về Shipage',
  Cargo_CopyShipInformation: 'Sao chép thông tin tàu',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: 'Xin vui lòng tư vấn cửa hàng hoặc dịch vụ khách hàng',
  UnverifiedAmountForCharge: 'Số tiền chưa bán (chi phí)',
  VerifiedAmountForCharge: 'Số tiền đã bán (chi phí)',
  ReceivableForCharge: 'Phải thu (phí)',
  PayableForCharge: 'Phải trả (chi phí)',
  Cargo_PrePlanBookingCheckSoNo: 'Số đóng cửa không được duy trì trong hoạt động kinh doanh của phiếu này tồn tại trong bản kê khai phân phối trước được gửi/chỉnh sửa. Tiếp tục không?',
  Cargo_SwitchToTheOldVersion: 'Chuyển sang phiên bản cũ hơn',
  Cargo_MaintainChargeItem: 'Vui lòng bảo trì chi phí trước!',
  Cargo_UsePeriodRate: 'Sử dụng Detail Rate',
  Cargo_initRatePeriod: 'Lịch sử khởi tạo Ngày hiệu lực của tỷ giá hối đoái',
  Cargo_MonthRate: 'Tỷ giá hàng tháng',
  Cargo_PartialImport: 'Nhập một phần',
  Cargo_CopyCustomerShippingInformation: 'Sao chép và nhận thông điệp',
  Cargo_NoPermissionForModule: 'Bạn không có quyền mở module!',
  Cargo_OcPayment: 'Truy vấn thông tin thu tiền dưới đường dây',
  Cargo_BatchProcess: 'Xử lý hàng loạt',
  Cargo_BatchCancelProcess: 'Hủy bỏ hàng loạt',
  Cargo_OcPaymentTime: 'Ngày thanh toán',
  Cargo_ErialNumber: 'Số dòng thanh toán ba bên',
  Cargo_OcErialNumber: 'Số dòng thanh toán OC',
  Cargo_BillingAccountId: 'Thanh toán hóa đơn Tên khách hàng',
  Cargo_BillingSettlementAgentId: 'Name',
  Cargo_Processed: 'Xử lý hay không',
  Cargo_Project: 'Tên dự án',
  Cargo_PaymentStatus: 'Trạng thái thanh toán',
  Cargo_UnlockPaymentTimeQuery: 'Nếu phạm vi ngày thanh toán được chọn lớn hơn 2 năm, nó có ảnh hưởng đến tốc độ tải dữ liệu và xác định truy vấn dữ liệu ngoài 2 năm không?',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: 'Chỉ có thể xử lý các bản ghi 【Chuyển tiền ngoại tuyến】 chưa được xử lý.',
  Cargo_ConfirmAndProcessSelectedRecord: 'Xác nhận bản ghi 【Chuyển tiền ngoại tuyến】 cho vùng chọn xử lý không?',
  Cargo_OnlyProcessedRecordsCanBeCancelled: 'Chỉ có thể hủy bỏ các bản ghi 【Chuyển tiền ngoại tuyến】 đã được xử lý.',
  Cargo_CancelProcessOfSelectedRecord: 'Xác nhận bản ghi 【Chuyển tiền ngoại tuyến】 cho vùng chọn hủy xử lý không?',
  Cargo_ProcessedSuccessfully: 'Đánh dấu đã xử lý',
  Cargo_CancelProcessSuccessfully: 'Đánh dấu là chưa xử lý',
  Cargo_LockedOrNot: 'Khóa hay không',
  Cargo_DeleteOCBillTips: 'Chỉ có thể xóa các hóa đơn không khóa!',
  Cargo_DeleteRecheckedBillTips: 'Chỉ có thể xóa hóa đơn chưa được kiểm tra!',
  Cargo_OCCanWriteOff: 'Chỉ có thể bán hóa đơn 【Chuyển tiền ngoại tuyến】 đã bị khóa!',
  Cargo_Adjustment: 'Điều chỉnh',
  Cargo_InChangeExpenseReview: 'Trong đánh giá chi phí thay đổi',
  Cargo_Verification: 'Pin hạt nhân',
  Cargo_BeWriteBack: 'bởi Red Rush',
  Cargo_InquiryAndQuotation: 'Yêu cầu báo giá & Báo giá',
  Cargo_AlertTodoCategoryList: 'Danh sách danh mục Cảnh báo & Việc cần làm',
  Cargo_ItemDescription: 'Mô tả hạng mục',
  Cargo_Alert: 'Cảnh báo',
  Cargo_Todo: 'Việc cần làm',
  Cargo_TodoAlert: 'Việc cần làm/Cảnh báo',
  Cargo_ChangeFeeApplicationProgress: 'Thay đổi tiến độ yêu cầu phí',
  Cargo_userDefinedRole1: 'Tùy chỉnh bài viết 1',
  Cargo_userDefinedRole2: 'Tùy chỉnh vị trí 2',
  Cargo_userDefinedRole3: 'Tùy chỉnh bài viết 3',
  Cargo_userDefinedRole4: 'Tùy chỉnh vị trí 4',
  Cargo_userDefinedRole5: 'Tùy chỉnh vị trí 5',
  Cargo_userDefinedRole6: 'Tùy chỉnh vị trí 6',
  Cargo_userDefinedRole7: 'Tùy chỉnh vị trí 7',
  Cargo_userDefinedRole8: 'Tùy chỉnh vị trí 8',
  Cargo_DisplaysTheRequestChangeFee: 'Hiển thị phí thay đổi ứng dụng',
  Cargo_UpdateVesselVoyageMsg: 'Bạn đã thay đổi tên tàu, {0} đã có giá trị, bạn có cần làm trống nó không?',
  Cargo_UpdateMblMsg: 'Bạn đã điều chỉnh số đơn hàng chính, dịch vụ theo dõi hàng hóa xuất khẩu bằng đường hàng không đã được thu thập, {0} Bạn có muốn làm trống các trường liên quan không?',
  Cargo_CheckUnitRate: 'Có đơn giá phí là 0, tiếp tục lưu sẽ tự động xóa phí với đơn giá là 0, bạn có tiếp tục lưu không?',
  Cargo_ZeroUnitPrice: 'Có khoản phí có đơn giá bằng 0, tiếp tục lưu hay xóa khoản phí có đơn giá bằng 0?',
  Cargo_ClearZeroFee: 'Xóa khoản phí có giá trị bằng 0',
  Cargo_NoFeesCanBeAdded: 'Không có phí nào để thêm',
  Cargo_ZeroUnitPriceEntry: 'Đơn giá nhập vào là 0, vui lòng xác nhận có muốn tiếp tục lưu không',
  Cargo_ZeroAmountWarning: 'Đơn giá hoặc số tiền đã được nhập là 0. Vui lòng xác nhận có muốn tiếp tục lưu không.',
  Cargo_Readjust: 'Điều chỉnh lại',
  Cargo_Validate_Insure: 'Chức năng bảo hiểm không được phép dưới trụ sở chính, vui lòng chuyển sang chi nhánh.',
  Cargo_ReceivingOperator: 'Người vận hành tiếp nhận',
  Cargo_ReceivingOperationTime: 'Thời gian hoạt động nhận',
  Cargo_ClaimOperator: 'Yêu cầu người vận hành',
  Cargo_ClaimOperationTime: 'Yêu cầu thời gian hoạt động',
  Cargo_OrderChangeOperator: 'Thay đổi người vận hành',
  Cargo_ChangeOrderOperationTime: 'Thay đổi thời gian hoạt động',
  Cargo_ContinueToReleaseDocuments: 'Xác nhận có tiếp tục đặt hàng không?',
  Cargo_ExpectedReturnDate: 'Ngày dự kiến trả lại',
  Cargo_OcPrePayment: 'Đánh dấu thu trước',
  Cargo_OcCancelPrePayment: 'Hủy thẻ pre-payment',
  Cargo_GetKingdeId: 'Nhận ID bướm vàng',
  Cargo_RefreshData: 'Thao tác thất bại, vui lòng thử lại sau khi làm mới!',
  Cargo_ContinueExportTip: 'Bản ghi đã chọn đã được xuất, bạn có chắc chắn muốn xuất lại không?',
  Cargo_WarnRuleConfiguration: 'Danh sách cấu hình quy tắc cảnh báo sớm',
  Cargo_BPMApprovalProcess: 'Quy trình phê duyệt BPM',
  Cargo_DataServiceReminder: 'Nhắc nhở dịch vụ dữ liệu',
  Cargo_ValueAddedServiceReminder: 'Nhắc nhở dịch vụ gia tăng giá trị',
  Cargo_DataServiceItems: 'Mục dịch vụ dữ liệu',
  Cargo_SopTemplate: 'SOP mẫu',
  Cargo_SopNode: 'Nút SOP',
  Cargo_TriggerTypeSelection: 'Chọn loại kích hoạt',
  Cargo_TriggerType: 'Loại kích hoạt',
  Cargo_WarningConditions: 'Điều kiện cảnh báo sớm',
  Cargo_NodeUpdate: 'Cập nhật nút',
  Cargo_EarlyWarning: 'Loại cảnh báo sớm',
  Cargo_WarningContent: 'Nội dung cảnh báo sớm',
  Cargo_DataServiceConfig: 'ชื่อการกำหนดค่าบริการข้อมูล',
  Cargo_ConfigureNameNotEmpty: 'ชื่อการกำหนดค่าต้องไม่ว่างเปล่า',
  Cargo_ConfigureNameRepeat: '{0} มีอยู่แล้ว; ชื่อการกำหนดค่าต้องไม่ซ้ำกัน',
  Cargo_NotifierRoleRepeat: 'ตำแหน่ง {0} มีอยู่แล้วในการกำหนดค่า {1}; กรุณาอย่ากำหนดค่าซ้ำ',
  Cargo_NotifierIdRepeat: 'ผู้ใช้ {0} มีอยู่แล้วในการกำหนดค่า {1}; กรุณาอย่ากำหนดค่าซ้ำ',
  Cargo_RemarksInfo: 'Thông tin nhận xét',
  Cargo_DesignatedPost: 'Đơn vị quản lý&vận hành: Trung tâm Thông tin (',
  Cargo_SendSettings: 'Cài đặt gửi',
  Cargo_SetTheNotificationRecipients: 'Thiết lập đối tượng thông báo (Insiders)',
  Cargo_ReminderMethod: 'Cách nhắc nhở',
  Cargo_DesignatedPersonnel: 'Người được chỉ định',
  Cargo_AutoIgnoreMode: 'Cách bỏ qua tự động',
  Cargo_WarningLevel: 'Mức cảnh báo sớm',
  Cargo_ShipPlanReminderMethod: 'Phương thức nhắc lịch tàu',
  Cargo_ShipNameAndVoyage: 'Nhắc theo tên tàu và chuyến',
  Cargo_Job: 'Nhắc theo công việc',
  Cargo_AlertOnStatus: 'Tình trạng báo động.',
  Cargo_EarlyWarningMode: 'Chế độ cảnh báo sớm',
  Cargo_WarningSwitch: 'Công tắc cảnh báo sớm',
  Cargo_StartAlert: 'Bật báo động.',
  Cargo_CloseAlert: 'Tắt cảnh báo sớm',
  Cargo_EnablePersonalSettings: 'Bật cài đặt cá nhân',
  Cargo_ClosePersonalSettings: 'Tắt cài đặt cá nhân',
  Cargo_DataServiceReminderWarning1: '1.【Gửi theo "Cấu hình cơ bản"】được đẩy tại các nút được thống nhất trong 【Cấu hình cơ bản】',
  Cargo_DataServiceReminderWarning2: '2. Sau khi 【Bật cảnh báo】-【Lưu】, các nút nhận sẽ theo cài đặt cá nhân',
  Cargo_ConfigurationAlert: 'Gửi theo "Cấu hình cơ bản"',
  Cargo_PushNodeSettings: 'Cài đặt nút gửi cá nhân',
  Cargo_NodPushSettings: 'Cài đặt gửi nút',
  Cargo_VesselReminderMethodDifferent: 'Cách nhắc lịch trình tàu hiệu lực cũ là {Theo tên tàu & chuyến} sẽ được thay toàn bộ bằng {Theo nghiệp vụ} mới nhất',
  Cargo_VesselReminderMethodDifferent2: 'Cách nhắc lịch trình tàu hiệu lực cũ là {Theo nghiệp vụ} sẽ được thay toàn bộ bằng {Theo tên tàu & chuyến} mới nhất',
  Cargo_UserConfigOpenDifferent: 'Cài đặt gửi nút hiệu lực cũ là {Tắt cài đặt cá nhân} sẽ được thay toàn bộ bằng {Bật cài đặt cá nhân} mới nhất',
  Cargo_UserConfigOpenDifferent2: 'Cài đặt gửi nút hiệu lực cũ là {Bật cài đặt cá nhân} sẽ được thay toàn bộ bằng {Tắt cài đặt cá nhân} mới nhất',
  Cargo_BringForward: 'Trước',
  Cargo_Postpone: 'Trì hoãn',
  Cargo_EarlyWarningReminder: 'Điểm, cảnh báo.',
  Cargo_EarlyTimedIgnore: 'Thời gian bỏ qua',
  Cargo_TurnOffAutoIgnore: 'Tắt bỏ qua tự động',
  Cargo_SetSOPNodeOfAlert: 'SOP cảnh báo sớm',
  Cargo_SOPNodeOfAlert: 'Cảnh báo nút SOP',
  Cargo_ApplicationScope: 'Phạm vi ứng dụng',
  Cargo_DocumentNotification: 'Thông báo tài liệu',
  Cargo_ApplyToAllTemplates: 'Áp dụng cho các mẫu cùng loại hình kinh doanh',
  Cargo_UseOnlyTheCurrentTemplate: 'Chỉ dùng mẫu hiện tại',
  Cargo_SetAlertNotificationObject: 'Đặt các đối tượng thông báo cảnh báo',
  Cargo_ReminderModes: 'Cách nhắc nhở',
  Cargo_IgnoreTime: 'Bỏ qua thời gian',
  Cargo_AutomaticallyIgnoreAfterHours: 'Tự động bỏ qua sau một giờ',
  Cargo_EditNodeAlertRules: 'Hiệu chỉnh các quy tắc cảnh báo nút',
  Cargo_CloudPlatformFeeStatus: 'Trạng thái chi phí nền tảng đám mây',
  Cargo_CloudPlatformSyncStatus: 'Trạng thái đồng bộ nền tảng đám mây',
  Cargo_CloudPlatformDocumentNumber: 'Số tài liệu nền tảng đám mây',
  Cargo_SynchronousCloudPlatform: 'Nền tảng đám mây đồng bộ',
  Cargo_SendThirdParty: 'Gửi bên thứ ba',
  Cargo_SupplementaryInformation: 'Thông tin bổ sung',
  Cargo_InvoiceTypeOfTheOppositePlatform: 'Các loại hóa đơn của nhau',
  Cargo_PaymentBranch: 'Chi nhánh thanh toán',
  Cargo_SyncInvoiceAttachment: 'Đồng bộ tệp đính kèm hóa đơn',
  Cargo_Send: 'Gửi',
  Cargo_SendSuccess: 'Gửi thành công',
  Cargo_SendFail: 'Gửi thất bại',
  Cargo_Remarks2: 'Nội dung ghi chú',
  Cargo_PaymentInstructions: 'Hướng dẫn thanh toán',
  Cargo_PaymentReason: 'Lý do thanh toán',
  Cargo_OurHeader: 'Tiêu đề của chúng tôi',
  Cargo_DeleteBookingNote: 'Bạn có chắc chắn muốn xóa bài viết này?',
  Cargo_ApplicationDetails: 'Chi tiết ứng dụng',
  Cargo_SubscribeToDataAlerts: 'Đăng ký nhắc nhở dữ liệu',
  Cargo_EnableDataServiceReminder: 'Bật nhắc nhở dịch vụ dữ liệu',
  Cargo_ClickToLearnMore: 'Tìm hiểu thêm',
  Cargo_DataServiceReminderWarningOne: '1. Đẩy nhắc nhở bất thường được đánh giá bằng logic, chỉ để tham khảo, dữ liệu cụ thể là thông tin chính thức.',
  Cargo_DataServiceReminderWarning: '2- Nếu bạn nhận được quá nhiều thông báo mỗi ngày, bạn có thể tắt thông báo này, các thông báo trên cần mở mô - đun dịch vụ giá trị gia tăng.',
  Cargo_AskDataServiceReminder: 'Sau khi mở dịch vụ dữ liệu, thông báo nhắc nhở tự động hiệu quả và chính xác cho nhân viên nội bộ, tìm hiểu chi tiết:',
  Cargo_AskSopDataService: 'Sau khi mở dịch vụ dữ liệu, thông báo đẩy tự động hiệu quả và chính xác cho nhân viên nội bộ và khách hàng (không mở hỗ trợ lưu lượng nhân tạo) và có thể thiết lập dịch vụ nhắc nhở dữ liệu trong cấu hình quy tắc cảnh báo, liên hệ với quản trị viên của công ty bạn ngay lập tức để biết thêm chi tiết:',
  Cargo_ContactDataServiceReminder: ', hoặc liên hệ với dịch vụ khách hàng trực tuyến WallTech hoặc vận hành 021-65143931',
  Cargo_DataServiceRemind: 'Dịch vụ nhắc nhở dữ liệu',
  Cargo_WhetherToTurnOffAlerts: 'Tắt cảnh báo sớm',
  Cargo_DayWarning: 'Cảnh báo hôm nay',
  Cargo_OnlyDataNodesAreDisplayed: 'Chỉ hiển thị các nút có cảnh báo sớm',
  Cargo_ViewProcessedAlerts: 'Xem cảnh báo sớm đã xử lý',
  Cargo_ViewIgnoredAlerts: 'Xem cảnh báo bị bỏ qua',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: 'Chọn mẫu SOP để áp dụng cho doanh nghiệp',
  Cargo_MakeSureToApplyTheSopTemplate: 'Vui lòng xác nhận áp dụng mẫu SOP 【{0}】',
  Cargo_PleaseSelectAnSOPTemplate: 'Vui lòng chọn mẫu SOP',
  Cargo_PleaseSelectSOPTemplateForChange: 'Vui lòng chọn mẫu SOP để thay thế',
  Cargo_PleaseSelectOtherSOPTemplate: 'Doanh nghiệp bạn chọn đã là mẫu SOP bạn cần, hãy chọn lại',
  Cargo_ReplaceTheSOPTemplate: 'Thay thế mẫu SOP',
  Cargo_Apply: 'Ứng dụng',
  Cargo_MoreFilters: 'Lọc thêm',
  Cargo_Handled: 'Đã xử lý',
  Cargo_ProcessSelectedData: 'Tất cả các thông tin cảnh báo sớm đã chọn sẽ được đánh dấu là đã xử lý và hoạt động này chỉ cập nhật trạng thái thông báo cảnh báo sớm?',
  Cargo_IgnoreSelectedData: 'Tất cả các thông tin cảnh báo sớm được lựa chọn sẽ bị bỏ qua?',
  Cargo_Personnel: 'Nhân sự',
  Cargo_NewSopTemplate: 'Mẫu SOP mới',
  Cargo_EditSopTemplate: 'Sửa mẫu SOP',
  Cargo_CopySopTemplate: 'Sao chép mẫu SOP hiện tại',
  Cargo_SopTemplateName: 'Name',
  Cargo_LookNode: 'Xem nút',
  Cargo_NewNode: 'Nút mới',
  Cargo_EditNode: 'Sửa nút',
  Cargo_NewNodeStatus: 'Trạng thái nút mới',
  Cargo_NodeSettings: 'Cài đặt nút',
  Cargo_NodeStatusSettings: 'Thiết lập trạng thái nút',
  Cargo_NoticeOfEachBill: 'Thông báo mỗi vé (bao gồm vé nhỏ)',
  Cargo_NoNoticeOfTickets: 'Giấy tờ nhỏ không được thông báo',
  Cargo_AlertSettings: 'Thiết lập cảnh báo sớm',
  Cargo_ConfigureSopMessagePush: 'Cấu hình SOP Message Push',
  Cargo_NodeType: 'Loại nút',
  Cargo_WhetherToDisclose: 'Công khai hay không',
  Cargo_EditTheAlertConfiguration: 'Sửa cấu hình cảnh báo sớm',
  Cargo_AddedAlertConfiguration: 'Cấu hình cảnh báo mới',
  Cargo_EditTheStatusDetails: 'Sửa chi tiết trạng thái',
  Cargo_NewStatusDetails: 'Chi tiết trạng thái mới',
  Cargo_StatusDetails: 'Chi tiết tình trạng',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: 'Thiết lập mẫu SOP để áp dụng kịch bản kinh doanh',
  Cargo_QuicklySelectBusinessNodes: 'Chọn nhanh Business Node',
  Cargo_QuicklyConfigureDataServices: 'Nhanh chóng cấu hình dịch vụ dữ liệu',
  Cargo_QuicklyConfigureStatusNotifications: 'Thông báo trạng thái cấu hình nhanh (Insiders)',
  Cargo_ShipPlanningAtThePortOfDeparture: 'Chương trình tàu tại cảng khởi hành',
  Cargo_ContainerTracking: 'Theo dõi hàng hóa hộp',
  Cargo_ShipDynamicsAtThePortOfDestination: 'Cảng đích tàu năng động',
  Cargo_CarryEmpty: 'Nâng cao',
  Cargo_TheActualDischarging: 'Unloader thực tế',
  Cargo_ReturnBox: 'Trống rỗng',
  Cargo_TheHomePageIsDisplayed: 'Trang chủ Hiển thị',
  Cargo_QuicklyConfigureSettings: 'Cài đặt cấu hình nhanh',
  Cargo_QuickConfigurationIsCheckedByDefault: 'Cấu hình nhanh Đánh dấu mặc định',
  Cargo_PleaseEnterAThemeTemplate: 'Vui lòng nhập mẫu sắc thái',
  Cargo_PleaseEnterTheBodyTemplateContent: 'Vui lòng nhập nội dung mẫu nội dung',
  Cargo_PleaseEnterTheTemplateContent: 'Vui lòng nhập nội dung mẫu',
  Cargo_PleaseEnterAnExampleTemplate: 'Vui lòng nhập mẫu mẫu',
  Cargo_SOPPushObjectChannelRepeats: 'Lặp lại kênh đối tượng đẩy SOP',
  Cargo_DataService: 'DVĐL',
  Cargo_WarningRuleTips: 'Sau khi cập nhật trạng thái nút SOP, thông tin cảnh báo tương ứng sẽ được đánh dấu là đã được xử lý.',
  Cargo_SopTemplateChangeTips: 'Đã khớp với mẫu SOP mới 【{0}】, Bạn có giữ lại mẫu SOP ban đầu không?',
  Cargo_ApplyTheSopTemplateAs: 'Mẫu SOP được áp dụng là:',
  Cargo_TheNodeIsShutDown: 'Nút đã đóng',
  Cargo_CanNotUploadFileOfNewContract: 'Thêm số hợp đồng chưa lưu không thể tải lên tệp!',
  Cargo_OrderReceiving: 'Nhận hóa đơn',
  Cargo_PrintTemplate: 'In mẫu',
  Cargo_ControlObject: 'Điều khiển đối tượng',
  Cargo_ControlMode: 'Cách kiểm soát',
  SetDefaultType: 'Đặt kiểu mặc định',
  DefaultFileType: 'Kiểu tập tin mặc định',
  DefaultType: 'Loại mặc định',
  Cargo_ActualPaymentAmount: 'Số tiền thanh toán',
  Cargo_ReceivedAmount: 'Số tiền vào tài khoản',
  Cargo_OcServiceCharge: 'Phí OC',
  Cargo_ChannelServiceCharge: 'Thanh toán phí xử lý kênh',
  Cargo_Abnormal: 'Bất thường',
  Cargo_AbnormalState: 'Description',
  Cargo_AbnormalRemark: 'Ghi chú',
  Cargo_ProcessedDate: 'Thời gian xử lý',
  Cargo_UpdateReceivedAmount: 'Chỉnh sửa số tiền vào tài khoản',
  Cargo_AbnormalComment: 'Comment',
  Cargo_MarkAbnormal: 'Đánh dấu bất thường',
  Cargo_ValueAddedServices: 'Dịch vụ giá trị gia tăng',
  Cargo_CustomsMode: 'Cách khai hải quan',
  Cargo_ServiceType: 'Loại dịch vụ',
  Cargo_PODServices: 'Dịch vụ cảng đích',
  Cargo_POD: 'Cảng đích',
  Cargo_POL: 'Cảng khởi hành',
  Cargo_InitData: 'Khởi tạo dữ liệu',
  Cargo_NotInitData: 'Đã có dữ liệu, không thể khởi tạo',
  Cargo_GeneratedVoucherInvoice: 'Số hóa đơn với chứng từ đã tạo:',
  Cargo_DownLoad_Summary: 'Tải xuống mẫu tóm tắt',
  Cargo_DownLoad_Detail: 'Tải xuống mẫu chi tiết',
  Cargo_Import_OnOrder: 'Nhập đơn đặt hàng',
  Cargo_Not_Submit: 'Xác nhận tạm thời không đệ trình sao?',
  Cargo_Not_Approved: 'Chỉ có thể tạm thời không gửi đơn đặt hàng [Bracket 0]!',
  Cargo_Not_Submit_Please: 'Vui lòng đánh dấu vào 【Tạm thời không đệ trình】 Business!',
  Cargo_Not_Submit_Batch_Success: 'Tạm thời không gửi cập nhật trạng thái thành công',
  Cargo_Submit_Batch: 'Vui lòng đánh dấu vào mục Business for 【Giới thiệu】',
  Cargo_Submit_Pre_Qualification: 'Xác nhận tình trạng nộp trước khi xét xử?',
  Cargo_Submit_Job: 'Các doanh nghiệp chỉ có thể gửi hàng loạt 【Tạm thời không đệ trình】',
  Cargo_Submit_Success: 'Lệnh đã được gửi',
  Cargo_OnlySelectedOneVoucher: 'Bạn chỉ có thể chọn một phần dữ liệu để xuất.',
  Cargo_BatchSetCategory: 'Thiết lập danh mục hàng loạt',
  Cargo_ExportExcelTemplate: 'Xuất mẫu Excel?',
  Cargo_Run: 'Chạy',
  Cargo_ExcelTemplateExport: 'Xuất báo cáo Excel',
  CARGO_OFFICE_EMAIL_ISEMPTY: 'Email chi nhánh hiện tại không được duy trì, vui lòng kiểm tra.',
  Cargo_ChangeChargeChanged: 'Chi phí ban đầu của {0} có sửa đổi (thanh toán/hóa đơn/yêu cầu thanh toán/bán hàng, v.v.), xin vui lòng kiểm tra!',
  Cargo_SecondPolCode: 'Cảng khởi hành 2 chiều (Mã)',
  Cargo_SecondPol: 'Cảng khởi hành 2 chiều',
  Cargo_SecondPodCode: 'Cảng đích thứ hai (Mã)',
  Cargo_SecondPod: 'Cảng đích thứ hai',
  Cargo_WaybillDestination: 'Vận đơn đích',
  Cargo_PolCountry: 'Quốc gia/khu vực vận chuyển',
  Cargo_IC: 'Du lịch quốc tế',
  Cargo_IC_Master: 'vé máy bay quốc tế',
  Cargo_IC_Basic: 'Thẻ quốc tế',
  Cargo_Settlement: 'Thanh toán',
  Cargo_ReconciliationTab: 'Tab đối chiếu',
  Cargo_BillTab: 'Tab hóa đơn',
  Cargo_CancelApprovalCheck: 'Dữ liệu đã chọn bao gồm các nghiệp vụ đã gửi BO. Không cho phép hủy duyệt, vui lòng kiểm tra!',
  Cargo_BusinessPushStatus: 'Trạng thái đẩy dữ liệu nghiệp vụ',
  Cargo_CostPushStatus: 'Trạng thái đẩy dữ liệu chi phí',
  Cargo_AutoGenerateEnabled: 'Có tự động tạo không？',
  Cargo_BusinessQuotationAmount: 'Số tiền báo giá thương mại',
  Cargo_BusinessQuotationConfirmed: 'Báo giá thương mại đã xác nhận',
  Cargo_BusinessQuotationConfirmedCancel: 'Hủy báo giá Xác nhận',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: 'Chỉ những chi phí có báo giá được xác nhận là "Không" mới được phép thực hiện thao tác này!',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: 'Chỉ những chi phí có báo giá thương mại khác 0 và báo giá được xác nhận là "Có" mới được phép thực hiện thao tác này!',
  Cargo_VehicleModel: 'Mô hình',
  Cargo_TypeKh: 'Trang chủ',
  Cargo_waybillInvoice: 'Thông tin hóa đơn vận chuyển',
  Cargo_customsMethodPol: 'Cách khai hải quan',
  Cargo_transferAgent: 'Đại lý trung chuyển',
  Cargo_destinationAgent: 'Đại lý đích',
  Cargo_dispatchingPlace: 'Nơi gửi hàng',
  Cargo_dispatchingPlace2: 'Nơi nhận/vận chuyển',
  Cargo_dischargingPortCode: 'Nơi dỡ hàng (POD)',
  Cargo_transferPortCode: 'Địa điểm trung chuyển',
  Cargo_loadingPortCode: 'Nơi khởi hành (POL)',
  Cargo_actAta: 'Ngày đến thực tế (ATA)',
  Cargo_estEta: 'Ngày đến dự kiến (ETA)',
  Cargo_actAtd: 'Ngày giao hàng thực tế (ATD)',
  Cargo_estEtd: 'Ngày giao hàng dự kiến (ETD)',
  Cargo_OrderCar: 'Đặt phòng',
  Cargo_DestinationDelivery: 'Giao hàng tận nơi',
  Cargo_trailerNumber: 'Đăng ký xe',
  Cargo_polInfo: 'Thông tin cảng khởi hành',
  Cargo_estLandingTime: 'Thời gian bay dự kiến',
  Cargo_actLandingTime: 'Thời gian đến bờ thực tế',
  Cargo_estEntryTime: 'Thời gian nhập cảnh dự kiến',
  Cargo_actEntryTime: 'Thời gian nhập cảnh thực tế',
  Cargo_estExitTime: 'Thời gian bay dự kiến',
  Cargo_actExitTime: 'Thời gian xuất cảnh thực tế',
  Cargo_estReplacementTime: 'Thời gian thay đồ dự kiến',
  Cargo_actReplacementTime: 'Thời gian thay đồ thực tế',
  Cargo_declareTime: 'Thời gian khai hải quan',
  Cargo_transferInfo: 'Thông tin chuyển tiếp',
  Cargo_declareCompletedTime: 'Thời gian hoàn thành khai báo địa điểm trung chuyển',
  Cargo_estShippingTime: 'Thời gian vận chuyển dự kiến',
  Cargo_actShippingTime: 'Thời gian vận chuyển thực tế nơi trung chuyển',
  Cargo_estArrivePodTime: 'Thời gian dự kiến đến biên giới đích',
  Cargo_actArrivePodTime: 'Thời gian thực tế đến biên giới đích',
  Cargo_estEnterPodTime: 'Thời gian dự kiến đến đích',
  Cargo_actEnterPodTime: 'Thời gian đến đích thực tế',
  Cargo_estArriveClearTime: 'Thời gian dự kiến đến nơi thông quan',
  Cargo_actArriveClearTime: 'Thời gian thực tế đến nơi thông quan',
  Cargo_estDischargeTime: 'Thời gian dỡ hàng dự kiến',
  Cargo_actDischargeTime: 'Thời gian dỡ hàng thực tế',
  Cargo_estArriveTime: 'Trailer Thời Gian Đến',
  Cargo_actArriveTime: 'Thời gian đến thực tế của trailer',
  Cargo_estTakeTime: 'Thời gian nhận hàng dự kiến của trailer',
  Cargo_actTakeTime: 'Thời gian nhận hàng thực tế của Trailer',
  Cargo_estUnloadTime: 'Thời gian dỡ hàng dự kiến của trailer',
  Cargo_actUnloadTime: 'Thời gian dỡ hàng thực tế của trailer',
  Cargo_podInfo: 'Cảng đích Gửi thông tin',
  Cargo_estWarehouseDeliveryTime: 'Thời gian giao hàng dự kiến',
  Cargo_actWarehouseDeliveryTime: 'Thời gian giao hàng thực tế',
  Cargo_estGoodsDeliveryTime: 'Thời gian giao hàng dự kiến',
  Cargo_actGoodsDeliveryTime: 'Thời gian giao hàng thực tế',
  Cargo_estReturnTime: 'Thời gian còn trống.',
  Cargo_actReturnTime: 'Thời gian còn trống.',
  Cargo_polPortInfo: 'Thông tin cửa khẩu khởi hành',
  Cargo_khLandingTime: 'Ca - na - đa lên bờ.',
  Cargo_khEntryTime: 'Air Canada nhập cảnh',
  Cargo_khExitTime: 'Chuyến bay của Qantas',
  Cargo_khReplacementTime: 'Trang phục Kahang',
  Cargo_khDeclare: 'Khai báo hải quan',
  Cargo_transferTransitInfo: 'Thông tin chuyển tiếp',
  Cargo_transferDeclareCompleted: 'Khai báo địa điểm trung chuyển hoàn thành',
  Cargo_transferShipping: 'Vận chuyển nơi trung chuyển',
  Cargo_arriveDestinationBorder: 'Đến biên giới đích',
  Cargo_podClearInfo: 'Thông tin thông quan điểm đến',
  Cargo_arrivePod: 'Đến đích',
  Cargo_arriveClear: 'Đến nơi thông quan',
  Cargo_khUnloading: 'Tag: dỡ hàng',
  Cargo_polExchangeInfo: 'Thông tin bốc dỡ hàng khởi hành',
  Cargo_trailerLoad: 'Trailer nhận hàng',
  Cargo_trailerArrive: 'Trailer đến',
  Cargo_trailerUnload: 'Tải Trailer',
  Cargo_podDeliveryInfo: 'Điểm đến Gửi thông tin',
  Cargo_warehouseDelivery: 'Vào kho và giao hàng',
  Cargo_goodsDelivery: 'Giao hàng',
  Cargo_podReturn: 'Trống rỗng',
  Cargo_estTime: 'Thời gian dự kiến',
  Cargo_actTime: 'Thời gian thực',
  Cargo_secondPlateNumber: 'Biển số 2.',
  Cargo_secondTrailerNumber: 'Số trailer 2',
  Cargo_secondVehicleType: 'Mô hình 2 chiều',
  Cargo_secondEtd: 'Ngày vận chuyển',
  Cargo_secondPol: 'Nơi khởi hành',
  Cargo_secondPod: 'Điểm đến',
  Cargo_secondLoadingTime: 'Thời gian tải',
  Cargo_secondShippingTime: 'Thời gian khởi hành',
  Cargo_secondArriveTime: 'Thời gian đến',
  Cargo_secondDischargeTime: 'Thời gian dỡ hàng',
  Cargo_secondTransportType: 'Phương pháp vận chuyển',
  Cargo_bargeInfo: 'Thông tin xe',
  Cargo_bargeEtd: 'Ngày vận chuyển xe tải',
  Cargo_bargeAtd: 'Ngày nhận xe',
  Cargo_bargePlateNumber: 'Biển số xe.',
  Cargo_bargeTrailerNumber: 'Xe tải chở hàng số',
  Cargo_bargePol: 'Nơi khởi hành (POL)',
  Cargo_bargePod: 'Điểm đến (POD)',
  Cargo_ActualEntryTime: 'Thời gian tiếp cận thực tế',
  Cargo_ActualLoadingTime: 'Thời gian tải thực tế',
  Cargo_EstimatedDepartureTime: 'Thời gian cất cánh dự kiến',
  Cargo_ActualDepartureTime: 'Thời gian cất cánh thực tế',
  Cargo_EstimatedArrivalTime: 'Thời gian đến dự kiến',
  Cargo_ActualArrivalTime: 'Thời gian đến thực tế',
  Cargo_ActualBillingTime: 'Thời gian thanh toán thực tế',
  Cargo_ActualUnloadingTime: 'Thời gian dỡ hàng thực tế',
  Cargo_ActualArrivalNotificationTime: 'Thời gian thông báo giao hàng thực tế',
  Cargo_ActualPickupTime: 'Thời gian nhận hàng thực tế',
  Cargo_EstimatedTransitArrivalTime: 'Thời gian vận chuyển dự kiến',
  Cargo_TransitArrivalTime: 'Thời gian vận chuyển đến',
  Cargo_EstimatedTransitDepartureTime: 'Thời gian khởi hành dự kiến',
  Cargo_TransitDepartureTime: 'Thời gian cất cánh',
  Cargo_bargeLine: 'Mã đường cao tốc',
  Cargo_bargeCarrierId: 'Công ty vận tải',
  Cargo_khPlateNumber: 'Biển số xe',
  Cargo_khPlateNum: 'Biển số xe.',
  Cargo_PlateNums: 'Biển số xe nội địa',
  Cargo_khTrailerNumber: 'Số trailer Kahang',
  Cargo_TypeTc: 'Trang chủ',
  Cargo_SyncTargetDocumentNo: 'Đồng bộ hóa số chứng từ của nhau',
  Cargo_PleaseChooseTargetDocumentNo: 'Vui lòng chọn hồ sơ có số chứng từ của đối phương',
  Cargo_WriteOffInputFail: 'Trong chi phí chờ tiêu thụ hạt nhân, có chi phí phải trả chưa làm đơn xin thanh toán hoặc quá trình xin thanh toán chưa hoàn thành, không cho phép tiêu thụ hạt nhân!',
  Cargo_WriteOffInputFail2: 'Trong chi phí tiêu thụ hạt nhân, có quy trình xin thanh toán chi phí ứng phó chưa hoàn thành, không cho phép tiêu thụ hạt nhân!',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: 'Hoạt động không thành công, yêu cầu thanh toán đang trong quá trình phê duyệt thanh toán, vui lòng thực hiện sau khi quá trình hoàn tất.',
  Cargo_estimation: 'Đánh giá tạm thời',
  Cargo_estimationAmount: 'Số tiền tạm thời',
  Cargo_CooperateBranchId: 'Chi nhánh hợp tác',
  Cargo_EntrustBranchId: 'Chi nhánh ủy thác',
  Cargo_CooperateBusinessType: 'Loại hình kinh doanh hợp tác',
  Cargo_BillingWeightActual: 'Trọng lượng tính phí',
  Cargo_BillingWeightContract: 'Trọng lượng tính phí',
  Cargo_NumberOfItemsActual: 'Số kiện (thực)',
  Cargo_NumberOfItemsContract: 'Số kiện (ủy ban)',
  Cargo_VolumeActual: 'Âm lượng (thực)',
  Cargo_VolumeContract: 'Thể tích (ủy ban)',
  Cargo_GrossWeightContract: 'Tổng trọng lượng',
  Cargo_GrossWeightActual: 'Tổng trọng lượng (thực)',
  Cargo_CooperateStatus: 'Trạng thái hợp tác',
  Cargo_BusinessStatusRemark: 'Tình trạng kinh doanh Ghi chú',
  Cargo_ChargeStatusRemark: 'Ghi chú tình trạng chi phí',
  Cargo_CooperateStatusLog: 'Changelog trạng thái hợp tác',
  Cargo_BusinessStatusLog: 'Thay đổi trạng thái kinh doanh',
  Cargo_ChargeStatusLog: 'Thay đổi trạng thái chi phí',
  Cargo_AssociatedWithMasterTicket: 'Có liên quan đến vé chính không?',
  Cargo_SelectCooperateBranch: 'Chọn chi nhánh hợp tác',
  Cargo_CooperateBranchCannotBeEmpty: 'Chi nhánh hợp tác không thể để trống.',
  Cargo_CooperateBusinessTypeCannotBeEmpty: 'Loại hình kinh doanh hợp tác không thể để trống.',
  Cargo_Cooperation: 'Hợp tác',
  Cargo_CooperationReturn: 'Trả lại',
  Cargo_CooperateStatusApprovedCanTBeDeleted: 'Trạng thái tác vụ cộng tác đã được xem xét và không thể xóa.',
  Cargo_AreYouSureUpdateState: 'Bạn có chắc muốn thay đổi trạng thái?',
  Cargo_CooperateSucceed: 'Hợp tác thành công',
  Cargo_CooperateLogOperation: 'Nội dung hoạt động',
  Cargo_CooperateLogState: 'Trạng thái sau hoạt động',
  Cargo_CooperateLogContent: 'Chi tiết',
  Cargo_AreYouSureReturn: 'Anh chắc là muốn trả lại chứ?',
  Cargo_CooperateCreatedDate: 'Thời gian tạo tác vụ cộng tác',
  Cargo_CooperateReviewSeparately: 'Chọn có doanh nghiệp hợp tác trong hồ sơ, vui lòng kiểm tra riêng',
  Cargo_CooperateNoPretrialReview: 'Không có hoạt động hợp tác.',
  Cargo_ShowCooperateAll: 'Thêm thông tin hợp tác',
  Cargo_SettleBranchId: 'Công ty giải quyết',
  Cargo_ShowInternalCharges: 'Hiện nút bên trong',
  Cargo_InternalCharges: 'Nút bên trong',
  Cargo_IsCooperate: 'Là nghiệp vụ hợp tác, chỉ có thể do chi nhánh tiếp nhận tiến hành thao tác.',
  Cargo_BranchCooperate: 'Công ty hỗ trợ doanh nghiệp',
  Cargo_DownLoad_Template: 'Tải xuống mẫu',
  Cargo_EstimatedWarehousingTime: 'Thời gian nhập kho dự kiến',
  Cargo_ActualWarehousingTime: 'Thời gian nhập kho thực tế',
  Cargo_EstimatedDeliveryTime: 'Thời gian xuất kho dự kiến',
  Cargo_ActualDeliveryTime: 'Thời gian xuất kho thực tế',
  Cargo_SyncWarehouseData: 'Lấy dữ liệu kho đồng bộ',
  Cargo_PleaseEnterActualWarehousingTime: 'Vui lòng nhập thời gian thực tế',
  Cargo_LockOrderTip: 'Tất cả các doanh nghiệp đủ điều kiện sẽ được cập nhật thành 【Kiểm toán】, bạn có tiếp tục không?',
  Cargo_RefreshTcloudToken: 'Làm mới OpenToken',
  Cargo_SeaBooking: 'Đặt hàng bằng đường biển',
  Cargo_RailwayOperate: 'Hoạt động đường sắt',
  Cargo_IntegratedOperate: 'Hoạt động logistics tích hợp',
  Cargo_Timezone: 'Múi giờ',
  Cargo_HiddenPlatform: 'Ẩn mẫu nền tảng đúc sẵn',
  Cargo_TemplateName: 'Sơ đồ mẫu Name',
  Cargo_PleaseEnterPlanRemark: 'Vui lòng nhập mô tả sơ đồ',
  Cargo_StartLine2: 'Dòng bắt đầu (bao gồm tiêu đề)',
  Cargo_PleaseEnterStartLine: 'Vui lòng nhập dòng bắt đầu',
  Cargo_ImportTableSet: 'Nhập thiết lập bảng',
  Cargo_PleaseQuery: 'Tìm kiếm',
  Cargo_EnableFilterRowRule: 'Bật quy tắc dòng lọc',
  Cargo_ImportColumnsFilterOut: 'Khi bạn nhập bảng, mỗi hàng dữ liệu trong các cột hợp lệ trong bảng đáp ứng các thiết lập ở đây được lọc ra.',
  Cargo_SpaceGreaterThan: 'Số lượng khoảng trắng lớn hơn',
  Cargo_PleaseEnterHeaderName: 'Tên ô Excel: Nhập tên tiêu đề mà bạn cần nhập bảng Excel.',
  Cargo_PleaseEnterHeaderGridNum: 'Số cột ô Excel: Vui lòng nhập số cột mà bạn cần nhập vào bảng Excel, chẳng hạn như: A、B、AA。',
  Cargo_AddNewTemplate: 'Bộ mẫu nhập mới',
  Cargo_SerialNo: 'Số sê-ri',
  Cargo_InternalTableName: 'Tên bảng nội bộ',
  Cargo_ExcelCellName: 'Excel Cell Name',
  Cargo_DocumentEntry: 'Nhập chứng từ khai hải quan',
  Cargo_QueryTags: 'Thẻ truy vấn',
  Cargo_ChargebackManage: 'Quản lý hoàn trả',
  Cargo_ReconciliationRule: 'Quy tắc đối chiếu',
  Cargo_ReconciliationRuleName: 'Quy tắc đối chiếu Name',
  Cargo_MatchFieldSettings: 'Thiết lập trường khớp',
  Cargo_PleaseSelectField: 'Vui lòng chọn trường khớp khi so sánh',
  Cargo_Relationship: 'Liên hệ',
  Cargo_And: 'Với',
  Cargo_Or: 'hoặc',
  Cargo_MatchingOrder: 'Thứ tự trận đấu',
  Cargo_MatchFieldName: 'Tên trường khớp',
  Cargo_CompareFieldOperations: 'Thiết lập trường tương phản',
  Cargo_SelectFieldToCompare: 'Chọn tên trường cần tương phản',
  Cargo_CompareOrder: 'Thứ tự tương phản',
  Cargo_CompareField: 'Trường tương phản',
  Cargo_ComparisonOperation: 'Hành động tương phản',
  Cargo_MultiRowSumMethod: 'Cách tổng hợp đa dòng',
  Cargo_ComparisonSingleLine: 'So sánh chi tiết một dòng',
  Cargo_AttachFilePlaneOrNot: 'Có đính kèm tập tin ngẫu nhiên hay không',
  Cargo_FlightDate: 'Ngày bay',
  Cargo_OtherWarehousingInstructions: 'Các mô tả khác về kho',
  Cargo_PhotoShootingAwait: 'Danh sách chờ chụp ảnh',
  Cargo_PhotoShootingAwaitPallets: 'Danh sách chờ chụp ảnh',
  Cargo_DeleteSelected: 'Bỏ chọn',
  Cargo_StartUploading: 'Tải lên',
  Cargo_Register: 'Đăng ký',
  Cargo_Void: 'Hủy bỏ',
  Cargo_Unbind: 'cởi trói',
  Cargo_OrderPassingAgent: 'Đại lý đơn lẻ',
  Cargo_BusinessBookiingAgent: 'Đại lý đặt phòng kinh doanh',
  Cargo_RegisteredDate: 'Ngày đăng ký',
  Cargo_EstimatedBackDate: 'Ngày dự kiến trở lại',
  Cargo_ActualBackDate: 'Ngày trở lại thực tế',
  Cargo_FreightRateM: 'Giá vận chuyển M',
  Cargo_FreightRateN: 'Giá vận chuyển n',
  Cargo_FreightRate45: 'Giá vận chuyển 45',
  Cargo_FreightRate100: 'Giá vận chuyển 100',
  Cargo_FreightRate300: 'Giá vận chuyển 300',
  Cargo_FreightRate500: 'Giá vận chuyển 500',
  Cargo_FreightRate1000: 'Giá vận chuyển 1000',
  Cargo_NewIATAFreightRate: 'Giá IATA mới',
  Cargo_EditIATAFreightRate: 'Sửa giá IATA',
  Cargo_DeliveryStation: 'Trạm giao hàng',
  Cargo_FlightSchedule: 'Lịch trình chuyến bay',
  Cargo_Schedule: 'Lớp học',
  Cargo_ArrivaledTime: 'Thời gian đến',
  Cargo_Voyage: 'Thời gian bay',
  Cargo_MustBEntered: 'Phải nhập',
  Cargo_NewFlight: 'Chuyến bay mới',
  Cargo_EditFlight: 'Biên tập Chuyến bay',
  Cargo_OneWayPort: 'Cảng một chiều',
  Cargo_SecondPort: 'Cảng 2 chiều',
  Cargo_ThirdPort: 'Cảng 3 chiều',
  Cargo_TransshipmentPort: 'Cảng trung chuyển',
  Cargo_NewLine: 'Dòng mới',
  Cargo_EditLine: 'Sửa dòng',
  Cargo_NewAirTransportationArea: 'Khu vực vận chuyển hàng không mới',
  Cargo_EditAirTransportationArea: 'Chỉnh sửa khu vực vận chuyển hàng không',
  Cargo_RegionalPorts: 'Cảng khu vực',
  Cargo_OriginRegionCode: 'Mã vùng khởi hành',
  Cargo_TargetRegionCode: 'Mã vùng đích',
  Cargo_NewRoute: 'Đường bay mới',
  Cargo_ResponsibilityList: 'Danh sách trách nhiệm',
  Cargo_ResponsibilityInformation: 'Thông tin trách nhiệm',
  Cargo_ResponsibilityStep1: 'Bước 1: Nhập thông tin cơ bản về trách nhiệm',
  Cargo_ResponsibilityStep2: 'Bước 2: Chọn đường bay',
  Cargo_ResponsibilityStep3: 'Bước 3: Chọn hãng hàng không',
  Cargo_ResponsibilityStep4: 'Bước 4: Chọn tính chất đặt phòng',
  Cargo_ResponsibilityStep5: 'Bước 5: Chọn Airport',
  Cargo_ResponsibilityStep6: 'Bước 6: Chọn bán hàng',
  Cargo_ResponsibilityStep7: 'Bước 7: Xác định thông tin trách nhiệm',
  Cargo_ResponsibilityNew: 'Nhiệm vụ hoạt động mới',
  Cargo_ResponsibilityEdit: 'Biên tập trách nhiệm hoạt động',
  Cargo_QueryType: 'Loại truy vấn',
  Cargo_NotClearedToday: 'Ngày hôm trước chưa báo',
  Cargo_ToBeClearedToday: 'Chuyến bay trong ngày khai báo hải quan',
  Cargo_DeclarationTheSameDay: 'Khai báo hải quan trong ngày',
  Cargo_InculdeHistoricalData: 'Chứa dữ liệu lịch sử',
  Cargo_DeclarationTracking: 'Theo dõi khai hải quan',
  Cargo_FlightTracking: 'Theo dõi chuyến bay',
  Cargo_ModifyDeclarationBatches: 'Sửa đổi hàng loạt trạng thái khai hải quan',
  Cargo_PrintedTag: 'Đã gắn thẻ',
  Cargo_PrintTag: 'Nhãn in',
  Cargo_CheckData: 'Kiểm tra dữ liệu',
  Cargo_AWBQuantity: 'Làm số mảnh đơn',
  Cargo_AWBWeight: 'Tổng trọng lượng làm đơn',
  Cargo_AWBVolume: 'Khối lượng đặt hàng',
  Cargo_GoodsSize: 'Kích thước hàng hóa',
  Cargo_ActualFlight: 'Chuyến bay thực tế',
  Cargo_OnwardInformation: 'Thông tin tiếp tục',
  Cargo_AttachmentDescription: 'Mô tả phụ kiện',
  Cargo_CustomsDeclarationStatus: 'Tình trạng khai hải quan',
  Cargo_NumberDeclaration: 'Số lượng tờ khai hải quan',
  Cargo_DeclarationGrossWeight: 'Tổng trọng lượng khai hải quan',
  Cargo_CustomsDeclarationRemarks: 'Ghi chú khai hải quan',
  Cargo_DeleteAccountingEntry: 'Xoá mục',
  Cargo_Assets: 'Tài sản',
  Cargo_LineNo: 'Hàng thứ',
  Cargo_LiabilitiesOwner: 'Nợ phải trả và vốn chủ sở hữu (hoặc cổ đông)',
  Cargo_LineNo2: 'Hàng thứ',
  Cargo_OpeningAmountOfTheYear2: 'Số đầu năm',
  Cargo_PeriodEndAmount2: 'Số cuối kỳ',
  Cargo_AmountOfMonth: 'Số tiền xảy ra trong tháng',
  Cargo_AmountOfYear: 'Số tiền tích lũy trong năm',
  Cargo_TrackingTipOne: 'Biểu tượng này được sử dụng cho các hệ thống B2B!',
  Cargo_TrackingTipTwo: 'Lưu ý: Nên sử dụng định dạng png màu trắng với các biểu tượng có kích thước không quá 500KB để tải lên.',
  Cargo_WarehouseMapTip: 'Lưu ý: Định dạng ảnh được khuyến nghị để tải lên bản đồ kho là PNG/JPG.',
  Cargo_UploadDataSizeMore500KB: 'Kích thước tập tin không được lớn hơn 500KB!',
  Cargo_RuleNotesTip: 'Ghi chú có thể được điền vào để người dùng dễ dàng xem các chú giải liên quan khi sử dụng.',
  Cargo_MainOrderRegistr: 'Đăng ký chính',
  Cargo_MainOrderStart: 'Số khởi đầu chính',
  Cargo_TotalCopies: 'Tổng số bản sao',
  Cargo_LastUpdateTime: 'Cập nhật lần cuối',
  Cargo_AddBranch: 'Thêm chi nhánh',
  Cargo_CopyBranch: 'Sao chép chi nhánh',
  Cargo_EORIDetail: 'EORI Chi tiết',
  Cargo_DeleteEORITip: 'EORI không thể khôi phục sau khi xóa, xác nhận xóa?',
  Cargo_EORINotNull: 'EORI không thể rỗng',
  Cargo_EORINotDuplicate: 'EORI không thể lặp lại',
  Cargo_AddDept: 'Thêm bộ phận',
  Cargo_BranchCnName: 'Chi nhánh Tên Trung Quốc',
  Cargo_ChineseAddress: 'Địa chỉ Trung Quốc',
  Cargo_BranchEnName: 'Chi nhánh Tên tiếng Anh',
  Cargo_BranchCode: 'Mã chi nhánh',
  Cargo_PostalCode: 'Mã bưu điện',
  Cargo_Email: 'Thư điện tử',
  Cargo_LocalCurrency2: 'Tiền tệ địa phương',
  Cargo_DefaultAirport: 'Cảng hàng không mặc định',
  Cargo_DefaultHarbor: 'Cảng mặc định',
  Cargo_DefaultTimeZone: 'Múi giờ mặc định',
  Cargo_RMBAccount: 'Tài khoản CNY thanh toán',
  Cargo_USDAccount: 'Tài khoản USD thanh toán',
  Cargo_ReceiveRMBAccount: 'Tài khoản CNY thu tiền',
  Cargo_ReceiveUSDAccount: 'Tài khoản USD thu tiền',
  Cargo_DefaultPaymentAccount: 'Mặc định thanh toán',
  Cargo_DefaultReceiveAccount: 'Mặc định thu tiền',
  Cargo_OverseasBillingAddress: 'Địa chỉ thanh toán ở nước ngoài',
  Cargo_DomesticBillingAddress: 'Địa chỉ thanh toán nội địa',
  Cargo_OverseasEDICode: 'Mã EDI ở nước ngoài',
  Cargo_ValueAddedTaxRate: 'Thuế đánh dấu',
  Cargo_InvoicingTaxRate: 'Thuế suất thanh toán',
  Cargo_SettleEmail: 'Hộp thư thanh toán',
  Cargo_TaxationSystemAPIAddress: 'Địa chỉ giao diện hệ thống thuế',
  Cargo_TaxControlMachineNo: 'Số đĩa thuế',
  Cargo_ElectronicInvoicePlatformCode: 'Mã hóa nền tảng vé điện',
  Cargo_ElectronicInvoice: 'Mã hóa vé điện',
  Cargo_ElectronicInvoiceTaxpayer: 'Số nhận dạng người nộp thuế',
  Cargo_ElectronicInvoiceAuthCode: 'Mã ủy quyền của người nộp thuế',
  Cargo_ElectronicInvoiceRequestAddress: 'Địa chỉ yêu cầu dịch vụ vé điện',
  Cargo_InvoiceCancellationRequestAddress: 'Địa chỉ yêu cầu hủy hóa đơn',
  Cargo_EFreighAMSAccount: 'E-Freigh (Tài khoản AMS)',
  Cargo_EFreighACIAccount: 'E-Freigh (Tài khoản ACI)',
  Cargo_Preview: 'Xem thử',
  Cargo_NewBranchInformation: 'Thông tin chi nhánh mới',
  Cargo_AssociatePartners: 'Đối tác liên kết',
  Cargo_AddRole: 'Tăng vai trò',
  Cargo_DepartmentCode: 'Mã ngành',
  Cargo_JobNumberCodeField: 'Trường mã hóa số công việc',
  Cargo_SettlementCompanyIsOrNot: 'Cho dù đó là một công ty giải quyết',
  Cargo_Introduction: 'Giới thiệu',
  Cargo_EnableOpen: 'Mở',
  Cargo_DisableOpen: 'Đóng cửa',
  Cargo_GeneralSettings: 'Áp dụng cài đặt tổng công ty',
  Cargo_ControlMode2: 'Chế độ điều khiển:',
  Cargo_ReminderMode: 'Chế độ nhắc nhở',
  Cargo_LockMode: 'Chế độ khóa đơn',
  Cargo_Notification: 'Thông báo nhắc nhở:',
  Cargo_LockingControl: 'Kiểm soát khóa:',
  Cargo_Event: 'Sự kiện',
  Cargo_NotificationMethod: 'Thông báo',
  Cargo_NotificationObject: 'Thông báo đối tượng',
  Cargo_BLRelease: 'Đặt hàng B/L',
  Cargo_NoLock: 'Không khấu trừ',
  Cargo_NewOrCopyJob: 'Thêm/sao chép doanh nghiệp chính thức',
  Cargo_LockAfterSaving: 'Khóa sau khi lưu',
  Cargo_CannotBeSaved: 'Không thể lưu',
  Cargo_JobSheetIsLocked: 'Doanh nghiệp bị khóa',
  Cargo_JobSheetIsUnlocked: 'Doanh nghiệp Unlocked',
  Cargo_CreditLimitExceeded2: 'Tin ngoài',
  Cargo_CreditLimitChanged: 'Thay đổi tín hiệu',
  Cargo_CreditForewarning: 'Tín hiệu cảnh báo sớm',
  Cargo_PaymentPeriodForewarning: 'Báo động tài khoản',
  Cargo_CreditControlManager: 'Giám Đốc Tín Dụng',
  Cargo_TemplateManagement: 'Quản lý mẫu',
  Cargo_TemplateTypeManagement: 'Quản lý kiểu mẫu',
  Cargo_ConfigurationManagement: 'Quản lý cấu hình',
  Cargo_MappingManagement: 'Quản lý bản đồ',
  Cargo_InitializeTemplateManagement: 'Khởi tạo quản lý mẫu',
  Cargo_BusinessStatusManagement: 'Quản lý tình trạng doanh nghiệp',
  Cargo_TriggerTypeManagement: 'Quản lý kiểu kích hoạt',
  Cargo_FileTypeManagement: 'Quản lý kiểu tập tin',
  Cargo_DefaultValueManagement: 'Quản lý mặc định',
  Cargo_ValidationRuleConfiguration: 'Kiểm tra cấu hình quy tắc',
  Cargo_EDITemplateSettings: 'Thiết lập EDI',
  Cargo_OnlineShippingOrderSettings: 'Vận tải biển trực tuyến để thiết lập một',
  Cargo_RouteAndWarehouseConfiguration: 'Cấu hình định sẵn tuyến/cảng',
  Cargo_PushServiceConfiguration: 'Cấu hình dịch vụ đẩy',
  Cargo_CustomInvoiceRemarks: 'Ghi chú tùy chỉnh hóa đơn',
  Cargo_EmailTemplateManagement: 'Quản lý mẫu hộp thư',
  Cargo_BillOfLadingConfiguration: 'Cấu hình đặt đơn',
  Cargo_BranchBankAccount: 'Tài khoản ngân hàng chi nhánh',
  Cargo_SetRMBAccount: 'Đặt làm tài khoản RMB mặc định',
  Cargo_SetUSDAccount: 'Đặt làm tài khoản USD mặc định',
  Cargo_SetReceiveRMBAccount: 'Đặt làm tài khoản RMB thu tiền mặc định',
  Cargo_SetReceiveUSDAccount: 'Đặt làm tài khoản USD thu tiền mặc định',
  Cargo_SetDefaultPaymentAccount: 'Đặt tài khoản thanh toán mặc định',
  Cargo_SetDefaultReceiveAccount: 'Đặt tài khoản thu tiền mặc định',
  Cargo_ShortName: 'Viết tắt',
  Cargo_Instructions: 'Mô tả',
  Cargo_BankChineseAddress: 'Địa chỉ ngân hàng Trung Quốc',
  Cargo_BankEnglishAddress: 'Địa chỉ ngân hàng bằng tiếng Anh',
  Cargo_BankCode: 'Số tài khoản ngân hàng',
  Cargo_HeaderTitle: 'Tiêu đề liên quan',
  Cargo_ClosingAccountRecord: 'Đăng nhập',
  Cargo_ClosingAccountReview: 'Kiểm toán đóng tài khoản',
  Cargo_EditConfigurationItem: 'Sửa mục cấu hình',
  Cargo_SelectClosingAccountDate: 'Chọn ngày đóng tài khoản',
  Cargo_EditConfigurationDefinition: 'Hiệu chỉnh định nghĩa cấu hình:',
  Cargo_CreditLimitExceededApproval: 'Sau khi điều khiển tín hiệu vượt quá, khóa danh sách công việc cho đến khi mở khóa tự động hoặc lô đặc biệt nhân tạo',
  Cargo_CreditOnlyReminder: 'Sau khi điều khiển tín hiệu vượt quá, chỉ gửi nhắc nhở, danh sách công việc sẽ không bị khóa',
  Cargo_OperationExecutive: 'Giám đốc điều hành',
  Cargo_SalesExecutive: 'Quản lý bán hàng',
  Cargo_CreditControlSupervisor: 'Giám Đốc Tín Dụng',
  Cargo_BusinessCustomerService: 'Dịch vụ khách hàng',
  Cargo_EmailsAndReminders: 'Thư&Nhắc nhở',
  Cargo_Bell2: 'Chuông bên trong trạm',
  Cargo_Email2: 'Thư',
  Cargo_BatchAddRolePermissions: 'Thêm quyền vai trò hàng loạt',
  Cargo_RoleName: 'Tên nhân vật',
  Cargo_PermissionName: 'Tên quyền hạn',
  Cargo_PermissionCategory: 'Lớp quyền',
  Cargo_PermissionType: 'Loại quyền hạn',
  Cargo_PermissionPoint: 'Điểm đặc quyền',
  Cargo_UpdatePermissionGroups: 'Cập nhật nhóm quyền',
  Cargo_Personal2: 'Cá nhân',
  Cargo_DepartmentGroups: 'Nhóm ngành',
  Cargo_GreaterRemove: 'Xóa>>',
  Cargo_LessAdd: '<<Thêm',
  Cargo_PleaseEnterNameEtc: 'Vui lòng nhập tên tiếng Trung, tên tiếng Anh, hộp thư và các truy vấn mờ khác...',
  QuickSearchUser: 'Truy xuất nhanh: Tên đăng nhập, Tên tiếng Trung, Tên tiếng Anh, Hộp thư',
  Cargo_Expired: 'Hết hạn',
  Cargo_NearExpiration: 'Tạm thời',
  Cargo_NotVetDueEytended: 'Chưa hết hạn/Gia hạn',
  Cargo_History: 'Lịch sử',
  Cargo_QuickSearchContractNumber: 'Truy cập nhanh: Số hợp đồng',
  Cargo_Reminder30Day: 'Lưu ý: Trong vòng 30 ngày hệ thống được đặt thành tạm thời',
  Cargo_PleaseSelectContractRecord: 'Vui lòng chọn bản ghi hợp đồng.',
  Cargo_ContractAgreement: 'Thỏa thuận hợp đồng',
  Cargo_WhetherBookingConfirmation: 'Đã tải lên chưa?',
  Cargo_IsContractAgreementUploaded: 'Thỏa thuận hợp đồng đã được tải lên chưa',
  Cargo_ContractProhibitedOperated: 'Hợp đồng đã được gia hạn và cấm hoạt động',
  Cargo_NeedToUpdateOrNot: 'Cần update hay không',
  Cargo_ContractCreator: 'Người tạo hợp đồng',
  Cargo_ContractCreationTime: 'Thời gian tạo hợp đồng',
  Cargo_PartnerCreation: 'Đối tác sáng tạo',
  Cargo_ContractAuditor: 'Kiểm toán hợp đồng',
  Cargo_ContractAuditTime: 'Thời gian xét duyệt hợp đồng',
  Cargo_TimeLeftUntilExpiry: 'Còn lại từ ngày hết hạn',
  Cargo_DayRemind: 'Ngày nhắc nhở',
  Cargo_NoteReminderMethod: 'Lưu ý: Cách nhắc nhở là"Nhắc nhở hệ thống"Hệ thống sẽ báo trước 2 ngày.',
  Cargo_ProhibitBusinessConfiguration: 'Việc tạo cấu hình kinh doanh bị cấm:',
  Cargo_SettlementMethodGreaterThan0: 'Phương thức thanh toán: Ngày được chỉ định hàng tháng hoặc kỳ hạn tài khoản lớn hơn 0',
  Cargo_ViewContract: 'Xem hợp đồng',
  Cargo_PaymentTermPeriod: 'Khoảng tài khoản',
  Cargo_WeekSettlement: 'Kết thúc tuần',
  Cargo_EveryMonth: 'Hàng tháng',
  Cargo_Day: 'Ngày',
  Cargo_CAN_NOT_APPROVED: 'Chọn các doanh nghiệp có chứa trạng thái {0} trong dữ liệu và không được phép kiểm toán, vui lòng kiểm tra!',
  Cargo_CAN_NOT_CANCEL_APPROVED: 'Chọn dữ liệu có chứa trạng thái {0} của doanh nghiệp, trạng thái của doanh nghiệp, không cho phép hủy kiểm toán, vui lòng kiểm tra!',
  Cargo_HasOneOnly: 'Vui lòng chỉ chọn một bản ghi!',
  Cargo_CloseAndCopySerialNumber: 'Tắt và sao chép dòng chảy',
  Cargo_QuickSearchBillPayment: 'Truy cập nhanh: Số yêu cầu thanh toán',
  Cargo_AmsNoTooltip: 'Chúng tôi khuyên bạn không nên gửi thông báo EDI với số ký tự AMS NO vượt quá 12 chữ số.',
  Cargo_AmsNoEFreightTooltip: 'Chúng tôi khuyên bạn không nên gửi thông báo EDI với số ký tự AMS NO vượt quá 12 chữ số và tiền tố bằng Nvocc Scac sẽ bị loại bỏ khi gửi.',
  Cargo_AmsNoLengthTooltip: 'Số ký tự AMS NO đã vượt quá 12 chữ số, bạn có tiếp tục gửi không?',
  Cargo_AmsShipperLine1tip: 'Mẹo: Nếu tên quá dài, bạn có thể điền ngay vào ADDRESS1',
  Cargo_AmsUnitTypeTip: 'Mã bản đồ "Mã gói chống khủng bố" có thể được duy trì trong cấu hình bản đồ',
  Cargo_VoyageFlightLengthTooltip: 'Voyage không được vượt quá 5 ký tự',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'Trường Voyage có ký tự đặc biệt, bạn có muốn tiếp tục gửi không? Tiếp tục gửi sau khi thay đổi được đề xuất!',
  Cargo_BargeRemarks: 'Khu vực Barge Nhận xét',
  Cargo_CalcRuleNotes: 'Ghi chú quy tắc tính toán',
  Cargo_NotSupportStartOldApprove: '【Yêu cầu thanh toán】 không còn được hỗ trợ để bắt đầu phê duyệt, vui lòng truy cập 【Yêu cầu thanh toán】 để bắt đầu phê duyệt.',
  Cargo_Pending: 'Đang xử lý',
  Cargo_Processing: 'Đang xử lý',
  Cargo_Completed1: 'Đã hoàn thành',
  Cargo_Revoked: 'Hủy bỏ',
  Cargo_StartTime: 'Thời gian khởi động',
  Cargo_StartDate: 'Ngày khởi xướng',
  Cargo_ProcessName: 'Quy trình Name',
  Cargo_ApprovalSerialNumber: 'Số dòng chảy phê duyệt',
  Cargo_ApprovalDate: 'Ngày phê duyệt',
  Cargo_Approver: 'Người phê duyệt',
  Cargo_ApprovalTemplate: 'Mẫu phê duyệt',
  Cargo_ProcessingStatus: 'Trạng thái xử lý',
  Cargo_PleaseFill: 'Vui lòng điền',
  Cargo_PleaseMaintain: 'Vui lòng bảo trì',
  Cargo_MessageNotificationMethod: 'Phương thức thông báo tin nhắn',
  Cargo_AreYouSureAboutTheModificationProcess: 'Xác định quy trình sửa đổi sao?',
  Cargo_AreYouSureAboutTheModificationProcessTips: 'Sau khi xác nhận sửa đổi, quy trình đang xử lý tiếp tục thực hiện theo quy trình khi khởi xướng. Quy trình khởi xướng tiếp theo sẽ được thực hiện theo quy trình sửa đổi.',
  Cargo_SetUpTheProcessTriggerCondition: 'Vui lòng đặt điều kiện kích hoạt quy trình.',
  Cargo_CurrentApprover: 'Người phê duyệt hiện tại',
  Cargo_Initiator: 'Trang chủ',
  Cargo_ApprovalRecord: 'Hồ sơ phê duyệt',
  Cargo_SelectTheApprover: 'Chọn người phê duyệt',
  Cargo_RoleSelection: 'Lựa chọn vai trò',
  Cargo_ReviewTheProcessRecord: 'Xem hồ sơ quá trình',
  Cargo_BatchApproval: 'Đồng ý hàng loạt',
  Cargo_BatchReject: 'Từ chối hàng loạt',
  Cargo_TerminateTheProcess: 'Chấm dứt quy trình',
  Cargo_ApprovalComments: 'Ý kiến phê duyệt',
  Cargo_ApprovalTime: 'Thời gian phê duyệt',
  Cargo_ApprovalCommentsRecord: 'Hồ sơ phê duyệt ý kiến',
  Cargo_IInitiated: 'Tôi đã khởi xướng nó.',
  Cargo_IDealWithIt: 'Tôi xử lý nó',
  Cargo_SubmitAPaymentRequestForApproval: 'Gửi yêu cầu thanh toán để phê duyệt',
  Cargo_Approving: 'Phê duyệt',
  Cargo_ThereIsDuplicateData: 'Dữ liệu trùng lặp tồn tại',
  Cargo_SelectTheApprovalPosition: 'Chọn vị trí phê duyệt',
  Cargo_FilterDimension: 'Lọc theo',
  Cargo_FilterValue: 'Giá trị lọc',
  Cargo_ReviewTheApprovalProcess: 'Xem quy trình phê duyệt',
  Cargo_Committed: 'Giới thiệu',
  Cargo_Agreed: 'Đã đồng ý',
  Cargo_Opinion: 'Ý kiến',
  Cargo_ReviewWithdrawal: 'Rút xét duyệt',
  Cargo_ProcessRevocation: 'Thu hồi quy trình',
  Cargo_AlreadyWithdraw: 'Đã rút',
  Cargo_NoHandlingRequired: 'Không cần xử lý',
  Cargo_MyApprovals: 'Việc phê duyệt của tôi.',
  Cargo_ApprovalsThatIInitiated: 'Sự chấp thuận của tôi.',
  Cargo_ApprovalsThatIHandle: 'Phê duyệt mà tôi xử lý',
  Cargo_CreateProcess: 'Tạo process',
  Cargo_EditProcess: 'Quy trình biên tập',
  Cargo_CopyProcess: 'Quy trình sao chép',
  Cargo_DeleteProcess: 'Quy trình xóa',
  Cargo_ProcessComment: 'Quy trình Comment',
  Cargo_RevertProcessStatus: 'Thu hồi trạng thái quy trình',
  Cargo_RevertProcess: 'Quy trình hủy bỏ',
  Cargo_RejectProcess: 'Quy trình từ chối',
  Cargo_NotificationEmailCC: 'Thông báo tin nhắn Cc',
  Cargo_Irrevocable: 'Không thể thu hồi',
  Cargo_BindApprovalTemplate: 'Mẫu phê duyệt ràng buộc',
  Cargo_ApplicationBusinessDivision: 'Chi nhánh kinh doanh ứng dụng',
  Cargo_ProcessTriggerCondition: 'Điều kiện kích hoạt quá trình',
  Cargo_TriggerConditionConfiguration: 'Cấu hình có điều kiện kích hoạt',
  Cargo_ApproverSource: 'Nguồn phê duyệt',
  Cargo_ApproverExecutionMode: 'Phương thức thi hành của người phê duyệt',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: 'Nút thứ nhất là cấp trên của người khởi xướng, nút tiếp theo là cấp trên của người phê duyệt nút trước.',
  Cargo_AnyApproverCanHandle: 'Bất cứ ai trong số những người phê duyệt có thể xử lý nó.',
  Cargo_AllApproversAtCurrentNodeRequired: 'Yêu cầu tất cả người phê duyệt nút hiện tại xử lý',
  Cargo_TheNumberOfApprovalsInProgress: 'Số lượng phê duyệt đang tiến hành',
  Cargo_NotNamed: 'Không tên',
  Cargo_AdministratorSettings: 'Thiết lập quản trị',
  Cargo_FormName: 'Tên biểu mẫu',
  Cargo_NumberOfConfigurableBranches: 'Số nhánh có thể cấu hình',
  Cargo_ExistDocumentPlatformConfig: 'Chi nhánh này đã tồn tại Trạng thái biểu mẫu này để bật, vui lòng hành động sau khi xác nhận',
  Cargo_InitiateApproval: 'Khởi xướng phê duyệt',
  Cargo_InitiateApprovalSuccessfully: 'Khởi xướng phê duyệt thành công.',
  Cargo_AreYouSureToInitiateTheApproval: 'Xác nhận khởi xướng phê duyệt sao?',
  Cargo_AreYouSureToDo: 'Xác nhận {0}?',
  Cargo_AgreeToTheApproval: 'Chấp thuận phê duyệt',
  Cargo_RejectApproval: 'Từ chối phê duyệt',
  Cargo_InitiateBranchCompany: 'Bắt đầu chi nhánh',
  Cargo_ApplicationBranch1: 'Chi nhánh ứng dụng',
  Cargo_InitiateDepartment: 'Ban khởi xướng',
  Cargo_WhetherItIsEnabled: 'Bật hay không',
  Cargo_Deactivate: 'Tắt',
  Cargo_PleaseSelectTenantId: 'Vui lòng chọn Platform ID',
  Cargo_PleaseSelectOfficeIds: 'Vui lòng chọn chi nhánh ứng dụng',
  Cargo_PleaseSelectDocumentConfigId: 'Vui lòng chọn tên form',
  Cargo_PleaseSelectBranchCount: 'Vui lòng chọn số nhánh có thể cấu hình',
  Cargo_PleaseSelectUserIds: 'Vui lòng chọn Administrator Settings',
  Cargo_DocumentPlatformConfigNote: 'Lưu ý: Người quản trị có thể xem tất cả các luồng phê duyệt liên quan đến biểu mẫu.',
  Cargo_AddBranchProcess: '+Thêm quy trình chi nhánh',
  Cargo_Priority: 'Ưu tiên',
  Cargo_TriggerConditions: 'Điều kiện kích hoạt',
  Cargo_PleaseSelectDocumentConfigId2: 'Vui lòng chọn hình thức ràng buộc',
  Cargo_AddBranchProcessCheck: 'Số nhánh của biểu mẫu hiện tại đã đạt đến giới hạn trên.',
  Cargo_BindForm: 'Biểu mẫu liên kết',
  Cargo_UnknownProcessProcessing: 'Xử lý quy trình không rõ',
  Cargo_AutoWriteOffAfterApproval: 'Có tự động xóa sau khi phê duyệt không',
  Cargo_Bell: 'Chuông',
  Cargo_NotifierSource: 'Nguồn CC',
  Cargo_PreconditionsForApproval: 'Điều kiện trước khi phê duyệt',
  Cargo_RuleConditions: 'Điều kiện quy tắc',
  Cargo_ConditionalItem: 'Điều kiện Item',
  Cargo_ConditionalRule: 'Quy tắc điều kiện',
  Cargo_ConditionalValue: 'Điều kiện lấy giá trị',
  Cargo_RejectMethod: 'Cách từ chối',
  Cargo_AllowDirectReturnToInitiator: 'Cho phép trả lại trực tiếp cho người khởi xướng',
  Cargo_ReturnToTheInitiatingNode: 'Quay lại nút khởi tạo',
  Cargo_Returned2: 'Đã trả lại',
  Cargo_RefuseAndReturnNode: 'Ghi chú: Từ chối=trả lại nút trước, trả lại=trả lại nút khởi xướng.',
  Cargo_RefuseTitle: 'Quay lại nút trước',
  Cargo_ReturnTitle: 'Quay lại nút khởi tạo',
  Cargo_BillPaymentUpdateFail: 'Cập nhật yêu cầu thanh toán thất bại.',
  Cargo_OneClickCopy: 'Sao chép một cú nhấp chuột',
  Cargo_OneClickCopyNote: 'Lưu ý: Tất cả các dòng phê duyệt có thể được sao chép bằng cách nhấp vào nút "One-Click Copy" để truy vấn hàng loạt sau này.',
  Cargo_OneClickCopyNoteBillPaymentApply: 'Lưu ý: Tất cả các số đơn đăng ký có thể được sao chép bằng cách nhấp vào nút "sao chép một cú nhấp chuột" để truy vấn hàng loạt sau này.',
  Cargo_SubmitException: 'Gửi ngoại lệ',
  Cargo_ApprovalException: 'Phê duyệt ngoại lệ',
  Cargo_PriceType: 'Vui lòng chọn giá trước cảng, giá tuyến chính hoặc giá chặng cuối. Ít nhất phải chọn một loại yêu cầu báo giá',
  Cargo_AccountPeriodRemainingDays: 'Số ngày còn lại của kỳ kế toán',
  Cargo_WorkflowsBranchCountNotNull: 'Số nhánh dòng công việc không thể rỗng',
  Cargo_WorkflowsPlatformConfigRepeat: 'Chi nhánh này đã tồn tại Trạng thái biểu mẫu này để bật, vui lòng hành động sau khi xác nhận',
  Cargo_PleaseSelectUser: 'Vui lòng chọn quản trị viên cho quá trình này',
  Cargo_Initiate: 'Bắt đầu',
  Cargo_InitiateForm: 'Khởi tạo form',
  Cargo_ApprovalMatters: 'Việc phê duyệt',
  Cargo_SelectApprovalWithSameTemplate: 'Vui lòng chọn giống nhau"Mẫu phê duyệt"Việc phê duyệt.',
  Cargo_SOPPanelNodeNotDisplayed: 'Bảng SOP không hiển thị nút này',
  Cargo_SOPPanelNoDataHide: 'Bảng SOP tự động ẩn khi không có dữ liệu',
  Cargo_TaxInputConfig: 'Cấu hình thuế đầu vào',
  Cargo_ReceiptInvoiceTitle: 'Tiêu đề hóa đơn',
  Cargo_ReceiptInvoiceChannel: 'Kênh hóa đơn',
  Cargo_InvoiceAssociation: 'Liên kết hóa đơn',
  Cargo_BoundInvoiceOrNot: 'Liên kết hóa đơn',
  Cargo_ManualUpdate: 'Cập nhật thủ công',
  Cargo_GetInvoice: 'Lấy hóa đơn',
  Cargo_InvoiceTime: 'Thời gian xuất hóa đơn',
  Cargo_SellerName: 'Tên người bán',
  Cargo_SellerTaxNumber: 'Mã số thuế người bán',
  Cargo_BuyerName: 'Tên người mua',
  Cargo_BuyerTaxNumber: 'Mã số thuế người mua',
  Cargo_InvoicePool: 'Hồ sơ hóa đơn',
  Cargo_InvoicePoolReceiving: 'Nhận hóa đơn trong bể',
  Cargo_WriteOffBank: 'Ngân hàng bán hàng',
  Cargo_DepartureStation: 'Trạm khởi hành',
  Cargo_DestinationStation: 'Trạm đích',
  Cargo_TransitStation: 'Trạm trung chuyển',
  Cargo_TransferStation: 'Trạm trung chuyển',
  Cargo_QuickApprovalMode: 'Các nút khác nhau xử lý cùng một cách phê duyệt',
  Cargo_AutoAgree: 'Tự động đồng ý',
  Cargo_PressToDo: 'Thúc giục.',
  Cargo_CarbonCopy: 'Cc',
  Cargo_ApplicationDimension: 'Kích thước ứng dụng',
  Cargo_ApplicationCode: 'Mã ứng dụng',
  Cargo_TotalReceivable: 'Tổng số phải thu',
  Cargo_TotalDues: 'Tổng đối phó',
  Cargo_PackingType: 'Loại Boxing',
  Cargo_ViewChargeDetails: 'Xem chi tiết chi phí',
  Cargo_StartingPort: 'Cảng khởi hành',
  Cargo_SubmitJobChargeForApproval: 'Nộp đơn xin phê duyệt chi phí kinh doanh',
  Cargo_SubmitJobChargeTip: 'Nghiệp vụ vé này cần khởi xướng quá trình đệ trình phê duyệt trước, sau khi quá trình thông qua tự động đệ trình, thất bại thì đệ trình thất bại. Bạn có muốn bắt đầu phê duyệt ngay bây giờ không?',
  Cargo_SubmitJobChargeFailTip: 'Tạm thời không có quy trình phê duyệt chi phí phù hợp, xin liên hệ với quản lý hoàn thiện điều kiện kích hoạt trong quy trình phê duyệt rồi khởi xướng lại đệ trình.',
  Cargo_BillHasBeenInitiatedForApproval: 'Hóa đơn này đã khởi xướng phê duyệt, có thể đến trang "Tôi khởi xướng" trong danh sách phê duyệt để kiểm tra tiến độ phê duyệt và chi tiết phê duyệt.',
  Cargo_SubmitInvoiceFailTip: 'Tạm thời không có quy trình kê đơn phê duyệt phù hợp, xin liên hệ với quản lý hoàn thiện điều kiện kích hoạt trong quy trình phê duyệt rồi khởi xướng lại đệ trình.',
  Cargo_SubmitInvoiceTip: 'Trước khi kê đơn phải khởi xướng quy trình kê đơn phê duyệt, bây giờ ông có muốn khởi xướng phê duyệt không?',
  Cargo_SOURCE_CURRENCY_NOT_NULL: 'Nguyên tệ tệ chủng không thể là không!',
  Cargo_SOURCE_AMOUNT_NOT_NULL: 'Kim ngạch nguyên tệ không thể để trống!',
  Cargo_imWarning: 'Công việc hiện tại không có đủ nhân vật để mở nhóm chat của Worktop.',
  Cargo_ReceiptPaymentOffset: 'Trả trước',
  Cargo_InvoicePayableOffset: 'Chi phí vận hành trở lại',
  Cargo_CheckFreightTermOne: '"{0}" Khi điều khoản vận chuyển，{1} Và {2} Không được để trống',
  Cargo_CheckFreightTermTwo: '"{0}"  Khi điều khoản vận chuyển，{1} Không được để trống',
  Cargo_ThirdTableCheck: 'Bảng trung gian của bên thứ ba đã được đẩy và không hoạt động',
  Cargo_CheckMergeExport: 'Hóa đơn phải trả và chứng từ trả trước hợp nhất xuất khẩu, đánh dấu rằng bạn không thể có loại chứng từ khác trong hồ sơ. Vui lòng kiểm tra',
  CargoMsg_QQ: 'QQ',
  CargoMsg_CorporateName: 'Tên công ty hợp pháp',
  Cargo_DeleteUnApprovedBillTips: 'Chỉ có thể xóa các hóa đơn chưa được phê duyệt!',
  Cargo_EditUnApprovedBillTips: 'Chỉ có thể chỉnh sửa hóa đơn chưa được phê duyệt!',
  Cargo_DeleteUnApprovedInvoiceTips: 'Chỉ có thể xóa hóa đơn chưa phê duyệt!',
  Cargo_InvalidUnApprovedInvoiceTips: 'Chỉ có thể hủy bỏ hóa đơn chưa phê duyệt!',
  Cargo_InvoiceID: 'ID hóa đơn',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: 'Vui lòng chọn yêu cầu thanh toán cần hủy bỏ.',
  Cargo_Deleted: 'Đã xoá',
  Cargo_EnableSopTemplate: 'Bật mẫu sop hiện tại',
  Cargo_UnableSopTemplate: 'Tắt mẫu sop hiện tại',
  Cargo_EnableSopTemplateConfirm: 'Xác nhận kích hoạt mẫu SOP hiện tại?',
  Cargo_UnableSopTemplateConfirm: 'Xác nhận vô hiệu hóa mẫu SOP hiện tại? Sau khi vô hiệu hóa, doanh nghiệp không thể áp dụng mẫu này. Nhưng nó sẽ không ảnh hưởng đến các doanh nghiệp đã sử dụng mẫu này.',
  Cargo_Disabled2: '(Đã tắt)',
  Cargo_Got_It: 'Hiểu rồi.',
  Cargo_Canceled: 'Đã hủy',
  Cargo_RepeatGoldenTaxExport: 'Xin đừng lặp lại thao tác xuất thuế vàng.',
  Cargo_UpdateCustomerInfo: 'Cập nhật thông tin khách hàng',
  Cargo_SyncCustomerData: 'Đồng bộ dữ liệu khách hàng',
  Cargo_Synchronizing: 'Đang đồng bộ hóa, vui lòng kiểm tra lại sau',
  Cargo_Prediction: 'Dự báo',
  Cargo_PlaceOfDeliveryRegion: 'Nơi giao hàng (khu vực)',
  Cargo_IsTransfer: 'Trung chuyển hay không',
  Cargo_TotalAmountTax: 'Tổng số tiền thuế (hóa đơn)',
  Cargo_CustomerNotOwn: '【Đơn vị ủy thác】 Công ty con không phù hợp với công ty hiện tại',
  Cargo_SimilarPartners: 'Đã có {1} doanh nghiệp có tên tương tự 【{0}】, v.v.',
  Cargo_GoBackSuccess: 'Lấy lại thành công!',
  Cargo_SendBackSuccess: 'Hoàn tiền thành công!',
  Cargo_AddSignature: 'Đã ký',
  Cargo_Appoint2: 'Tuyển dụng',
  Cargo_Appointer: 'Trang chủ',
  Cargo_ApproverRepeat: 'Người phê duyệt không được phép lặp lại',
  Cargo_ApproverAndAppointerRepeat: 'Người dùng không thể có cả trạng thái "Phê duyệt" và "Ủy quyền"',
  Cargo_CancelAddSignature: 'Không thể "hủy bỏ" bản thân',
  Cargo_CancelAddSignatureNotSupport: 'Người dùng "Phê duyệt" hoặc "Được ủy quyền" không hỗ trợ "Hủy đăng ký"',
  Cargo_RuleError: 'Thay đổi kiểu biểu mẫu, cấu hình sai quy tắc quy trình',
  Cargo_SelectCcTo: 'Chọn CC BY',
  Cargo_SelectSigner: 'Chọn người ký',
  Cargo_SelectTransferor: 'Chọn Referrer',
  Cargo_TransferSignature: 'Đã chuyển',
  Cargo_Appointed: 'Đã ủy thác',
  Cargo_CancelSignature: 'Hủy đăng ký',
  Cargo_AddSignatureSelf: 'Không thể đối với chính mình"Thêm chữ ký"',
  Cargo_OnlySupportedFCL: 'Tạm thời chỉ hỗ trợ toàn bộ doanh nghiệp',
  Cargo_CannotExceedThree: 'Trong hệ thống có hơn 3 hộp khác nhau, lần này không thể gửi dữ liệu liên quan, xin liên lạc kịp thời với nhân viên phục vụ khách hàng.',
  Cargo_TransferSignatureSelf: 'Bạn không được phép chọn mình là "người chuyển nhượng".',
  Cargo_AddSignatureCurrentNode: 'Không cho phép các node hiện tại"Thêm chữ ký"',
  Cargo_ApproverNotEmpty: 'Người phê duyệt không được để trống',
  Cargo_AppointerNotEmpty: 'Người ủy thác không thể để trống',
  Cargo_NewWarehouseFee: 'Chỉ cho phép nghiệp vụ đang thao tác tăng thêm phí kho báu mới!',
  Cargo_DefaultCurrencyConversion: 'Đồng tiền tương đương mặc định',
  Cargo_ChargeGroupCheck: 'Nhóm chi phí 【{0}】, không hỗ trợ lựa chọn lặp lại, vui lòng lưu lại sau khi điều chỉnh lại.',
  Cargo_RelatedChargeItems: 'Dự án thu phí liên quan',
  Cargo_IncludeSoc: 'Bao gồm hộp chính',
  Cargo_SubsidiaryLedgerDay: 'Báo cáo chi tiết hàng ngày',
  AccountingDate: 'Ngày kế toán',
  PleaseSelectAccountDate: 'Vui lòng chọn ngày kế toán.',
  CurrentDayAmountTo: 'Tổng cộng trong ngày',
  TotalReportingCurrencyOfThisDay: 'Tổng số tiền trong ngày',
  Cargo_LastOverseasPort: 'Khi cảng dỡ hàng là cảng của Hoa Kỳ, nó có thể bằng trực tiếp với cảng xếp hàng. \n' +
      'Khi cảng dỡ hàng không thuộc Hoa Kỳ, cảng trước đó không thuộc Hoa Kỳ phải được lấp đầy ở đây.',
  Cargo_FirstPortOfCall: 'Khi cảng dỡ hàng là cảng của Hoa Kỳ, nó có thể bằng trực tiếp với cảng dỡ hàng. \n' +
      'Khi cảng dỡ hàng không phải là cảng của Hoa Kỳ, cảng đầu tiên của Hoa Kỳ đi qua Hoa Kỳ phải được lấp đầy ở đây.',
  Cargo_PoNoExistTips: 'Số mục được lặp lại, bạn có xác nhận lưu không?',
  Cargo_Assignment: 'Phân phối',
  Cargo_SetMarginReminder: 'Đặt nhắc nhở phụ cấp',
  Cargo_NumberOfCompanyReminders: 'Số dư nhắc nhở',
  Cargo_CompanyTrackingNumLower: 'Phụ cấp số đơn của công ty hiện tại thấp hơn 【{0}】',
  Cargo_BatchAdd: 'Thêm hàng loạt',
  Cargo_DownloadTemplate: 'Tải xuống mẫu',
  Cargo_AssignCompany: 'Công ty phân phối',
  Cargo_MawbSource: 'Nguồn: Master Single',
  CARGO_CAN_NOT_ASSIGNMENT: 'Chỉ hỗ trợ phân phối lệnh chính trạng thái mới',
  CARGO_Confirm_Assignment: 'Xác nhận phân phối',
  CARGO_Confirm_Assignment_Success: 'Phân phối thành công',
  CARGO_Confirm_Assignment_Error: 'Phân phối thất bại',
  CARGO_Only_Invalidated: 'Chỉ hỗ trợ lệnh chính không hủy bỏ',
  CARGO_Only_Unbind: 'Chỉ hỗ trợ các lệnh chính bị ràng buộc',
  CARGO_Not_Met_New_Conditions: 'Các lệnh sau không đáp ứng các điều kiện mới',
  Cargo_Assign_People: 'Người phân phối',
  AERequiredChecksum: 'Số lượng bắt đầu, số lượng lớn mới bắt buộc',
  Cargo_DeleteCharge: 'Không có chi phí nào được chọn, tất cả các chi phí kinh doanh được đánh dấu đã bị xóa theo mặc định',
  Cargo_BusinessOperationUpdateDynamics: 'Hoạt động kinh doanh Cập nhật động',
  Cargo_UpdateDetails: 'Cập nhật chi tiết',
  Cargo_UpdateContent: 'Cập nhật nội dung',
  Cargo_ChangeLogRecord: 'Đăng nhập thay đổi',
  Cargo_BusinessNoChangeLogRecord: 'Số doanh nghiệp Changelog',
  Cargo_ResultsDisplayedInRed: 'Kết quả tìm kiếm sẽ được hiển thị màu đỏ',
  Cargo_ChangeLocation: 'Thay đổi vị trí',
  Cargo_TimeQuery: 'Yêu cầu thời gian',
  Cargo_BusinessNotExist: 'Kinh doanh không tồn tại!',
  Cargo_UserNoRole: 'Người dùng này không có vai trò liên kết, xác nhận lưu?',
  Cargo_ResultsDisplayedInYellow: 'Kết quả tìm kiếm sẽ có màu vàng',
  Cargo_CreateBillYesOrNo: 'Tạo hóa đơn hay không',
  CurrencyReceivable: '{0} Phải nhận',
  CurrencyPayable: '{0} Đối phó',
  CurrencyNotReceived: '{0} Không nhận',
  CurrencyUnpaid: '{0} Chưa thanh toán',
  CurrencyReceived: '{0} Đã nhận',
  CurrencyPaid: '{0} đã trả',
  Cargo_CheckShippingCompanyCargoTracking: 'Bạn đã bắt đầu dịch vụ theo dõi hàng hóa của công ty tàu, vui lòng lưu lại sau khi chọn công ty tàu để đảm bảo bạn có được thông tin trường thành công.',
  Cargo_PodPortInfoPrompt: 'Nếu bạn bắt đầu dịch vụ theo dõi hàng hóa của công ty tàu, dấu trang cơ bản - công ty tàu là bắt buộc, vui lòng lưu doanh nghiệp sau khi chọn công ty tàu một cách chính xác và đảm bảo rằng bạn có được thông tin trường thành công.',
  Cargo_StatementReviewStatus: 'Tình trạng kiểm tra hóa đơn',
  Cargo_StatementReviewer: 'Người kiểm tra hóa đơn',
  Cargo_StatementReviewTime: 'Thời gian kiểm tra hóa đơn',
  Cargo_Port_Departure_Sea: 'Cảng khởi hành (bằng đường biển)',
  Cargo_Port_Destination_Sea: 'Cảng đích (bằng đường biển)',
  Cargo_Port_Departure_Air: 'Cảng khởi hành (bằng đường hàng không)',
  Cargo_Port_Destination_Air: 'Cảng đích (bằng đường hàng không)',
  Cargo_Port_Departure_Rail: 'Cảng khởi hành (đường sắt)',
  Cargo_Port_Destination_Rail: 'Cảng đích (đường sắt)',
  Cargo_Lob_NEQ_Port: 'Loại hình kinh doanh không phù hợp với loại cảng, nhấp để xác định để trống cảng đã chọn',
  Cargo_DuplicateLaneCodePleaseTryItAgain: 'Lặp lại, vui lòng nhập lại.',
  Need: 'Yêu cầu',
  NoNeed: 'Không cần',
  Responsible: 'Trách nhiệm',
  No_Responsibility: 'Không trách nhiệm',
  Cargo_VAT_FEI: 'Hóa đơn điện tử (hóa đơn đặc biệt VAT)',
  Cargo_NORMAL_FEI: 'Hóa đơn điện tử (General Invoice)',
  Cargo_ViewMoreLogs: 'Xem thêm nhật ký',
  Cargo_ThreeDaysLogs: 'Gần 3 ngày hoạt động',
  Cargo_CarryForward: 'Xoay nút',
  Cargo_ReconciliationNewVersion: 'Đối chiếu phiên bản mới',
  Cargo_NuoNuo: 'Không',
  Cargo_AISINO_EI: 'Thư hàng hải',
  Pigeonhole: 'Lưu trữ',
  Unarchive: 'Hủy lưu trữ',
  Confirm_Archiving_Business: 'Xác nhận lưu trữ doanh nghiệp đã chọn',
  Confirm_Unarchiving_Business: 'Xác nhận hủy lưu trữ doanh nghiệp đã chọn',
  Is_Pigeonhole: 'Lưu trữ hay không',
  Financial_Review_Status: 'Tình trạng kiểm toán tài chính',
  Other_Reminders: 'Nhắc nhở khác',
  Can_Be_Archived: 'Lưu trữ',
  Not_Accrued: 'Không đề cập',
  Receivables_Not_Fully_Written_Off: 'Không bán hết hạt nhân',
  Payable_Not_Fully_Written_Off: 'Không bán hết hạt nhân',
  Financial_Archiving_Settings: 'Thiết lập lưu trữ tài chính',
  Financial_Filing_Preconditions: 'Điều kiện trước khi nộp hồ sơ tài chính',
  Financial_Filing_Effective_Effect: 'Hiệu quả của việc lưu trữ tài chính',
  WHETHER_FINANCIAL_AUDIT: 'Có xét duyệt tài chính hay không:',
  WHETHER_ACCRUED: 'Đã tính chưa:',
  CARGO_RECOGNITION_SETTING: 'Thiết lập nhận dạng OCR',
  AE_IDENTIFY_VENDORS: 'Nhà cung cấp nhận dạng mới/chỉnh sửa',
  TENANT_BUSINESS_NAME: 'Tên doanh nghiệp cho thuê',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: 'Nhà cung cấp nhận dạng sách ủy thác biển',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: 'Nhà cung cấp nhận dạng vận đơn đường biển',
  DTip: 'Bạn có chắc chắn muốn xóa cài đặt cho đối tượng thuê này không? Sau khi xóa, các nhà cung cấp nhận dạng được thiết lập nền tảng sẽ được sử dụng',
  FormEditTip: 'Vui lòng đánh dấu vào cài đặt nhận dạng đối tượng thuê cần chỉnh sửa',
  FormDeleteTip: 'Vui lòng đánh dấu vào thiết lập nhận dạng đối tượng thuê cần xóa',
  OCRRecognition: 'Nhận dạng OCR',
  FINANCIAL_RECEIVABLES_VERIFICATION: 'Có nên thu toàn bộ tiêu thụ hạt nhân hay không:',
  FINANCIAL_DUE_VERIFICATION: 'Đối phó với toàn bộ tiêu thụ hạt nhân:',
  FINANCIAL_CHARGE: 'Có chi phí đang tiến hành Thêm/Thay đổi/Xóa:',
  CANCEL_FINANCIAL_AUDIT: 'Hủy xét duyệt tài chính:',
  MODIFY_CHARGE: 'Chi phí sửa đổi:',
  MODIFY_JOB: 'Thay đổi thông tin doanh nghiệp:',
  MODIFY_RATE: 'Thay đổi tỷ giá hối đoái:',
  MODIFY_FINANCE_JOB_DATE: 'Thay đổi ngày tài chính/ngày kinh doanh:',
  GENERATE_RED_INVOICE: 'Tạo hóa đơn Red Rush:',
  RECEIVABLE_GENERATES_INVOICE: 'Hóa đơn phải được thu thập:',
  COPE_GENERATES_INVOICE: 'Đối phó với các hóa đơn có thể tạo ra:',
  CANCEL_RECEIVABLE_VERIFICATION: 'Hủy bỏ tiêu thụ hạt nhân:',
  COPE_RECEIVABLE_VERIFICATION: 'Hủy bỏ việc bán hạt nhân:',
  MODIFY_ACCRUAL: 'Sửa đổi kế hoạch:',
  NON_FILEABLE_BUSINESS: 'Có một doanh nghiệp không thể lưu trữ',
  NOT_FULLY_COMPLETED: 'Có một doanh nghiệp chưa hoàn thành, hãy xem nhắc nhở',
  BUSINESS_CAN_ARCHIVED: 'Doanh nghiệp có thể nộp',
  ARCHIVE_DATE: 'Ngày nộp hồ sơ',
  NOT_OPERATIONAL: 'Không hoạt động, vì lý do: doanh nghiệp đã nộp đơn.',
  CHANGE_CHARGE_IN_PROGRESS: 'Đang tiến hành "Kiểm tra chi phí thay đổi" Vui lòng hoàn thành trước',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: 'Vui lòng lọc để chọn doanh nghiệp chưa nộp',
  ONLY_ARCHIVED_TRANSACTIONS: 'Vui lòng lọc để chọn doanh nghiệp đã nộp',
  Cargo_Preplan: 'Trang chủ',
  Cargo_SeaManagerSendPreplan: 'Hải quản gia',
  Cargo_SeaManagerUpdatePreplan: 'Quản gia Hải (sửa đổi tiền phối)',
  Cargo_SeaManagerDeletePreplan: 'Disable (adj): khuyết tật (',
  Cargo_SeaManagerSendingVGM: 'Sea Butler (Gửi VGM)',
  Cargo_WseSendMPreplanQd: 'CV: Hướng dẫn nhiệm vụ quản lý chất lượng năm học 2019-2020 (',
  Cargo_WseSendPreplanQd: 'B5-05=giá trị thông số Kd, (cài 2)',
  Cargo_WseSendUpdatePreplanQd: 'CV: Hướng dẫn nhiệm vụ quản lý chất lượng năm học 2019-2020 (',
  Cargo_WseDeletePreplanQd: 'CV: Hướng dẫn nhiệm vụ quản lý chất lượng năm học 2019-2020 (',
  Cargo_WseSendPreplanSh: 'CW (Bản kê khai gửi cảng Thượng Hải)',
  Cargo_WseSendUpdatePreplanSh: 'CW (Bản kê khai sửa đổi cảng Thượng Hải)',
  Cargo_WseDeletePreplanSh: 'CW (Bản kê khai xóa cảng Thượng Hải)',
  Cargo_WseSendingVGM: 'Gửi VGM',
  Cargo_Ams: 'AMS gửi',
  Cargo_Aci: 'ACI gửi',
  Cargo_Afr: 'AFR gửi',
  Cargo_EMainfest: 'eMainfest gửi',
  Cargo_Ens: 'ENS gửi',
  Cargo_Send_error: 'Gửi ngoại lệ',
  Cargo_Confirm_Delete: 'Xác nhận rằng bạn muốn xóa dữ liệu đã chọn?',
  Cargo_ApiCallBack: 'API gọi lại',
  Cargo_BWJS: 'Bách Vượng Kim Tuệ Vân',
  Cargo_TaxEasy: 'Dung Tân',
  Cargo_YGSH: 'Nắng nhanh',
  Cargo_BaiHui: 'Bách Huy Kim Nhâm',
  Cargo_OverseasSettlementCenter: 'Trung tâm thanh toán nước ngoài',
  Cargo_Receivable2: 'Nên thu:',
  Cargo_Payable2: 'Đối phó:',
  Cargo_From_Import: 'Đồng bộ hóa nhập khẩu',
  Cargo_From_Export: 'Đồng bộ hóa lối ra',
  Approval_Approved_Time: 'Thời gian phê duyệt',
  CheckingExportToImport: 'Nghiệp vụ này không thể xuất khẩu sang nhập khẩu, xin kiểm tra rồi thử lại!',
  OnlySupportOneCustomsInfo: 'Khi mở giao diện cờ tín hiệu, chỉ hỗ trợ một chi tiết báo hải quan.',
  CustomsDeclareTime: 'Yêu cầu ngày khai hải quan',
  SendContainer: 'Đẩy danh sách LCL đến môi giới hải quan',
  IsTheLCLListSent: 'Danh sách LCL Có Được Gửi Không',
  LCLList: 'Danh sách LCL',
  iEPort: 'Xuất cảnh quan biệt',
  OceanBillOfLadingNumber: 'Số vận đơn đường biển',
  NoticeBgh: 'Chờ thông báo khai hải quan',
  SelfDeclaration: 'Khách hàng tự khai hải quan',
  NotSentCustomsFile: 'Chưa gửi tài liệu khai hải quan. (Bạn có thể bỏ qua lời nhắc này nếu các đường khác đã được gửi đi)',
  FilledMustFill: 'Khi gửi thông tin khai hải quan, [{0}] trường bắt buộc',
  NoContainerInfo: 'Không có thông tin đóng gói bên dưới hộp',
  InformationComparison: 'So sánh thông tin',
  Diff: 'Khác biệt',
  PostLCLTask: 'Nhiệm vụ LCL đẩy',
  ForceDeleteCustomsTips: 'Tài liệu khai hải quan đã được đẩy lên cờ tín hiệu, xác định phải cưỡng chế xóa bỏ sao?',
  AddCustomerFileFirst: 'Vui lòng thêm thông tin khai hải quan',
  Local: 'Địa phương',
  CustomsDocumentPreparation: 'Chế độ khai hải quan',
  PleaseCreateSplitBillFirst: 'Vui lòng tạo Undo trước',
  Cargo_DisplaySell: 'Hiển thị tài khoản ngân hàng của bên bán hàng',
  Cargo_DisplayBuyer: 'Hiển thị tài khoản ngân hàng của người mua',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(Ghi chú: Cửa khẩu xuất cảnh là đề nghị điền khi Thượng Hải)',
  PleaseFillInTheIEPort: 'Vui lòng điền thông tin xuất cảnh',
  CustomsUnFrozen: 'Khai hải quan rã đông',
  UnFrozen: 'Làm tan băng',
  LCLTaskSent: 'Nhiệm vụ LCL đã gửi',
  LCLTaskNotSent: 'Chưa gửi tác vụ LCL',
  Unfreeze: 'Name',
  NotUnfreeze: 'Chưa rã đông',
  CustomerFileHasBeenSent: 'Thông tin khai hải quan đã được gửi',
  NotSendingCustomerFile: 'Không gửi thông tin khai hải quan',
  XhqCustomerState: 'Tình trạng khai hải quan cờ tín hiệu',
  VGMWeighingAddressCannotBeEmpty: 'VGM không thể cân địa chỉ trống',
  unfrozenOffline: 'Lời bài hát: Freeze (Unline Freeze)',
  NotifyCustomsUnfreeze: 'Thông báo khai hải quan rã đông',
  CargoOwnerSOC: 'Chủ hàng SOC',
  ForwarderSOC: 'Giao nhận SOC',
  SOCType: 'Danh mục thùng hàng chính',
  InvoiceConfig: 'Cấu hình thanh toán',
  InvoiceChannel: 'Kênh thanh toán',
  FEI_NuoNuo: 'Hóa đơn điện đầy đủ của Nono Network: NUONUO',
  FEI_Bwjsy: 'Bách Vượng Kim Tuệ Vân: BWJSY',
  FEI_Kpzddm: 'Mã thiết bị đầu cuối thanh toán (KPZDDM)',
  FEI_Yhdm: 'Mã người dùng (yhdm)',
  FEI_NotUse: 'Chưa bật',
  InvoicerConfig: 'Cấu hình thanh toán',
  Invoicer: 'Trang chủ',
  ExtensionNumber: 'Số máy mở rộng',
  OnlyInvoicer: 'Chỉ dành cho người lập hóa đơn.',
  AllInvoicer: 'Chia sẻ cho tất cả người dùng',
  Cargo_ReceiveAmount: 'Số tiền phải thu',
  Cargo_BatchDeleteChargeTips: 'Không có phí nào được chọn, tất cả phí kinh doanh đã đánh dấu đã bị xóa theo mặc định, bạn có muốn tiếp tục không?',
  Cargo_Template_Push: 'Đẩy mẫu',
  Empty: '(trống)',
  Cargo_UploadTemplateDataSample: 'Tải lên mẫu dữ liệu mẫu',
  Cargo_SureDeleteTheFile: 'Xác định xem có xóa file không?',
  Cargo_DownloadContent: 'Tải xuống nội dung',
  Cargo_ImportOrderTemplateFile: ': Nhập tệp mẫu đơn đặt hàng',
  Cargo_ImportOrderTemplateDataSampleFile: ': Nhập tệp mẫu dữ liệu mẫu đơn đặt hàng',
  Cargo_Sample: 'Ví dụ',
  Cargo_Sample_Tip: '* Nếu HQ đã tải lên tệp mẫu dữ liệu và khi các chi nhánh khác không tải lên, các chi nhánh khác sử dụng tệp mẫu dữ liệu của HQ theo mặc định',
  OpenXhqChat: 'Mở thư',
  OpenXhqChatTips: 'Doanh nghiệp chưa gửi hồ sơ khai hải quan, vui lòng gửi hồ sơ khai hải quan trước',
  CustomsBrokerNotEntered: 'Đại lý hải quan không nhập',
  Cargo_CanNotSplitMasterJob: 'Loại ghép hoàn chỉnh không tương đương với SelfLCL hoặc Buyer Console và không thể tách ra!',
  RespMsg: 'Thông tin',
  Cargo_BillPaymentRemarkTip: '* Khi ghi chú trống, nội dung ghi chú dữ liệu ban đầu sẽ không bị ghi đè.',
  Cargo_WarehouseCode: 'Mã số vào kho',
  Cargo_WarehouseCodeLengthLimit: 'Được sử dụng để tạo cấu hình số vị trí đến, ký tự mã dài nhất là 10 chữ số.',
  Cargo_ValueSetting: 'Cài đặt lấy giá trị',
  Cargo_SettingValuePriority: 'Đặt mức ưu tiên giá trị.',
  Cargo_PleaseToPartnerWarehouseCode: 'Vui lòng xem mã số đối tác',
  Cargo_LineSeaAir: 'Đường bay (bằng đường biển/đường hàng không)',
  Cargo_LineRailWay: 'Đường sắt (Railway)',
  Cargo_BatchDeleteCharge: 'Phí xóa hàng loạt',
  Cargo_SetDeleteCondition: 'Đặt điều kiện xóa',
  Cargo_ToBeDeletedCharge: 'Dữ liệu chi phí cần xóa',
  Cargo_ToBeDeletedChargeSelected: 'Xóa dữ liệu phí đã chọn:',
  Cargo_MatchCharge: 'Chi phí phù hợp',
  Cargo_SureDelete: 'Bạn có chắc chắn xóa {0} mục dữ liệu đã chọn?',
  Cargo_ShowChargeDeleteResult: 'Hiển thị kết quả xóa phí',
  Cargo_DeletedTips: '{0} dữ liệu đã bị xóa',
  Cargo_NotSelectDeletedTips: 'Không có dữ liệu chi phí nào được chọn để xóa!',
  Cargo_PleaseMatchDataFirstTips: 'Vui lòng xác nhận dữ liệu cần xử lý hàng loạt sau khi khớp dữ liệu trước.',
  Cargo_NotSelectDeleteConditionTips: 'Chưa chọn điều kiện xóa phí!',
  Cargo_BatchEditCharge: 'Chi phí chỉnh sửa hàng loạt',
  Cargo_SetEditCondition: 'Đặt điều kiện điều chỉnh',
  Cargo_ToBeEditCharge: 'Dữ liệu chi phí cần điều chỉnh',
  Cargo_ToBeEditChargeSelected: 'Dữ liệu chi phí điều chỉnh đã được chọn:',
  Cargo_SureEdit: 'Bạn có chắc chắn rằng điều chỉnh {0} mục dữ liệu đã được chọn?',
  Cargo_ShowChargeEditResult: 'Hiển thị kết quả cập nhật phí',
  Cargo_EditTips: 'Đã cập nhật {0} dữ liệu',
  Cargo_NotSelectEditTips: 'Không có dữ liệu chi phí nào được chọn để điều chỉnh!',
  Cargo_NotSelectEditConditionTips: 'Không có điều kiện điều chỉnh chi phí nào được chọn!',
  Cargo_EditAmountNoZero: 'Điều chỉnh đơn giá không thể là 0!',
  Cargo_EditUnitRate: 'Điều chỉnh đơn giá',
  Cargo_EditSettleAccountsTo: 'Điều chỉnh đối tượng thanh toán',
  Cargo_HandleResult: 'Kết quả xử lý',
  Cargo_LoadMore: 'Tải thêm',
  Cargo_NoMoreData: 'Không thêm dữ liệu',
  Cargo_ChargeHasDiffAmount: 'Chi phí đã được xử lý chênh lệch, không cho phép sửa đổi!',
  Cargo_ChargeHasConfirm: 'Chi phí được xác nhận không cho phép sửa đổi!',
  Cargo_ChargeHasVerified: 'Chi phí đã tiêu thụ không cho phép sửa đổi!',
  Cargo_ChargeHasCommit: 'Phí đã nộp Không cho phép sửa đổi!',
  Cargo_ChargeHasCreateBillPayment: 'Phí đã tạo Yêu cầu thanh toán Không được phép sửa đổi!',
  Cargo_ChargeHasCreateInvoice: 'Chi phí đã lập hóa đơn không cho phép sửa đổi!',
  Cargo_JobStateNotAllowModified: 'Doanh nghiệp đã gửi/đã được xem xét Không cho phép sửa đổi!',
  Cargo_InvoiceChargeItemSetup: 'Thiết lập chi phí (thanh toán tại Việt Nam)',
  Cargo_InvoiceChargeUnitSetup: 'Thiết lập đơn vị (thanh toán tại Việt Nam)',
  Cargo_ChargeItemId: 'Thu phí (Cargoware)',
  Cargo_ChargeItemName: 'REFERENCES [Tên bảng tham chiếu] (',
  Cargo_ChargeUnitCode: 'Đơn vị (Cargoware)',
  Cargo_ChargeUnitName: 'Mô tả (nền tảng kế toán)',
  Cargo_InvoicingByTaxRate: 'Lập hóa đơn theo nhóm điểm thuế',
  Cargo_SureToVoidTheInvoiceVietnam: 'theo chính sách kiểm soát thuế của Việt Nam. Vui lòng xác nhận rằng khách hàng đã được liên hệ để đảm bảo rằng hóa đơn chưa được khai thuế. Nếu đã ngoại thuế, xin đừng hủy bỏ hóa đơn. <br/><br/>Xác nhận có hủy bỏ hóa đơn này không?',
  Cargo_RandomPassword: 'Mật khẩu ngẫu nhiên',
  ChargeSchemeCopy: 'Chi phí sao chép kế hoạch',
  CompanyCopy: 'Đối tác Sao chép',
  SourceCompany: 'Công ty nguồn',
  QueryChargeScheme: 'Yêu cầu gói cước',
  CopyChargeScheme: 'Kế hoạch chi phí sao chép',
  QueryCompany: 'Yêu cầu đối tác',
  CopyCompany: 'Đối tác sao chép',
  FuzzyQueryOfIdOrName: 'Name',
  CopyToCompany: 'Sao chép chi nhánh',
  CopySuccessCount: 'Sao chép thành công {0}',
  PleaseSelectTargetTenant: 'Vui lòng chọn đối tượng thuê mục tiêu',
  Cargo_TemplateNodeWorkTaskSetting: 'Thiết lập nhiệm vụ làm việc nút cho mẫu',
  Cargo_WorkTaskEnable: 'Bật thiết lập nhiệm vụ làm việc của nút',
  Cargo_SetNodeResponsible: 'Thiết lập node chịu trách nhiệm',
  Cargo_DesignatedPosition: 'REFERENCES [Tên bảng tham chiếu] (',
  Cargo_SetPreNode: 'Đặt nút trước (trạng thái nút trước cần thiết để nút bắt đầu)',
  Cargo_SetPreNodeTips: 'Thiết lập các pre-node của node này (tối đa 5 pre-node, tương ứng với các mối quan hệ)',
  Cargo_HandlingPriorityMarkers: 'Làm việc với thẻ ưu tiên',
  Cargo_HandlingPriorityMarkersTips: 'Thiết lập mức độ ưu tiên xử lý (tối đa 3, mặc định là mức độ ưu tiên thấp khi không thiết lập)',
  Cargo_HandlingPriorityMarkersHigh: 'Đặt mức ưu tiên xử lý thành: Cao',
  Cargo_HandlingPriorityMarkersMedium: 'Đặt mức ưu tiên xử lý thành: Trung bình',
  Cargo_HandlingPriorityMarkersLow: 'Đặt ưu tiên xử lý thành: Thấp',
  Cargo_SOPWorkTaskBoard: 'NV SOP Kanban',
  Cargo_High: 'Cao:',
  Cargo_Medium: 'Trong:',
  Cargo_Low: 'Thấp:',
  Cargo_SopBusinessFlowDashboard: 'Bảng quy trình SOP',
  Cargo_WarnTodoList: 'CV cần cảnh báo',
  Cargo_BpmTodoList: 'DS phê duyệt',
  Cargo_BusinessTime: 'Thời gian kinh doanh',
  Cargo_HandleLevel: 'Mức độ xử lý',
  Cargo_PreNode: 'Nút trước',
  Cargo_PriorityHigh: 'Ưu tiên cao',
  Cargo_PriorityMedium: 'Ưu tiên trung bình',
  Cargo_PriorityLow: 'Ưu tiên thấp',
  Cargo_SetDefaultDisplayItem: 'Đặt làm mặc định',
  Cargo_PreNodeRepeat: 'Cấu hình nút trước lặp lại',
  Cargo_PriorityRepeat: 'Trong cấu hình ưu tiên, 【Điều kiện mục+cách kích hoạt+ngày】 không thể lặp lại',
  Cargo_TrackingIconTip: 'Biểu tượng này được sử dụng cho các hệ thống B2B và các nhiệm vụ SOP để sử dụng Kanban!',
  Cargo_LoadData: 'Tải lại',
  Cargo_TemplateNodeMergeShow: 'Hiển thị hợp nhất nút mẫu',
  Cargo_MblTip: 'Vui lòng nhập 6-30 ký tự chữ hoa và số',
  Cargo_VesselTip: 'Vui lòng nhập chữ cái, số, dấu ".", "-", "khoảng trắng"',
  Cargo_VesselTip2: 'Không thể nhập tiếng Trung và ký tự toàn giác',
  Cargo_VoyageTip: 'Vui lòng nhập không có V. Chuyến bay',
  Cargo_ShippingCompanyTip: 'Vui lòng chọn tàu',
  Cargo_CarrierAgentTip: 'Vui lòng chọn Shipman',
  Cargo_SailingDateTip: 'Vui lòng chọn ngày khởi hành',
  Cargo_PortOfLoadingHgjTip: 'Hải quản gia chỉ hỗ trợ cảng Thượng Hải gửi',
  Cargo_PortOfLoadingWsTip: 'Vui lòng chọn cảng khởi hành, hỗ trợ Thượng Hải, Thanh Đảo',
  Cargo_PortOfLoadingTip: 'Vui lòng chọn tên đầy đủ bằng tiếng Anh',
  Cargo_PortOfDischargeTip: 'Vui lòng chọn cảng dỡ hàng',
  Cargo_PortOfDestinationTip: 'Vui lòng chọn cảng đích',
  Cargo_PortOfDestinationTip2: 'Vui lòng chọn tên đầy đủ bằng tiếng Anh',
  Cargo_BlNumberTip: 'Vui lòng chọn phương thức vận đơn',
  Cargo_DispatchingPlaceCodeTip: 'Nếu Nam Kinh nhận hàng qua Thượng Hải, nơi giao hàng sẽ điền vào Nam Kinh.',
  Cargo_DispatchingPlaceCodeTip2: 'Vui lòng chọn nơi gửi hàng',
  Cargo_DispatchingPlaceCodeTip3: 'Chỉ có thể hỗ trợ nơi giao hàng là Thanh Đảo hoặc Nhật Chiếu.',
  Cargo_ShipperEnterpriseNameTip: 'Vui lòng nhập ký tự trong vòng 140',
  Cargo_ShipperEnterpriseNameTip2: 'Vui lòng nhập các ký tự trong vòng 70',
  Cargo_ShipperContactsTip: 'Vui lòng nhập số điện thoại trong vòng 20 ký tự',
  Cargo_PortPlaceOfDeparture: 'Cảng khởi hành/Nơi khởi hành',
  Cargo_PortPlaceOfDischarge: 'Cảng dỡ hàng/Nơi dỡ hàng',
  Cargo_MsgClassifyManager: 'Quản lý phân loại tin nhắn',
  Cargo_BellMsg: 'Tin nhắn chuông',
  QuickSearchMsgClassify: 'Vui lòng nhập tên truy xuất mờ',
  Cargo_GroupingDimensionForRate: '"Điều kiện nhóm" bằng "thuế suất" và "giá trị" phải được điền là "số"!',
  Cargo_CheckAccountSetBranchId: 'Chi nhánh của sổ cái hiện tại không thuộc chi nhánh hiện tại hoặc chi nhánh cao hơn, có tiếp tục không?',
  Cargo_BillPayment: 'Yêu cầu thanh toán',
  Cargo_MakeInvoice: 'Yêu cầu thanh toán',
  Cargo_JobCharge: 'Đơn yêu cầu chi phí kinh doanh',
  Cargo_CopyNotifier: 'Sao chép thông báo',
  Cargo_CopyRecipient: 'Sao chép người nhận hàng',
  Cargo_InputIMO: 'Vui lòng nhập số IMO',
  Cargo_InputBLFreightTermTootip: 'Vui lòng chọn điều khoản vận chuyển',
  Cargo_PureNumbers: 'Vui lòng nhập số thuần',
  Cargo_DefaultShanghai: 'Mặc định Shanghai | CNSHA, không thể thay đổi',
  Cargo_IMO: 'Số IMO',
  Cargo_DangerousGoodsCheck: 'Bạn điền {0}, nhưng loại hàng hóa được chọn là "hàng hóa thông thường", vui lòng gửi lại sau khi xác minh',
  ChinaPostProductConfiguration: 'Cấu hình sản phẩm Email Trung Quốc',
  AllowSaleProduct: 'Sản phẩm bán chạy',
  AllowSaleProductNotNull: 'Sản phẩm bán được Chưa chọn',
  NewChargeGroup: 'Nhóm chi phí thế hệ mới',
  ChargeMapping: 'Bản đồ chi phí thế hệ mới',
  ChargeMappingFuzzySearch: 'Vui lòng nhập mã phí truyền tải hoặc truy vấn mờ tên',
  RailwayUse: 'Sử dụng đường sắt',
  BecameInvalid: 'Hết hạn',
  FullOrInside: 'Toàn bộ/trong nước',
  FullOrInsideNotNull: 'Toàn quốc/Không chọn',
  TransmitChargeName: 'Nhóm phí truyền tải',
  TransmitChargeNameNotNull: 'Không chọn nhóm phí truyền tải',
  TransmitChargeCode: 'Mã nhóm phí truyền tải',
  MaintainerRemarks: 'Nhân viên bảo trì Ghi chú',
  PushOrNot: 'Đẩy lại hay không',
  Cargo_BusinessLeaderCompanyPrePort: 'Công ty Lãnh đạo Kinh Doanh Cảng Trước',
  Cargo_BusinessLeaderDeptPrePort: 'Phòng Ban Lãnh Đạo Kinh Doanh Cảng Trước',
  Cargo_BusinessLeaderCompanyEndPort: 'Công ty Lãnh đạo Kinh Doanh Cảng Cuối',
  Cargo_BusinessLeaderDeptEndPort: 'Phòng Ban Lãnh Đạo Kinh Doanh Cảng Cuối',
  Cargo_CurrentNode: 'Nút hiện tại',
  Cargo_WorkNode: 'Nút làm việc',
  Cargo_EditStateTip: 'Xác định thay đổi trạng thái nút của mục dữ liệu {0} đã chọn?',
  Cargo_BpmSubmitDuplicated: 'Tài liệu hiện tại đã có phiếu đánh giá, đừng gửi lại',
  Cargo_TempCreditApply: 'Đơn xin kiểm soát tín dụng tạm thời',
  Cargo_PartnerName: 'Tên đối tác',
  Cargo_ContractAmount: 'Hạn mức hợp đồng',
  Cargo_ContractAccountingPeriod: 'Thời hạn hợp đồng',
  VerificationSheetRequired: 'Kiểm tra cần thiết',
  Cargo_TransportSource: 'Nguồn gốc của Mobility',
  Cargo_CustomerExpandMode: 'Cách của Tuo Guest',
  Cargo_SubmitTempCreditTip: 'Bảo vệ điều khiển tín dụng tạm thời phải khởi xướng quy trình phê duyệt tín dụng tạm thời, bây giờ ông có muốn khởi xướng phê duyệt không?',
  Cargo_CustomFields: 'Trường cấu hình',
  Cargo_CustomerCode: 'Hệ thống chứng từ Mã khách hàng',
  Cargo_NoHasFinanceCode: 'Hóa đơn tương ứng ngẩng đầu không tương ứng với "Mã hóa khách hàng hệ thống chứng từ" của bạn bè.',
  Cargo_MultiCurrency: 'Hóa đơn được đánh dấu tồn tại nhiều loại tiền tệ.',
  Cargo_YongYouDeleteTip: 'Hóa đơn hiện hành đã được gửi cho bạn bè, nếu cần thao tác, cần phải đến hệ thống chứng từ, xóa các bản ghi tương ứng. Chắc chắn về chiến dịch chứ?',
  Cargo_SyncVerifyDoc: 'Đồng bộ hóa các tài liệu tiếp thị hạt nhân',
  Cargo_HasSync: 'Dữ liệu đã chọn đã đồng bộ',
  Cargo_OverseaActualAmount: 'Số liệu tiêu thụ sổ sách nước ngoài, không thể đồng bộ dùng bạn bè.',
  Cargo_MultiInvoiceTitle: 'Tồn tại trong một dòng nước tiêu thụ, bao gồm nhiều hóa đơn ngẩng đầu. Không thể đẩy bạn bè, xin hãy điều chỉnh dữ liệu.',
  Cargo_InvoiceTitleMustBeIdentical: 'Hóa đơn phải giống nhau.',
  Cargo_ChargeChangeApply: 'Yêu cầu thay đổi phí',
  Cargo_HideUnmodifiedFees: 'CP ẩn cố định',
  Cargo_ChargeChangeTip: 'Ghi chú: Nội dung thay đổi hiện nay đã tồn tại đợi phê duyệt, đợi khi kết thúc sửa đổi lần này mới có thể tiến hành điều chỉnh chi phí một lần nữa.',
  Cargo_UniqueIdentification: 'Nhận dạng duy nhất',
  Cargo_CostNumber: 'Số chi phí',
  Cargo_OriginalCostUniqueIdentifier: 'Chi phí ban đầu được xác định duy nhất',
  Cargo_OriginalExpenseNumber: 'Số phí gốc',
  Cargo_ChargeChange: 'Phí thay đổi',
  Cargo_ApprovalProcessForChargeChange: 'Quy trình phê duyệt yêu cầu thay đổi phí',
  Cargo_ChargeChangeTip2: 'Xin hỏi bây giờ có cần xác nhận phê duyệt thay đổi chi phí khởi xướng không?',
  Cargo_ChargeChangeTip3: 'Lưu ý: Không thể thay đổi chi phí cho đến khi kết thúc phê duyệt này.',
  Cargo_ViewChangeData: 'Xem dữ liệu thay đổi',
  Cargo_GrossProfitMarginBeforeChange: 'Lợi nhuận gộp trước khi thay đổi',
  Cargo_GrossProfitMarginAfterChange: 'Lợi nhuận gộp sau khi thay đổi',
  CustomFieldDisplayConfiguration: 'Hiển thị trường tùy chỉnh',
  Field: 'Lĩnh vực',
  ChineseDisplayName: 'Name',
  EnglishDisplayName: 'Tên hiển thị tiếng Anh',
  FieldNotEmpty: 'Field không thể để trống',
  ChineseDisplayNameNotEmpty: 'Chưa điền tên hiển thị tiếng Trung',
  EnglishDisplayNameNotEmpty: 'Chưa điền tên hiển thị bằng tiếng Anh',
  Cargo_ContractRule: 'Quy định hợp đồng',
  Cargo_ApplicationConditions: 'ĐKƯD',
  Cargo_ConditionValue: 'Giá trị điều kiện',
  Cargo_ContractWarning: 'Hợp đồng cảnh báo sớm',
  Cargo_ApplicationRules: 'Quy tắc áp dụng',
  Cargo_ContractRuleChangeTip: 'Các quy tắc hiện tại đã được áp dụng cho một số hợp đồng, vui lòng thực hiện trước khi thay đổi quy tắc mới cho hợp đồng áp dụng quy tắc này.',
  Cargo_DailySettlement: 'Trang chủ',
  Cargo_ContractNumber2: 'Số hợp đồng',
  CheckArApDisparity: 'Kiểm tra hóa đơn đã được cấu hình, vui lòng nhận và thanh toán hóa đơn riêng biệt',
  VASChannelSetting: 'Cấu hình kênh dịch vụ giá trị gia tăng',
  ManifestChannel: 'Nhà cung cấp gửi Manifest',
  VGMChannel: 'Nhà cung cấp gửi VGM',
  VASChannelFormEditTip: 'Vui lòng đánh dấu vào thiết lập kênh gửi cho đối tượng thuê cần chỉnh sửa',
  VASChannelFormDeleteTip: 'Vui lòng đánh dấu vào thiết lập kênh gửi đối tượng thuê cần xóa',
  VASChannelSelectOneTip: 'Nhà cung cấp gửi bản kê khai trước/Nhà cung cấp gửi VGM Chọn ít nhất một',
  VASChannelDeleteTip: 'Xác nhận rằng bạn muốn xóa cài đặt của đối tượng thuê này',
  VASChannelDTip: 'Xóa cài đặt kênh gửi',
  Cargo_PushAddCustomer: 'Đẩy khách hàng mới',
  Cargo_ChooseArea: 'Vui lòng chọn khu vực',
  Cargo_AllocationSuccessful: 'Phân phối thành công',
  Cargo_CreatedSuccessful: 'Tạo thành công',
  Cargo_DuplicateCustomerName: 'Tên khách hàng lặp lại',
  Cargo_ExistFinanceCode: 'Mã hóa khách hàng đã tồn tại, không cần đẩy',
  Cargo_EntrustedReceiveInfo: 'Delegate nhận thông tin',
  Cargo_ContainerLoadTypeRailWay: 'Đường sắt (Railway)',
  ExclusionOffice: 'Thiết lập công ty giao diện thế hệ mới',
  Cargo_TransportationType: 'Loại vận chuyển',
  Cargo_MultiOrderTip: 'Nếu bạn có nhiều dữ liệu, bạn sẽ tạo đơn đặt hàng.',
  Cargo_IdentifyTemplateName: 'Nhận dạng tên mẫu',
  Cargo_IdentifyTemplateName2: 'Nhận dạng tên mẫu:',
  Cargo_TemplateId: 'Mẫu ID',
  Cargo_CodeProcessing: 'Xử lý mã',
  Cargo_TestFile: 'Tài liệu kiểm tra',
  Cargo_TemplateIdAutomaticallyGenerated: 'ID mẫu (được tạo tự động):',
  Cargo_TemplateStatus: 'Trạng thái mẫu:',
  Cargo_DocumentTypeDescription: 'Mô tả loại tập tin',
  Cargo_DocumentTypeDescription2: 'Mô tả loại tập tin:',
  Cargo_ReadField: 'Trường đọc',
  Cargo_FieldName: 'Tên trường',
  Cargo_FieldRuleDescription: 'Description',
  Cargo_PreviewPromptWords: 'Xem thử từ gợi ý',
  Cargo_Invalid3: 'Không hợp lệ',
  Cargo_Sequence: 'Chuỗi',
  Cargo_FieldAdd: 'Trường mới',
  Cargo_FieldEdit: 'Sửa trường',
  Cargo_FieldView: 'Xem trường',
  Cargo_PlatformEnterpriseName: 'Tên doanh nghiệp nền tảng',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: 'Địa chỉ gọi lại',
  Cargo_PlatformEnterpriseInterfaceConfiguration: 'Cấu hình giao diện doanh nghiệp nền tảng',
  Cargo_OcrTemplateConfig: 'Thiết lập mẫu OCR',
  Cargo_OcrCode: 'Xử lý mã nhúng (xử lý thứ cấp mã nhúng trả về kết quả cuối cùng dưới dạng giá trị đầu ra API)',
  Cargo_originalValue: 'Giá trị gốc',
  Cargo_DebuggingResults: 'Kết quả gỡ lỗi',
  Cargo_UsageStatistics: 'Thống kê sử dụng',
  Cargo_NumberOfSuccessfulCalls: 'Số lần gọi thành công',
  Cargo_UsingFlowingWater: 'Sử dụng nước chảy',
  Cargo_CallTemplateId: 'Gọi ID mẫu',
  Cargo_CallResult: 'Kết quả cuộc gọi',
  Cargo_Template: 'Mẫu',
  Cargo_QueryFlowingWater: 'Xem nước chảy',
  Cargo_TemplateId2: 'Mã mẫu:',
  Cargo_FileName2: 'Tên tập tin:',
  Cargo_IdentifyReturnResult: 'Xác định kết quả trả về:',
  Cargo_CustomsChannel: 'Nhà cung cấp nhận dạng tờ khai hải quan',
  Cargo_PleaseSelectSpecificFields: 'Vui lòng chọn một lĩnh vực cụ thể để chỉnh sửa',
  Cargo_ConfirmToDeleteThisField: 'Bạn chắc chắn muốn xóa lĩnh vực này? Giao diện sẽ không còn trả về thông tin trường này sau khi xóa',
  Cargo_ValidThisRecognitionTemplate: 'Bạn có chắc chắn muốn khôi phục mẫu nhận dạng này hợp lệ?',
  Cargo_InValidThisRecognitionTemplate: 'Bạn chắc chắn muốn vô hiệu hóa cấu hình này? Giao diện gọi sẽ không còn trả về dữ liệu sau khi lỗi',
  Cargo_ValidThisRecognitionEnterprise: 'Bạn có chắc chắn rằng bạn muốn khôi phục doanh nghiệp của bạn có hiệu quả không?',
  Cargo_InValidThisRecognitionEnterprise: 'Bạn có chắc chắn muốn vô hiệu hóa doanh nghiệp? Không thể gọi giao diện sau khi lỗi',
  Cargo_DateErrorTip: 'Ngày hết hạn phải lớn hơn ngày có hiệu lực',
  Cargo_ModifyCodeHandle: 'Sửa đổi"Xử lý mã"',
  Cargo_ModifyPromptWords: 'Sửa đổi"Từ gợi ý"',
  Cargo_CannotEnable: 'Không có hiệu lực, không thể nhấp vào 【Bật】',
  Cargo_InputTokenCount: 'Số lượng input_token',
  Cargo_OutputTokenCount: 'Số lượng output_token',
  Cargo_PlsGenerate: 'Vui lòng tạo',
  Cargo_TemplateUsed: 'Mẫu này đã được sử dụng bởi khách hàng và không thể chỉnh sửa. Có thể tháo dây và chỉnh sửa lại hoặc sao chép mẫu để chỉnh sửa.',
  Cargo_SelectOneData: 'Chỉ cho phép đánh dấu một phần dữ liệu để sao chép!',
  Cargo_OutputRequirements: 'Yêu cầu đầu ra:',
  Cargo_AnalyticMethod: 'Phương thức phân tích:',
  Cargo_BLNoStatistics: 'Số Bill of Lading',
  Cargo_RemainingQuantity: 'Số lượng còn lại',
  Cargo_RegistrationDate: 'Ngày đăng ký',
  AnalyzeChannelSettings: 'Phân tích thiết lập kênh',
  EmailParsingSettings: 'Thiết lập phân giải thư',
  EmailPasswordAuthorizationCode: 'Mật khẩu hộp thư/Mã ủy quyền',
  SenderServer: 'Máy chủ gửi thư',
  Port: 'Cổng',
  AddOrEditEmail: 'Thêm/Sửa hộp thư',
  EmailPurpose: 'Sử dụng hộp thư',
  EnterCorrectEmail: 'Vui lòng nhập đúng địa chỉ email',
  SelectDeleteEmail: 'Vui lòng chọn hộp thư bạn muốn xóa',
  DeleteEmailConfirm: 'Xác nhận xóa hộp thư đã chọn? Hộp thư đã xóa sẽ không còn được đọc để phân tích cú pháp sau khi xóa',
  ImportMblNo: 'Nhập đơn vị chính',
  ApplicableDepartment: 'Bộ phận áp dụng',
  Cargo_QuoteMethod_ExistingRate: 'Báo giá với "Tỷ giá hiện có" không thể bị rút lại',
  Cargo_QuoteMethod: 'Phương thức báo giá',
  Cargo_ExistingRate: 'Tỷ giá hiện có',
  Cargo_CommercialQuote: 'Báo giá thương mại',
  Cargo_PrePortQuoteMethod: 'Phương thức báo giá trước cảng',
  Cargo_MainlineQuoteMethod: 'Phương thức báo giá tuyến chính',
  Cargo_EndlineQuoteMethod: 'Phương thức báo giá cuối tuyến',
  PleaseSelectApplicableBranch: 'Vui lòng chọn chi nhánh áp dụng',
  Cargo_CheckSetting: 'Thiết lập kiểm tra',
  Cargo_BookNoteFieldName: 'Name',
  Cargo_IfRequired: 'Bắt buộc',
  Cargo_Channel: 'Kênh',
  Cargo_IfSame: 'Tương phản không phù hợp',
  Cargo_DefaultValue2: 'Mặc định rỗng',
  Cargo_BookFieldNameRepeat: 'Tên trường Thư viện Lặp lại',
  Cargo_BookNoteFieldAndSort: 'Thư viện hiển thị các trường và thứ tự.',
  Cargo_IfAutoBooking: 'Đặt phòng tự động',
  Cargo_BookRecognitionResults: 'Sách nhận dạng kết quả',
  Cargo_ConfirmedBusinessData: 'Thông tin danh sách',
  Cargo_OtherData: 'Dữ liệu khác',
  Cargo_BranchOffice: 'Chi nhánh (BranchOffice)',
  Cargo_ShippingCompany: 'Hãng tàu (ShippingCompany)',
  Cargo_IfAutomaticBooking: 'Đặt phòng tự động (IfAutomaticBooking)',
  Cargo_Book: 'Sách ủy thác',
  Cargo_GoodNameContainSensitiveWord: 'Có các từ nhạy cảm<span style="color: red">{0}</span>, bạn có tiếp tục đặt phòng không?',
  Cargo_OnlyGenerateJob: 'Chỉ tạo doanh nghiệp',
  Cargo_PleaseReceiveCallback: 'Chú ý nhận receive',
  Cargo_JobProcess: 'Tiến độ kinh doanh',
  Cargo_IdentificationMethod: 'Cách nhận dạng',
  Cargo_NoNeedSupplementaryInformationBookNote: 'Không cần thêm thông tin bổ sung',
  Cargo_SupplementaryInformationTip: 'Hãy chọn một bản ghi có 【Tiến trình tải lên】 là 【Phân tích xong】 và 【Xác định kênh】 là 【CW - Nhận dạng đa phương thức】 và 【Loại nhận dạng】 là 【Sách ủy thác biển】',
  CannotBeLongerThan35: 'Thông tin siêu dài, vui lòng chỉnh sửa lại, tối đa {0} dòng, tối đa 35 ký tự mỗi dòng',
  Cargo_OcrSetTip: 'Bạn chưa thiết lập bất kỳ thông tin nào, các trường sau và cài đặt xác minh là mặc định của hệ thống, hiển thị cài đặt mặc định của nền tảng<br/><br/>Ưu tiên giá trị: Nếu bạn chọn Tổng công ty Ứng dụng, Ưu tiên Tổng công ty Ứng dụng>Cài đặt Đối tượng thuê>Cài đặt Nền tảng',
  Cargo_AutomaticAllocation: 'Phí chia sẻ ảo tự động',
  Cargo_ChargeAutomaticAllocationConfig: 'Cấu hình chia sẻ chi phí tự động',
  Cargo_EditAutomaticAllocationConfig: 'Chỉnh sửa phí vé chính Cấu hình chia sẻ tự động',
  Cargo_AddAutomaticAllocationConfig: 'Cấu hình chia sẻ tự động phí vé chính mới',
  Cargo_MatchingCriteriaSelection: 'Điều kiện khớp Chọn',
  Cargo_AutomaticAllocationRuleConfig: 'Cấu hình quy tắc chia sẻ tự động',
  Cargo_AllocationNature: 'Phân chia tài sản',
  Cargo_HblSingleAllocation: 'HBL được chia',
  Cargo_OnlyAllocatedToHblSingle: 'Chỉ chia ra và đơn lẻ.',
  Cargo_MasterBill: 'Danh sách chính',
  Cargo_AddEditReceivablePayableFees: 'Thêm/Sửa phí phải thu và phải trả',
  Cargo_AddEditReceivableFees: 'Thêm/Sửa phí phải thu',
  Cargo_AddEditPayableFees: 'Thêm/Sửa phí phải trả',
  Cargo_AddEditReceivableSpecialFees: 'Thêm/Sửa phí đặc biệt phải thu',
  Cargo_AddEditPayableSpecialFees: 'Thêm/Sửa phí đặc biệt phải trả',
  Cargo_DeleteReceivablePayableFees: 'Xóa phí phải thu và phải trả',
  Cargo_DeleteReceivableFees: 'Xóa phí phải thu',
  Cargo_DeletePayableFees: 'Xóa phí phải trả',
  Cargo_ImportReceivablePayableFees: 'Nhập khẩu phí phải thu và phải trả',
  Cargo_ImportReceivableFees: 'Nhập khẩu phí phải thu',
  Cargo_ImportPayableFees: 'Nhập khẩu phí phải trả',
  Cargo_BusinessTypeError: 'Loại giao dịch tài liệu đã chọn không khớp và không thể sửa đổi!',
  Cargo_ReceivableSpecialFee: 'Phí đặc biệt phải thu',
  Cargo_PayableSpecialFee: 'Phí đặc biệt phải trả',
  Cargo_ReceivablePayableSpecialFee: 'Phí đặc biệt phải thu và phải trả',
  Cargo_PleaseSetChargeNameAndAllocationType: 'Vui lòng đặt tên chi phí và loại chia sẻ',
  Cargo_PleaseSetChargeName: 'Vui lòng đặt tên phí',
  Cargo_PleaseSetAllocationType: 'Vui lòng đặt loại chia sẻ',
  Cargo_HasDuplicateConfigItem: 'Đã có dữ liệu cấu hình lặp lại!',
  Cargo_ConfirmDeleteTheConfigItem: 'Xác định xem mục cấu hình có bị xóa không?',
  Cargo_ConfirmSaveModifiedInfo: 'Xác định xem bạn có lưu thông tin sửa đổi không?',
  Cargo_InvoiceRepeat: 'Số hóa đơn lặp lại',
  Cargo_TurnOffAutomaticAllocation: 'Thay vào đó, hãy tắt phí chia sẻ ảo tự động cho vé chính đó bằng cách chia sẻ thủ công!',
  Cargo_RemainingAmountNotEnough: 'Số dư không đủ, vui lòng nạp tiền',
  Cargo_RemainingAmountNotEnough2: 'Không đủ số dư để xây dựng lại doanh nghiệp',
  Cargo_ExpandAll: 'Mở rộng>',
  Cargo_PackUp: '<Thu gọn',
  Cargo_OcrTip: 'Gợi ý ấm áp: Thông tin danh sách đề cập đến việc ghi dữ liệu trong doanh nghiệp, trong đó phông chữ màu đỏ biểu thị lỗi không thể được ánh xạ với nền tảng, cần phải sửa đổi danh sách sau khi',
  Cargo_OcrTip2: 'Lời nhắc: Thông tin nhập đơn là dữ liệu được ghi vào công việc, phông chữ màu đỏ biểu thị lỗi không thể ánh xạ với nền tảng.',
  Cargo_ClaimSettlement: 'Bồi thường',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: 'Tình trạng thanh toán không đáp ứng yêu cầu thanh toán',
  Cargo_GetReceiptSettings: 'Cài đặt Callback',
  Cargo_AddEditReadReceiptMethod: 'Thêm/sửa cách đọc trả về',
  Cargo_ReadReceiptMethod: 'Đọc phương thức trả lại',
  Cargo_DeleteReceiptTip: 'Bạn chắc chắn muốn xóa cấu hình này? Sau khi xóa, bạn sẽ không còn đọc receipt theo quy tắc này nữa.',
  Cargo_PleaseInputTitleOrContentTip: 'Vui lòng nhập tiêu đề hoặc nội dung',
  Cargo_BookingState: 'Trạng thái đặt phòng',
  Cargo_BookingChannelConfig: 'Cấu hình kênh đặt cọc',
  Cargo_BookingMode: 'Chế độ đặt phòng',
  Cargo_RpaSupplier: 'RPA Nhà cung cấp',
  Cargo_BookingChannel: 'Kênh đặt phòng',
  Cargo_ConfirmRejectQuote: 'Bạn chắc chắn muốn từ chối báo giá này không?',
  Cargo_MainlineRejectReason: 'Lý do từ chối tuyến chính',
  Cargo_PortRejectReason: 'Lý do từ chối trước cảng',
  Cargo_EndlineRejectReason: 'Lý do từ chối cuối tuyến',
  Cargo_WebSite: 'Trang chủ',
  Cargo_CompanyCode: 'Mã công ty',
  Cargo_ReceiptConfig: 'Cấu hình trả về',
  Cargo_EditBookingChannelConfig: 'Chỉnh sửa cài đặt kênh đặt chỗ',
  Cargo_AddBookingChannelConfig: 'Thiết lập kênh đặt phòng mới',
  Cargo_ReceiptConfigCannotBeEmpty: 'Cấu hình trả về không thể để trống',
  Cargo_IndiaLineInfo: 'Ấn Độ đường',
  Cargo_CargoAmount: 'Giá trị',
  Cargo_CargoCurrency: 'Tiền tệ',
  Cargo_YdShipCode: 'Công ty tàu',
  Cargo_SendThisPageEDI: 'Gửi trang này EDI',
  Cargo_SendAllEDI: 'Gửi tất cả EDI',
  Cargo_SendEDI: 'Gửi EDI hay không?',
  Cargo_IsSendAllEDI: 'Gửi tất cả EDI?',
  Cargo_SendEDISucceeded: 'Gửi EDI thành công',
  Cargo_FailedToSendEDI: 'Gửi EDI không thành công',
  Cargo_CheckCanSendEDI: 'Đang đặt hàng hoặc đã đặt hàng không thể gửi lại',
  Cargo_OneKeyBooking: 'Đặt phòng một phím',
  Cargo_OneKeyBookingTip1: 'Thỏa mãn điều kiện khởi xướng nghiệp vụ đặt phòng: span style="color: blue">{0}</span>, sau khi nhấp vào 【Xác nhận】 sẽ trực tiếp khởi xướng đặt phòng, có thể kiểm tra trạng thái đặt phòng trong thẻ đặt phòng EDI hoặc bằng đường biển',
  Cargo_OneKeyBookingTip2: 'Lời khuyên ấm áp: Đơn đặt hàng đáp ứng các điều kiện sau sẽ bắt đầu đặt hàng bằng một cú nhấp chuột<br/>1) Ngày khởi hành>Ngày<br/>2) Trạng thái đặt hàng là "Danh sách đã ghi, chưa đặt hàng<br/>3) Loại hàng hóa: Phổ biến<br/>4) Loại cắt dán hoàn chỉnh: FCL',
  Cargo_CanNotBooking: 'Không có doanh nghiệp phù hợp với [Bracket0]',
  Cargo_CurrentlyBooking: 'Đã đặt phòng gần 2 tháng:',
  Cargo_SendSuccess2: 'Gửi thành công:',
  Cargo_CallEdiFail: 'Gọi ngoại lệ:',
  Cargo_ValidFail: 'Lỗi kiểm tra:',
  Cargo_TemplateMatchFail: 'Lỗi khớp mẫu:',
  Cargo_BookingSendMethod: 'Cách gửi đặt phòng',
  Cargo_BookingSendChannel: 'Đặt phòng kênh gửi',
  Cargo_BookingSendDate: 'Thời gian gửi đặt phòng',
  Cargo_BookingReceiptDate: 'Thời gian hoàn trả cabin',
  Cargo_OriginBookingState: 'Trạng thái ban đầu của cabin',
  Cargo_NotBooking: 'Không đặt phòng',
  Cargo_ContinueBooking: 'Tiếp tục đặt phòng.',
  Cargo_ChangeInfo: 'Sửa đổi thông tin',
  Cargo_BookingTransportMode: 'Phương thức truyền tải Staking',
  Cargo_EdiBookingExportState: 'Trạng thái xuất',
  Cargo_OneKeyBookingTip3: 'Đang khởi động đặt phòng, có thể kiểm tra trạng thái đặt phòng cụ thể sau.',
  Cargo_BookingInProgress: 'Đang đặt phòng.',
  Cargo_NewSpaceCarrier: 'Hãng vận chuyển cabin mới',
  Cargo_AlreadyExistsCheck: 'Dữ liệu tương tự đã tồn tại và không cần lưu.',
  Cargo_portOfLoadingSeaport: 'Thông tin khoang khởi hành cảng (cảng biển)',
  Cargo_portOfDestinationSeaport: 'Thông tin vị trí cảng đích (cảng biển)',
  Cargo_portOfLoadingAirport: 'Thông tin khoang khởi hành (cảng hàng không)',
  Cargo_portOfDestinationAirport: 'Cảng thông tin vị trí (cảng hàng không)',
  Cargo_shippingCarrier: 'Hãng vận chuyển cabin',
  Cargo_shippingAirline: 'Thông tin cabin Tuyến đường',
  Cargo_newEventRecord: 'Lịch sử sự kiện mới',
  Cargo_SelectInquiryToCopy: 'Vui lòng chọn yêu cầu cần sao chép',
  Cargo_VerifyStateReceivableDomestic: 'Tình trạng tiêu thụ hạt nhân trong nước',
  Cargo_VerifyStateReceivableOversea: 'Nước ngoài phải thu mua tình trạng tiêu thụ hạt nhân',
  Cargo_ReturnActualAmountNo: 'Đơn vị nước liên quan',
  Cargo_ReturnAmount: 'Số tiền hoàn trả',
  Cargo_ReturnApplyAmount: 'Số tiền hoàn lại',
  Cargo_ReturnApplyState: 'Tình trạng hoàn tiền',
  Cargo_ReturnApply: 'Hoàn tiền',
  Cargo_ReturnApplyCancel: 'Hoàn tiền',
  Cargo_ReturnApplyAudit: 'Đồng ý hoàn tiền',
  Cargo_ReturnApplyReject: 'Từ chối hoàn tiền',
  Cargo_RemainingClaimedAmount: 'Số tiền yêu cầu còn lại',
  Cargo_RefundAmount: 'Số tiền hoàn trả',
  Cargo_ReturnApplyCheck: 'Tồn tại ghi chép hoàn tiền chờ phê duyệt, tạm thời không thể khởi xướng đơn xin hoàn tiền mới!',
  Cargo_RemainingClaimedAmountZero: 'Số tiền yêu cầu còn lại là 0 và không thể hoàn lại!',
  Cargo_ReturnApplyAmountZero: 'Số tiền hoàn lại là 0 và không thể hoàn lại tiền!',
  Cargo_ReturnApplyAuditCheck: 'Chỉ có thể đối với trạng thái là ghi chép trong phê duyệt, xin đánh dấu lại!',
  Cargo_WaterRefundedNoWriteOff: 'Hồ sơ hoàn lại tiền nước, không hỗ trợ thao tác nhận lãnh!',
  Cargo_WaterRefundingNoWriteOff: 'Trạng thái hoàn tiền là hồ sơ trong phê duyệt, không hỗ trợ thao tác nhận lãnh!',
  Cargo_WaterRefundedNoCancel: 'Hồ sơ hoàn trả hóa đơn nước, không hỗ trợ hủy bỏ thao tác nhận lãnh!',
  Cargo_khEntryActTime: 'Thời gian thực (Real time)',
  Cargo_transferDeclareCompletedActTime: 'Khai báo địa điểm trung chuyển hoàn thành (thời gian thực tế)',
  Cargo_khExitActTime: 'Thời gian thực tế (Real time)',
  Cargo_khDeclareActTime: 'Thời gian thực (Real time)',
  Cargo_khReplacementActTime: 'Thời gian thực chuyển đổi',
  Cargo_arrivePodActTime: 'Thời gian thực đến đích',
  Cargo_arriveClearActTime: 'Thời gian thực đến nơi thông quan',
  Cargo_khUnloadingActTime: 'Thời gian thực dỡ hàng',
  Cargo_CustomerReserveVoyage: 'Khách hàng đặt chuyến bay',
  Cargo_CustomsDeclarationInformation: 'Thông tin liên hệ',
  Cargo_CustomsDeclarationCommissionNumber: 'Giấy ủy thác hải quan',
  Cargo_CustomsDeclarationNotExist: 'Vui lòng duy trì ít nhất một 【Thông tin liên hệ】',
  Cargo_QuantityWeightCubageChange: 'Thay đổi thông tin về bộ lông, có đóng nắp không?',
  Cargo_ReferenceNoRepeat: 'Số tham chiếu trong VGM không thể lặp lại',
  Cargo_CustomerDemandClearanceNumber: 'Yêu cầu khách hàng Số ít',
  Cargo_Empty2: '(trống)',
  Cargo_QuantityWeightCubage: 'Bộ lông',
  Cargo_CustomsDeclarationDeleteTip: 'Số đơn hàng hiện tại đã được ủy quyền khai hải quan liên kết, không thể xóa',
  Cargo_CustomsDeclarationValidTip: 'Thông tin cá nhân không thể là 0',
  Cargo_CustomsDeclarationSoNoRepeat: 'REFERENCES [Tên bảng tham chiếu] (',
  Cargo_AuditCancel: 'Bạn có chắc chắn muốn hủy bỏ kiểm duyệt!',
  Cargo_AuditCancelReason: 'Lý do hủy xét duyệt',
  Cargo_NuoNuoTipOne: 'Khi kênh kê đơn=Nặc Nặc, trong trường hợp Hồng Xung không tự động kê đơn, mục cấu hình này điền 1, khi kê đơn tự động không cần cấu hình.',
  Cargo_DestinationVehicleNumberOne: 'Số đầu xe.',
  Cargo_DestinationVehicleRegister: 'Đăng ký xe tại điểm đến',
  Cargo_ConfirmLockLabelBuyingPrice: 'Có chắc chắn về giá mua bị khóa không?',
  Cargo_ConfirmLockLabelSellingPrice: 'Có chắc chắn về giá chốt không?',
  Cargo_ConfirmUnlockLabelBuyingPrice: 'Bạn có chắc chắn về giá mở khóa không?',
  Cargo_ConfirmUnlockLabelSellingPrice: 'Bạn có chắc chắn về giá mở khóa không?',
  Cargo_PurchasePriceLockedStatus: 'Tình trạng khóa giá mua',
  Cargo_SellingPriceLockedStatus: 'Trạng thái khóa giá bán',
  Cargo_BatchPurchasePriceLock: 'Giá mua khóa hàng loạt',
  Cargo_BatchPurchasePriceUnLock: 'Giá mở khóa hàng loạt',
  Cargo_BatchSellingPriceUnLock: 'Giá mở khóa hàng loạt',
  Cargo_BatchSellingPriceLock: 'Giá bán khóa hàng loạt',
  Cargo_NotActiveCompanyCleared: 'Vé này bao gồm các đối tác không hoạt động: {0} Hệ thống tự động làm trống nó, vui lòng chọn lại nhập.',
  Cargo_FBA_SE: 'Vận tải biển FBA',
  Cargo_FBA_AE: 'Vận chuyển hàng không FBA',
  Cargo_FBA_RE: 'Đường sắt FBA',
  Cargo_SyncCreditTip: 'Sau khi nhấp vào nút 【Đồng bộ】 này, điều khiển tín dụng tạm thời đáp ứng yêu cầu của trang hiện hành sẽ có hiệu lực ngay lập tức, mức độ, kỳ hạn sẽ tiến hành tính toán lại có thể bị trì hoãn một phần, xin kiên nhẫn chờ.',
  Cargo_SyncTempCreditTip: 'Khi có dòng phê duyệt điều khiển tín dụng tạm thời, không làm ngay lập tức đồng bộ.',
  Cargo_OperationInstructions: 'Hướng dẫn vận hành',
  Cargo_InstructionName: 'Tên hướng dẫn',
  Cargo_InstructionType: 'Các loại directive',
  Cargo_RuleCode: 'Mã quy tắc',
  Cargo_CodeParameterValues: 'Giá trị tham số mã',
  Cargo_InstructionCode: 'Mã hướng dẫn',
  Cargo_CommandDisplayName: 'Name',
  Cargo_InstructionDescription: 'Mô tả hướng dẫn',
  Cargo_InstructionRuleSetting: 'Cài đặt quy tắc chỉ thị',
  Cargo_IfAllowedSendMultipleTimes: 'Cho phép gửi nhiều lần',
  Cargo_CanOnlyBeSentOnce: 'Chỉ có thể gửi một lần',
  Cargo_CanBeSentMultipleTimes: 'Có thể gửi nhiều lần',
  Cargo_TemplateMatching: 'Khớp mẫu',
  Cargo_UnifiedBusinessScenario: 'Khi chọn phân đoạn đẩy, các chi nhánh khác nhau có mẫu bảo trì độc lập, tương ứng với mẫu chi nhánh.',
  Cargo_SelectEmailTemplate: 'Chọn mẫu thư',
  Cargo_SelectOperationInstruction: 'Chọn lệnh hoạt động',
  Cargo_SelectSpecificBusinessRule: 'Chọn quy tắc kinh doanh cụ thể',
  Cargo_SelectThePushLink: 'Chọn phần Push',
  Cargo_OperationButtonSettingsAndTip: 'Cài đặt nút hoạt động (cài đặt tối đa 5 hướng dẫn hoạt động)',
  Cargo_SelectInstruction: 'Chọn lệnh',
  Cargo_SetParameters: 'Đặt tham số',
  Cargo_SetParameterValues: 'Đặt giá trị tham số',
  Cargo_InstructionChineseName: 'Name',
  Cargo_InstructionEnglishName: 'Hướng dẫn Tên tiếng Anh',
  Cargo_InstructionJapaneseName: 'Lệnh tên tiếng Nhật',
  Cargo_CheckRuleNameExist: 'Name',
  Cargo_LatestInstructionRecord: 'Thực hiện các lệnh hoạt động gần đây',
  Cargo_InstructionRecords: 'Nhật ký hướng dẫn hoạt động',
  Cargo_QueryInstructionRecords: 'Xem nhật ký thực hiện lệnh',
  Cargo_ExecuteResult: 'Kết quả thực hiện',
  Cargo_OperationInstructionsManagement: 'Quản lý hướng dẫn hoạt động',
  Cargo_PlatformInstructionDisabled: 'Hướng dẫn không còn sử dụng được nữa, hãy kiểm tra cấu hình chính xác!',
  Cargo_NotMatchInstruction: 'Không có doanh nghiệp nào đáp ứng yêu cầu này',
  Cargo_SelectJobCount: 'Số lượng doanh nghiệp đã chọn',
  Cargo_MatchInstructionTip: 'Chọn {0} mục, phù hợp với điều kiện của lệnh hoạt động',
  Cargo_OperationInstructionSetTip: 'Giá trị 【Chọn lệnh】 không thể rỗng khi lệnh thao tác được thiết lập!',
  Cargo_OperationInstructionRepeatTip: 'Khi hướng dẫn hoạt động được thiết lập, hướng dẫn được chọn không thể được lặp lại!',
  Cargo_OperationInstructionBatchTip: 'Đừng chọn nhiều hơn 30 dữ liệu doanh nghiệp mỗi khi bạn gửi thư hàng loạt.',
  Cargo_CurrentUserRole: 'Vai trò người dùng hiện tại',
  Cargo_DisabledUnableToSave: '"{0}" đã bị vô hiệu hóa và không thể lưu, vui lòng xóa các khoản phí liên quan để lưu lại.',
  Cargo_CompanyDateOfCreation: 'Thời gian tạo đơn vị ủy quyền',
  Cargo_BringInBusinessInformation: 'Thông tin đặt hàng bổ sung',
  Cargo_LclSendDestinationPortAgentTip: 'Chỉ có thể chọn một doanh nghiệp vé chính để gửi đại lý tại cảng đích',
  Cargo_LclSendPackageAgentTip: 'Chỉ có thể chọn một dịch vụ vé chính để gửi bộ đại lý cảng đơn',
  Cargo_SetUploadFileType: 'Đặt kiểu tập tin tải lên',
  Cargo_PillReportData: 'Tạo và thay thế nguồn dữ liệu',
  Cargo_CanOnlyPrintOnce: 'Chỉ in một lần',
  Cargo_CanPrintMultipleTimes: 'Có thể in nhiều lần',
  Cargo_IfSelectTemplateType: 'Chọn loại tệp mẫu phù hợp với mẫu chi nhánh khi có mẫu bảo trì độc lập tại các chi nhánh khác nhau',
  Cargo_PrintMode: 'Chế độ in',
  Cargo_SingleJobPrint: 'In ấn kinh doanh vé đơn',
  Cargo_BatchJobPrint: 'In ấn kinh doanh số lượng lớn',
  Cargo_SinglePrintFileType: 'Loại tập tin in vé đơn',
  Cargo_BatchPrintFileType: 'Kiểu tập tin in hàng loạt',
  Cargo_SinglePrintFileTemplate: 'Mẫu tập tin in vé đơn',
  Cargo_BatchPrintFileTemplate: 'Mẫu tập tin in hàng loạt',
  Cargo_SelectPrintFileTemplate: 'Chọn mẫu tập tin in',
  Cargo_SelectPrintFileType: 'Chọn kiểu tập tin in',
  Cargo_SelectPrintFileTypeTip: 'Mẫu in đã chọn không có kiểu tập tin được đặt! Trước tiên hãy đặt kiểu tập tin tương ứng với mẫu in',
  Cargo_CabinRetrievalSuccessful: 'Thu hồi cabin thành công',
  Cargo_CabinFlowExitAndNo: 'Dữ liệu về dòng chảy khoang và dòng chảy không khoang không thể hoạt động cùng nhau',
  Cargo_CabinRetrievalAndReturnSuccessful: 'Thu hồi và hạ cánh thành công',
  Cargo_revokeCabinSpace: 'Lệnh bạn đã đánh dấu sẽ thực hiện quy trình thu hồi cabin',
  Cargo_CancelCabinAtTheSameTime: 'Thoát khỏi cabin cùng một lúc',
  Cargo_DeleteConfigTip: 'Có chắc là xóa không? Sau khi xóa, các thiết lập tính năng ban đầu sẽ không thể sử dụng được!',
  Cargo_PreviewVoucher: 'Xem thử chứng từ',
  Cargo_InvoiceNotVoucher: 'Hóa đơn không tạo chứng từ, vui lòng chọn lại.',
  Cargo_BankSlipNotVoucher: 'Hóa đơn nước này không tạo ra chứng từ, vui lòng chọn lại.',
  Cargo_PleaseChooseDataThatHasVouchered: 'Vui lòng chọn dữ liệu đã tạo chứng từ.',
  Cargo_ExportVoucherSuccessfully: '{0} Chứng từ đã được xuất thành công.',
  Cargo_ExportVoucherFailedByBankSlip: 'Việc xuất khẩu đơn vị nước {0} không thành công, lý do {1}, vui lòng thử lại.',
  Cargo_ExportVoucherFailedByInvoice: 'Hóa đơn {0} xuất không thành công, lý do {1}, vui lòng thử lại.',
  Cargo_UpdatePaidOffFlag: 'Refresh đã được bán chưa',
  Cargo_CheckMblSame: 'MB/L NO không phù hợp với trang cơ bản',
  Cargo_IfExistMblNumberRange: 'Có đoạn số đơn chính không?',
  Cargo_UserName_Password_Maintained: 'Vui lòng liên hệ với quản trị viên để bảo trì "Cài đặt cơ bản - Phân tích cài đặt kênh"',
  Cargo_ShipCompany_Maintained: 'Vui lòng liên hệ với quản trị viên để "Đối tác" Bảo trì tàu liên kết',
  Cargo_ShippingCompanyCode_Maintained: 'Công ty tàu bản đồ không bảo trì, vui lòng liên hệ với dịch vụ khách hàng nền tảng',
  Cargo_ShippingCompanyCode_MaintainedTip: 'Vui lòng liên hệ dịch vụ khách hàng',
  Cargo_BookingChannelConfig_Maintained: 'Không khớp với cài đặt kênh đặt chỗ, vui lòng liên hệ với quản trị viên để bảo trì "Cấu hình cơ bản - Cấu hình kênh đặt chỗ"',
  Cargo_BookingChannelConfig_MaintainedTip: 'Vui lòng liên hệ với quản trị viên để bảo trì "Cấu hình cơ bản - Cấu hình kênh đặt hàng"',
  Cargo_ErrorMsg: 'Nguyên nhân bất thường',
  Cargo_SelectJumpErrorTip: '【{0}】 không phải là trang có thể chuyển tiếp, vui lòng chọn một trang như: 【Cơ bản】',
  Cargo_SelectJumpPage: 'Chọn trang để nhảy',
  Cargo_JumpSet: 'Thiết lập nhảy',
  Cargo_ClickJobNoJumpPage: 'Nhấp vào số doanh nghiệp để nhảy trang',
  Cargo_JumpPage: 'Trang nhảy',
  Cargo_TabNotExistTip: 'Trang không thể truy cập được, hãy xác nhận xem có quyền truy cập hoặc tài liệu nào chứa trang đó không.',
  Cargo_CargoValue: 'Giá trị hệ thống',
  Cargo_YdValue: 'Thông tin trả về',
  Cargo_ConfirmReplace: 'Xác nhận ghi đè',
  Cargo_NotReplace: 'Không che đậy.',
  Cargo_ReplaceSystemValue: 'Ghi đè thông tin hệ thống',
  Cargo_PleaseSelectDataToReplace: 'Vui lòng chọn thông tin cần ghi đè',
  Cargo_YdBookingResultTip: 'Phát hiện sự sai lệch giữa thông tin trong quá trình kiểm tra và dữ liệu nhập vào hệ thống, vui lòng xác nhận',
  Cargo_NoMappingValuesTip: '{0} không khớp với giá trị hệ thống, nếu cần thay đổi, hãy chọn thủ công',
  Cargo_NonReplaceDataTip: 'Không có dữ liệu cần ghi đè',
  Cargo_JobNotFound: 'Không tìm thấy doanh nghiệp 【{0}】',
  Cargo_AE_IDENTIFICATION_SUPPLIER: 'Nhận dạng sách trống Nhà cung cấp',
  Cargo_AIR_BILL_SUPPLIER: 'Nhà cung cấp nhận dạng vận đơn hàng không',
  Cargo_LoadingDate: 'Dịch vụ tại cửa - Thời gian nhận hàng',
  Cargo_DoorAddr: 'Dịch vụ Door Point - Địa chỉ Door Point',
  Cargo_DoorMan: 'Dịch vụ Door Point - Liên hệ',
  Cargo_DriverTel: 'Dịch vụ Door Point - Contact Phone',
  Cargo_aeFile: 'Giấy ủy thác trống',
  Cargo_aiFile: 'Giấy tờ vận đơn rỗng',
  Cargo_carrierType: 'Loại Cabin Carrier',
  Cargo_DeclaredValue: 'Giá trị khai báo',
  Cargo_DeclaredValueForCustoms: 'Giá trị tuyên bố hải quan',
  Cargo_RateLevel: 'Mức giá',
  Cargo_PleaseSelectOperateType: 'REFERENCES [Tên bảng tham chiếu] (',
  Cargo_BaoDiCreditInfoNote: 'Lưu ý: Khi các loại ngày được cấu hình trong hệ thống là trống rỗng, nó sẽ được tính toán bằng cách sử dụng thời hạn bảo hiểm (xử lý thanh toán hàng tháng thống nhất) và ngày hết hạn chi phí sẽ được tính toán lại khi các loại ngày trong doanh nghiệp có giá trị',
  Cargo_BottomLineCreditControl: 'Bảo quản Tín dụng',
  Cargo_ProfitShareConfig: 'Phân chia lợi nhuận',
  Cargo_CreateRule: 'Tạo quy tắc',
  Cargo_EditRule: 'Chỉnh sửa quy tắc',
  Cargo_CopyRule: 'Quy tắc sao chép',
  Cargo_RuleName: 'Name',
  Cargo_RuleConfig: 'Cấu hình quy tắc',
  Cargo_RuleRole: 'Vai trò',
  Cargo_ShareMode: 'Chế độ chia',
  Cargo_ShareModeJob: 'Chia sẻ lợi nhuận trên toàn bộ phiếu',
  Cargo_ShareModeCurrency: 'Chia sẻ lợi nhuận bằng tiền tệ',
  Cargo_UsdRatio: 'Tỷ lệ chia',
  Cargo_NonUsdRatio: 'Tỷ lệ không USD',
  Cargo_ShareModeTip: 'Chế độ:',
  Cargo_ShareModeJobTip: 'Toàn bộ vé',
  Cargo_BankSlipDateCreated: 'Ngày tạo hóa đơn nước',
  Cargo_ShareRatio: 'Phân nhuận:',
  Cargo_PleaseSelectSalesBranch: 'Vui lòng chọn chi nhánh bán hàng',
  Cargo_RuleConfigSubCountNotNull: 'Số nhánh cấu hình quy tắc không được để trống',
  Cargo_SetUpConfigSubTriggerCondition: 'Vui lòng đặt điều kiện kích hoạt.',
  Cargo_ConfigSubRuleError: 'Quy tắc phân chia Điều kiện thay đổi, điều kiện kích hoạt sai cấu hình',
  Cargo_AddRuleConfigSub: '+Thêm cấu hình nhánh',
  Cargo_AreYouSureModifyRuleConfigTips: 'Xác nhận sửa đổi?',
  Cargo_ProfitShare: 'Có tham gia phân chia hay không',
  Cargo_ProfitShareColumn: 'Phân chia hay không',
  Cargo_ProfitShareAdjust: 'Điều chỉnh chia',
  Cargo_ProfitShareReset: 'Tái phân chia',
  Cargo_NonProfitShareBranch: 'Chi nhánh không tham gia phân chia',
  Cargo_ProfitShareRatioSumExceed: 'Tỷ lệ lãi suất hiện tại vượt quá 100%, vui lòng xác nhận sau khi điều chỉnh lại.',
  Cargo_UsdProfit: 'Lợi nhuận USD',
  Cargo_NonUsdProfit: 'Lợi nhuận không USD',
  Cargo_JobProfit: 'Lợi nhuận trọn vé',
  Cargo_ShareBranchId: 'Quảng trường chia',
  Cargo_UsdRatioColumn: 'Tỷ lệ USD',
  Cargo_UsdProfitColumn: 'USD dự kiến sẽ thu lợi nhuận',
  Cargo_UsdProfitColumn2: 'Lợi nhuận dự kiến',
  Cargo_NonUsdRatioColumn: 'Tỷ lệ không USD',
  Cargo_NonUsdProfitColumn: 'Không phải đô - la Mỹ.',
  Cargo_CheckProfitShareResetTip: 'Phân chia chi phí để thực hiện các hành động tài chính tiếp theo (lập hóa đơn, thanh toán, hóa đơn, tiêu thụ hạt nhân...), tạm thời không thể phân chia lại, đợi hủy bỏ các hành động tài chính tương ứng thì thử lại.',
  Cargo_AdjustColumn: 'Thay đổi',
  Cargo_UsdProfitAdjustColumn: 'USD dự kiến sẽ có thêm lợi nhuận',
  Cargo_UsdProfitAdjustColumn2: 'Lợi nhuận bổ sung dự kiến',
  Cargo_NonUsdProfitAdjustColumn: 'Không phải đô la Mỹ, dự kiến sẽ có thêm lợi nhuận.',
  Cargo_JobProfitShare: 'Hoàn thành phân chia',
  Cargo_ReceivableFeeLockTime: 'Thời gian khóa chi phí',
  Cargo_ReceivableFeeLockTime2: 'Thời gian khóa chi phí',
  Cargo_PayableFeeLockTime: 'Thời gian khóa chi phí phải trả',
  Cargo_PayableFeeLockTime2: 'Thời gian khóa chi phí phải trả',
  Cargo_PayableFeeLockPerson: 'Người khóa chi phí phải trả',
  Cargo_PleaseConfirmFinancialDate: 'Vui lòng xác nhận ngày tài chính:',
  Cargo_SoldSlots: 'Số ghế đã bán',
  Cargo_RemainingSlots: 'Số ghế còn lại',
  Cargo_SoldVolume: 'Khối lượng đã bán',
  Cargo_RemainingVolume: 'Khối lượng còn lại',
  Cargo_FlightDateError: 'Ngày chuyến bay không nằm trong thời hạn hiệu lực của sản phẩm tuyến đường, hoặc chuyến bay tương ứng không tồn tại trong sản phẩm tuyến đường. Bạn có muốn tiếp tục?',
  Cargo_DimensionsExceedRouteProductLimits: 'Kích thước vượt quá giới hạn của sản phẩm tuyến đường - chuyến bay. Bạn có muốn tiếp tục?',
  Cargo_FlightReassignment: 'Thay đổi chuyến bay',
  Cargo_InformationMaintenance: 'Bảo trì thông tin',
  Cargo_VehicleInformation: 'Thông tin xe',
  Cargo_CountyDistrict: 'Huyện/Quận',
  Cargo_TownStreet: 'Thị trấn/Đường phố',
  Cargo_VillageCommunity: 'Làng/Địa bàn',
  Cargo_FleetPhoneNumber: 'Số điện thoại của hạm đội',
  Cargo_DoorPointName: 'Tên điểm cửa',
  Cargo_DeliveryArea: 'Khu vực giao hàng',
  Cargo_EstimatedLoadingTime: 'Thời gian tải dự kiến',
  Cargo_ActualLoadingTime1: 'Thời gian tải thực tế',
  Cargo_DeliverySequenceNumber: 'Số thứ tự giao hàng',
  Cargo_DispatchVehicleNoteFields: 'Lưu ý khi thực hiện phân công xe, vui lòng hoàn thiện các trường sau:',
  Cargo_TTDEG: 'Công ty vận tải, phí kéo xe, tên điểm cửa, thời gian tải dự kiến, trọng lượng bruto',
  Cargo_RouteMarking: 'Đánh dấu tuyến đường',
  Cargo_SecondaryConfirmation: 'Xác nhận lần hai',
  Cargo_BookingCompleted: 'Đã hoàn thành đặt chỗ, vui lòng kiểm tra:',
  Cargo_DataNotPendingConfirmation: 'Có dữ liệu không phải trạng thái chờ xác nhận, vui lòng kiểm tra:',
  Cargo_PortMismatch: 'Cảng đi và cảng đến không khớp hoàn toàn, bạn có chắc chắn muốn tiếp tục?',
  Cargo_DataNotConfirmed: 'Có dữ liệu không phải đã xác nhận, vui lòng kiểm tra:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: 'Có dữ liệu chưa xác nhận tuyến đường hoặc đã xác nhận lần hai, vui lòng kiểm tra:',
  Cargo_SelectOneMasterBill: 'Chỉ được chọn tối đa 1 phiếu chính',
  Cargo_DataNotRouteDoubleConfirmed: 'Có dữ liệu xác nhận lần hai không thuộc tuyến đường, vui lòng kiểm tra:',
  Cargo_GrossProfitAmount: 'Số tiền lợi nhuận gộp',
  Cargo_SpecialExpenseIndicator: 'Biểu thị chi phí đặc biệt',
  Cargo_SpecialExpensePayableTotal: 'Tổng chi phí đặc biệt phải thanh toán',
  Cargo_SpecialExpensePayableCurrency: 'Loại tiền tệ cho chi phí đặc biệt phải thanh toán',
  Cargo_SpecialExpenseReceivableTotal: 'Tổng chi phí đặc biệt phải thu',
  Cargo_SpecialExpenseReceivableCurrency: 'Loại tiền tệ cho chi phí đặc biệt phải thu',
  Cargo_BookingCompletion: 'Hoàn thành đặt chỗ',
  Cargo_RouteConfirmation: 'Xác nhận tuyến đường',
  Cargo_RouteConfirmationStatus: 'Trạng thái xác nhận tuyến đường',
  Cargo_FlightDateRange: 'Ngày chuyến bay',
  Cargo_RouteConfirmationPerson: 'Người xác nhận tuyến đường',
  Cargo_RouteConfirmationTimeRange: 'Thời gian xác nhận tuyến đường',
  Cargo_IsBookingCompleted: 'Đặt chỗ đã hoàn thành?',
  Cargo_OrderNumber: 'Mã đơn hàng',
  Cargo_FlightNumber: 'Mã chuyến bay',
  Cargo_SecondLegFlight: 'Chuyến bay phân phối 2',
  Cargo_SecondLegAirline: 'Hãng vận tải phân phối 2',
  Cargo_SecondLegDocumentNumber: 'Số hiệu vận đơn phân phối 2',
  Cargo_SecondLegETD: 'ETD phân phối 2',
  Cargo_SecondLegETA: 'ETA phân phối 2',
  Cargo_ThirdLegFlight: 'Chuyến bay phân phối 3',
  Cargo_ThirdLegAirline: 'Hãng vận tải phân phối 3',
  Cargo_ThirdLegDocumentNumber: 'Số hiệu vận đơn phân phối 3',
  Cargo_ThirdLegETD: 'ETD phân phối 3',
  Cargo_ThirdLegETA: 'ETA phân phối 3',
  Cargo_FreightUnitPrice: 'Đơn giá vận chuyển',
  Cargo_SignatureWeight: 'Trọng lượng tính hóa đơn',
  Cargo_SignatureDimensions: 'Kích thước tính hóa đơn',
  Cargo_SignatureRemarks: 'Ghi chú hóa đơn',
  Cargo_FoldedWeightRemarks: 'Ghi chú điều chỉnh trọng lượng',
  Cargo_TotalPrice: 'Tổng giá trị',
  Cargo_TransshipmentFee: 'Phí chuyển tải',
  Cargo_HumanResourcePerformance: 'Hiệu quả nhân sự',
  Cargo_AIEngine: 'Động cơ AI',
  Cargo_ProvisionReport: 'Báo cáo trích lập',
  Cargo_ScriptName: 'Tên kịch bản',
  Cargo_ScriptDescription: 'Mô tả kịch bản',
  Cargo_GenerateScript: 'Tạo kịch bản',
  Cargo_RuleDescription: 'Mô tả quy tắc',
  Cargo_ScriptPreview: 'Xem trước kịch bản',
  Cargo_CommissionRole: 'Vai trò hoa hồng',
  Cargo_CommissionPersonnel: 'Nhân viên hoa hồng',
  Cargo_ApplicableScript: 'Kịch bản áp dụng',
  Cargo_RuleApplication: 'Áp dụng quy tắc',
  Cargo_ApplicablePersonnel: 'Nhân viên áp dụng',
  Cargo_BusinessVolume: 'Khối lượng kinh doanh',
  Cargo_ApplicableRule: 'Quy tắc áp dụng',
  Cargo_CustomsProvision: 'Trích lập hải quan',
  Cargo_OperationProvision: 'Trích lập hoạt động',
  Cargo_CustomerServiceProvision: 'Trích lập dịch vụ khách hàng',
  Cargo_BusinessProvision: 'Trích lập kinh doanh',
  Cargo_SalesProvision: 'Trích lập bán hàng',
  Cargo_OperationTicketProvision: 'Trích lập vé hoạt động',
  Cargo_SalesSupervisorProvision: 'Trích lập quản lý bán hàng',
  Cargo_OperationSupervisorProvision: 'Trích lập quản lý hoạt động',
  Cargo_ConfirmCancelProvision: 'Xác nhận hủy trích lập không?',
  Cargo_LockLimit: 'Giới hạn khóa',
  Cargo_ReceivableFullWriteOffTime: 'Thời gian thu hồi toàn bộ',
  Cargo_LockAccountsReceivableAndPayableEntry: 'Khóa nhập khoản phải thu và phải trả',
  Cargo_ViewDetailedBusiness: 'Xem chi tiết kinh doanh',
  Cargo_TestRun: 'Chạy thử',
  Cargo_ProvisionLimit: 'Giới hạn trích lập',
  Cargo_ViewProvisionDetails: 'Xem chi tiết trích lập',
  Cargo_ProvisionBatchNumber: 'Số lô trích lập',
  Cargo_ProvisionPerson: 'Người trích lập',
  Cargo_ProvisionTime: 'Thời gian trích lập',
  Cargo_ProvisionRole: 'Vai trò trích lập',
  Cargo_PendingProvision: 'Chờ trích lập',
  Cargo_ProvisionHistory: 'Lịch sử trích lập',
  Cargo_ResponsibleCustomerService: 'Nhân viên chăm sóc khách hàng phụ trách',
  Cargo_ResponsibleOperator: 'Nhân viên vận hành phụ trách',
  Cargo_ConfirmAndBookingCompleted: 'Xác nhận và hoàn thành đặt chỗ',
  Cargo_OrderQuantity: 'Số lượng đơn hàng',
  Cargo_FinancialStatus: 'Trạng thái tài chính',
  Cargo_FinancialColorTip: 'Phạm vi cấu hình kiểm soát màu sắc bảng: \nĐặt chỗ hàng không - Danh \nHoạt động hàng không - Danh \nLogistics tổng hợp - Danh \nHoạt động đường sắt - Danh \nĐặt chỗ từ xa - Danh \nTra cứu bán hàng - Danh \nXuất khẩu đường biển - Danh \nHoạt động đường biển - Danh \nNhập khẩu đường biển - Dự báo - Danh \nTra cứu bán hàng - Bộ phận nước ngoài - Danh \nTra cứu bán hàng - Bộ phận bán hàng - Danh \nXuất khẩu đường biển - Lệnh vận chuyển - Danh \nXuất khẩu đường biển - EDI - Danh \nKiểm toán tài chính - Danh \n Kiểm toán tài chính - Chuyển khoản - Danh \nXuất khẩu hàng không - Tờ khai hải quan - Danh \nXuất khẩu hàng không - Kho trước - Danh \nXuất khẩu hàng không - Kho - Danh sách \nNhập khẩu đường biển - Hoạt động kho - Danh ',
  Cargo_CurrentInvoiceDifferentRates: 'Hóa đơn hiện tại có chi phí với các mức thuế suất khác nhau. Hóa đơn sẽ được phân chia theo thuế suất và xuất riêng biệt, sử dụng mã thuế mặc định để bảo trì. Bạn có muốn tiếp tục thao tác này không?',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: 'Các lựa chọn hiện tại bao gồm 9 điểm thuế và các điểm thuế khác. Do đặc thù của hóa đơn vận chuyển hàng hóa, vui lòng đăng ký riêng. Không hỗ trợ gửi hóa đơn cùng một lúc.',
  Cargo_NumberOfOriginalCopies: 'Số bản chính',
  Cargo_DisplayDllInformation: 'Hiển thị toàn bộ thông tin',
  Cargo_DisplayDifferenceInformation: 'Hiển thị thông tin khác biệt',
  Cargo_OverrideSystemBillOfLading: 'Ghi đè vận đơn hệ thống',
  Cargo_ContainerIdTip: 'Thông tin đóng gói (chọn để thêm vào vận đơn hoặc ghi đè dữ liệu)',
  Cargo_ContainerInfo2: 'Thông tin container (nếu chọn, sẽ được thêm vào vận đơn hoặc ghi đè dữ liệu vận đơn)',
  Cargo_ContainerTypeQuantityMismatch: 'Loại/số lượng container không khớp với thông tin container đã chọn, vui lòng xác nhận.',
  Cargo_SystemData: 'Dữ liệu hệ thống',
  Cargo_RecognitionData: 'Dữ liệu nhận diện',
  Cargo_GrossProfit: 'Lợi nhuận gộp',
  Cargo_MustEnterComplete: 'Phải nhập đầy đủ thông tin',
  Cargo_CostVirtualImplementationToConsolidationPlan: 'Phân bổ chi phí ảo vào kế hoạch lắp ráp',
  Cargo_ReceivablesWriteoffDate: 'Ngày đối soát công nợ phải thu',
  Cargo_PayablesWriteoffDate: 'Ngày đối soát công nợ phải trả',
  Cargo_FeeInvoiceTitle: 'Tên đơn vị trên hóa đơn',
  Cargo_PaymentApplicationTitle: 'Tên đơn vị trong yêu cầu thanh toán',
  Cargo_NotData: 'Không tìm thấy dữ liệu',
  Cargo_LclHasMaster: 'Phiếu nhỏ đã liên kết với phiếu chính',
  Cargo_ParamError: 'Lỗi tham số, vui lòng kiểm tra',
  Cargo_BillResults: 'Trường nhận diện vận đơn',
  Cargo_BillResults2: 'Dữ liệu vận đơn hệ thống',
  Cargo_NotUpdate: 'Không thể chỉnh sửa',
  Cargo_UpdateCheck1: 'Lưu ý: Loại và số lượng container không khớp với thông tin đóng gói đã chọn',
  Cargo_seaFile2: 'Nhận diện vận đơn xuất khẩu biển',
  Cargo_siFile2: 'Nhận diện vận đơn nhập khẩu biển',
  Cargo_seBillFile2: 'Nhận diện vận đơn xuất khẩu biển',
  Cargo_aeFile2: 'Nhận diện vận đơn xuất khẩu hàng không',
  Cargo_aiFile2: 'Nhận diện vận đơn nhập khẩu hàng không',
  Cargo_OnlyServiceDataLocked: 'Chỉ khóa dữ liệu kinh doanh, tab chi phí có thể chỉnh sửa',
  Cargo_AutomaticallyLocksServiceData: 'Tự động khóa chứng từ kinh doanh',
  Cargo_AutomaticallySubmitServiceData: 'Tự động nộp chứng từ kinh doanh',
  Cargo_SystemAutomaticExecution: 'Hệ thống tự động thực hiện',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: 'Công việc chưa nộp sẽ tự động thực hiện nộp (Trạng thái: Đang xử lý -> Đã nộp)',
  Cargo_IdentifyTheSupplier: 'Nhận diện nhà cung cấp',
  Cargo_PleaseSet: 'Vui lòng thiết lập',
  Cargo_OnlyOneSupplier: 'Mỗi loại chỉ được thiết lập 1 nhà cung cấp',
  Cargo_IdentificationCannotBePerformedTip: 'Không thiết lập loại nhận diện sẽ không thể xử lý, liên hệ hỗ trợ nếu cần',
  Cargo_TemplateSettings: 'Thiết lập mẫu',
  Cargo_IdentificationTip1: 'Vui lòng thiết lập nhà cung cấp cho loại nhận diện',
  Cargo_RpaAccount: 'Tài khoản RPA được quản lý',
  Cargo_WechatGroupName: 'Tên nhóm WeCom',
  Cargo_TabEnterpriseWechat: 'Quản lý tài khoản WeCom',
  Cargo_LoginEnterpriseWechat: 'Đăng nhập WeCom',
  Cargo_LoginEnterpriseWechatTip: 'Vui lòng quét mã QR để đăng nhập WeCom',
  Cargo_RpaAccountSummary: 'Thông tin tài khoản RPA được quản lý',
  Cargo_RpaAccountSummaryTip: 'Để điều chỉnh, vui lòng truy cập tab [Đối tác - Liên hệ]',
  Cargo_RpaAccountColumn: 'Tài khoản WeCom',
  Cargo_RpaAccountEnabled: 'Trạng thái tài khoản',
  Cargo_BatchEditEnterpriseWechat: 'Sửa đổi hàng loạt nhóm WeCom của liên hệ',
  Cargo_EditEnterpriseWechatButton: 'Sửa đổi tên nhóm WeCom hàng loạt',
  Cargo_RpaAccountColumn2: 'Tài khoản RPA được quản lý',
  Cargo_EditEnterpriseWechatTitle: 'Chỉnh sửa nhóm WeCom của liên hệ',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: 'Vui lòng điền thông tin Tài khoản RPA/Danh bạ WeCom trước khi lưu',
  Cargo_EnterpriseWechat: 'WeCom',
  Cargo_MessageContent: 'Nội dung thông điệp',
  Cargo_PushFiles: 'Đẩy tệp tin',
  Cargo_PushFilesTip: 'Tệp sẽ được nén thành ZIP và gửi qua liên kết tải về đến nhóm WeCom',
  Cargo_EnterpriseWechat2DataServiceReminder: '(Chỉ áp dụng cho thay đổi kế hoạch tàu)',
  Cargo_EnterpriseWechatSopTip: 'Vui lòng nhập chính xác tên nhóm, nếu có nhiều tên hãy dùng","phân tách bằng dấu',
  Cargo_PleaseInputVerificationCode: 'Nhập mã xác thực',
  Cargo_InputVerificationCodeTip1: 'Đây là lần đăng nhập đầu tiên, vui lòng nhập mã xác thực nhận được trên ứng dụng WeCom',
  Cargo_InputVerificationCodeTip2: 'Xác thực thất bại, mã đã hết hạn hoặc không hợp lệ. Vui lòng nhập lại',
  Cargo_CaptchaUsing: 'Đang xác thực, vui lòng tải lại trạng thái sau',
  Cargo_LoginSuccess: 'Tài khoản: {0}, đăng nhập thành công.',
  Cargo_PushEnterpriseWechat: 'Có nên đẩy mạnh hay không',
  Cargo_PushEnterpriseWechatTip: 'Người liên hệ không có tài khoản doanh nghiệp và tên trò chuyện nhóm được thiết lập và việc đẩy tin nhắn không thành công',
  Cargo_ServiceProductID: 'ID sản phẩm dịch vụ',
  Cargo_ServiceProductName: 'Tên sản phẩm dịch vụ',
  Cargo_ForceRoutingBooking: 'Đặt chỗ tuyến đường bắt buộc',
  Cargo_UsedAsRoutingProduct: 'Sử dụng làm sản phẩm tuyến đường?',
  Cargo_AirServiceProduct: 'Sản phẩm dịch vụ hàng không',
  Cargo_BusinessManager: 'Người đứng đầu kinh doanh',
  Cargo_AirlinePersonSetting: 'Đặt người đứng đầu các tuyến đường',
  Cargo_PrePortFreightRateOfficer: 'Người đứng đầu giá vận chuyển trước hồng kông',
  Cargo_PersonChargeTrunkLineFreightRates: 'Giám đốc vận tải đường chính',
  Cargo_PersonChargeLastMileFreightRates: 'Người đứng đầu chi phí vận chuyển',
  Cargo_NamePersonResponsible: 'Người đứng đầu tên',
  Cargo_ResponsiblePortDeparture: 'Chịu trách nhiệm về cảng khởi hành',
  Cargo_OnlyOneFullPerson: 'Chỉ có một người quản lý cảng trống rỗng',
  Cargo_OnlyOneFullPersonSameType: 'Cùng một người có thể chỉ có một',
  Cargo_AdministrativeDivision: 'Khu hành chính',
  Cargo_StreetTownship: 'Đường phố/thị trấn',
  Cargo_PostalCodeManagement: 'Quản lý zip',
  Cargo_UsPostalCode: 'Mã bưu chính hoa kỳ',
  Cargo_preportAudit: 'Kiểm tra trước hồng kông',
  Cargo_TrunkLineAudit: 'Kiểm toán đường chính',
  Cargo_TailEndAudit: 'Kiểm toán đuôi',
  Cargo_preportAuditStatus: 'Tình trạng kiểm toán trước hồng kông',
  Cargo_TrunkLineAuditStatus: 'Kiểm toán đường chính',
  Cargo_TailEndAuditStatus: 'Tình trạng kiểm toán quá trình đuôi tàu',
  Cargo_NoReviewRequired: 'Không cần phải kiểm tra',
  Cargo_HasBeenReviewed: 'Đã được kiểm duyệt',
  Cargo_NoAuthorityReview: 'Không có quyền kiểm toán',
  Cargo_AddBasicAirFreightServiceProduct: 'Thêm sản phẩm dịch vụ hàng không cơ bản',
  Cargo_DeleteServiceProductWarning: 'Bạn sẽ xóa {0} sản phẩm dịch vụ, hãy thận trọng.',
  Cargo_RouteProductName: 'Tên sản phẩm tuyến đường',
  Cargo_ServiceProduct: 'Sản phẩm dịch vụ',
  Cargo_PurchaseMethod: 'Phương thức mua hàng',
  Cargo_Airline2: 'Hãng hàng không',
  Cargo_PurchaseSource: 'Nguồn cung ứng',
  Cargo_OriginPort: 'Cảng đi',
  Cargo_RouteOfficer: 'Nhân viên tuyến đường',
  Cargo_IsEffective: 'Có hiệu lực?',
  Cargo_BaseWeight: 'Trọng lượng cơ sở',
  Cargo_LimitWeight: 'Trọng lượng giới hạn',
  Cargo_SellableSpace: 'Số ghế có sẵn',
  Cargo_LengthLimit: 'Giới hạn chiều dài',
  Cargo_HeightLimit: 'Giới hạn chiều cao',
  Cargo_TheoreticalVolume: 'Thể tích lý thuyết',
  Cargo_SellableVolume: 'Thể tích có sẵn',
  Cargo_Box: 'Pallet/container',
  Cargo_PayingParty: 'Đối tượng thanh toán',
  Cargo_UnitPrice_TotalPrice: 'Đơn giá/Tổng giá',
  Cargo_RouteProductCode: 'Mã sản phẩm tuyến đường',
  Cargo_BoardCount: 'Số pallet',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'Ngày hiệu lực phải ≤ ngày hết hạn',
  Cargo_AirlineProductCode: 'Sản phẩm tuyến đường',
  Cargo_NotAssemblyQuantity: 'Số lượng lắp ráp được',
  Cargo_NotAssemblyGrossWeight: 'Trọng lượng thô lắp ráp được',
  Cargo_NotAssemblyVolume: 'Thể tích lắp ráp được',
  Cargo_NotAssemblyChargeableWeight: 'Trọng lượng tính lắp ráp được',
  Cargo_Density_Weight: 'Mật độ/Hàng hóa',
  Cargo_PreWarehouseStatus: 'Trạng thái kho tiền tuyến',
  Cargo_DeliveryStation2: 'Bãi giao hàng',
  Cargo_DeliveryStatus: 'Trạng thái giao hàng',
  Cargo_PreAssemblyPlanProductionPlan: 'Kế hoạch lắp ráp dự kiến - Tạo kế hoạch',
  Cargo_ShipmentOrder: 'Lệnh xuất kho',
  Cargo_GenerateAssemblyPlan: 'Tạo kế hoạch lắp ráp',
  Cargo_AssemblyPlanNumber: 'Mã kế hoạch lắp ráp',
  Cargo_AssemblyPlanStatus: 'Trạng thái kế hoạch lắp ráp',
  Cargo_AssemblyItemCount: 'Số lượng lắp ráp',
  Cargo_AssemblyGrossWeight: 'Trọng lượng thô lắp ráp',
  Cargo_AssemblyVolume: 'Thể tích lắp ráp',
  Cargo_AssemblyChargeableWeight: 'Trọng lượng tính lắp ráp',
  Cargo_ContainerGroup: 'Nhóm container',
  Cargo_LoadingPool: 'Bể phân phối',
  Cargo_MergeGroup: 'Nhóm hợp nhất',
  Cargo_DeleteGroup: 'Xóa nhóm',
  Cargo_AddToPlan: 'Thêm vào kế hoạch',
  Cargo_AssemblyPlan: 'Kế hoạch lắp ráp',
  Cargo_PlanIssued: 'Phê duyệt kế hoạch',
  Cargo_CancelPlanIssued: 'Hủy phê duyệt kế hoạch',
  Cargo_PlanPrint: 'In kế hoạch',
  Cargo_AssemblyCompleted: 'Hoàn thành lắp ráp',
  Cargo_CancelAssemblyCompleted: 'Hủy hoàn thành lắp ráp',
  Cargo_ConfirmCompleted: 'Xác nhận hoàn thành',
  Cargo_CancelConfirmCompleted: 'Hủy xác nhận hoàn thành',
  Cargo_ImportAssemblyPlan: 'Nhập kế hoạch lắp ráp',
  Cargo_UnifiedError: '[{0}] không đồng nhất, bạn có muốn tiếp tục?',
  Cargo_JoinExistingAssemblyPlan: 'Thêm vào kế hoạch lắp ráp hiện có?',
  Cargo_ExistingPlanIssued: 'Có kế hoạch lắp ráp đã phê duyệt, không thể hợp nhất. Hãy hủy phê duyệt để thử lại.',
  Cargo_CostAllocated: 'Chi phí đã được phân bổ, vui lòng xóa trước khi tiếp tục.',
  Cargo_MaintainAtLeastOneGroup: 'Vui lòng duy trì ít nhất 1 nhóm container',
  Cargo_FieldsCannotBeEmpty: '【Số lượng/Trọng lượng thô/Thể tích/Trọng lượng tính】Phải lớn hơn 0, vui lòng kiểm tra',
  Cargo_AssemblyPlanExceedsContainerGroup: '【Kế hoạch lắp ráp - Nhóm container】Số lượng lớn hơn【Sản phẩm tuyến đường - Chuyến bay - Pallet】Số lượng, nếu tiếp tục？',
  Cargo_PlanIssuedTip: 'Kế hoạch lắp ráp đã phê duyệt, không thể thao tác. Hãy hủy phê duyệt để thử lại.',
  Cargo_PieceWeightVolumeUnit: 'Số lượng/Trọng lượng thô/Thể tích/Trọng lượng tính',
  Cargo_VehicleRequestForm: 'Đơn yêu cầu xe',
  Cargo_VehicleOrder: 'Phiếu điều xe',
  Cargo_BatchGenerateVehicleOrder: 'Tạo hàng loạt phiếu điều xe',
  Cargo_VehicleRequestFormNo: 'Số đơn yêu cầu xe',
  Cargo_PickUpDelivery: 'Nhận/giao hàng',
  Cargo_EstimatedPickUpDate: 'Ngày nhận hàng dự kiến',
  Cargo_Port2: 'Cảng',
  Cargo_VehicleOrderNo: 'Số phiếu điều xe',
  Cargo_VehicleTime: 'Thời gian xuất xe',
  Cargo_CancelVehicleOrder: 'Hủy phiếu điều xe',
  Cargo_VehicleDispatched: 'Đã xuất xe',
  Cargo_CancelVehicleStatus: 'Hủy trạng thái xuất xe',
  Cargo_CancelCompletedStatus: 'Hủy trạng thái hoàn thành',
  Cargo_StatusUpdateRecord: 'Lịch sử cập nhật trạng thái',
  Cargo_UpdateVehicleOrderStatus: 'Cập nhật trạng thái phiếu điều xe',
  Cargo_CancelCondition: 'Chỉ hủy được khi trạng thái là "Chưa xuất xe"',
  Cargo_ConfirmCancelVehicleOrder: 'Xác nhận hủy xuất xe?',
  Cargo_SelectNotDispatched: 'Vui lòng chọn phiếu điều xe có trạng thái "Chưa xuất xe"',
  Cargo_SelectDispatched: 'Vui lòng chọn phiếu điều xe có trạng thái "Đã xuất xe"',
  Cargo_SelectStatusConsistent: 'Trạng thái các phiếu điều xe phải giống nhau',
  Cargo_VehicleOrderCompleted: 'Phiếu điều xe đã hoàn thành',
  Cargo_SelectCompleted: 'Vui lòng chọn phiếu điều xe có trạng thái "Hoàn thành"',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: '"Thời gian hoàn thành" không được sớm hơn "Thời gian xuất xe"',
  Cargo_ActualPickupDate: 'Ngày nhận hàng thực tế',
  Cargo_DispatchTaskLinkedToVehicle: 'Phiếu nhiệm vụ đã liên kết với phiếu điều xe, không thể xóa. Hãy hủy liên kết trước.',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: 'Phiếu nhiệm vụ đã liên kết với phiếu điều xe, không thể sửa "Phương thức nhận hàng". Hãy hủy liên kết trước.',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: 'Phiếu nhiệm vụ đã liên kết với phiếu điều xe, không thể hủy "Điều xe đến cảng đích". Hãy hủy liên kết trước.',
  Cargo_Port_Airport: 'Cảng (sân bay)',
  Cargo_VehicleRequestDifferentPorts: 'Đơn yêu cầu xe thuộc các cảng khác nhau, có muốn hợp nhất không?',
  Cargo_VehicleOrderGeneratedSuccess: 'Tạo phiếu điều xe thành công',
  Cargo_VehicleOrderSerialNumber: 'Số serial phiếu điều xe là',
  Cargo_BusinessCreationTime: 'Thời gian tạo nghiệp vụ',
  Cargo_BoxesInStock: 'Số thùng trong kho',
  Cargo_PalletsInStock: 'Số pallet trong kho',
  Cargo_Goods: 'Hàng hóa',
  Cargo_InventoryInfo: 'Thông tin tồn kho',
  Cargo_OutboundByPallet: 'Xuất kho theo pallet',
  Cargo_OutboundByBox: 'Xuất kho theo thùng',
  Cargo_Outbound: 'Đã xuất kho',
  Cargo_NotOutbound: 'Chưa xuất kho',
  Cargo_OutboundBatch: 'Lô xuất kho',
  Cargo_BoxQuantity: 'Số lượng thùng',
  Cargo_OutboundMode: 'Chế độ xuất kho',
  Cargo_PalletQuantity: 'Số lượng pallet',
  Cargo_InventoryAge: 'Tuổi tồn kho (ngày/tuần)',
  Cargo_OutboundOperator: 'Người thao tác xuất kho',
  Cargo_RemainingBoxes: 'Số thùng còn lại trong kho',
  Cargo_EstimatedAmazonArrivalTime: 'Thời gian dự kiến đến kho Amazon',
  Cargo_SelectCommonShipper: 'Chọn người gửi thường dùng',
  Cargo_SaveAsCommonShipper: 'Lưu làm người gửi thường dùng',
  Cargo_SelectCommonConsignee: 'Chọn người nhận thường dùng',
  Cargo_SaveAsCommonConsignee: 'Lưu làm người nhận thường dùng',
  Cargo_SelectCommonNotifier: 'Chọn người thông báo thường dùng',
  Cargo_SaveAsCommonNotifier: 'Lưu làm người thông báo thường dùng',
  Cargo_NotInWarehouse: 'Hàng chưa nhập kho. Phát lệnh xuất kho sớm? Nhấn "Xác nhận" để thực hiện.',
  Cargo_NotInWarehouse2: 'Hàng chưa nhập kho. Thu hồi lệnh xuất kho sớm? Nhấn "Xác nhận" để hủy.',
  Cargo_OutboundInstructionIssued: 'Đã phát lệnh xuất kho',
  Cargo_AlreadyOutbound: 'Hàng đã xuất kho, không thể hủy lệnh.',
  Cargo_PromptWord: '##Tổng quan tệp đính kèm：\n' +
    'Đây là một hóa đơn tiêu dùng. Vui lòng xác định loại tiền tệ dựa trên ngôn ngữ của hóa đơn. Vui lòng nhận diện các trường sau: Đơn vị thu phí (nhà cung cấp dịch vụ), Số tiền tiêu dùng, Thuế tiêu dùng (số tiền thuế), Mức thuế suất, Loại tiền tệ.\n' +
    '##Yêu cầu đầu ra：\n' +
    '1、Trả về dưới dạng JSON. Tất cả tên trường trong JSON phải được viết bằng tiếng Trung.\n' +
    '2、Ví dụ định dạng json：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "Người nhận hàng": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##Các định nghĩa và quy tắc cho từng trường như sau：\n' +
    '#1、Đơn vị thu phí (nhà cung cấp dịch vụ)）\n' +
    '#2、Số tiền tiêu dùng\n' +
    '#3、Thuế tiêu dùng (số tiền thuế)\n' +
    '#4、Mức thuế suất\n' +
    '#5、Loại tiền tệ',
  CargoMsg_AIAddressRecognition: 'Nhận diện địa chỉ thông minh AI',
  Cargo_ContainerGroupHasOrder: 'Nhóm container chứa đơn hàng, không thể xóa. Vui lòng di chuyển đơn hàng ra ngoài trước',
  Cargo_HSCode: 'Mã HS',
  Cargo_ShippingExchangeRateBatchConfig: 'Cấu hình lô giá cước vận tải biển',
  Cargo_DeclarationScope: 'Phạm vi khai báo',
  Cargo_DeclarationBusiness: 'Nghiệp vụ khai báo',
  Cargo_DeclarationFee: 'Chi phí khai báo',
  Cargo_SetBranch: 'Thiết lập chi nhánh',
  Cargo_FollowHQ: 'Theo HQ',
  Cargo_FreightRate: 'Giá cước vận chuyển',
  Cargo_ContainerLock: 'Phí khóa container',
  Cargo_OtherAdditionalCharges: 'Các phụ phí khác',
  Cargo_UpperLimit: 'Giới hạn trên',
  Cargo_LowerLimit: 'Giới hạn dưới',
  Cargo_AlertNotification: 'Thông báo cảnh báo',
  Cargo_RPASettings: 'Cài đặt RPA',
  Cargo_UnregisteredShippingRate: 'Khi mức giá vận chuyển kinh doanh tạo ra không được khai báo tại sở giao dịch vận tải',
  Cargo_ExceedMaintainedLimit: 'Khi mức giá vận chuyển kinh doanh tạo ra vượt quá giới hạn đã duy trì',
  Cargo_RPAPaused: 'Khi RPA tạm dừng',
  Cargo_RPACompleted: 'Khi RPA hoàn thành',
  Cargo_ProhibitSaving: 'Cấm lưu',
  Cargo_RecordOnly: 'Chỉ ghi lại không cảnh báo',
  Cargo_NoRecordNoAlert: 'Không ghi lại không cảnh báo',
  Cargo_NotifyRoleByEmail: 'Thông báo qua email cho vai trò chỉ định',
  Cargo_NotifyPersonByEmail: 'Thông báo qua email cho người chỉ định',
  Cargo_NotifyPositionByEmail: 'Thông báo qua email cho vị trí chỉ định',
  Cargo_RPAService: 'Dịch vụ RPA',
  Cargo_EnableRPAService: 'Kích hoạt dịch vụ RPA',
  Cargo_ShippingExchangeAccount: 'Tài khoản sở giao dịch vận tải',
  Cargo_ShippingExchangePassword: 'Mật khẩu sở giao dịch vận tải',
  Cargo_RPASubmission: 'Gửi dữ liệu thay mặt trên {0} RPA',
  Cargo_WarningReason: 'Lý do cảnh báo',
  Cargo_WarningMessage: 'Thông báo cảnh báo',
  Cargo_UnregisteredRateSaveError: 'Công ty chúng tôi đã kích hoạt chức năng công bố giá cước trên sở giao dịch vận tải. Giá cước nghiệp vụ hiện tại chưa được khai báo trên sở giao dịch, vì vậy không thể lưu. Nếu cần nhập nghiệp vụ, vui lòng liên hệ người đăng ký: <br/>{0}',
  Cargo_UnregisteredRateWarning: 'Công ty chúng tôi đã kích hoạt chức năng công bố giá cước trên sở giao dịch vận tải. Giá cước nghiệp vụ hiện tại chưa được khai báo trên sở giao dịch. Để tránh thao tác vi phạm, vui lòng liên hệ người đăng ký kịp thời: <br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: 'Công ty chúng tôi đã kích hoạt chức năng công bố giá cước trên sở giao dịch vận tải. Giá cước nghiệp vụ hiện tại vượt quá giới hạn đã khai báo nên không thể lưu. Nếu cần nhập nghiệp vụ, vui lòng liên hệ người đăng ký: <br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: 'Công ty chúng tôi đã kích hoạt chức năng công bố giá cước trên sở giao dịch vận tải. Giá cước nghiệp vụ hiện tại vượt quá giới hạn đã khai báo. Để tránh thao tác vi phạm, vui lòng liên hệ người đăng ký kịp thời: <br/>{0}',
  Cargo_GoToProcess: 'Đi xử lý',
  Cargo_GoToDeclare: 'Đi kê khai',
  Cargo_CheckWarningToProcess: 'Vui lòng chọn thông tin cảnh báo cần xử lý',
  Cargo_SelectedWarningMarkedProcessed: 'Thông tin cảnh báo đã chọn đã được đánh dấu là"Đã xử lý"',
  Cargo_SelectInfoToDeclare: 'Vui lòng chọn thông tin cần kê khai',
  Cargo_SureSaveUnControlledProduct: 'Xác nhận tiết kiệm? Doanh nghiệp sẽ bị khóa sau khi lưu, không còn hoạt động và không thể rút lại!',
  Cargo_ScmNeedAllowProduct: 'Khi xuất khẩu các sản phẩm được kiểm soát, cần có sự cho phép trước. Vui lòng liên hệ với SCM Propulsion Room để biết thêm chi tiết.',
  Cargo_SureSave: 'Xác nhận lưu',
  Cargo_FilingBatchNo: 'Lập hồ sơ lô',
  Cargo_FilingState: 'Trạng thái lô',
  Cargo_SubmitDate: 'Ngày gửi',
  Cargo_DeclareFinal: 'Số dòng khai báo/Số dòng cuối cùng',
  Cargo_FiletotalRecordPass: 'Tổng số hồ sơ tập tin/số thư viện/số kiểm tra vượt qua',
  Cargo_StartRPA: 'Khởi động RPA',
  Cargo_SuspendRPA: 'Tạm dừng RPA',
  Cargo_SuspendRPA2: 'Tạm dừng',
  Cargo_RpaState: 'Tình trạng RPA',
  Cargo_ImportFinalResult: 'Nhập kết quả cuối cùng',
  Cargo_ManuallyExportFile: 'Xuất tập tin theo cách thủ công',
  Cargo_FilingBatchInfo: 'Thông tin lô',
  Cargo_FilingDate: 'Ngày nộp hồ sơ',
  Cargo_OpenPriceInfo: 'Khai báo giá vận chuyển',
  Cargo_Past6MonthPort: 'Cảng để có được gần 6 tháng kinh doanh',
  Cargo_Past1MonthPrice: 'Nhận giá vận chuyển gần 1 tháng',
  Cargo_CompanyCode2: 'Mã công ty',
  Cargo_Lane: 'Tên đường bay',
  Cargo_DepartureDay: 'Tuần làm việc',
  Cargo_CargoType2: 'Loại hàng hóa',
  Cargo_EqSize: 'Kích thước',
  Cargo_Cost2: 'Giá vận chuyển',
  Cargo_CostRange: 'Phạm vi vận chuyển',
  Cargo_CostMin: 'Giới hạn vận chuyển thấp hơn',
  Cargo_CostMax: 'Giới hạn vận chuyển',
  Cargo_EqDeduct: 'Hộp khóa',
  Cargo_BatchReturnPreApproval: 'Trả về duyệt trước/đặt chỗ từ xa hàng loạt',
  Cargo_ReturnPreApprovalRemoteBooking: 'Trả về duyệt trước/Đặt chỗ từ xa',
  Cargo_ConfirmReturnResubmit: 'Xác nhận trả về duyệt trước/đặt chỗ từ xa để nộp lại?',
  Cargo_ReturnModuleSelection: 'Chọn mô-đun trả về',
  Cargo_ReturnModule: 'Mô-đun trả về',
  Cargo_ReturnReason: 'Lý do trả về',
  Cargo_MasterTicketRelationError: 'Tồn tại quan hệ vé chính, không允許 trả về',
  Cargo_CostStatusReturnError: 'Chi phí đã {0}, không允許 trả về',
  Cargo_RouteManagerEmptyError: 'Số nghiệp vụ: {0} Người phụ trách tuyến đường trống, không允許 trả về',
  Cargo_FOBReturnRestriction: 'Nghiệp vụ FOB chỉ có thể trả về đặt chỗ từ xa',
  Cargo_SelectedBusiness: 'Nghiệp vụ đã chọn',
  Cargo_RemoteBooking: 'Đặt chỗ từ xa',
  Cargo_RemoteBookingExportOnly: 'Đặt chỗ từ xa chỉ hỗ trợ hoàn trả nghiệp vụ xuất khẩu',
  Cargo_ReturnResult: 'Đã trả về thành công {0} mục, thất bại {1} mục',
  Cargo_MasterTicketRelationAlert: '【{0}】Tồn tại quan hệ vé chính',
  Cargo_NotFromRemoteBookingError: '[{0}] Đơn hàng không đến từ đặt chỗ từ xa, không允許 trả về',
  Cargo_NotFromPreApprovalError: '[{0}] Đơn hàng không đến từ duyệt trước đặt chỗ, không允許 trả về',
  Cargo_CostStatusAlert: '【{0}】Chi phí đã {1}',
  Cargo_ReturnCurrentOperationOnly: 'Chỉ hỗ trợ hoàn trả nghiệp vụ đang thao tác',
  Cargo_MixedBusinessTypeError: 'Nghiệp vụ đã chọn có cả loại FOB và không FOB, không thể trả về cùng lúc',
  Cargo_CollabBatchRejectError: 'Bao gồm {0} là nghiệp vụ hợp tác, không hỗ trợ từ chối hàng loạt',
  Cargo_OtherSurcharge: 'Phụ phí khác',
  Cargo_MoreDetails: 'Xem chi tiết',
  Cargo_SureToStartRPA: '[{0}] Sau khi RPA được kích hoạt, hệ thống sẽ tự động chuyển dữ liệu đến trang web của nhà ga, trước khi bắt đầu, hãy đảm bảo rằng dữ liệu đã được điền đầy đủ.',
  Cargo_SureToSuspendRPA: '[{0}] Sau khi RPA bị đình chỉ, nếu khởi động lại, hệ thống sẽ hiển thị trạng thái dữ liệu trên nhà ga, nếu tải không được xác nhận, hệ thống sẽ tạo lại lịch trình và tải lên, nếu không có vấn đề nghiêm trọng, vui lòng cố gắng không đình chỉ RPA.',
  Cargo_SureToDeleteOpenPrice: 'Vui lòng xác nhận nếu dữ liệu của [{0}] lô bị xóa?',
  Cargo_SureToImportFinalResult: 'Nhập kết quả cuối cùng theo cách thủ công có nghĩa là bạn xác nhận rằng lô đã hoàn thành và RPA sẽ không được thực hiện nữa.',
  Cargo_SureToExportFile: 'Vui lòng xác nhận xem dữ liệu của lô [{0}] có được xuất không?',
  FileBeLargerThan10MB: 'Kích thước tập tin không được lớn hơn 10MB',
  FileBeLargerThan5MB: 'Kích thước tập tin không được lớn hơn 5MB',
  Cargo_DeclareFile: 'Tài liệu khai báo',
  Cargo_ImportFinalFile: 'Kết quả nhập cuối cùng',
  Cargo_FinalPriceInfo: 'Giá vận chuyển cuối cùng',
  Cargo_DeclareNumLabel: 'Tổng giá vận chuyển: {0}',
  Cargo_DeclareFinalLabel: 'Số dòng cuối cùng/final line: {0}',
  Cargo_QuerySuccess: 'Nhận dữ liệu thành công',
  ChargeHasUpdate: 'Phí đã được {0} sửa đổi ở {1}. Vui lòng tra cứu lại dữ liệu trước khi thực hiện thao tác!',
  HasDeletedForDeleteJob: 'Dịch vụ đã chọn hiện tại đã bị xoá!',
  HasSlaveJobForDeleteJob: '[{0}]Vui lòng lấy hoá đơn ra trước!',
  HasChargeForDeleteJob: '[{0}]Đã nhập chi phí!',
  HasMergeForDeleteJob: '[{0}]Đơn hàng đã được hợp nhất!',
  Cargo_ArCustomerPaidOff: 'Chi phí đơn vị ủy thác Tình trạng bán hạt nhân',
  Cargo_ContainsAdvancePayment: 'Có chứa chi phí tạm ứng hay không',
  Cargo_JdySendStatus: 'Trạng thái gửi JianDaoYun',
  Cargo_JdySendTime: 'Thời gian gửi JianDaoYun',
  Cargo_DetailsLockedStatus: 'Trạng thái khóa chi tiết hàng hóa',
  Cargo_InterestAmountCurrency: 'Lãi suất quá hạn',
  Cargo_CheckRuleResult: 'Kết quả kiểm tra',
  DataHasModified: 'Dữ liệu đã bị [{0}] sửa đổi vào {1}, vui lòng làm mới!',
  Cargo_CheckNeedSynccloud: 'Vui lòng chọn hóa đơn nền tảng đám mây cần đồng bộ',
  Cargo_CheckJingdiesynccloud: 'Chỉ có hóa đơn nước ngoài và hóa đơn thu hộ/chi hộ mới có thể đẩy sang Kingdee',
  DisplayReceiptsOnly: 'Chỉ hiển thị hóa đơn',
  AssignedWorkResponsibleForNode: 'Vị trí được chỉ định (theo người phụ trách công việc tại nút thiết lập vị trí)',
  Cargo_CheckZySave: 'Vui lòng xác nhận xem hàng hóa trong đơn đặt hàng có liên quan đến Đạo luật Kiểm soát Xuất khẩu của Cộng hòa Nhân dân Trung Hoa, Quy định Kiểm soát Xuất khẩu của Cộng hòa Nhân dân Trung Hoa đối với các mặt hàng lưỡng dụng và Danh sách Kiểm soát Xuất khẩu của Cộng hòa Nhân dân Trung Hoa hay không. Nếu có, khách hàng được yêu cầu cung cấp Giấy phép xuất khẩu cho các mặt hàng lưỡng dụng làm tài liệu kèm theo tờ khai hải quan xuất khẩu. Hàng hóa trong đơn đặt hàng có thể được truy xuất thông qua tên hàng hóa và HSCODE, cơ sở dữ liệu truy xuất tham khảo các trang web sau:',
  Cargo_HasVerified: 'Đã kiểm tra',
  Cargo_ContainSensitiveWord: 'Bao gồm các từ nhạy cảm',
  Cargo_BusinessSingleMode: 'Chế độ giao dịch đơn lẻ cho doanh nghiệp',
  Cargo_BusinessBatchMode: 'Chế độ xử lý hàng loạt cho doanh nghiệp',
  Cargo_JobsSavedSuccessfully: '{0} nhiệm vụ được lưu thành công',
  Cargo_JobsFailedToSave: '{0} nhiệm vụ lưu thất bại',
  Cargo_BatchSaveFailed: 'Lưu hàng loạt thất bại',
  Cargo_PleaseAddGoods: '',
  confirmLock: '',
  confirmUnLock: '',
  Cargo_PleaseselectedGoods: '',
  Cargo_PleaseAddCheck: '',
  PriorityDisplay: 'Hiển thị mức độ ưu tiên',
  WhenTheNodeAllDisplayed: 'Khi không thiết lập ưu tiên cho nút, tất cả dữ liệu nút sẽ được hiển thị!',
  DefaultDisplay: 'Hiển thị mặc định:',
  PrioritizationSettings: 'Thiết lập ưu tiên',
  Cargo_OperationProvince: 'Tỉnh nơi công ty hoạt động',
  Cargo_SalesProvince: 'Khu vực công ty bán hàng',
  Cargo_PushTime: 'Thời gian đẩy',
  CargoMsg_CheckSecondCustomJobType: 'Khi loại hình kinh doanh tùy chỉnh là cấp hai, loại hình kinh doanh tùy chỉnh cấp trên không được để trống!',
  Cargo_EnterpriseWechatApprovalPayCompany: 'Công ty thanh toán (WeCom)',
  // Tiêu đề cột vị trí tùy chỉnh của danh sách đặt chỗ xuất khẩu đường biển (đặt theo vai trò nghiệp vụ)
  Cargo_UserDefinedRoleHeader1: 'Nhân viên đặt chỗ tuyến phụ',
  Cargo_UserDefinedRoleHeader2: 'Nhân viên đặt chỗ tuyến chính',
  Cargo_UserDefinedRoleHeader3: 'Nhân viên bảo hiểm',
  Cargo_UserDefinedRoleHeader4: 'Nhân viên theo dõi đơn hàng nước ngoài',
  Cargo_UserDefinedRoleHeader5: 'Trợ lý dịch vụ khách hàng'
}
